/* eslint-disable */
import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AuditTrail_DateTime: any;
  BillPlansOverviewData: any;
  BillingDetails: any;
  BillingTransactionTagFilterInput: any;
  Color: any;
  Column: any;
  CustomFieldValueInput: any;
  Date: any;
  /**
   * Luxon DateTime object, String, or object representing a date in ISO 8601
   * Midnight UTC or yyyy-MM-dd format or {year, month, day}. Returns a Luxon
   * DateTime object.
   */
  Date2: any;
  DateObject: any;
  DateTime: any;
  /** Luxon DateTime object, String, or object representing a date in object {year, month, day, hour, minute, second, zone} */
  DateTimeWithTimeZone: any;
  JobResult: any;
  KeyValue: any;
  /**
   * Object containing key-value settings, if key contains groupDropdown
   * andoverViewUnit, groupDropdown must be one of [employeeType, location,role,
   * department, serviceCenter, costCenter, division] and overViewUnitmust be one of
   * [percentage, hours, ftd].
   */
  KeyValueSettings: any;
  /** Consume an ISO-8601 datetime string which is set to midnight UTC. */
  MidnightDateTime: any;
  Overbudget: any;
  PPRA_Date: any;
  PPRA_DateTime: any;
  PRAA_CategorizedSkills: any;
  PRAA_SkillsWithProficiency: any;
  PRAA_Tags: any;
  PRAA_ToolsWithProficiency: any;
  PRAA_UserProfileCertifications: any;
  PTI_DateTime: any;
  PaginationTokenInput: any;
  PaginationTokenResponse: any;
  ProjectBillingScriptInput: any;
  ProjectBillingScriptParameter: any;
  ProjectScriptInput: any;
  /** Object containing project script parameters. */
  ProjectScriptParameter: any;
  /**
   * A project workflow checklist data object containing the keys
   * "urn:replicon-psa:project-stage:initiate",
   * "urn:replicon-psa:project-stage:planning",
   * "urn:replicon-psa:project-stage:execution",
   * "urn:replicon-psa:project-stage:close-out" which each has a value of an array
   * containing {name, checked, id} objects where name is a string, checked is a
   * boolean and id is a guid.
   */
  ProjectWorkflowChecklistData: any;
  RevenueEntriesCustomMetadata: any;
  ScheduleRuleDo: any;
  SearchCriterionSettings: any;
  TaxRateKeyValue: any;
  TimeAndExpense: any;
  Total: any;
};

export type AcceptAllocationForResourceRequestInput = {
  resourceRequestId: Scalars['String'];
  userIds: Array<Scalars['String']>;
};

export type AcceptAllocationForResourceRequestResult = {
  __typename?: 'AcceptAllocationForResourceRequestResult';
  resourceAllocations: Array<ResourceAllocation>;
  resourceRequest: ResourceRequest;
};

export type ActiveTasksSummary = {
  __typename?: 'ActiveTasksSummary';
  onTrackTasksCount?: Maybe<Scalars['Int']>;
  overEstimatedDateTasksCount?: Maybe<Scalars['Int']>;
  overEstimatedHourTasksCount?: Maybe<Scalars['Int']>;
  overEstimatedTasksCount?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  underEstimatedTasksCount?: Maybe<Scalars['Int']>;
};

export type ActiveUserCount = {
  __typename?: 'ActiveUserCount';
  count?: Maybe<Scalars['Int']>;
};

export type AddClientInput = {
  clientManagerUri?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  customFieldValues?: InputMaybe<Array<InputMaybe<Scalars['CustomFieldValueInput']>>>;
  name: Scalars['String'];
};

export type AddProgramInput = {
  name: Scalars['String'];
  programManagerReference?: InputMaybe<ProgramManagerReferenceInput>;
};

export type AddProjectError = {
  __typename?: 'AddProjectError';
  reason?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type AddProjectLinkInput = {
  linkType: ProjectLinkType;
  targetProjectId: Scalars['String'];
};

export type AddProjectResponse = {
  __typename?: 'AddProjectResponse';
  /** @deprecated RepliconServiceError is now thrown */
  error?: Maybe<AddProjectError>;
  errors: Array<ValidationNotificationSummary>;
  project?: Maybe<Project>;
};

export type AddRoleInput = {
  billingRate?: InputMaybe<MoneyInput>;
  costRate?: InputMaybe<MoneyInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  skills?: InputMaybe<Array<InputMaybe<RoleSkillInput>>>;
};

export type AddSkillsInput = {
  category?: InputMaybe<UserSkillCategoryInput>;
  description?: InputMaybe<Scalars['String']>;
  skillName: Scalars['String'];
};

export type AddUserDefinedSkillInput = {
  skillLevelId?: InputMaybe<Scalars['String']>;
  skillName: Scalars['String'];
};

export type Address = {
  __typename?: 'Address';
  address?: Maybe<Scalars['String']>;
  addressType: AddressType;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  stateProvince?: Maybe<Scalars['String']>;
  zipPostalCode?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  address?: InputMaybe<Scalars['String']>;
  addressType: AddressType;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryInput>;
  stateProvince?: InputMaybe<Scalars['String']>;
  zipPostalCode?: InputMaybe<Scalars['String']>;
};

export enum AddressType {
  Billing = 'BILLING',
  Others = 'OTHERS',
  Primary = 'PRIMARY'
}

export type AllocatedTimeEntry = {
  __typename?: 'AllocatedTimeEntry';
  comment?: Maybe<Scalars['String']>;
  /** @deprecated Use entryDate2 */
  entryDate?: Maybe<Scalars['Date']>;
  entryDate2?: Maybe<Scalars['Date2']>;
  estimatedCompletionDate?: Maybe<Scalars['Date']>;
  hoursRemaining?: Maybe<Scalars['Float']>;
  hoursWorked?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  quality?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  workDone?: Maybe<Scalars['Float']>;
};

export enum AllocationDistributionMode {
  ExtendAllocation = 'EXTEND_ALLOCATION',
  FitsAvailableHours = 'FITS_AVAILABLE_HOURS',
  FullHours = 'FULL_HOURS',
  Redistribute = 'REDISTRIBUTE'
}

export type AllocationExchangeRateValues = {
  __typename?: 'AllocationExchangeRateValues';
  baseCurrency?: Maybe<ExchangeRate>;
  projectBudgetCurrency?: Maybe<ExchangeRate>;
  resourceRequestCurrency?: Maybe<ExchangeRate>;
};

export type AllocationHoursInDateRangeInput = {
  dateRange: DateRangeInput2;
  distributionMode?: InputMaybe<AllocationDistributionMode>;
  hoursPerPeriod: Scalars['Float'];
  periodType: AllocationPeriodType;
};

export enum AllocationPeriodType {
  EntireRange = 'ENTIRE_RANGE',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type AllocationTotalCostByCurrency = {
  __typename?: 'AllocationTotalCostByCurrency';
  baseCurrency?: Maybe<MoneyValue>;
  projectBudgetCurrency?: Maybe<MoneyValue>;
  resourceRequestCurrency?: Maybe<MoneyValue>;
};

export enum AllocationUpdateBehaviour {
  Merge = 'MERGE',
  Replace = 'REPLACE'
}

export type ApplyUserDefinedSkillModificationsForUserInput = {
  addSkills?: InputMaybe<Array<AddUserDefinedSkillInput>>;
  removeSkills?: InputMaybe<Array<Scalars['String']>>;
  updateSkills?: InputMaybe<Array<UpdateUserDefinedSkillInput>>;
  userId: Scalars['String'];
};

export type ApplyUserDefinedSkillModificationsForUserResult = {
  __typename?: 'ApplyUserDefinedSkillModificationsForUserResult';
  addedSkills?: Maybe<Array<UserDefinedSkill>>;
  removedSkills?: Maybe<Array<Scalars['String']>>;
  updatedSkills?: Maybe<Array<UserDefinedSkill>>;
  userId: Scalars['String'];
};

export type ApprovalsSummary = {
  __typename?: 'ApprovalsSummary';
  awaitingExpenses?: Maybe<Scalars['Int']>;
  awaitingSellBacks?: Maybe<Scalars['Int']>;
  awaitingTimeOffs?: Maybe<Scalars['Int']>;
  awaitingTimesheets?: Maybe<Scalars['Int']>;
};

export type ArchiveProjectInput = {
  id: Scalars['String'];
};

export type AssignProjectRequestsToPortfolioInput = {
  portfolioId: Scalars['String'];
  projectRequestIds?: InputMaybe<Array<Scalars['String']>>;
};

export type AssignProjectsToPortfolioInput = {
  portfolioId: Scalars['String'];
  projectIds?: InputMaybe<Array<Scalars['String']>>;
};

export type AssignProjectsToProgramInput = {
  programId: Scalars['String'];
  projectIds?: InputMaybe<Array<Scalars['String']>>;
};

export type AssignSkillToUserError = {
  __typename?: 'AssignSkillToUserError';
  displayText?: Maybe<Scalars['String']>;
  failureUri: Scalars['String'];
  skill: SkillReference;
};

export type AssignSkillToUserErrors = {
  __typename?: 'AssignSkillToUserErrors';
  errors: Array<AssignSkillToUserError>;
  userUri: Scalars['String'];
};

export type AssignedProject = {
  __typename?: 'AssignedProject';
  id?: Maybe<Scalars['String']>;
  project: Project;
  taskCount: Scalars['Int'];
};

export type AssignedTaskCount2 = {
  __typename?: 'AssignedTaskCount2';
  count: Scalars['Int'];
  error?: Maybe<AssignedTaskCountError>;
};

export type AssignedTaskCountError = {
  __typename?: 'AssignedTaskCountError';
  reason?: Maybe<Scalars['String']>;
  type: AssignedTaskCountErrorCode;
};

export enum AssignedTaskCountErrorCode {
  ErrorInTaskService = 'ERROR_IN_TASK_SERVICE'
}

export enum AssignedTaskCountFilter {
  ExcludeTasksFromCurrentTimesheet = 'EXCLUDE_TASKS_FROM_CURRENT_TIMESHEET'
}

export type AssignedTasksCountInput = {
  projectId: Scalars['String'];
  textSearch?: InputMaybe<Scalars['String']>;
};

export type AssociatedBillForCreditMemo = {
  __typename?: 'AssociatedBillForCreditMemo';
  allocatedBillAmount?: Maybe<Money>;
  allocatedCreditMemoAmount?: Maybe<Money>;
  balanceAmount?: Maybe<Money>;
  displayText?: Maybe<Scalars['String']>;
  /** @deprecated Use dueDate2 */
  dueDate?: Maybe<Scalars['Date']>;
  dueDate2?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
};

export type AssociatedBillForPayment = {
  __typename?: 'AssociatedBillForPayment';
  allocatedBillAmount?: Maybe<Money>;
  allocatedBillPaymentAmount?: Maybe<Money>;
  balanceAmount?: Maybe<Money>;
  displayText?: Maybe<Scalars['String']>;
  /** @deprecated Use dueDate2 */
  dueDate?: Maybe<Scalars['Date']>;
  dueDate2?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
};

export type AssociatedBillPayment = {
  __typename?: 'AssociatedBillPayment';
  allocatedBillAmount?: Maybe<Money>;
  allocatedBillPaymentAmount?: Maybe<Money>;
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  paymentDate?: Maybe<Scalars['DateTime']>;
};

export type AssociatedCreditMemo = {
  __typename?: 'AssociatedCreditMemo';
  allocatedBillAmount?: Maybe<Money>;
  allocatedCreditMemoAmount?: Maybe<Money>;
  creditDate?: Maybe<Scalars['DateTime']>;
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};

export type Attachment = {
  __typename?: 'Attachment';
  fileExtension?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileSize?: Maybe<Scalars['String']>;
  linkUri: Scalars['String'];
  type: Scalars['String'];
  uploadUri: Scalars['String'];
  uploadedBy?: Maybe<User>;
  uploadedOn: Scalars['String'];
};

export type AttachmentLink = {
  __typename?: 'AttachmentLink';
  link?: Maybe<Scalars['String']>;
  linkName?: Maybe<Scalars['String']>;
  objectUri: Scalars['String'];
  type: Scalars['String'];
  uploadUri: Scalars['String'];
  uploadedByUserUri: Scalars['String'];
  uploadedOn: Scalars['String'];
};

export type AttachmentLinkInput = {
  linkName?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  uploadUri: Scalars['String'];
};

export enum AttachmentType {
  FileSourceUri = 'FILE_SOURCE_URI',
  LinkSourceUri = 'LINK_SOURCE_URI'
}

export type AuditTrail_AncestorField = {
  __typename?: 'AuditTrail_AncestorField';
  displayText?: Maybe<Scalars['String']>;
};

export type AuditTrail_AuditDateRangeInput = {
  endDate?: InputMaybe<Scalars['AuditTrail_DateTime']>;
  startDate?: InputMaybe<Scalars['AuditTrail_DateTime']>;
};

export type AuditTrail_DateRangeInput = {
  endDate?: InputMaybe<Scalars['AuditTrail_DateTime']>;
  startDate?: InputMaybe<Scalars['AuditTrail_DateTime']>;
};

export type AuditTrail_ObjectDetails = {
  __typename?: 'AuditTrail_ObjectDetails';
  displayText?: Maybe<Scalars['String']>;
  uri: Scalars['String'];
};

export type AuditTrail_ObjectReference = {
  __typename?: 'AuditTrail_ObjectReference';
  displayText?: Maybe<Scalars['String']>;
  uri: Scalars['String'];
};

export type AuditTrail_PortfolioField = {
  __typename?: 'AuditTrail_PortfolioField';
  ancestors: Array<Maybe<AuditTrail_AncestorField>>;
  displayText?: Maybe<Scalars['String']>;
};

export type AuditTrail_PortfolioRevisionField = {
  __typename?: 'AuditTrail_PortfolioRevisionField';
  current?: Maybe<AuditTrail_PortfolioField>;
  previous?: Maybe<AuditTrail_PortfolioField>;
};

export type AuditTrail_ProjectRequestFilter = {
  projectRequestUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AuditTrail_ProjectRequestRevisionDetail = {
  __typename?: 'AuditTrail_ProjectRequestRevisionDetail';
  actualUser?: Maybe<AuditTrail_ObjectReference>;
  clientIp?: Maybe<Scalars['String']>;
  effectiveUser?: Maybe<AuditTrail_ObjectReference>;
  projectRequest: AuditTrail_ObjectReference;
  revisionValue?: Maybe<AuditTrail_ProjectRequestRevisionFields>;
  timestampUtc: Scalars['AuditTrail_DateTime'];
};

export type AuditTrail_ProjectRequestRevisionFields = {
  __typename?: 'AuditTrail_ProjectRequestRevisionFields';
  description?: Maybe<AuditTrail_StringRevisionField>;
  name?: Maybe<AuditTrail_StringRevisionField>;
  portfolio?: Maybe<AuditTrail_PortfolioRevisionField>;
  requestedBy?: Maybe<AuditTrail_StringRevisionField>;
  statusType?: Maybe<AuditTrail_ProjectRequestStatusTypeRevisionField>;
};

export type AuditTrail_ProjectRequestRevisionResult = {
  __typename?: 'AuditTrail_ProjectRequestRevisionResult';
  cursor?: Maybe<Scalars['String']>;
  items: Array<AuditTrail_ProjectRequestRevisionDetail>;
};

export enum AuditTrail_ProjectRequestStatusType {
  Approved = 'APPROVED',
  InReview = 'IN_REVIEW',
  New = 'NEW',
  Rejected = 'REJECTED'
}

export type AuditTrail_ProjectRequestStatusTypeRevisionField = {
  __typename?: 'AuditTrail_ProjectRequestStatusTypeRevisionField';
  current?: Maybe<AuditTrail_ProjectRequestStatusType>;
  previous?: Maybe<AuditTrail_ProjectRequestStatusType>;
};

export type AuditTrail_ProjectTeamMemberBillingRateAssignmentDetail = {
  __typename?: 'AuditTrail_ProjectTeamMemberBillingRateAssignmentDetail';
  actualUser?: Maybe<AuditTrail_ObjectDetails>;
  clientIp?: Maybe<Scalars['String']>;
  currentBillingRate?: Maybe<AuditTrail_ObjectDetails>;
  effectiveUser?: Maybe<AuditTrail_ObjectDetails>;
  previousBillingRate?: Maybe<AuditTrail_ObjectDetails>;
  project: AuditTrail_ObjectDetails;
  timestampUtc: Scalars['AuditTrail_DateTime'];
  user: AuditTrail_ObjectDetails;
};

export type AuditTrail_ProjectTeamMemberBillingRateAssignmentFilter = {
  dateRange?: InputMaybe<AuditTrail_AuditDateRangeInput>;
  projectUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AuditTrail_ProjectTeamMemberBillingRateAssignmentResult = {
  __typename?: 'AuditTrail_ProjectTeamMemberBillingRateAssignmentResult';
  cursor?: Maybe<Scalars['String']>;
  items: Array<AuditTrail_ProjectTeamMemberBillingRateAssignmentDetail>;
};

export enum AuditTrail_SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type AuditTrail_StringRevisionField = {
  __typename?: 'AuditTrail_StringRevisionField';
  current?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
};

export type AuditTrail_UserPermissionSetRevisionDetail = {
  __typename?: 'AuditTrail_UserPermissionSetRevisionDetail';
  actualUser?: Maybe<AuditTrail_ObjectReference>;
  clientIp?: Maybe<Scalars['String']>;
  currentPermissionSet?: Maybe<AuditTrail_ObjectReference>;
  effectiveUser?: Maybe<AuditTrail_ObjectReference>;
  policyUri: Scalars['String'];
  previousPermissionSet?: Maybe<AuditTrail_ObjectReference>;
  timestampUtc: Scalars['AuditTrail_DateTime'];
  user: AuditTrail_ObjectReference;
};

export type AuditTrail_UserPermissionSetRevisionFilter = {
  dateRange?: InputMaybe<AuditTrail_DateRangeInput>;
  userUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AuditTrail_UserPermissionSetRevisionResult = {
  __typename?: 'AuditTrail_UserPermissionSetRevisionResult';
  cursor?: Maybe<Scalars['String']>;
  items: Array<AuditTrail_UserPermissionSetRevisionDetail>;
};

export type AvailabilityPercentageInRangeInput = {
  dateRange: DateRangeInput;
  number: Scalars['Float'];
};

export type AvailabilityPeriod = {
  __typename?: 'AvailabilityPeriod';
  allocatedDuration: Duration;
  availableDuration: Duration;
  dateRange: DateRange;
  holidayDuration: Duration;
  overAllocatedDuration: Duration;
  scheduledDuration: Duration;
  timeOffDuration: Duration;
};

export type AvailableBillingItemFilter = {
  billingItemColumnOption?: InputMaybe<Array<InputMaybe<BillingItemColumnOption>>>;
  billingItemTypes?: InputMaybe<Array<InputMaybe<BillingItemType>>>;
  clientUri: Scalars['String'];
  dateRange?: InputMaybe<BillingDateRangeInput>;
  projectUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textSearch?: InputMaybe<Scalars['String']>;
  userUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AvailableBillingItemFilter2 = {
  billingItemColumnOption?: InputMaybe<Array<InputMaybe<BillingItemColumnOption>>>;
  billingItemTypes?: InputMaybe<Array<InputMaybe<BillingItemType>>>;
  clientUri: Scalars['String'];
  dateRange?: InputMaybe<BillingDateRangeInput2>;
  excludeZeroAmounts?: InputMaybe<Scalars['Boolean']>;
  projectLeaderUris?: InputMaybe<Array<Scalars['String']>>;
  projectUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textSearch?: InputMaybe<Scalars['String']>;
  userUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AvailableBillingItemInput2 = {
  billingAmountCurrencyUri?: InputMaybe<Scalars['String']>;
  billingItemColumnOption?: InputMaybe<Array<InputMaybe<BillingItemColumnOption>>>;
  filter?: InputMaybe<AvailableBillingItemFilter2>;
};

export type AvailableCreditMemo = {
  __typename?: 'AvailableCreditMemo';
  balanceAmountInCreditMemoCurrency: Money;
  balanceAmountInInvoiceCurrency: Money;
  /** @deprecated Use creditDate2 */
  creditDate: Scalars['DateObject'];
  creditDate2: Scalars['Date2'];
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};

export type AvailablePayment = {
  __typename?: 'AvailablePayment';
  balanceAmountInInvoiceCurrency: Money;
  balanceAmountInPaymentCurrency: Money;
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** @deprecated Use paymentDate2 */
  paymentDate: Scalars['DateObject'];
  paymentDate2: Scalars['Date2'];
};

export type AvailableToBill = {
  __typename?: 'AvailableToBill';
  amount?: Maybe<Money>;
  billingFrequencyPeriod?: Maybe<DateRange>;
  client?: Maybe<ObjectReference>;
  /** @deprecated Use endDate2 */
  endDate?: Maybe<Scalars['DateObject']>;
  endDate2?: Maybe<Scalars['Date2']>;
  id: Scalars['String'];
  project?: Maybe<ObjectReference>;
  projectLeader?: Maybe<ObjectReference>;
  /** @deprecated Use startDate2 */
  startDate?: Maybe<Scalars['DateObject']>;
  startDate2?: Maybe<Scalars['Date2']>;
};

export type AvailableToBillFilter2 = {
  billingPeriod?: InputMaybe<BillingDateTimeRangeInput>;
  clientUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludeZeroAmount?: InputMaybe<Scalars['Boolean']>;
  programUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projectLeaderUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projectUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AvailableToBillOverviewData = {
  __typename?: 'AvailableToBillOverviewData';
  amountTotal?: Maybe<BillingOverviewAmountData>;
  billableHours?: Maybe<BillingOverviewHoursData>;
  nonBillableHours?: Maybe<BillingOverviewHoursData>;
};

export type AvailableToBillTotal = {
  __typename?: 'AvailableToBillTotal';
  amount?: Maybe<Array<Maybe<Money>>>;
  amountInBaseCurrency?: Maybe<Money>;
};

export enum AvailableToBillType {
  Expense = 'EXPENSE',
  FixedBid = 'FIXED_BID',
  Timesheet = 'TIMESHEET'
}

export type Avatar = {
  __typename?: 'Avatar';
  avatar?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  medium?: Maybe<Scalars['String']>;
  original?: Maybe<Scalars['String']>;
};

export type BackgroundJob = {
  __typename?: 'BackgroundJob';
  id: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['JobResult']>;
  status: Scalars['String'];
};

export enum BatchState {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Succeeded = 'SUCCEEDED'
}

export type BeginBulkProposeAllocationsForResourceRequestInput = {
  proposedAllocationInput: Array<BeginProposeAllocationsForResourceRequestInput>;
};

export type BeginMassEditProjectBackgroundJobResult = {
  __typename?: 'BeginMassEditProjectBackgroundJobResult';
  batchUri: Scalars['String'];
  jobId: Scalars['String'];
};

export type BeginProposeAllocationsForResourceRequestInput = {
  resourceRequestId: Scalars['String'];
  userIds: Array<Scalars['String']>;
};

export type BeginResourceUserTaskAssignmentBulkActionInput = {
  actionType: TaskAssignmentBulkActionType;
  projectId: Scalars['String'];
  resourceUserId: Scalars['String'];
  taskFilter?: InputMaybe<ResourceUserTaskAssignmentBulkActionTaskFilter>;
};

export type Bill = {
  __typename?: 'Bill';
  associatedBillPayments?: Maybe<GetPageOfAssociatedBillPaymentsForBillResponse>;
  associatedCreditMemos?: Maybe<GetPageOfAssociatedCreditMemosForBillResponse>;
  balanceStatus?: Maybe<BillingTransactionBalanceStatus>;
  billStatus?: Maybe<BillStatus>;
  billingAddress?: Maybe<Scalars['String']>;
  client?: Maybe<ObjectReference>;
  currency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']>;
  displayId?: Maybe<Scalars['String']>;
  draftSubStatusUri?: Maybe<Scalars['String']>;
  /** @deprecated Use dueDate2 */
  dueDate?: Maybe<Scalars['DateObject']>;
  dueDate2?: Maybe<Scalars['Date2']>;
  id: Scalars['String'];
  internalNotes?: Maybe<Scalars['String']>;
  /** @deprecated Use billStatus */
  invoiceStatus?: Maybe<Scalars['String']>;
  invoiceTemplate?: Maybe<InvoiceTemplate>;
  /** @deprecated Use issueDate2 */
  issueDate?: Maybe<Scalars['DateObject']>;
  issueDate2?: Maybe<Scalars['Date2']>;
  lineItems?: Maybe<GetPageOfLineItemsForBillResponse>;
  notesForCustomer?: Maybe<Scalars['String']>;
  paymentTerms?: Maybe<Scalars['Int']>;
  period?: Maybe<DateRange>;
  permittedActions?: Maybe<Array<Maybe<Scalars['String']>>>;
  poNumber?: Maybe<Scalars['String']>;
  showComments?: Maybe<Scalars['Boolean']>;
  summarizeColumn?: Maybe<Array<Maybe<BillingItemColumn>>>;
  syncStatus?: Maybe<Scalars['String']>;
  taxProfile?: Maybe<TaxProfile>;
  voidBillDescription?: Maybe<Scalars['String']>;
};


export type BillAssociatedBillPaymentsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type BillAssociatedCreditMemosArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type BillLineItemsArgs = {
  filter?: InputMaybe<LineItemFilter>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  summarizeColumnOptions?: InputMaybe<Array<InputMaybe<BillingItemColumn>>>;
};

export type BillInput = {
  clientUri: Scalars['String'];
  currencyUri?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  displayId: Scalars['String'];
  dueDate: Scalars['DateObject'];
  id?: InputMaybe<Scalars['String']>;
  issueDate: Scalars['DateObject'];
  lineItems?: InputMaybe<Array<InputMaybe<LineItemInput>>>;
  paymentTerms: Scalars['Int'];
  poNumber?: InputMaybe<Scalars['String']>;
  summarizeColumn?: InputMaybe<Array<InputMaybe<BillingItemColumn>>>;
};

export type BillInput2 = {
  adhocLineItems?: InputMaybe<Array<InputMaybe<LineItemInput>>>;
  billingAddress?: InputMaybe<Scalars['String']>;
  clientUri: Scalars['String'];
  currencyUri?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  displayId: Scalars['String'];
  draftSubStatusUri?: InputMaybe<Scalars['String']>;
  dueDate: Scalars['Date2'];
  id?: InputMaybe<Scalars['String']>;
  internalNotes?: InputMaybe<Scalars['String']>;
  invoiceTemplateUri?: InputMaybe<Scalars['String']>;
  issueDate: Scalars['Date2'];
  lineItems?: InputMaybe<Array<InputMaybe<LineItemInput>>>;
  notesForCustomer?: InputMaybe<Scalars['String']>;
  paymentTerms: Scalars['Int'];
  period?: InputMaybe<PeriodInput>;
  poNumber?: InputMaybe<Scalars['String']>;
  showComments?: InputMaybe<Scalars['Boolean']>;
  standardLineItems?: InputMaybe<Array<InputMaybe<LineItemInput>>>;
  summarizeColumn?: InputMaybe<Array<InputMaybe<BillingItemColumn>>>;
  taxProfileUri?: InputMaybe<Scalars['String']>;
};

export type BillInput3 = {
  adhocLineItems?: InputMaybe<Array<InputMaybe<LineItemInput>>>;
  billingAddress?: InputMaybe<Scalars['String']>;
  clientUri: Scalars['String'];
  currencyUri?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  displayId?: InputMaybe<Scalars['String']>;
  draftSubStatusUri?: InputMaybe<Scalars['String']>;
  dueDate: Scalars['Date2'];
  id?: InputMaybe<Scalars['String']>;
  internalNotes?: InputMaybe<Scalars['String']>;
  invoiceTemplateUri?: InputMaybe<Scalars['String']>;
  issueDate: Scalars['Date2'];
  lineItems?: InputMaybe<Array<InputMaybe<LineItemInput>>>;
  notesForCustomer?: InputMaybe<Scalars['String']>;
  paymentTerms: Scalars['Int'];
  period?: InputMaybe<PeriodInput>;
  poNumber?: InputMaybe<Scalars['String']>;
  showComments?: InputMaybe<Scalars['Boolean']>;
  standardLineItems?: InputMaybe<Array<InputMaybe<LineItemInput>>>;
  summarizeColumn?: InputMaybe<Array<InputMaybe<BillingItemColumn>>>;
  taxProfileUri?: InputMaybe<Scalars['String']>;
};

export type BillLineItem = {
  __typename?: 'BillLineItem';
  amount?: Maybe<Money>;
  billingRate?: Maybe<Scalars['String']>;
  billingType?: Maybe<BillingItemType>;
  description?: Maybe<Scalars['String']>;
  expenseCode?: Maybe<Scalars['String']>;
  hasAccessToLineItemProject?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  keyValues?: Maybe<Scalars['KeyValue']>;
  notes?: Maybe<Scalars['String']>;
  payCode?: Maybe<Scalars['String']>;
  project?: Maybe<ObjectReference>;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Money>;
  role?: Maybe<Scalars['String']>;
  task?: Maybe<ObjectReference>;
  timesheetPeriod?: Maybe<DateRange>;
  unit?: Maybe<Scalars['String']>;
  user?: Maybe<ObjectReference>;
};

export type BillPayment = {
  __typename?: 'BillPayment';
  associatedBills?: Maybe<GetPageOfAssociatedBillsForBillPaymentResponse>;
  balanceStatus?: Maybe<BillingTransactionBalanceStatus>;
  client: ObjectReference;
  description?: Maybe<Scalars['String']>;
  displayId: Scalars['String'];
  id: Scalars['String'];
  paymentAmount: Money;
  /** @deprecated Use paymentDate2 */
  paymentDate?: Maybe<Scalars['DateObject']>;
  paymentDate2?: Maybe<Scalars['Date2']>;
  paymentMethod?: Maybe<PaymentMethodReference>;
  paymentMethodUri?: Maybe<Scalars['String']>;
  projectUri?: Maybe<Scalars['String']>;
};


export type BillPaymentAssociatedBillsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type BillPaymentInput2 = {
  associatedBills?: InputMaybe<Array<InputMaybe<BillToBillPaymentAssociationInput>>>;
  clientUri: Scalars['String'];
  currencyUri: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  displayId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  paymentAmount: Scalars['Float'];
  paymentDate: Scalars['Date2'];
  paymentMethodUri?: InputMaybe<Scalars['String']>;
  projectUri?: InputMaybe<Scalars['String']>;
};

export type BillPaymentsForBillInput = {
  associatedBillPayments?: InputMaybe<Array<InputMaybe<BillToBillPaymentAssociationInput>>>;
  billId: Scalars['String'];
};

export type BillPeriod = {
  __typename?: 'BillPeriod';
  dateRange?: Maybe<DateRange>;
  dateRangeValue?: Maybe<Scalars['String']>;
};

export enum BillPlanOverviewMode {
  AvailableToBill = 'AVAILABLE_TO_BILL',
  Estimated = 'ESTIMATED'
}

export type BillPlansOverviewData2 = {
  __typename?: 'BillPlansOverviewData2';
  displayText?: Maybe<Array<Maybe<DisplayObject>>>;
  series?: Maybe<Array<Maybe<SeriesObject>>>;
};

export type BillSettings = {
  __typename?: 'BillSettings';
  billLineItemsBy?: Maybe<Array<Maybe<LineItemColumnOptions>>>;
  defaultInvoicePaymentTerm?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  invoiceCurrency?: Maybe<Currency>;
  invoiceTemplate?: Maybe<InvoiceTemplate>;
  poNumber?: Maybe<Scalars['String']>;
  showComments?: Maybe<Scalars['Boolean']>;
  taxProfile?: Maybe<TaxProfile>;
};

export type BillSnapshot = {
  __typename?: 'BillSnapshot';
  /** @deprecated Use asOfDate2 */
  asOfDate?: Maybe<Scalars['Date']>;
  /** @deprecated Use asOfDateTime */
  asOfDate2?: Maybe<Scalars['Date2']>;
  asOfDateTime?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  signature?: Maybe<Scalars['String']>;
};

export enum BillStatus {
  Billed = 'BILLED',
  Draft = 'DRAFT',
  IssuedPaid = 'ISSUED_PAID',
  IssuedPartiallypaid = 'ISSUED_PARTIALLYPAID',
  IssuedUnpaid = 'ISSUED_UNPAID',
  Void = 'VOID'
}

export type BillSubStatus = {
  __typename?: 'BillSubStatus';
  id: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  order?: Maybe<Scalars['Float']>;
  text: Scalars['String'];
};

export type BillToBillPaymentAssociationInput = {
  allocatedBillAmount?: InputMaybe<MoneyInput>;
  allocatedBillPaymentAmount?: InputMaybe<MoneyInput>;
  id: Scalars['String'];
};

export type BillToCreditMemoAssociationInput = {
  allocatedBillAmount?: InputMaybe<MoneyInput>;
  allocatedCreditMemoAmount?: InputMaybe<MoneyInput>;
  id: Scalars['String'];
};

export type BillingAggregation = {
  __typename?: 'BillingAggregation';
  availableToBill?: Maybe<Money>;
  billed?: Maybe<Money>;
  client?: Maybe<ObjectReference>;
  costCenter?: Maybe<Groups>;
  department?: Maybe<Groups>;
  division?: Maybe<Groups>;
  employeeType?: Maybe<Groups>;
  estimatedBilling?: Maybe<Money>;
  location?: Maybe<Groups>;
  program?: Maybe<ObjectReference>;
  project?: Maybe<ObjectReference>;
  serviceCenter?: Maybe<Groups>;
  unBilled?: Maybe<Money>;
};

export enum BillingAggregationColumn {
  Availabletobill = 'AVAILABLETOBILL',
  Billed = 'BILLED',
  Client = 'CLIENT',
  Costcenter = 'COSTCENTER',
  Department = 'DEPARTMENT',
  Division = 'DIVISION',
  Employeetype = 'EMPLOYEETYPE',
  Estimatedbilling = 'ESTIMATEDBILLING',
  Location = 'LOCATION',
  Program = 'PROGRAM',
  Project = 'PROJECT',
  Servicecenter = 'SERVICECENTER',
  Unbilled = 'UNBILLED'
}

export type BillingAggregationFilter2 = {
  dateRange?: InputMaybe<BillingDateTimeRangeInput>;
};

export type BillingAggregationSort = {
  direction: SortDirection;
  field: BillingAggregationColumn;
};

export type BillingAggregationTotals = {
  __typename?: 'BillingAggregationTotals';
  availableToBill?: Maybe<Money>;
  billed?: Maybe<Money>;
  estimatedBilling?: Maybe<Money>;
  unBilled?: Maybe<Money>;
};

export type BillingContract = {
  __typename?: 'BillingContract';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type BillingContractInput = {
  contractId: Scalars['String'];
  projectId: Scalars['String'];
  projectScripts?: InputMaybe<Array<InputMaybe<Scalars['ProjectScriptInput']>>>;
};

export type BillingDateRangeInput = {
  endDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
};

export type BillingDateRangeInput2 = {
  endDate?: InputMaybe<Scalars['Date2']>;
  startDate?: InputMaybe<Scalars['Date2']>;
};

export type BillingDateTimeRangeInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type BillingFilter = {
  clientUri?: InputMaybe<Scalars['String']>;
  programUri?: InputMaybe<Scalars['String']>;
  projectUri?: InputMaybe<Scalars['String']>;
};

export enum BillingFrequency {
  Biweekly = 'BIWEEKLY',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Semimonthly = 'SEMIMONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type BillingItem = {
  __typename?: 'BillingItem';
  billingAmount?: Maybe<Money>;
  billingAmountOriginal?: Maybe<Money>;
  billingContractClauseName?: Maybe<Scalars['String']>;
  billingItemRate?: Maybe<Money>;
  billingItemUris?: Maybe<Array<Maybe<Scalars['String']>>>;
  billingRate?: Maybe<Scalars['String']>;
  entryDate?: Maybe<Scalars['DateObject']>;
  expenseCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  itemType?: Maybe<BillingItemType>;
  payCode?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  role?: Maybe<Scalars['String']>;
  taskName?: Maybe<Scalars['String']>;
  timesheetPeriod?: Maybe<TimesheetPeriod>;
  unitLabel?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type BillingItem2 = {
  __typename?: 'BillingItem2';
  billingAmount?: Maybe<Money>;
  billingAmountOriginal?: Maybe<Money>;
  billingContractClauseName?: Maybe<Scalars['String']>;
  billingItemRate?: Maybe<Money>;
  billingItemUris?: Maybe<Array<Maybe<Scalars['String']>>>;
  entryDate?: Maybe<Scalars['Date2']>;
  id?: Maybe<Scalars['String']>;
  itemType?: Maybe<BillingItemType>;
  projectName?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  taskName?: Maybe<Scalars['String']>;
  unitLabel?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export enum BillingItemColumn {
  BillingContractClause = 'BILLING_CONTRACT_CLAUSE',
  BillingRate = 'BILLING_RATE',
  ExpenseCode = 'EXPENSE_CODE',
  Itemtype = 'ITEMTYPE',
  Paycode = 'PAYCODE',
  Project = 'PROJECT',
  Quantity = 'QUANTITY',
  Rate = 'RATE',
  Role = 'ROLE',
  Task = 'TASK',
  TimesheetPeriod = 'TIMESHEET_PERIOD',
  Unit = 'UNIT',
  User = 'USER'
}

export enum BillingItemColumnFilterOption {
  BillingRate = 'BILLING_RATE',
  EntryDate = 'ENTRY_DATE',
  ExpenseCode = 'EXPENSE_CODE',
  ExpenseDescription = 'EXPENSE_DESCRIPTION',
  FixedBidEntryPeriod = 'FIXED_BID_ENTRY_PERIOD',
  Project = 'PROJECT',
  Task = 'TASK',
  TimesheetPeriod = 'TIMESHEET_PERIOD',
  User = 'USER'
}

export enum BillingItemColumnOption {
  BillingContractClause = 'BILLING_CONTRACT_CLAUSE',
  BillingRate = 'BILLING_RATE',
  Description = 'DESCRIPTION',
  ExpenseCode = 'EXPENSE_CODE',
  Itemtype = 'ITEMTYPE',
  Paycode = 'PAYCODE',
  Project = 'PROJECT',
  Quantity = 'QUANTITY',
  Rate = 'RATE',
  Role = 'ROLE',
  Task = 'TASK',
  TimesheetPeriod = 'TIMESHEET_PERIOD',
  Unit = 'UNIT',
  User = 'USER'
}

export type BillingItemFilter2 = {
  billingItemColumnFilterOption?: InputMaybe<Array<InputMaybe<BillingItemColumnFilterOption>>>;
  billingItemGroup?: InputMaybe<BillingItemGroup>;
  billingItemTypes?: InputMaybe<Array<InputMaybe<BillingItemType>>>;
  clientUri: Scalars['String'];
  dateRange?: InputMaybe<BillingDateRangeInput2>;
  projectUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textSearch?: InputMaybe<Scalars['String']>;
  userUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum BillingItemGroup {
  BillingRate = 'BILLING_RATE',
  Project = 'PROJECT',
  Task = 'TASK'
}

export type BillingItemSearch2 = {
  billingItemTypes?: InputMaybe<Array<InputMaybe<BillingItemType>>>;
  dateRange?: InputMaybe<BillingDateRangeInput2>;
  excludeZeroAmounts?: InputMaybe<Scalars['Boolean']>;
  projectLeaderUris?: InputMaybe<Array<Scalars['String']>>;
  projectUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textSearch?: InputMaybe<Scalars['String']>;
  userUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type BillingItemSearchFilter2 = {
  billingItemColumnFilterOption?: InputMaybe<Array<InputMaybe<BillingItemColumnFilterOption>>>;
  billingItemGroup?: InputMaybe<BillingItemGroup>;
  billingItemTypes?: InputMaybe<Array<InputMaybe<BillingItemType>>>;
  dateRange?: InputMaybe<BillingDateRangeInput2>;
  projectUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textSearch?: InputMaybe<Scalars['String']>;
  userUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type BillingItemSummary = {
  __typename?: 'BillingItemSummary';
  groupCount?: Maybe<Scalars['Int']>;
  totalBillingAmount?: Maybe<Money>;
};

export enum BillingItemType {
  Adhoc = 'ADHOC',
  Expense = 'EXPENSE',
  FixedBid = 'FIXED_BID',
  Timesheet = 'TIMESHEET'
}

export type BillingOverview = {
  __typename?: 'BillingOverview';
  availableToBill?: Maybe<AvailableToBillOverviewData>;
  billingTransactionActuals?: Maybe<BillingTransactionActualsOverviewData>;
  estimatedBilling?: Maybe<EstimatedBillingOverviewData>;
};

export type BillingOverviewAmountData = {
  __typename?: 'BillingOverviewAmountData';
  series?: Maybe<BillingOverviewAmountSeries>;
  summary?: Maybe<BillingOverviewAmountSummary>;
};

export type BillingOverviewAmountSeries = {
  __typename?: 'BillingOverviewAmountSeries';
  currency?: Maybe<Currency>;
  dataPoints?: Maybe<Array<Maybe<BillingOverviewAmountSeriesDataPoint>>>;
};

export type BillingOverviewAmountSeries2 = {
  __typename?: 'BillingOverviewAmountSeries2';
  amount?: Maybe<Money>;
  currency?: Maybe<Currency>;
  dataPoints?: Maybe<Array<Maybe<BillingOverviewAmountSeriesDataPoint>>>;
};

export type BillingOverviewAmountSeriesDataPoint = {
  __typename?: 'BillingOverviewAmountSeriesDataPoint';
  amount?: Maybe<Scalars['Float']>;
  period?: Maybe<DataPointPeriod>;
};

export type BillingOverviewAmountSummary = {
  __typename?: 'BillingOverviewAmountSummary';
  amount?: Maybe<Money>;
};

export type BillingOverviewHoursData = {
  __typename?: 'BillingOverviewHoursData';
  series?: Maybe<Array<Maybe<BillingOverviewHoursSeriesDataPoint>>>;
  summary?: Maybe<BillingOverviewHoursSummary>;
};

export type BillingOverviewHoursSeriesDataPoint = {
  __typename?: 'BillingOverviewHoursSeriesDataPoint';
  hours?: Maybe<Scalars['Float']>;
  period?: Maybe<DataPointPeriod>;
};

export type BillingOverviewHoursSummary = {
  __typename?: 'BillingOverviewHoursSummary';
  hours?: Maybe<Scalars['Float']>;
};

export type BillingRate = {
  __typename?: 'BillingRate';
  displayText: Scalars['String'];
  id: Scalars['String'];
};

export type BillingRateInput = {
  billingScheduleEntries?: InputMaybe<Array<InputMaybe<BillingScheduleEntryInput>>>;
  id: Scalars['String'];
  type?: InputMaybe<BillingRateType>;
};

export type BillingRateSchedulesResult = {
  __typename?: 'BillingRateSchedulesResult';
  billingRate?: Maybe<ProjectBillingRate>;
  id: Scalars['String'];
};

export enum BillingRateType {
  BillingRate = 'billingRate',
  ProjectRate = 'projectRate',
  UserRate = 'userRate'
}

export type BillingScheduleEntry = {
  __typename?: 'BillingScheduleEntry';
  effectiveDate?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  rate?: Maybe<Money>;
};

export type BillingScheduleEntryInput = {
  effectiveDate?: InputMaybe<Scalars['Date']>;
  rate?: InputMaybe<MoneyInput>;
};

export type BillingSettings = {
  __typename?: 'BillingSettings';
  billFrequency?: Maybe<BillingFrequency>;
  billFrequencyAbsoluteDate?: Maybe<Scalars['Date2']>;
  /** @deprecated Use billFrequencyAbsoluteDate */
  billFrequencyRelativeDate?: Maybe<Scalars['Date2']>;
  billLineItemsBy?: Maybe<Array<Maybe<LineItemColumnOptions>>>;
  consolidateBillsBy?: Maybe<ConsolidateBillsBy>;
  description?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  showComments?: Maybe<Scalars['Boolean']>;
};

export type BillingTransaction = {
  __typename?: 'BillingTransaction';
  balanceAmount?: Maybe<Money>;
  balanceStatus?: Maybe<BillingTransactionBalanceStatus>;
  balanceWithoutAllocationsAmount?: Maybe<Money>;
  billStatus?: Maybe<BillStatus>;
  client?: Maybe<ObjectReference>;
  description?: Maybe<Scalars['String']>;
  displayText?: Maybe<Scalars['String']>;
  draftSubStatus?: Maybe<ObjectReference>;
  dueDate?: Maybe<DueDate>;
  id: Scalars['String'];
  pastDueDays?: Maybe<Scalars['Int']>;
  period?: Maybe<BillPeriod>;
  tags?: Maybe<Array<Maybe<TagAssignment>>>;
  transactionDate?: Maybe<Scalars['String']>;
  type?: Maybe<BillingTransactionType>;
};

export type BillingTransactionActualsOverviewData = {
  __typename?: 'BillingTransactionActualsOverviewData';
  adhocInvoiceItemBillings?: Maybe<BillingOverviewAmountData>;
  billingItemBillings?: Maybe<BillingOverviewAmountData>;
  creditMemo?: Maybe<BillingOverviewAmountData>;
  invoiceItemOverrides?: Maybe<BillingOverviewAmountData>;
  outstanding?: Maybe<BillingOverviewAmountData>;
  payment?: Maybe<BillingOverviewAmountData>;
};

export enum BillingTransactionBalanceStatus {
  FullyAllocated = 'FULLY_ALLOCATED',
  PartiallyAllocated = 'PARTIALLY_ALLOCATED',
  Unallocated = 'UNALLOCATED'
}

export type BillingTransactionFilter = {
  balanceStatusList?: InputMaybe<Array<InputMaybe<BillingTransactionBalanceStatus>>>;
  billStatus?: InputMaybe<Array<InputMaybe<BillStatus>>>;
  billingTransactionUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clientUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateRange?: InputMaybe<BillingDateRangeInput>;
  draftSubStatusUris?: InputMaybe<Array<Scalars['String']>>;
  dueDate?: InputMaybe<BillingDateRangeInput>;
  isOverdue?: InputMaybe<Scalars['Boolean']>;
  programUri?: InputMaybe<Scalars['String']>;
  projectUri?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['BillingTransactionTagFilterInput']>>;
  transactionTypes?: InputMaybe<Array<InputMaybe<BillingTransactionType>>>;
};

export type BillingTransactionFilter2 = {
  balanceStatusList?: InputMaybe<Array<InputMaybe<BillingTransactionBalanceStatus>>>;
  billStatus?: InputMaybe<Array<InputMaybe<BillStatus>>>;
  billingTransactionUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clientUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateRange?: InputMaybe<BillingDateTimeRangeInput>;
  draftSubStatusUris?: InputMaybe<Array<Scalars['String']>>;
  dueDate?: InputMaybe<BillingDateTimeRangeInput>;
  isOverdue?: InputMaybe<Scalars['Boolean']>;
  programUri?: InputMaybe<Scalars['String']>;
  projectUri?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['BillingTransactionTagFilterInput']>>;
  transactionTypes?: InputMaybe<Array<InputMaybe<BillingTransactionType>>>;
};

export type BillingTransactionSort = {
  direction: SortDirection;
  field: BillingTransactionSortableFields;
};

export enum BillingTransactionSortableFields {
  BalanceAmount = 'balanceAmount',
  BalanceStatus = 'balanceStatus',
  BalanceWithoutAllocationsAmount = 'balanceWithoutAllocationsAmount',
  Client = 'client',
  Description = 'description',
  DisplayText = 'displayText',
  DueDate = 'dueDate',
  PastDueDays = 'pastDueDays',
  Period = 'period',
  TransactionDate = 'transactionDate',
  Type = 'type'
}

export type BillingTransactionSummaryResult = {
  __typename?: 'BillingTransactionSummaryResult';
  draftSummary?: Maybe<BillingTransactionTotal>;
  issuedSummary?: Maybe<BillingTransactionTotal>;
  outstandingBillSummary?: Maybe<BillingTransactionTotal>;
  overdueSummary?: Maybe<BillingTransactionTotal>;
  unallocatedSummary?: Maybe<BillingTransactionTotal>;
  voidBillSummary?: Maybe<BillingTransactionTotal>;
};

export type BillingTransactionTotal = {
  __typename?: 'BillingTransactionTotal';
  balanceAmount?: Maybe<Array<Maybe<Money>>>;
  balanceAmountInBaseCurrency?: Maybe<Money>;
  balanceWithoutAllocationsAmount?: Maybe<Array<Maybe<Money>>>;
  balanceWithoutAllocationsAmountInBaseCurrency?: Maybe<Money>;
  billAmount?: Maybe<Array<Maybe<Money>>>;
  creditMemoAmount?: Maybe<Array<Maybe<Money>>>;
  paymentAmount?: Maybe<Array<Maybe<Money>>>;
};

export enum BillingTransactionType {
  Bill = 'BILL',
  Creditmemo = 'CREDITMEMO',
  Payment = 'PAYMENT'
}

export type BillingType = {
  __typename?: 'BillingType';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
};

export type BillingTypeInput = {
  displayText?: InputMaybe<Scalars['String']>;
  uri?: InputMaybe<Scalars['String']>;
};

export enum BindingContext {
  Bill = 'BILL',
  Project = 'PROJECT',
  Task = 'TASK'
}

export type Budget = {
  __typename?: 'Budget';
  capital?: Maybe<Money>;
  operational?: Maybe<Money>;
  total?: Maybe<Money>;
};

export type BudgetInput = {
  capital?: InputMaybe<MoneyInput>;
  operational?: InputMaybe<MoneyInput>;
  total?: InputMaybe<MoneyInput>;
};

export type BulkAcceptAllocationsForResourceRequestError = {
  __typename?: 'BulkAcceptAllocationsForResourceRequestError';
  errorMessage: Scalars['String'];
  resourceRequestId: Scalars['String'];
};

export type BulkAcceptAllocationsForResourceRequestInput = {
  acceptAllocationInput: Array<AcceptAllocationForResourceRequestInput>;
};

export type BulkAcceptAllocationsForResourceRequestResult = {
  __typename?: 'BulkAcceptAllocationsForResourceRequestResult';
  acceptedResourceRequestAndAllocationsEntry: Array<AcceptAllocationForResourceRequestResult>;
  errors?: Maybe<Array<BulkAcceptAllocationsForResourceRequestError>>;
};

export type BulkAssignSkillToUserInput = {
  skills: Array<SkillInput>;
  userUri: Scalars['String'];
};

export type BulkAssignSkillToUserResult = {
  __typename?: 'BulkAssignSkillToUserResult';
  error?: Maybe<AssignSkillToUserErrors>;
  skills?: Maybe<Array<Maybe<ResourceSkillDetails>>>;
};

export type BulkAssignTasksToResourceUserInput = {
  projectId: Scalars['String'];
  resourceUserId: Scalars['String'];
  textSearch?: InputMaybe<Scalars['String']>;
};

export type BulkAssignTasksToResourceUserResult = {
  __typename?: 'BulkAssignTasksToResourceUserResult';
  failedTaskIds: Array<Scalars['String']>;
};

export type BulkCreateAndAssignSkillsToUserError = {
  __typename?: 'BulkCreateAndAssignSkillsToUserError';
  displayText: Scalars['String'];
  skill: SkillParameterError;
};

export type BulkCreateAndAssignSkillsToUserErrors = {
  __typename?: 'BulkCreateAndAssignSkillsToUserErrors';
  errors: Array<BulkCreateAndAssignSkillsToUserError>;
  userUri: Scalars['String'];
};

export type BulkCreateAndAssignSkillsToUserInput = {
  skills: Array<SkillParameter>;
  userUri: Scalars['String'];
};

export type BulkCreateAndAssignSkillsToUserResult = {
  __typename?: 'BulkCreateAndAssignSkillsToUserResult';
  error?: Maybe<BulkCreateAndAssignSkillsToUserErrors>;
  skills: Array<ResourceSkillDetails>;
};

export type BulkCreateNewProjectLinkError = {
  __typename?: 'BulkCreateNewProjectLinkError';
  baseProjectId?: Maybe<Scalars['String']>;
  notifications: Array<ValidationNotificationSummary>;
  targetProjectId?: Maybe<Scalars['String']>;
};

export type BulkCreateNewProjectLinkResult = {
  __typename?: 'BulkCreateNewProjectLinkResult';
  errors: Array<BulkCreateNewProjectLinkError>;
  projectLinks: Array<ProjectLink>;
};

export type BulkDeleteResourceRequestsInput = {
  resourceRequestIds: Array<Scalars['String']>;
};

export type BulkDeleteResourceRequestsResult = {
  __typename?: 'BulkDeleteResourceRequestsResult';
  resourceRequestIds: Array<Scalars['String']>;
};

export type BulkMarkResourceRequestsAsAllocationRejectedInput = {
  resourceRequestIds: Array<Scalars['String']>;
};

export type BulkMarkResourceRequestsAsAllocationRejectedResult = {
  __typename?: 'BulkMarkResourceRequestsAsAllocationRejectedResult';
  resourceRequests: Array<ResourceRequest>;
};

export type BulkMarkResourceRequestsAsCompleteInput = {
  resourceRequestIds: Array<Scalars['String']>;
};

export type BulkMarkResourceRequestsAsCompleteResult = {
  __typename?: 'BulkMarkResourceRequestsAsCompleteResult';
  resourceRequests: Array<ResourceRequest>;
};

export type BulkMarkResourceRequestsAsDraftInput = {
  resourceRequestIds: Array<Scalars['String']>;
};

export type BulkMarkResourceRequestsAsDraftResult = {
  __typename?: 'BulkMarkResourceRequestsAsDraftResult';
  resourceRequests: Array<ResourceRequest>;
};

export type BulkMarkResourceRequestsAsRejectedInput = {
  resourceRequestIds: Array<Scalars['String']>;
};

export type BulkMarkResourceRequestsAsRejectedResult = {
  __typename?: 'BulkMarkResourceRequestsAsRejectedResult';
  resourceRequests: Array<ResourceRequest>;
};

export type BulkMarkResourceRequestsAsSubmittedInput = {
  resourceRequestIds: Array<Scalars['String']>;
};

export type BulkMarkResourceRequestsAsSubmittedResult = {
  __typename?: 'BulkMarkResourceRequestsAsSubmittedResult';
  resourceRequests: Array<ResourceRequest>;
};

export type BulkMarkResourceRequestsAsTentativeInput = {
  resourceRequestIds: Array<Scalars['String']>;
};

export type BulkMarkResourceRequestsAsTentativeResult = {
  __typename?: 'BulkMarkResourceRequestsAsTentativeResult';
  resourceRequests: Array<ResourceRequest>;
};

export type BulkMarkResourceRequestsAsToBeHiredInput = {
  resourceRequestIds: Array<Scalars['String']>;
};

export type BulkMarkResourceRequestsAsToBeHiredResult = {
  __typename?: 'BulkMarkResourceRequestsAsToBeHiredResult';
  resourceRequests: Array<ResourceRequest>;
};

export type BulkProjectLinkTargetInput = {
  baseProjectId: Scalars['String'];
  linksToAdd: Array<LinkTargetInput>;
};

export type BulkProposeAllocationsForResourceRequestError = {
  __typename?: 'BulkProposeAllocationsForResourceRequestError';
  errorMessage: Scalars['String'];
  resourceRequestId: Scalars['String'];
};

export type BulkProposeAllocationsForResourceRequestInput = {
  proposedAllocationInput: Array<ProposeAllocationsForResourceRequestInput>;
};

export type BulkProposeAllocationsForResourceRequestResult = {
  __typename?: 'BulkProposeAllocationsForResourceRequestResult';
  errors?: Maybe<Array<BulkProposeAllocationsForResourceRequestError>>;
  proposedResourceRequestAndAllocationsEntry: Array<ProposeAllocationsForResourceRequestResult>;
};

export type BulkPutProjectStageResult = {
  __typename?: 'BulkPutProjectStageResult';
  projectIds: Array<Scalars['String']>;
};

export type BulkPutResourceRequestAllocationForUserEntry = {
  allocationUpdateBehaviour?: InputMaybe<AllocationUpdateBehaviour>;
  comment?: InputMaybe<Scalars['String']>;
  costCenterUri?: InputMaybe<Scalars['String']>;
  currencyUri?: InputMaybe<Scalars['String']>;
  departmentUri?: InputMaybe<Scalars['String']>;
  divisionUri?: InputMaybe<Scalars['String']>;
  employeeTypeUri?: InputMaybe<Scalars['String']>;
  isAdjustedLoading?: InputMaybe<Scalars['Boolean']>;
  load?: InputMaybe<Scalars['Float']>;
  locationUri?: InputMaybe<Scalars['String']>;
  preferredResourceUris?: InputMaybe<Array<Scalars['String']>>;
  quantity?: InputMaybe<Scalars['Int']>;
  requestAttributeWeights?: InputMaybe<RequestAttributeWeightsInput>;
  requestedLoad?: InputMaybe<Scalars['Float']>;
  requestedScheduleRules?: InputMaybe<Array<ScheduleRuleInput>>;
  requestedTotalHours?: InputMaybe<Scalars['Float']>;
  resourceAllocationId: Scalars['String'];
  resourcePoolUris?: InputMaybe<Array<Scalars['String']>>;
  resourceRequestId?: InputMaybe<Scalars['String']>;
  resourceRequestStatus?: InputMaybe<ResourceRequestStatus>;
  roleRate?: InputMaybe<Scalars['Float']>;
  roleUri?: InputMaybe<Scalars['String']>;
  scheduleRules: Array<ScheduleRuleInput>;
  serviceCenterUri?: InputMaybe<Scalars['String']>;
  skills?: InputMaybe<Array<RequestSkillInput>>;
  sourceMetadata?: InputMaybe<SourceMetadataInput>;
  tags?: InputMaybe<Array<RequestTagInput>>;
  totalHours?: InputMaybe<Scalars['Float']>;
};

export type BulkPutResourceRequestAllocationForUserInput = {
  allocationEntries: Array<BulkPutResourceRequestAllocationForUserEntry>;
  projectUri: Scalars['String'];
  user: ResourceAllocationUserInput;
};

export type BulkPutResourceRequestAllocationForUserResult = {
  __typename?: 'BulkPutResourceRequestAllocationForUserResult';
  resourceAllocations?: Maybe<Array<ResourceAllocation>>;
};

export type BulkPutUserCertificateError = {
  __typename?: 'BulkPutUserCertificateError';
  certificate: CertificateParameter;
  error: Error;
};

export type BulkPutUserCertificateInput = {
  certificates: Array<CertificateInput>;
  userUri: Scalars['String'];
};

export type BulkPutUserCertificateResult = {
  __typename?: 'BulkPutUserCertificateResult';
  certificates: Array<Certificate>;
  errors: Array<BulkPutUserCertificateError>;
};

export type BulkReleaseResourceAllocationsInput = {
  allocationIds: Array<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  releaseBehaviorOptions?: InputMaybe<ReleaseBehaviorOptions>;
  releaseDate?: InputMaybe<Scalars['Date']>;
  releaseType: ReleaseResourceAllocationType;
  sendNotification?: InputMaybe<Scalars['Boolean']>;
};

export type BulkReleaseResourceAllocationsResult = {
  __typename?: 'BulkReleaseResourceAllocationsResult';
  resourceAllocations: Array<ResourceAllocation>;
  resourceRequests?: Maybe<Array<Maybe<ResourceRequest>>>;
};

export type BulkReleaseTaskOwnershipInput = {
  projectId: Scalars['String'];
  taskIds: Array<Scalars['String']>;
  taskOwnerId: Scalars['String'];
};

export type BulkReleaseTaskOwnershipResult = {
  __typename?: 'BulkReleaseTaskOwnershipResult';
  failedTaskIds?: Maybe<Array<Scalars['String']>>;
  succeededTaskIds?: Maybe<Array<Scalars['String']>>;
};

export type BulkResourcePlanUserActualSeriesByRoleResponse = {
  __typename?: 'BulkResourcePlanUserActualSeriesByRoleResponse';
  actualSeriesByRole: Array<ResourceUserActualSeriesByProjectRole>;
  user: UserReference;
};

export type BulkUnassignTasksToResourceUserInput = {
  projectId: Scalars['String'];
  resourceUserId: Scalars['String'];
  textSearch?: InputMaybe<Scalars['String']>;
};

export type BulkUnassignTasksToResourceUserResult = {
  __typename?: 'BulkUnassignTasksToResourceUserResult';
  failedTaskIds: Array<Scalars['String']>;
  isResourceAllocationSynced: Scalars['Boolean'];
  syncedResourceAllocation?: Maybe<ResourceAllocation>;
};

export type BulkUpdateAvailableResourcePoolsForUserInput = {
  resourcePoolUris: Array<Scalars['String']>;
  userUri: Scalars['String'];
};

export type Calendar = {
  __typename?: 'Calendar';
  displayText?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type CancelClosedHiringResourceRequestInput = {
  resourceRequestId: Scalars['String'];
};

export type CancelClosedHiringResourceRequestResult = {
  __typename?: 'CancelClosedHiringResourceRequestResult';
  resourceRequest: ResourceRequest;
};

export type CancelDeletedHiringResourceRequestInput = {
  resourceRequestId: Scalars['String'];
};

export type CancelDeletedHiringResourceRequestResult = {
  __typename?: 'CancelDeletedHiringResourceRequestResult';
  resourceRequest: ResourceRequest;
};

export enum CarryOverType {
  Carryover = 'CARRYOVER',
  Deferred = 'DEFERRED'
}

export type Category = {
  __typename?: 'Category';
  displayText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type CategoryInput = {
  category?: InputMaybe<UserSkillCategoryInput>;
  certificate?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  skillCustomMetadata?: InputMaybe<Array<InputMaybe<CustomMetadataInput>>>;
  skillLevelUri?: InputMaybe<Scalars['String']>;
  skillUri?: InputMaybe<Scalars['String']>;
};

export type Certificate = {
  __typename?: 'Certificate';
  credentialId?: Maybe<Scalars['String']>;
  credentialUrl?: Maybe<Scalars['String']>;
  expires?: Maybe<Scalars['Boolean']>;
  expiryDate?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  issueDate?: Maybe<Scalars['Date']>;
  issuer?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  uri: Scalars['String'];
};

export type CertificateInput = {
  credentialId?: InputMaybe<Scalars['String']>;
  credentialUrl?: InputMaybe<Scalars['String']>;
  expires?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['String']>;
  issueDate?: InputMaybe<Scalars['Date']>;
  issuer?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  uri?: InputMaybe<Scalars['String']>;
};

export type CertificateParameter = {
  __typename?: 'CertificateParameter';
  credentialId?: Maybe<Scalars['String']>;
  credentialUrl?: Maybe<Scalars['String']>;
  expires?: Maybe<Scalars['Boolean']>;
  expiryDate?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['String']>;
  issueDate?: Maybe<Scalars['Date']>;
  issuer?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
};

export type ChangeResourceUserInput = {
  asOfDate?: InputMaybe<Scalars['Date2']>;
  existingResourceUserId: Scalars['String'];
  modificationType: ChangeResourceUserModificationType;
  newResourceUserId: Scalars['String'];
  projectId: Scalars['String'];
};

export enum ChangeResourceUserModificationType {
  Asof = 'ASOF',
  Entirely = 'ENTIRELY'
}

export type ChangeResourceUserResult = {
  __typename?: 'ChangeResourceUserResult';
  newResourceAllocationId?: Maybe<Scalars['String']>;
};

export type ChangeResourceUserTaskAssignmentSummaryResult = {
  __typename?: 'ChangeResourceUserTaskAssignmentSummaryResult';
  hasTaskAssignmentConflict: Scalars['Boolean'];
};

export type ChangeTaskResourceResult = {
  __typename?: 'ChangeTaskResourceResult';
  taskResourceEstimateId: Scalars['String'];
  taskResourceUserAllocationId?: Maybe<Scalars['String']>;
};

export enum ChangeTaskResourceUserAllocationMode {
  RemoveAllocation = 'REMOVE_ALLOCATION'
}

export type ChangeTaskResourceUserInput = {
  allocationMode?: InputMaybe<ChangeTaskResourceUserAllocationMode>;
  existingResourceUserId: Scalars['String'];
  hoursToAllocate?: InputMaybe<Scalars['Float']>;
  newResourceUserId: Scalars['String'];
  projectId: Scalars['String'];
  taskId: Scalars['String'];
};

export enum Channels {
  Email = 'EMAIL',
  Push = 'PUSH',
  Web = 'WEB'
}

export type Client = {
  __typename?: 'Client';
  billPlanOverview2?: Maybe<Scalars['BillPlansOverviewData']>;
  billPlanOverview3?: Maybe<BillPlansOverviewData2>;
  billingContactInfo?: Maybe<ContactInfo>;
  billingOverview2?: Maybe<BillingOverview>;
  billingSettings?: Maybe<BillingSettings>;
  canBeDeleted?: Maybe<Scalars['Boolean']>;
  clientManager?: Maybe<ClientManager>;
  clientRepresentatives?: Maybe<Array<Maybe<User>>>;
  code?: Maybe<Scalars['String']>;
  comanagers?: Maybe<Array<Maybe<User>>>;
  comment?: Maybe<Scalars['String']>;
  contactInfo?: Maybe<ContactInfo>;
  contactName?: Maybe<Scalars['String']>;
  costAmountSummary?: Maybe<ClientCostAmountSummary>;
  costSeriesData?: Maybe<CostSeriesData>;
  customFieldValues?: Maybe<Array<Maybe<CustomFieldValue>>>;
  defaultInvoicePaymentTerm?: Maybe<Scalars['Int']>;
  displayText?: Maybe<Scalars['String']>;
  estimatedCompletionDate?: Maybe<Scalars['Date']>;
  estimatedCompletionDate2?: Maybe<Scalars['Date2']>;
  hourSeriesData?: Maybe<Array<Maybe<HoursDataPoint>>>;
  id?: Maybe<Scalars['String']>;
  invoiceCurrency?: Maybe<Currency>;
  invoiceTemplate?: Maybe<InvoiceTemplate>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  permittedActionUris?: Maybe<Array<Maybe<Scalars['String']>>>;
  projectCount?: Maybe<Scalars['Int']>;
  /** @deprecated Use projectRate2, no longer uses Date scalar */
  projectRate?: Maybe<ClientRate>;
  projectRate2?: Maybe<ClientRate>;
  projectsStatusCountSummary?: Maybe<ProjectsStatusCountSummary>;
  revenueAmountSummary?: Maybe<ClientRevenueAmountSummary>;
  /** @deprecated Use roleRates2, no longer uses Date scalar */
  roleRates?: Maybe<Array<Maybe<ClientRate>>>;
  roleRates2?: Maybe<Array<Maybe<ClientRate>>>;
  /** @deprecated Use roleRatesCount2, no longer uses Date scalar */
  roleRatesCount?: Maybe<Scalars['Int']>;
  roleRatesCount2?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  taxProfile?: Maybe<TaxProfile>;
  timeEnteredSummary?: Maybe<ClientTimeEnteredSummary>;
  totalActualBilling?: Maybe<Money>;
  totalActualCost?: Maybe<Money>;
  totalActualExpenseCost?: Maybe<Money>;
  totalActualHours?: Maybe<Scalars['Float']>;
  totalActualResourceCost?: Maybe<Money>;
  totalActualRevenue?: Maybe<Money>;
  totalEstimatedBilling?: Maybe<Money>;
  totalEstimatedCost?: Maybe<Money>;
  totalEstimatedHours?: Maybe<Scalars['Float']>;
  uri?: Maybe<Scalars['String']>;
  /** @deprecated Use userRates2, no longer uses Date scalar */
  userRates?: Maybe<Array<Maybe<ClientRate>>>;
  userRates2?: Maybe<Array<Maybe<ClientRate>>>;
  /** @deprecated Use userRatesCount2, no longer uses Date scalar */
  userRatesCount?: Maybe<Scalars['Int']>;
  userRatesCount2?: Maybe<Scalars['Int']>;
};


export type ClientBillPlanOverview2Args = {
  dateRange?: InputMaybe<DateRangeInput2>;
  overviewMode: BillPlanOverviewMode;
  periodResolutionUri?: InputMaybe<Scalars['String']>;
};


export type ClientBillPlanOverview3Args = {
  dateRange?: InputMaybe<DateRangeInput2>;
  overviewMode: BillPlanOverviewMode;
  periodResolutionUri?: InputMaybe<Scalars['String']>;
};


export type ClientBillingOverview2Args = {
  dateRange?: InputMaybe<DateRangeInput2>;
  periodResolutionUri?: InputMaybe<Scalars['String']>;
};


export type ClientCostAmountSummaryArgs = {
  dateRange?: InputMaybe<DateTimeRangeInput>;
};


export type ClientCostSeriesDataArgs = {
  dateRange?: InputMaybe<DateTimeRangeInput>;
};


export type ClientHourSeriesDataArgs = {
  dateRange?: InputMaybe<DateTimeRangeInput>;
};


export type ClientProjectRateArgs = {
  effectiveDate?: InputMaybe<Scalars['DateObject']>;
  effectiveDateRange?: InputMaybe<DateRangeInput>;
};


export type ClientProjectRate2Args = {
  effectiveDate?: InputMaybe<Scalars['Date2']>;
  effectiveDateRange?: InputMaybe<DateRangeInput2>;
};


export type ClientRevenueAmountSummaryArgs = {
  dateRange?: InputMaybe<DateTimeRangeInput>;
};


export type ClientRoleRatesArgs = {
  effectiveDate?: InputMaybe<Scalars['DateObject']>;
  effectiveDateRange?: InputMaybe<DateRangeInput>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type ClientRoleRates2Args = {
  effectiveDate?: InputMaybe<Scalars['Date2']>;
  effectiveDateRange?: InputMaybe<DateRangeInput2>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type ClientRoleRatesCountArgs = {
  effectiveDateRange?: InputMaybe<DateRangeInput>;
};


export type ClientRoleRatesCount2Args = {
  effectiveDateRange?: InputMaybe<DateRangeInput2>;
};


export type ClientTimeEnteredSummaryArgs = {
  dateRange?: InputMaybe<DateTimeRangeInput>;
};


export type ClientUserRatesArgs = {
  effectiveDate?: InputMaybe<Scalars['DateObject']>;
  effectiveDateRange?: InputMaybe<DateRangeInput>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type ClientUserRates2Args = {
  effectiveDate?: InputMaybe<Scalars['Date2']>;
  effectiveDateRange?: InputMaybe<DateRangeInput2>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type ClientUserRatesCountArgs = {
  effectiveDateRange?: InputMaybe<DateRangeInput>;
};


export type ClientUserRatesCount2Args = {
  effectiveDateRange?: InputMaybe<DateRangeInput2>;
};

export type ClientBillingAllocation = {
  __typename?: 'ClientBillingAllocation';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
};

export type ClientBillingAllocationInput = {
  displayText?: InputMaybe<Scalars['String']>;
  uri?: InputMaybe<Scalars['String']>;
};

export enum ClientBillingSettings {
  BillingContactInfo = 'billingContactInfo',
  BillingSettings = 'billingSettings',
  DefaultInvoicePaymentTerm = 'defaultInvoicePaymentTerm',
  InvoiceCurrency = 'invoiceCurrency',
  InvoiceTemplate = 'invoiceTemplate'
}

export type ClientCostAllocation = {
  __typename?: 'ClientCostAllocation';
  client?: Maybe<ClientReference>;
  costAllocationPercentage?: Maybe<Scalars['Float']>;
};

export type ClientCostAmountSummary = {
  __typename?: 'ClientCostAmountSummary';
  costActual?: Maybe<Money>;
  costTotalEstimated?: Maybe<Money>;
};

export type ClientDetailsInput = {
  displayText?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type ClientFilter = {
  clientManagers?: InputMaybe<Array<Scalars['String']>>;
  clients?: InputMaybe<Array<Scalars['String']>>;
  dateRange?: InputMaybe<DateRangeInput>;
  includeMyClientsOnly?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type ClientFilter2 = {
  clientManagers?: InputMaybe<Array<Scalars['String']>>;
  clients?: InputMaybe<Array<Scalars['String']>>;
  dateRange?: InputMaybe<DateRangeInput2>;
  includeMyClientsOnly?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type ClientInput = {
  client?: InputMaybe<ClientDetailsInput>;
  costAllocationPercentage?: InputMaybe<Scalars['Float']>;
};

export type ClientManager = {
  __typename?: 'ClientManager';
  displayText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type ClientRate = {
  __typename?: 'ClientRate';
  billingScheduleEntries?: Maybe<Array<Maybe<RateScheduleEntry>>>;
  companyBillingRateReference?: Maybe<ObjectReference>;
  costScheduleEntries?: Maybe<Array<Maybe<RateScheduleEntry>>>;
  effectiveBillingRate: RateScheduleEntry;
  effectiveBillingRate2: RateScheduleEntry;
  id: Scalars['String'];
  rateType: RateType;
  roleReference?: Maybe<ObjectReference>;
  userReference?: Maybe<ObjectReference>;
};


export type ClientRateEffectiveBillingRateArgs = {
  effectiveDateRange: DateRangeInput;
};


export type ClientRateEffectiveBillingRate2Args = {
  effectiveDateRange: DateRangeInput2;
};

export type ClientRate2 = {
  __typename?: 'ClientRate2';
  billingScheduleEntries?: Maybe<Array<Maybe<RateScheduleEntry>>>;
  costScheduleEntries?: Maybe<Array<Maybe<RateScheduleEntry>>>;
  id: Scalars['String'];
  rateType: RateType;
  roleReference?: Maybe<ObjectReference>;
  userReference?: Maybe<ObjectReference>;
};

export type ClientReference = {
  __typename?: 'ClientReference';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type ClientReferencesList = ListResults & {
  __typename?: 'ClientReferencesList';
  items?: Maybe<Array<Maybe<ClientReference>>>;
  totalItems?: Maybe<Scalars['Int']>;
};

export type ClientRepresentative = {
  __typename?: 'ClientRepresentative';
  displayText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loginName?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type ClientRepresentativeInput = {
  displayText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  loginName?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type ClientRevenueAmountSummary = {
  __typename?: 'ClientRevenueAmountSummary';
  revenueActual?: Maybe<Money>;
};

export type ClientSchedule = {
  __typename?: 'ClientSchedule';
  clients?: Maybe<Array<Maybe<ClientCostAllocation>>>;
};

export type ClientScheduleInput = {
  clients?: InputMaybe<Array<InputMaybe<ClientInput>>>;
};

export type ClientSort = {
  direction: SortDirection;
  field: ClientSortableFields;
};

export enum ClientSortableFields {
  ClientManager = 'clientManager',
  Code = 'code',
  EstimatedCompletionDate = 'estimatedCompletionDate',
  IsActive = 'isActive',
  Name = 'name',
  ProjectCount = 'projectCount',
  TaxProfile = 'taxProfile',
  TotalActualBilling = 'totalActualBilling',
  TotalActualCost = 'totalActualCost',
  TotalActualExpenseCost = 'totalActualExpenseCost',
  TotalActualHours = 'totalActualHours',
  TotalActualResourceCost = 'totalActualResourceCost',
  TotalActualRevenue = 'totalActualRevenue',
  TotalEstimatedBilling = 'totalEstimatedBilling',
  TotalEstimatedCost = 'totalEstimatedCost',
  TotalEstimatedHours = 'totalEstimatedHours'
}

export type ClientTimeEnteredSummary = {
  __typename?: 'ClientTimeEnteredSummary';
  timeEnteredActual?: Maybe<Scalars['Float']>;
  timeEnteredTotalEstimated?: Maybe<Scalars['Float']>;
};

export type ClientTotals = {
  __typename?: 'ClientTotals';
  projectCount?: Maybe<Scalars['Int']>;
  totalActualBilling?: Maybe<Money>;
  totalActualCost?: Maybe<Money>;
  totalActualExpenseCost?: Maybe<Money>;
  totalActualHours?: Maybe<Scalars['Float']>;
  totalActualResourceCost?: Maybe<Money>;
  totalActualRevenue?: Maybe<Money>;
  totalEstimatedBilling?: Maybe<Money>;
  totalEstimatedCost?: Maybe<Money>;
  totalEstimatedHours?: Maybe<Scalars['Float']>;
};

export type ClientWithOverEstimatedProjectsCount = {
  __typename?: 'ClientWithOverEstimatedProjectsCount';
  client: ClientReference;
  projectsCount: Scalars['Int'];
};

export type ClientWithOverEstimatedProjectsList = ListResults & {
  __typename?: 'ClientWithOverEstimatedProjectsList';
  items?: Maybe<Array<Maybe<ClientWithOverEstimatedProjectsCount>>>;
  totalItems?: Maybe<Scalars['Int']>;
};

export type ClientsAllocation = {
  client?: InputMaybe<CopiedClientInput>;
  costAllocationPercentage?: InputMaybe<Scalars['Float']>;
};

export type ClientsList = ListResults & {
  __typename?: 'ClientsList';
  items?: Maybe<Array<Maybe<Client>>>;
  totalItems?: Maybe<Scalars['Int']>;
};

export type CloseTaskInput = {
  taskId: Scalars['String'];
};

export type CloseTaskResult = {
  __typename?: 'CloseTaskResult';
  task?: Maybe<Task>;
};

export type ColumnNameOverrides = {
  column: Scalars['String'];
  name: Scalars['String'];
};

export enum Columns {
  Billableamount = 'billableamount',
  Billablehours = 'billablehours',
  Client = 'client',
  CostType = 'costType',
  Costamount = 'costamount',
  Entrydate = 'entrydate',
  Expenseamount = 'expenseamount',
  Invoice = 'invoice',
  IsBillable = 'isBillable',
  Resourcecostamount = 'resourcecostamount',
  Task = 'task',
  Username = 'username'
}

export enum ConsolidateBillsBy {
  Client = 'CLIENT',
  Project = 'PROJECT'
}

export type Contact = {
  __typename?: 'Contact';
  contactType: ContactType;
  email?: Maybe<Scalars['String']>;
  faxNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type ContactInfo = {
  __typename?: 'ContactInfo';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<ContactInfoCountry>;
  email?: Maybe<Scalars['String']>;
  faxNumber?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  stateProvince?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  zipPostalCode?: Maybe<Scalars['String']>;
};

export type ContactInfoCountry = {
  __typename?: 'ContactInfoCountry';
  displayText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type ContactInfoInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryUri?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  faxNumber?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  stateProvince?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  zipPostalCode?: InputMaybe<Scalars['String']>;
};

export type ContactInput = {
  contactType: ContactType;
  email?: InputMaybe<Scalars['String']>;
  faxNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export enum ContactType {
  Billing = 'BILLING',
  Others = 'OTHERS',
  Primary = 'PRIMARY'
}

export type ContractClause = {
  __typename?: 'ContractClause';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  parameters?: Maybe<Array<Maybe<Scalars['ProjectScriptParameter']>>>;
  script?: Maybe<Script>;
};

export type CopiedClientInput = {
  uri?: InputMaybe<Scalars['String']>;
};

export type CopyProjectBatchResult = {
  __typename?: 'CopyProjectBatchResult';
  batchId?: Maybe<Scalars['String']>;
  jobId?: Maybe<Scalars['String']>;
};

export type CostAmountSummary = {
  __typename?: 'CostAmountSummary';
  costActual?: Maybe<Money>;
  costTotalEstimated?: Maybe<Money>;
};

export type CostDataPoint = {
  __typename?: 'CostDataPoint';
  costAmountActual?: Maybe<Scalars['Float']>;
  costAmountEstimated?: Maybe<Scalars['Float']>;
  period?: Maybe<DataPointPeriod>;
};

export type CostSeriesData = {
  __typename?: 'CostSeriesData';
  currency?: Maybe<Currency>;
  dataPoints?: Maybe<Array<Maybe<CostDataPoint>>>;
};

export type CostSeriesInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  periodResolutionOption?: InputMaybe<PeriodResolutionOption>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type CostType = {
  __typename?: 'CostType';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
};

export type CostTypeInput = {
  displayText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Country = {
  __typename?: 'Country';
  displayText: Scalars['String'];
  id: Scalars['String'];
};

export type CountryInput = {
  displayText: Scalars['String'];
  id: Scalars['String'];
};

export type CreateBillFromBillingItemsBatchExecutionResult = {
  __typename?: 'CreateBillFromBillingItemsBatchExecutionResult';
  billId?: Maybe<Scalars['String']>;
};

export type CreateBillFromBillingItemsResult = {
  __typename?: 'CreateBillFromBillingItemsResult';
  billUri: Scalars['String'];
};

export type CreateBulkBillFromBillingItemsBatchResult = {
  __typename?: 'CreateBulkBillFromBillingItemsBatchResult';
  displayId: Scalars['String'];
  id: Scalars['String'];
};

export type CreateBulkInvoiceFromBillingItemsBatchInput = {
  allowEmptyInvoice: Scalars['Boolean'];
  billFromBillingItemsBatchParameter: LineItemsFromBillingItemsBatchInput2;
  billInput: BillInput3;
};

export type CreateBulkInvoiceFromBillingItemsBatchResult = {
  __typename?: 'CreateBulkInvoiceFromBillingItemsBatchResult';
  batchUri: Scalars['String'];
};

export type CreateFulfillResourceAllocationInput = {
  comment?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  load: Scalars['Float'];
  scheduleRules?: InputMaybe<Array<ScheduleRuleInput>>;
  user: ResourceAllocationUserInput;
};

export type CreateFulfillResourceRequestInput = {
  overrideAllocationWithSmartFitScheduleRules?: InputMaybe<FulfillAllocationResourceWithSmartFit>;
  resourceAllocationsInput?: InputMaybe<Array<InputMaybe<CreateFulfillResourceAllocationInput>>>;
  resourceRequestInput: CreateResourceRequestInput;
};

export type CreateFulfillResourceRequestResult = {
  __typename?: 'CreateFulfillResourceRequestResult';
  resourceRequest: ResourceRequest;
};

export type CreateFulfilledResourceAllocationWithoutResourceRequestInput = {
  allocationHoursInDateRange?: InputMaybe<AllocationHoursInDateRangeInput>;
  id: Scalars['String'];
  load?: InputMaybe<Scalars['Float']>;
  projectUri: Scalars['String'];
  requestedRoleUri?: InputMaybe<Scalars['String']>;
  scheduleRules?: InputMaybe<Array<ScheduleRuleInput>>;
  user: ResourceAllocationUserInput;
};

export type CreateFulfilledResourceAllocationWithoutResourceRequestResult = {
  __typename?: 'CreateFulfilledResourceAllocationWithoutResourceRequestResult';
  resourceAllocation: ResourceAllocation;
};

export type CreateInvoiceItemsFromBillingItemsBatchResult = {
  __typename?: 'CreateInvoiceItemsFromBillingItemsBatchResult';
  batchUri: Scalars['String'];
};

export type CreateProjectBillingContractScriptRecalculationBatchResult = {
  __typename?: 'CreateProjectBillingContractScriptRecalculationBatchResult';
  batchUri: Scalars['String'];
};

export type CreateProjectDeleteBatchResult = {
  __typename?: 'CreateProjectDeleteBatchResult';
  batchUri: Scalars['String'];
};

export type CreateProjectRevenuePolicyScriptRecalculationBatchResult = {
  __typename?: 'CreateProjectRevenuePolicyScriptRecalculationBatchResult';
  batchUri: Scalars['String'];
};

export type CreateResourceAllocationInput = {
  comment?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isAdjustedLoading?: InputMaybe<Scalars['Boolean']>;
  load: Scalars['Float'];
  matchScore?: InputMaybe<Scalars['Float']>;
  matchScoreDimensions?: InputMaybe<MatchScoreDimensionsInput>;
  projectUri: Scalars['String'];
  requestedRoleUri?: InputMaybe<Scalars['String']>;
  resourceRequestId: Scalars['String'];
  scheduleRules: Array<ScheduleRuleInput>;
  totalHours?: InputMaybe<Scalars['Float']>;
  user: ResourceAllocationUserInput;
};

export type CreateResourceAllocationResult = {
  __typename?: 'CreateResourceAllocationResult';
  resourceAllocation: ResourceAllocation;
};

export type CreateResourceRequestInput = {
  comment?: InputMaybe<Scalars['String']>;
  costCenterUri?: InputMaybe<Scalars['String']>;
  currencyUri?: InputMaybe<Scalars['String']>;
  departmentUri?: InputMaybe<Scalars['String']>;
  divisionUri?: InputMaybe<Scalars['String']>;
  employeeTypeUri?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isAdjustedLoading?: InputMaybe<Scalars['Boolean']>;
  load?: InputMaybe<Scalars['Float']>;
  locationUri?: InputMaybe<Scalars['String']>;
  preferredResourceUris?: InputMaybe<Array<Scalars['String']>>;
  projectUri: Scalars['String'];
  quantity: Scalars['Int'];
  requestAttributeWeights?: InputMaybe<RequestAttributeWeightsInput>;
  resourcePoolUris?: InputMaybe<Array<Scalars['String']>>;
  roleRate?: InputMaybe<Scalars['Float']>;
  roleUri?: InputMaybe<Scalars['String']>;
  scheduleRules: Array<ScheduleRuleInput>;
  serviceCenterUri?: InputMaybe<Scalars['String']>;
  skills?: InputMaybe<Array<InputMaybe<RequestSkillInput>>>;
  sourceMetadata?: InputMaybe<SourceMetadataInput>;
  tags?: InputMaybe<Array<InputMaybe<RequestTagInput>>>;
  totalHours?: InputMaybe<Scalars['Float']>;
};

export type CreateResourceRequestResult = {
  __typename?: 'CreateResourceRequestResult';
  resourceRequest: ResourceRequest;
};

export type CreateRevenueRunBatchResult = {
  __typename?: 'CreateRevenueRunBatchResult';
  batchUri?: Maybe<Scalars['String']>;
};

export type CreateTaskInput = {
  assignedRoleUri?: InputMaybe<Scalars['String']>;
  assignedUserRoleId?: InputMaybe<Scalars['String']>;
  assignedUserUri?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  costTypeUri?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<Array<InputMaybe<Scalars['CustomFieldValueInput']>>>;
  description?: InputMaybe<Scalars['String']>;
  doNotCopyParentTaskResourceAllocations?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['Date']>;
  estimatedCost?: InputMaybe<MoneyInput>;
  estimatedHours?: InputMaybe<Scalars['Float']>;
  extensionFieldValues?: InputMaybe<Array<InputMaybe<ExtensionFieldValueInput>>>;
  isMilestone?: InputMaybe<Scalars['Boolean']>;
  isTimeEntryAllowed?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parentUri: Scalars['String'];
  resourceAllocations?: InputMaybe<Array<TaskResourceAllocationInput>>;
  resourceEstimates?: InputMaybe<Array<CreateTaskTaskResourceEstimateInput>>;
  shouldRollupTaskDates?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['Date']>;
  timeAndExpenseEntryTypeUri?: InputMaybe<Scalars['String']>;
  timesheetAccessUris?: InputMaybe<TaskTimesheetAccessInput>;
};

export type CreateTaskResourceUserAllocationInput = {
  /** TODO: Remove ScheduleRules, allocationHours and dateRange must be required */
  allocationHours?: InputMaybe<Scalars['Float']>;
  allocationUserUri: Scalars['String'];
  dateRange?: InputMaybe<DateRangeInput2>;
  projectUri: Scalars['String'];
  roleUri?: InputMaybe<Scalars['String']>;
  scheduleRules?: InputMaybe<Array<ScheduleRuleInput>>;
  taskAllocationId: Scalars['String'];
  taskUri: Scalars['String'];
};

export type CreateTaskResourceUserAllocationResult = {
  __typename?: 'CreateTaskResourceUserAllocationResult';
  syncedResourceAllocation?: Maybe<ResourceAllocation>;
  taskResourceUserAllocation: TaskResourceUserAllocation;
};

export type CreateTaskResult = {
  __typename?: 'CreateTaskResult';
  error?: Maybe<Error>;
  task?: Maybe<TaskReference>;
};

export type CreateTaskTaskResourceEstimateInput = {
  addTaskAllocation?: InputMaybe<Scalars['Boolean']>;
  initialEstimatedHours?: InputMaybe<Scalars['Float']>;
  projectRoleId?: InputMaybe<Scalars['String']>;
  resourceUserId?: InputMaybe<Scalars['String']>;
};

export type CreditMemo = {
  __typename?: 'CreditMemo';
  associatedBills?: Maybe<GetPageOfAssociatedBillsForCreditMemoResponse>;
  balanceStatus?: Maybe<BillingTransactionBalanceStatus>;
  client: ObjectReference;
  /** @deprecated Use creditDate2 */
  creditDate: Scalars['DateObject'];
  creditDate2: Scalars['Date2'];
  currency: Currency;
  description?: Maybe<Scalars['String']>;
  displayId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lineItems?: Maybe<GetPageOfLineItemsForCreditMemoResponse>;
};


export type CreditMemoAssociatedBillsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type CreditMemoLineItemsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type CreditMemoInput2 = {
  associatedBills?: InputMaybe<Array<InputMaybe<BillToCreditMemoAssociationInput>>>;
  clientUri: Scalars['String'];
  creditDate: Scalars['Date2'];
  currencyUri: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  displayId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lineItems?: InputMaybe<Array<InputMaybe<CreditMemoLineItemInput>>>;
};

export type CreditMemoLineItem = {
  __typename?: 'CreditMemoLineItem';
  amount?: Maybe<Money>;
  hasAccessToLineItemProject?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  project?: Maybe<ObjectReference>;
};

export type CreditMemoLineItemInput = {
  amount?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  projectUri?: InputMaybe<Scalars['String']>;
};

export type CreditMemosForBillInput = {
  associatedCreditMemos?: InputMaybe<Array<InputMaybe<BillToCreditMemoAssociationInput>>>;
  billId: Scalars['String'];
};

export enum CropType {
  Manual = 'MANUAL',
  Smartcrop = 'SMARTCROP'
}

export type Currency = {
  __typename?: 'Currency';
  displayText?: Maybe<Scalars['String']>;
  exchangeRates: Array<Maybe<ExchangeRate>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};


export type CurrencyExchangeRatesArgs = {
  asOfDate: Scalars['Date'];
  otherCurrencyIds: Array<InputMaybe<Scalars['String']>>;
};

export type CurrencyInput = {
  displayText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  symbol?: InputMaybe<Scalars['String']>;
  uri?: InputMaybe<Scalars['String']>;
};

export type CustomFieldDateConfiguration = {
  __typename?: 'CustomFieldDateConfiguration';
  defaults?: Maybe<CustomFieldDateDefaultsConfiguration>;
  maximumDate?: Maybe<Scalars['Date']>;
  minimumDate?: Maybe<Scalars['Date']>;
};

export type CustomFieldDateDefaultsConfiguration = {
  __typename?: 'CustomFieldDateDefaultsConfiguration';
  useTodayAsDefault?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Date']>;
};

export type CustomFieldDefinition = {
  __typename?: 'CustomFieldDefinition';
  dateConfiguration?: Maybe<CustomFieldDateConfiguration>;
  defaultDropDownValue?: Maybe<CustomFieldDropdownOption>;
  displayText?: Maybe<Scalars['String']>;
  dropDownOptions?: Maybe<Array<Maybe<CustomFieldDropdownOption>>>;
  group?: Maybe<CustomFieldGroup>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  isRequired?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  numericConfiguration?: Maybe<CustomFieldNumericConfiguration>;
  textConfiguration?: Maybe<CustomFieldTextConfiguration>;
  type?: Maybe<CustomFieldType>;
  uri?: Maybe<Scalars['String']>;
};

export type CustomFieldDefinitionReference = {
  __typename?: 'CustomFieldDefinitionReference';
  displayText?: Maybe<Scalars['String']>;
  groupUri?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type CustomFieldDropdownOption = {
  __typename?: 'CustomFieldDropdownOption';
  displayText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDefaultValue?: Maybe<Scalars['Boolean']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  uri?: Maybe<Scalars['String']>;
};

export type CustomFieldGroup = {
  __typename?: 'CustomFieldGroup';
  displayText?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type CustomFieldNumericConfiguration = {
  __typename?: 'CustomFieldNumericConfiguration';
  decimalPlaces?: Maybe<Scalars['Int']>;
  defaultNumericValue?: Maybe<Scalars['Float']>;
  maximumNumericValue?: Maybe<Scalars['Float']>;
  minimumNumericValue?: Maybe<Scalars['Float']>;
};

export type CustomFieldTextConfiguration = {
  __typename?: 'CustomFieldTextConfiguration';
  defaultTextValue?: Maybe<Scalars['String']>;
  maximumLength?: Maybe<Scalars['Int']>;
};

export type CustomFieldType = {
  __typename?: 'CustomFieldType';
  displayText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type CustomFieldValue = {
  __typename?: 'CustomFieldValue';
  customField?: Maybe<CustomFieldDefinitionReference>;
  customFieldDefinition?: Maybe<CustomFieldDefinition>;
  customFieldType?: Maybe<CustomFieldType>;
  date?: Maybe<Scalars['Date']>;
  dropDownOptionUri?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Float']>;
  text?: Maybe<Scalars['String']>;
};

export type CustomMetadataInput = {
  date?: InputMaybe<Scalars['Date']>;
  displayText?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Float']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  uri?: InputMaybe<Scalars['String']>;
};

export type CustomMetadataInput2 = {
  date?: InputMaybe<Scalars['Date2']>;
  displayText?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Float']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  uri: Scalars['String'];
};

export type CustomProjectStatusName = {
  __typename?: 'CustomProjectStatusName';
  slug: Scalars['String'];
  text: Scalars['String'];
  uri: Scalars['String'];
};

export type CustomTerm = {
  __typename?: 'CustomTerm';
  customTerm?: Maybe<Scalars['String']>;
  originalTerm?: Maybe<Scalars['String']>;
};

export type DailyAllocationHoursSummaryForDateRangeResponse = {
  __typename?: 'DailyAllocationHoursSummaryForDateRangeResponse';
  hasMoreAllocations: Scalars['Boolean'];
  projects: Array<DailyMyAllocationHoursSummaryForDateRange>;
};

export type DailyMyAllocationHoursSummaryForDate = {
  __typename?: 'DailyMyAllocationHoursSummaryForDate';
  actualHours: Scalars['Float'];
  allocatedHours: Scalars['Float'];
  date: Scalars['Date2'];
};

export type DailyMyAllocationHoursSummaryForDateRange = {
  __typename?: 'DailyMyAllocationHoursSummaryForDateRange';
  days: Array<DailyMyAllocationHoursSummaryForDate>;
  project: ProjectReference;
  tasks: Array<DailyMyTaskAllocationHoursSummary>;
};

export type DailyMyAllocationHoursSummaryForDateRangeInput = {
  dateRange: DateRangeInput2;
};

export type DailyMyTaskAllocationHoursSummary = {
  __typename?: 'DailyMyTaskAllocationHoursSummary';
  days: Array<DailyMyAllocationHoursSummaryForDate>;
  fullPath: Array<TaskReference>;
  task: TaskReference;
};

export type DataPointPeriod = {
  __typename?: 'DataPointPeriod';
  /** @deprecated Use periodEnd2 */
  periodEnd?: Maybe<Scalars['DateObject']>;
  periodEnd2?: Maybe<Scalars['Date2']>;
  /** @deprecated Use periodStart2 */
  periodStart?: Maybe<Scalars['DateObject']>;
  periodStart2?: Maybe<Scalars['Date2']>;
};

export type DateRange = {
  __typename?: 'DateRange';
  /** @deprecated Use endDate2 */
  endDate: Scalars['Date'];
  endDate2: Scalars['Date2'];
  /** @deprecated Use startDate2 */
  startDate: Scalars['Date'];
  startDate2: Scalars['Date2'];
};

export type DateRangeInput = {
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};

export type DateRangeInput2 = {
  endDate: Scalars['Date2'];
  startDate: Scalars['Date2'];
};

export type DateTimeFormat = {
  __typename?: 'DateTimeFormat';
  amDesignator?: Maybe<Scalars['String']>;
  dateSeparator?: Maybe<Scalars['String']>;
  dotNetPattern?: Maybe<Scalars['String']>;
  pmDesignator?: Maybe<Scalars['String']>;
  timeSeparator?: Maybe<Scalars['String']>;
};

export type DateTimeRangeInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type DateTimeSetting = {
  __typename?: 'DateTimeSetting';
  daysOfWeek?: Maybe<Array<Maybe<DayOfWeek>>>;
  fullDateTimeFormat?: Maybe<DateTimeFormat>;
  longDateFormat?: Maybe<DateTimeFormat>;
  longTimeFormat?: Maybe<DateTimeFormat>;
  months?: Maybe<Array<Maybe<Month>>>;
  shortDateFormat?: Maybe<DateTimeFormat>;
  shortTimeFormat?: Maybe<DateTimeFormat>;
};

export type DayOfWeek = {
  __typename?: 'DayOfWeek';
  abbreviatedName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export enum DayOfWeekValue {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DefaultScheduleRule = {
  __typename?: 'DefaultScheduleRule';
  dateRange?: Maybe<DefaultScheduleRuleDateRange>;
  do: Scalars['ScheduleRuleDo'];
};

export type DefaultScheduleRuleDateRange = {
  __typename?: 'DefaultScheduleRuleDateRange';
  endDate?: Maybe<Scalars['Date']>;
  startDate?: Maybe<Scalars['Date']>;
};

export type DefinitionInput = {
  uri: Scalars['String'];
};

export type DeleteAttachmentInput = {
  objectUri: Scalars['String'];
  type: Scalars['String'];
  uploadUri: Scalars['String'];
};

export type DeleteAttachmentResult = {
  __typename?: 'DeleteAttachmentResult';
  uploadUri: Scalars['String'];
};

export type DeleteCertificateInput = {
  userCertificateUri: Scalars['String'];
};

export type DeleteClientResult = {
  __typename?: 'DeleteClientResult';
  id: Scalars['String'];
  status?: Maybe<DeleteStatus>;
};

export enum DeletePortfolioResult {
  Archived = 'ARCHIVED',
  Deleted = 'DELETED'
}

export type DeleteProgramResult = {
  __typename?: 'DeleteProgramResult';
  id: Scalars['String'];
  status?: Maybe<DeleteStatus>;
};

export type DeleteProjectBatchResult = {
  __typename?: 'DeleteProjectBatchResult';
  archived: Array<Maybe<ProjectReference>>;
  deleted: Array<Maybe<ProjectReference>>;
  errors: Array<Maybe<DeleteProjectError>>;
};

export type DeleteProjectError = {
  __typename?: 'DeleteProjectError';
  displayText: Scalars['String'];
  project: ProjectReference;
};

export type DeleteProjectLinkResults = {
  __typename?: 'DeleteProjectLinkResults';
  ids: Array<Scalars['String']>;
};

export type DeleteProjectLinksInput = {
  baseProjectId: Scalars['String'];
  id: Scalars['String'];
  linkType: ProjectLinkType;
  reverseLinkId: Scalars['String'];
  targetProjectId: Scalars['String'];
};

export type DeleteProjectReportInput = {
  id: Scalars['String'];
  projectUri: Scalars['String'];
};

export type DeleteProjectReportResult = {
  __typename?: 'DeleteProjectReportResult';
  id: Scalars['String'];
};

export type DeleteProjectResult = {
  __typename?: 'DeleteProjectResult';
  id: Scalars['String'];
  status?: Maybe<DeleteStatus>;
};

export type DeleteProjects = {
  __typename?: 'DeleteProjects';
  archivedUris: Array<Maybe<Scalars['String']>>;
  deletedUris: Array<Maybe<Scalars['String']>>;
  errors: Array<Maybe<DeleteProjectError>>;
};

export type DeleteResourceAllocationInput = {
  id: Scalars['String'];
};

export type DeleteResourceAllocationResult = {
  __typename?: 'DeleteResourceAllocationResult';
  id: Scalars['String'];
};

export type DeleteResourceAllocationsForResourceRequestInput = {
  resourceRequestId: Scalars['String'];
};

export type DeleteResourceAllocationsForResourceRequestResult = {
  __typename?: 'DeleteResourceAllocationsForResourceRequestResult';
  resourceRequest: ResourceRequest;
};

export type DeleteResourceRequestInput = {
  id: Scalars['String'];
};

export type DeleteResourceRequestResult = {
  __typename?: 'DeleteResourceRequestResult';
  id: Scalars['String'];
};

export type DeleteResumeInput = {
  userUri: Scalars['String'];
};

export type DeleteResumeResult = {
  __typename?: 'DeleteResumeResult';
  userUri: Scalars['String'];
};

export enum DeleteStatus {
  Deleted = 'DELETED',
  Disabled = 'DISABLED'
}

export type DeleteTaskInput = {
  taskId: Scalars['String'];
};

export type DeleteTaskResourceUserAllocationInput = {
  projectUri: Scalars['String'];
  taskAllocationId: Scalars['String'];
  taskUri: Scalars['String'];
};

export type DeleteTaskResourceUserAllocationResult = {
  __typename?: 'DeleteTaskResourceUserAllocationResult';
  syncedResourceAllocation?: Maybe<ResourceAllocation>;
  taskAllocationId: Scalars['String'];
};

export type DeleteTaskResult = {
  __typename?: 'DeleteTaskResult';
  result?: Maybe<Scalars['String']>;
};

export type DeleteUserCertificateResult = {
  __typename?: 'DeleteUserCertificateResult';
  userCertificateUri: Scalars['String'];
};

export type DeleteVendorResult = {
  __typename?: 'DeleteVendorResult';
  id: Scalars['String'];
  status?: Maybe<DeleteStatus>;
};

export type DeletedResourceAllocation = {
  __typename?: 'DeletedResourceAllocation';
  id: Scalars['String'];
  projectUri: Scalars['String'];
  userUri: Scalars['String'];
};

export type DeletedResourceRequest = {
  __typename?: 'DeletedResourceRequest';
  id: Scalars['String'];
  projectUri: Scalars['String'];
  requestStatus: ResourceRequestStatus;
};

export enum DimensionObjectType {
  PayCode = 'PAY_CODE',
  ProjectRole = 'PROJECT_ROLE',
  User = 'USER'
}

export type DisplayObject = {
  __typename?: 'DisplayObject';
  outputPath?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
};

export type DownloadUrl = {
  __typename?: 'DownloadUrl';
  url?: Maybe<Scalars['String']>;
};

export type DueDate = {
  __typename?: 'DueDate';
  dateValue?: Maybe<Scalars['Date']>;
  textValue?: Maybe<Scalars['String']>;
};

export type Duration = {
  __typename?: 'Duration';
  hours: Scalars['Int'];
  minutes: Scalars['Int'];
  seconds: Scalars['Int'];
};

export type DurationDate = {
  __typename?: 'DurationDate';
  date?: Maybe<Scalars['Date']>;
  hours: Scalars['Float'];
};

export type EffectiveBillingRate = {
  __typename?: 'EffectiveBillingRate';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  rate?: Maybe<Money>;
};

export type EmailBillResult = {
  __typename?: 'EmailBillResult';
  error?: Maybe<Error>;
};

export type EmailProjectReportError = {
  __typename?: 'EmailProjectReportError';
  isFailedRecipient?: Maybe<Scalars['Boolean']>;
  isInvalidRecipient?: Maybe<Scalars['Boolean']>;
};

export type EmailProjectReportInput = {
  projectId: Scalars['String'];
  projectName: Scalars['String'];
  reportId: Scalars['String'];
  users?: InputMaybe<Array<InputMaybe<SelectedUser>>>;
};

export type EmailProjectReportResult = {
  __typename?: 'EmailProjectReportResult';
  error?: Maybe<EmailProjectReportError>;
  success?: Maybe<Scalars['Boolean']>;
};

export type EnhancedTaskData = {
  __typename?: 'EnhancedTaskData';
  effectiveTimestamp?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statusUpdatedDate?: Maybe<Scalars['String']>;
};

export type Error = {
  __typename?: 'Error';
  reason?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ErrorWithMessage = {
  __typename?: 'ErrorWithMessage';
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type EstimatedBillingOverviewData = {
  __typename?: 'EstimatedBillingOverviewData';
  amountTotal?: Maybe<BillingOverviewAmountData>;
  totalHours?: Maybe<BillingOverviewHoursData>;
};

export type EstimatedExpensesEntryInput = {
  billableAmount?: InputMaybe<Scalars['Float']>;
  currencyId: Scalars['String'];
  expenseCodeId: Scalars['String'];
  incurredDate: Scalars['Date2'];
  nonBillableAmount?: InputMaybe<Scalars['Float']>;
};

export type EstimationMode = {
  __typename?: 'EstimationMode';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
};

export type EstimationModeInput = {
  displayText?: InputMaybe<Scalars['String']>;
  uri?: InputMaybe<Scalars['String']>;
};

export type ExchangeRate = {
  __typename?: 'ExchangeRate';
  currencyId?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
};

export type ExpenseCardSettings = {
  __typename?: 'ExpenseCardSettings';
  allowBillable: Scalars['Boolean'];
  showActuals: Scalars['Boolean'];
};

export type ExpenseCode = {
  __typename?: 'ExpenseCode';
  displayText?: Maybe<Scalars['String']>;
  expenseEntryType?: Maybe<ExpenseEntryType>;
  id: Scalars['String'];
  isExpenseEntryToThisCodeAllowed?: Maybe<Scalars['Boolean']>;
};

export type ExpenseCodeInput = {
  displayText?: InputMaybe<Scalars['String']>;
  expenseEntryType?: InputMaybe<ExpenseEntryType>;
  id: Scalars['String'];
  isExpenseEntryToThisCodeAllowed?: InputMaybe<Scalars['Boolean']>;
};

export enum ExpenseEntryType {
  Billable = 'BILLABLE',
  BillableAndNonBillable = 'BILLABLE_AND_NON_BILLABLE',
  NonBillable = 'NON_BILLABLE'
}

export type ExpenseSummary = {
  __typename?: 'ExpenseSummary';
  amount?: Maybe<Money>;
  count: Scalars['Int'];
  statusSlug?: Maybe<Scalars['String']>;
  webDeepLinkUrl?: Maybe<Scalars['String']>;
};

export type ExportTableFilter = {
  clientFilter?: InputMaybe<ClientFilter>;
  isManaged?: InputMaybe<Scalars['Boolean']>;
  programFilter?: InputMaybe<ProgramFilter>;
  projectFilter?: InputMaybe<ProjectFilter>;
  resourceDetailsFilter?: InputMaybe<ResourceDetailsFilter>;
  revenueEntryFilter?: InputMaybe<RevenueEntryFilter2>;
  taskFilter?: InputMaybe<TaskFilter>;
};

export type ExportUri = {
  __typename?: 'ExportUri';
  uri?: Maybe<Scalars['String']>;
};

export type ExtensionFieldDefinition = {
  __typename?: 'ExtensionFieldDefinition';
  definitionTypeUri?: Maybe<Scalars['String']>;
  displayText?: Maybe<Scalars['String']>;
  fileDetails?: Maybe<ExtensionFieldFileDetails>;
  id: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<ExtensionFieldTag>>>;
  uri?: Maybe<Scalars['String']>;
};

export type ExtensionFieldFileDetails = {
  __typename?: 'ExtensionFieldFileDetails';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  enabledSourceUris?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type ExtensionFieldFileValue = {
  __typename?: 'ExtensionFieldFileValue';
  identityUri?: Maybe<Scalars['String']>;
  keyValues?: Maybe<Array<Maybe<ExtensionFieldFileValueKeyValue>>>;
  linkUri?: Maybe<Scalars['String']>;
};

export type ExtensionFieldFileValueKeyValue = {
  __typename?: 'ExtensionFieldFileValueKeyValue';
  keyUri?: Maybe<Scalars['String']>;
  value?: Maybe<ExtensionFieldFileValueKeyValueValue>;
};

export type ExtensionFieldFileValueKeyValueValue = {
  __typename?: 'ExtensionFieldFileValueKeyValueValue';
  text?: Maybe<Scalars['String']>;
};

export type ExtensionFieldTag = {
  __typename?: 'ExtensionFieldTag';
  definition?: Maybe<ExtensionFieldDefinition>;
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type ExtensionFieldTagValue = {
  __typename?: 'ExtensionFieldTagValue';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type ExtensionFieldValue = {
  __typename?: 'ExtensionFieldValue';
  definition?: Maybe<ExtensionFieldDefinition>;
  definitionTypeUri?: Maybe<Scalars['String']>;
  fileValue?: Maybe<ExtensionFieldFileValue>;
  numericValue?: Maybe<Scalars['Float']>;
  tag?: Maybe<ExtensionFieldTagValue>;
  textValue?: Maybe<Scalars['String']>;
};

export type ExtensionFieldValueInput = {
  definition: DefinitionInput;
  fileValue?: InputMaybe<FileValueInput>;
  numericValue?: InputMaybe<Scalars['Float']>;
  tag?: InputMaybe<TagInput>;
  textValue?: InputMaybe<Scalars['String']>;
};

export type FailedInvoiceStatusDetails = {
  __typename?: 'FailedInvoiceStatusDetails';
  exceededBillAmount: Money;
  project: ProjectReference;
  projectTCVAmount: Money;
};

export type FailedInvoiceStatusResult = {
  __typename?: 'FailedInvoiceStatusResult';
  details?: Maybe<Array<Maybe<FailedInvoiceStatusDetails>>>;
  invoice: ObjectReference;
};

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  featureFlagBool?: Maybe<Scalars['Boolean']>;
  featureFlagInt?: Maybe<Scalars['Int']>;
  featureFlagString?: Maybe<Scalars['String']>;
};


export type FeatureFlagsFeatureFlagBoolArgs = {
  defaultValue?: InputMaybe<Scalars['Boolean']>;
  flagKey: Scalars['String'];
};


export type FeatureFlagsFeatureFlagIntArgs = {
  defaultValue?: InputMaybe<Scalars['Int']>;
  flagKey: Scalars['String'];
};


export type FeatureFlagsFeatureFlagStringArgs = {
  defaultValue?: InputMaybe<Scalars['String']>;
  flagKey: Scalars['String'];
};

export type FileValueDataInput = {
  base64Content?: InputMaybe<Scalars['String']>;
  keyValues?: InputMaybe<Array<InputMaybe<FileValueDataKeyValuesInput>>>;
  mimeType?: InputMaybe<Scalars['String']>;
};

export type FileValueDataKeyValueInput = {
  text?: InputMaybe<Scalars['String']>;
};

export type FileValueDataKeyValuesInput = {
  keyUri?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<FileValueDataKeyValueInput>;
};

export type FileValueInput = {
  data?: InputMaybe<FileValueDataInput>;
  identityUri?: InputMaybe<Scalars['String']>;
};

export type FinancialOverviewAmountSeries = {
  __typename?: 'FinancialOverviewAmountSeries';
  currency: Currency;
  dataPoints: Array<FinancialOverviewAmountSeriesDataPoint>;
};

export type FinancialOverviewAmountSeriesDataPoint = {
  __typename?: 'FinancialOverviewAmountSeriesDataPoint';
  amount?: Maybe<Scalars['Float']>;
  period?: Maybe<DataPointPeriod>;
};

export type FinancialOverviewSeriesData = {
  __typename?: 'FinancialOverviewSeriesData';
  billableRevenue?: Maybe<FinancialOverviewAmountSeries>;
  estimatedBilling?: Maybe<FinancialOverviewAmountSeries>;
  forecastedRevenue?: Maybe<FinancialOverviewAmountSeries>;
  recognizedRevenue?: Maybe<FinancialOverviewAmountSeries>;
};

export type FinancialOverviewTotals = {
  __typename?: 'FinancialOverviewTotals';
  totalActualCost?: Maybe<Money>;
  totalBillableRevenue?: Maybe<Money>;
  totalEstimatedBilling?: Maybe<Money>;
  totalEstimatedCost?: Maybe<Money>;
  totalForecastedRevenue?: Maybe<Money>;
  totalRecognizedRevenue?: Maybe<Money>;
};

export enum FulfillAllocationResourceWithSmartFit {
  AllocateFullScheduleRules = 'AllocateFullScheduleRules',
  None = 'None'
}

export type GetBatchStatusResponse = {
  __typename?: 'GetBatchStatusResponse';
  executionState?: Maybe<BatchState>;
  overallProgress?: Maybe<OverallProgress>;
};

export type GetPageOfAssociatedBillPaymentsForBillResponse = {
  __typename?: 'GetPageOfAssociatedBillPaymentsForBillResponse';
  associatedBillPayments?: Maybe<Array<Maybe<AssociatedBillPayment>>>;
};

export type GetPageOfAssociatedBillsForBillPaymentResponse = {
  __typename?: 'GetPageOfAssociatedBillsForBillPaymentResponse';
  associatedBills?: Maybe<Array<Maybe<AssociatedBillForPayment>>>;
};

export type GetPageOfAssociatedBillsForCreditMemoResponse = {
  __typename?: 'GetPageOfAssociatedBillsForCreditMemoResponse';
  associatedBills?: Maybe<Array<Maybe<AssociatedBillForCreditMemo>>>;
};

export type GetPageOfAssociatedCreditMemosForBillResponse = {
  __typename?: 'GetPageOfAssociatedCreditMemosForBillResponse';
  associatedCreditMemos?: Maybe<Array<Maybe<AssociatedCreditMemo>>>;
};

export type GetPageOfLineItemsForBillResponse = {
  __typename?: 'GetPageOfLineItemsForBillResponse';
  lineItems: Array<Maybe<BillLineItem>>;
};

export type GetPageOfLineItemsForCreditMemoResponse = {
  __typename?: 'GetPageOfLineItemsForCreditMemoResponse';
  lineItems: Array<Maybe<CreditMemoLineItem>>;
};

export type GetResourceAllocationForUserInput = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  userUri: Scalars['String'];
};

export type GetResourceAllocationsForUserWithinDateRange = {
  __typename?: 'GetResourceAllocationsForUserWithinDateRange';
  id: Scalars['String'];
  project?: Maybe<Project>;
  projectUri: Scalars['String'];
  scheduleRules: Array<ScheduleRule>;
};

export type GetResourcePlansResult = {
  __typename?: 'GetResourcePlansResult';
  paginationToken?: Maybe<Scalars['String']>;
  plans: Array<ResourcePlan>;
};

export type GetResourceUsersFilter = {
  availabilityPercentageInRange?: InputMaybe<AvailabilityPercentageInRangeInput>;
  clients?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clientsWithActualOrAllocation?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  costCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  employeeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludeRoles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  primaryRoles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  programs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  programsWithActualOrAllocation?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projectsWithActualOrAllocation?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resourcePools?: InputMaybe<Array<Scalars['String']>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  serviceCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tags?: InputMaybe<Array<TagFilterInput>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userScoreMatchFilter?: InputMaybe<GetResourceUsersScoreMatchFilter>;
};

export type GetResourceUsersScoreMatchFilter = {
  score?: InputMaybe<Scalars['Float']>;
};

export type GetRevenueRunListResult = {
  __typename?: 'GetRevenueRunListResult';
  asOfDate?: Maybe<Scalars['Date2']>;
  creationDate?: Maybe<Scalars['Date2']>;
  creator?: Maybe<ObjectReference>;
  description?: Maybe<Scalars['String']>;
  lastRecalculatedTime?: Maybe<Scalars['Date2']>;
  previouslyRecognizedRevenue?: Maybe<Array<Maybe<Money>>>;
  revenueRun?: Maybe<ObjectReference>;
  status?: Maybe<ObjectReference>;
  statusLastUpdatedTime?: Maybe<Scalars['Date2']>;
  totalAmount?: Maybe<Array<Maybe<Money>>>;
};

export type Group = {
  __typename?: 'Group';
  assignedBillingRates?: Maybe<Array<Maybe<ProjectTeamBillingRate>>>;
  assignedTaskCount?: Maybe<Scalars['Int']>;
  displayText?: Maybe<Scalars['String']>;
  fullPath?: Maybe<Array<Scalars['String']>>;
  hierarchyLevel?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};


export type GroupAssignedTaskCountArgs = {
  taskAssignmentsFilter?: InputMaybe<TaskAssignmentsFilter>;
};

export type GroupInput = {
  displayText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  uri?: InputMaybe<Scalars['String']>;
};

export type GroupSetting = {
  __typename?: 'GroupSetting';
  id: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  pluralName?: Maybe<Scalars['String']>;
  singularName?: Maybe<Scalars['String']>;
};

export type GroupSettings = {
  __typename?: 'GroupSettings';
  costCenter?: Maybe<GroupSetting>;
  department?: Maybe<GroupSetting>;
  division?: Maybe<GroupSetting>;
  employeeType?: Maybe<GroupSetting>;
  location?: Maybe<GroupSetting>;
  serviceCenter?: Maybe<GroupSetting>;
};

export enum Groupings {
  EntrydateDay = 'entrydate__day',
  EntrydateMonth = 'entrydate__month',
  EntrydateQuarter = 'entrydate__quarter',
  EntrydateWeek = 'entrydate__week',
  EntrydateYear = 'entrydate__year'
}

export type Groups = {
  __typename?: 'Groups';
  ancestors?: Maybe<Array<Maybe<Groups>>>;
  displayText?: Maybe<Scalars['String']>;
  /** @deprecated Use effectiveDate2 */
  effectiveDate?: Maybe<Scalars['Date']>;
  effectiveDate2?: Maybe<Scalars['Date2']>;
  id?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export enum HiringStatus {
  HiringRequested = 'HIRING_REQUESTED',
  HiringWithdrawn = 'HIRING_WITHDRAWN'
}

export type HiringStatusSummary = {
  __typename?: 'HiringStatusSummary';
  hiringRequestedCount: Scalars['Int'];
  hiringWithdrawnCount: Scalars['Int'];
  noHiringStatusCount: Scalars['Int'];
};

export type HiringStatusSummaryFilter = {
  costCenters?: InputMaybe<Array<Scalars['String']>>;
  departments?: InputMaybe<Array<Scalars['String']>>;
  divisions?: InputMaybe<Array<Scalars['String']>>;
  employeeTypes?: InputMaybe<Array<Scalars['String']>>;
  locations?: InputMaybe<Array<Scalars['String']>>;
  projects?: InputMaybe<Array<Scalars['String']>>;
  resourcePools?: InputMaybe<Array<Scalars['String']>>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  serviceCenters?: InputMaybe<Array<Scalars['String']>>;
  skills?: InputMaybe<Array<Scalars['String']>>;
  text?: InputMaybe<Scalars['String']>;
};

export type Holiday = {
  __typename?: 'Holiday';
  date: Scalars['Date'];
  duration?: Maybe<Duration>;
  effectiveDuration: Duration;
  name: Scalars['String'];
  uri: Scalars['String'];
};

export type HoursDataPoint = {
  __typename?: 'HoursDataPoint';
  period?: Maybe<DataPointPeriod>;
  timeEnteredActual?: Maybe<Scalars['Float']>;
  timeEnteredEstimated?: Maybe<Scalars['Float']>;
};

export type ImageTransformationParameters = {
  cropType?: InputMaybe<CropType>;
  squareSideLength?: InputMaybe<Scalars['Int']>;
  xOffset?: InputMaybe<Scalars['Int']>;
  yOffset?: InputMaybe<Scalars['Int']>;
  zoom?: InputMaybe<Scalars['Float']>;
};

export type ImpactedTasksSummary = {
  __typename?: 'ImpactedTasksSummary';
  maxTaskEndDate?: Maybe<Scalars['Date2']>;
  taskAllocationsSummary?: Maybe<TaskResourceUserAllocationsSummaryForUser>;
  taskUris: Array<Scalars['String']>;
};

export enum IncludeReleaseTaskByStatusType {
  InProgressAndNotStarted = 'IN_PROGRESS_AND_NOT_STARTED',
  None = 'NONE',
  NotStartedOnly = 'NOT_STARTED_ONLY'
}

export enum InvoiceNumberUniquenessRequirements {
  All = 'all',
  NotOpenInvoices = 'notOpenInvoices'
}

export type InvoiceStatusUpdateBatchResult = {
  __typename?: 'InvoiceStatusUpdateBatchResult';
  result: InvoiceStatusUpdateResult;
};

export type InvoiceStatusUpdateResult = {
  __typename?: 'InvoiceStatusUpdateResult';
  failedInvoices?: Maybe<Array<Maybe<FailedInvoiceStatusResult>>>;
  updatedInvoices?: Maybe<Array<Maybe<UpdatedInvoiceStatusResult>>>;
};

export type InvoiceTemplate = {
  __typename?: 'InvoiceTemplate';
  displayText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type IssueBillInput = {
  invoiceId: Scalars['String'];
  syncBill?: InputMaybe<Scalars['Boolean']>;
};

export type IssueBillOutput = {
  __typename?: 'IssueBillOutput';
  failedLineItems?: Maybe<Array<Maybe<LineItemReference>>>;
  success: Scalars['Boolean'];
};

export type KeyValues = {
  __typename?: 'KeyValues';
  keyUri?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['KeyValue']>;
};

export type KeyValuesInput = {
  keyUri?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['KeyValue']>;
};

export type Language = {
  __typename?: 'Language';
  cultureCode?: Maybe<Scalars['String']>;
  displayText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  languageCode?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export enum LineItemColumnOptions {
  BillingContractClause = 'BILLING_CONTRACT_CLAUSE',
  BillingRate = 'BILLING_RATE',
  ExpenseCode = 'EXPENSE_CODE',
  Itemtype = 'ITEMTYPE',
  Paycode = 'PAYCODE',
  Project = 'PROJECT',
  Quantity = 'QUANTITY',
  Rate = 'RATE',
  Role = 'ROLE',
  Task = 'TASK',
  TimesheetPeriod = 'TIMESHEET_PERIOD',
  Unit = 'UNIT',
  User = 'USER'
}

export type LineItemFilter = {
  isAdhoc?: InputMaybe<Scalars['Boolean']>;
  isTaxItem?: InputMaybe<Scalars['Boolean']>;
};

export type LineItemForBillInput = {
  billId: Scalars['String'];
  lineItem?: InputMaybe<LineItemInput>;
};

export type LineItemInput = {
  amount?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  expenseCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isAdhoc?: InputMaybe<Scalars['Boolean']>;
  payCode?: InputMaybe<Scalars['String']>;
  projectUri?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  rate?: InputMaybe<Scalars['Float']>;
  role?: InputMaybe<Scalars['String']>;
  timesheetPeriod?: InputMaybe<BillingDateRangeInput2>;
  unitLabel?: InputMaybe<Scalars['String']>;
};

export type LineItemReference = {
  __typename?: 'LineItemReference';
  exceededBillAmount: Money;
  project: ProjectReference;
  projectTCVAmount: Money;
};

export type LineItemsFromBillingItemsBatchInput2 = {
  billingItemColumnOption?: InputMaybe<Array<InputMaybe<BillingItemColumnOption>>>;
  billingItemSearch?: InputMaybe<BillingItemSearch2>;
  billingItemsExcludedUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  billingItemsIncludedUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LineItemsFromBillingItemsForBillInput2 = {
  billingItemFilter?: InputMaybe<BillingItemSearchFilter2>;
  billingItemsExcludedUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  billingItemsIncludedUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LinkAttachmentToObjectInput = {
  attachToUri: Scalars['String'];
  linkName?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  uploadUri: Scalars['String'];
};

export type LinkAttachmentToObjectResult = {
  __typename?: 'LinkAttachmentToObjectResult';
  attachment2: AttachmentLink;
  uploadUri: Scalars['String'];
};

export type LinkAttachmentsToObjectInput = {
  attachToUri: Scalars['String'];
  attachments: Array<AttachmentLinkInput>;
};

export type LinkAttachmentsToObjectResult = {
  __typename?: 'LinkAttachmentsToObjectResult';
  attachments2: Array<AttachmentLink>;
};

export type LinkTargetInput = {
  linkType: ProjectLinkType;
  targetProjectId: Scalars['String'];
};

export type ListResults = {
  totalItems?: Maybe<Scalars['Int']>;
};

export type Locale = {
  __typename?: 'Locale';
  customTerms?: Maybe<Array<Maybe<CustomTerm>>>;
  dateTimeSettings?: Maybe<DateTimeSetting>;
  language?: Maybe<Language>;
  numberSettings?: Maybe<NumberSettingGroup>;
  timeZone?: Maybe<TimeZone>;
};

export type MarkAllNotificationsAsReadResult = {
  __typename?: 'MarkAllNotificationsAsReadResult';
  notifications?: Maybe<Array<Maybe<Notification>>>;
};

export type MarkNotificationAsReadResult = {
  __typename?: 'MarkNotificationAsReadResult';
  notification?: Maybe<Notification>;
};

export type MarkResourceRequestAsAllocationRejectedInput = {
  resourceRequestId: Scalars['String'];
};

export type MarkResourceRequestAsAllocationRejectedResult = {
  __typename?: 'MarkResourceRequestAsAllocationRejectedResult';
  resourceRequest: ResourceRequest;
};

export type MarkResourceRequestAsCompleteAndMergeInput = {
  resourceRequestId: Scalars['String'];
};

export type MarkResourceRequestAsCompleteAndMergeResult = {
  __typename?: 'MarkResourceRequestAsCompleteAndMergeResult';
  isResourceRequestMerged: Scalars['Boolean'];
  resourceRequests: Array<ResourceRequest>;
};

export type MarkResourceRequestAsCompleteInput = {
  resourceRequestId: Scalars['String'];
};

export type MarkResourceRequestAsCompleteResult = {
  __typename?: 'MarkResourceRequestAsCompleteResult';
  resourceRequest: ResourceRequest;
};

export type MarkResourceRequestAsDraftInput = {
  resourceRequestId: Scalars['String'];
};

export type MarkResourceRequestAsDraftResult = {
  __typename?: 'MarkResourceRequestAsDraftResult';
  resourceRequest: ResourceRequest;
};

export type MarkResourceRequestAsRejectedInput = {
  resourceRequestId: Scalars['String'];
};

export type MarkResourceRequestAsRejectedResult = {
  __typename?: 'MarkResourceRequestAsRejectedResult';
  resourceRequest: ResourceRequest;
};

export type MarkResourceRequestAsSubmittedInput = {
  resourceRequestId: Scalars['String'];
};

export type MarkResourceRequestAsSubmittedResult = {
  __typename?: 'MarkResourceRequestAsSubmittedResult';
  resourceRequest: ResourceRequest;
};

export type MarkResourceRequestAsTentativeInput = {
  resourceRequestId: Scalars['String'];
};

export type MarkResourceRequestAsTentativeResult = {
  __typename?: 'MarkResourceRequestAsTentativeResult';
  resourceRequest: ResourceRequest;
};

export type MarkResourceRequestAsToBeHiredInput = {
  resourceRequestId: Scalars['String'];
};

export type MarkResourceRequestAsToBeHiredResult = {
  __typename?: 'MarkResourceRequestAsToBeHiredResult';
  resourceRequest: ResourceRequest;
};

export type MarkToBeHiredResourceRequestWithHiringRequestedSubStatusInput = {
  hiringStatus: HiringStatus;
  resourceRequestId: Scalars['String'];
};

export type MarkToBeHiredResourceRequestWithHiringRequestedSubStatusResult = {
  __typename?: 'MarkToBeHiredResourceRequestWithHiringRequestedSubStatusResult';
  resourceRequest: ResourceRequest;
};

export type MatchResourcePoolsMetaData = {
  __typename?: 'MatchResourcePoolsMetaData';
  matchingResourcePoolsCount: Scalars['Int'];
  requestedResourcePoolsCount: Scalars['Int'];
};

export type MatchScore = {
  __typename?: 'MatchScore';
  isError?: Maybe<Scalars['Boolean']>;
  matchResourcePoolsMetadata?: Maybe<MatchResourcePoolsMetaData>;
  matchSkillsMetadata?: Maybe<MatchSkillsMetaData>;
  matchTagsMetadata?: Maybe<MatchTagsMetaData>;
  matchingDimensions?: Maybe<Array<Maybe<Scalars['String']>>>;
  score?: Maybe<Scalars['Float']>;
  totalCost?: Maybe<MatchScoreTotalCost>;
  unMatchedDimensions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MatchScoreCurrency = {
  __typename?: 'MatchScoreCurrency';
  symbol?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type MatchScoreDimensionsInput = {
  matchedDimensions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  partialMatchedDimensions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unmatchedDimensions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MatchScoreTotalCost = {
  __typename?: 'MatchScoreTotalCost';
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<MatchScoreCurrency>;
};

export type MatchSkillsMetaData = {
  __typename?: 'MatchSkillsMetaData';
  matchingSkillsCount: Scalars['Int'];
  requestedSkillsCount: Scalars['Int'];
};

export type MatchTagsMetaData = {
  __typename?: 'MatchTagsMetaData';
  matchingTagsCount: Scalars['Int'];
  requestedTagsCount: Scalars['Int'];
};

export type Me = {
  __typename?: 'Me';
  actualIdentityUri?: Maybe<Scalars['String']>;
  approvalsSummary2?: Maybe<ApprovalsSummary>;
  baseCurrency?: Maybe<Currency>;
  billingProcessType?: Maybe<Scalars['String']>;
  certificates?: Maybe<Array<Maybe<Certificate>>>;
  clientNameAndCodeUniqueness?: Maybe<NameCodeUniqueOption>;
  companyKey?: Maybe<Scalars['String']>;
  companyTimeZone?: Maybe<TimeZone>;
  /** @deprecated Use completedTasks2 */
  completedTasks?: Maybe<Array<Maybe<Task>>>;
  completedTasks2?: Maybe<Array<Maybe<Task>>>;
  /** @deprecated Use completedTasksCount2 */
  completedTasksCount?: Maybe<Scalars['Int']>;
  completedTasksCount2?: Maybe<Scalars['Int']>;
  cpoUrl?: Maybe<Scalars['String']>;
  currentTimeInUserTimeZone: Scalars['DateTimeWithTimeZone'];
  dailyAllocationHoursSummaryForDateRange: DailyAllocationHoursSummaryForDateRangeResponse;
  defaultRequestAttributeWeights?: Maybe<RequestAttributeWeights>;
  details?: Maybe<User>;
  displayText?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  expenses?: Maybe<UserExpenseSummary>;
  featureFlags?: Maybe<FeatureFlags>;
  firstName?: Maybe<Scalars['String']>;
  gainsightTagKey?: Maybe<Scalars['String']>;
  groupSettings?: Maybe<GroupSettings>;
  hasTenantPermission: Scalars['Boolean'];
  hasTenantRole: Scalars['Boolean'];
  helpUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** @deprecated Use inProgressTasks2 */
  inProgressTasks?: Maybe<Array<Maybe<Task>>>;
  inProgressTasks2?: Maybe<Array<Maybe<Task>>>;
  /** @deprecated Use inProgressTasksCount2 */
  inProgressTasksCount?: Maybe<Scalars['Int']>;
  inProgressTasksCount2?: Maybe<Scalars['Int']>;
  isExpenseProductEnabled?: Maybe<Scalars['Boolean']>;
  isFipsEnabled: Scalars['Boolean'];
  isGainsightDisabled: Scalars['Boolean'];
  isLogToSentryEnabled: Scalars['Boolean'];
  isRolledUpTaskEstimateCalculationMethodEnabled: Scalars['Boolean'];
  isTimePunchAllowedFromAnyPunchSource?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  legacyDepartmentDisabled?: Maybe<Scalars['Boolean']>;
  legacyEmployeeTypeDisabled?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Locale>;
  loginName?: Maybe<Scalars['String']>;
  logoutHref?: Maybe<Scalars['String']>;
  notificationPolicies?: Maybe<Array<Maybe<NotificationPolicy>>>;
  notifications?: Maybe<NotificationsResponse>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
  projectAllocations?: Maybe<Array<Maybe<ResourceAllocation>>>;
  projectNameAndCodeUniqueness?: Maybe<NameCodeUniqueOption>;
  projectRequestScoreScaleDetails?: Maybe<ProjectRequestScoreScaleDetails>;
  projectRoleSchedules?: Maybe<Array<Maybe<UserProjectRoleSchedule>>>;
  projectRoles?: Maybe<Array<Maybe<UserProjectRole>>>;
  projects?: Maybe<Array<Maybe<Project>>>;
  resourceCostMode?: Maybe<ResourceCostModeType>;
  resourcePlanningLimitInYears?: Maybe<Scalars['Int']>;
  roleSchedulesAsOfDate?: Maybe<RoleScheduleAsOfDateResponse>;
  roles?: Maybe<Array<Maybe<Role>>>;
  scheduledAndTotalHoursWorkedForDateRange?: Maybe<Array<Maybe<ScheduledAndTotalHoursWorkedForDate>>>;
  serverNodeEnv?: Maybe<Scalars['String']>;
  servicesUrl: Scalars['String'];
  sessionTimeoutDuration?: Maybe<TimeoutDuration>;
  skills?: Maybe<Array<Maybe<Skill>>>;
  slug?: Maybe<Scalars['String']>;
  substituteUserMetadata?: Maybe<SubstituteUserMetadata>;
  substituteUsers?: Maybe<Array<Maybe<User>>>;
  swimlane?: Maybe<Scalars['String']>;
  targetBillableHours2?: Maybe<UserProductivityTargetHoursSummary>;
  /** @deprecated Use taskEntries2 */
  taskEntries?: Maybe<Array<Maybe<TaskEntry>>>;
  /** @deprecated Use taskEntries3 */
  taskEntries2?: Maybe<Array<Maybe<TaskEntry>>>;
  /** @deprecated Use tasks2 */
  tasks?: Maybe<Array<Maybe<Task>>>;
  tasks2?: Maybe<Array<Maybe<Task>>>;
  /** @deprecated Use tasksCount2 */
  tasksCount?: Maybe<Scalars['Int']>;
  tasksCount2?: Maybe<Scalars['Int']>;
  tenantSlug?: Maybe<Scalars['String']>;
  tenantType?: Maybe<TenantType>;
  timeOff?: Maybe<TimeOffInfo>;
  timesheet?: Maybe<UserTimesheetSummary>;
  uiRootPath?: Maybe<Scalars['String']>;
  unreadNotifications?: Maybe<Array<Maybe<Notification>>>;
  unreadNotificationsCount: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  userAccessRoles?: Maybe<Array<Maybe<Scalars['String']>>>;
  userScopedGroups: Array<Maybe<UserEffectiveGroupPolicy>>;
  workWeekStartDay?: Maybe<WorkWeek>;
  zeroTimeUrl: Scalars['String'];
};


export type MeApprovalsSummary2Args = {
  effectiveDate?: InputMaybe<Scalars['DateTime']>;
};


export type MeCertificatesArgs = {
  includeExpired?: InputMaybe<Scalars['Boolean']>;
};


export type MeCompletedTasksArgs = {
  effectiveTimestamp: Scalars['Date'];
  onlyOpenTasks?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};


export type MeCompletedTasks2Args = {
  effectiveTimestamp: Scalars['DateTime'];
  onlyOpenTasks?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};


export type MeCompletedTasksCountArgs = {
  effectiveTimestamp: Scalars['Date'];
  onlyOpenTasks?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};


export type MeCompletedTasksCount2Args = {
  effectiveTimestamp: Scalars['DateTime'];
  onlyOpenTasks?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};


export type MeDailyAllocationHoursSummaryForDateRangeArgs = {
  input: DailyMyAllocationHoursSummaryForDateRangeInput;
};


export type MeHasTenantPermissionArgs = {
  permissionUri: Scalars['String'];
};


export type MeHasTenantRoleArgs = {
  roleUri: Scalars['String'];
};


export type MeInProgressTasksArgs = {
  effectiveTimestamp: Scalars['Date'];
  onlyOpenTasks?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};


export type MeInProgressTasks2Args = {
  effectiveTimestamp: Scalars['DateTime'];
  onlyOpenTasks?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};


export type MeInProgressTasksCountArgs = {
  effectiveTimestamp: Scalars['Date'];
  onlyOpenTasks?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};


export type MeInProgressTasksCount2Args = {
  effectiveTimestamp: Scalars['DateTime'];
  onlyOpenTasks?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};


export type MeNotificationsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type MeProjectAllocationsArgs = {
  allocationStatus?: InputMaybe<Array<ResourceAllocationStatus>>;
  effectiveDate?: InputMaybe<Scalars['Date']>;
  filter?: InputMaybe<ProjectAllocationFilter>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  projectManagementTypes?: InputMaybe<Array<ProjectManagementType>>;
};


export type MeProjectsArgs = {
  page: Scalars['Int'];
  pagesize: Scalars['Int'];
  projectFilter?: InputMaybe<ProjectFilter2>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type MeRoleSchedulesAsOfDateArgs = {
  asOfDate?: InputMaybe<Scalars['Date2']>;
};


export type MeScheduledAndTotalHoursWorkedForDateRangeArgs = {
  endDate?: InputMaybe<Scalars['Date']>;
  projectManagementTypes?: InputMaybe<Array<ProjectManagementType>>;
  startDate?: InputMaybe<Scalars['Date']>;
};


export type MeTargetBillableHours2Args = {
  dateRange: DateRangeInput2;
};


export type MeTaskEntriesArgs = {
  effectiveTimestamp: Scalars['Date'];
  status?: InputMaybe<TaskProgressStatus>;
};


export type MeTaskEntries2Args = {
  effectiveTimestamp: Scalars['DateTime'];
  status?: InputMaybe<TaskProgressStatus>;
};


export type MeTasksArgs = {
  effectiveTimestamp?: InputMaybe<Scalars['Date']>;
  onlyOpenTasks?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  projectUris?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<TaskProgressStatus>;
  text?: InputMaybe<Scalars['String']>;
};


export type MeTasks2Args = {
  effectiveTimestamp?: InputMaybe<Scalars['DateTime']>;
  onlyOpenTasks?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  projectUris?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<TaskProgressStatus>;
  taskUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text?: InputMaybe<Scalars['String']>;
};


export type MeTasksCountArgs = {
  effectiveTimestamp?: InputMaybe<Scalars['Date']>;
  onlyOpenTasks?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  projectUris?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<TaskProgressStatus>;
  text?: InputMaybe<Scalars['String']>;
};


export type MeTasksCount2Args = {
  effectiveTimestamp?: InputMaybe<Scalars['DateTime']>;
  onlyOpenTasks?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  projectUris?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<TaskProgressStatus>;
  text?: InputMaybe<Scalars['String']>;
};


export type MeUnreadNotificationsArgs = {
  count?: InputMaybe<Scalars['Int']>;
};

export type MergeAndMigrateResourceAllocationsInput = {
  projectUri: Scalars['String'];
  userUri: Scalars['String'];
};

export type MergeAndMigrateResourceAllocationsResult = {
  __typename?: 'MergeAndMigrateResourceAllocationsResult';
  mergedResourceAllocationId?: Maybe<Scalars['String']>;
};

export type ModifyAssignedTagValuesInput = {
  tagsToAssign?: InputMaybe<Array<InputMaybe<PutAssignedTagValueInput>>>;
  tagsToRemove?: InputMaybe<Array<InputMaybe<RemoveAssignedTagValueInput>>>;
};

export type ModifyAssignedTagValuesResult = {
  __typename?: 'ModifyAssignedTagValuesResult';
  assigned?: Maybe<Array<Maybe<PutAssignedTagValueResult>>>;
  removed?: Maybe<Array<Maybe<RemoveAssignedTagValueResult>>>;
};

export type Money = {
  __typename?: 'Money';
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Currency>;
};

export type MoneyInput = {
  amount?: InputMaybe<Scalars['Float']>;
  currency?: InputMaybe<CurrencyInput>;
};

export type MoneyValue = {
  __typename?: 'MoneyValue';
  amount: Scalars['Float'];
  currency: Currency;
};

export type Month = {
  __typename?: 'Month';
  abbreviatedName?: Maybe<Scalars['String']>;
  calendar?: Maybe<Calendar>;
  displayText?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type MoveTaskInput = {
  moveTaskMethod: MoveTaskMethod;
  targetId: Scalars['String'];
  taskId: Scalars['String'];
};

export enum MoveTaskMethod {
  AfterTarget = 'AFTER_TARGET',
  BeforeTarget = 'BEFORE_TARGET',
  ChildOfTarget = 'CHILD_OF_TARGET'
}

export type MoveTaskResult = {
  __typename?: 'MoveTaskResult';
  result?: Maybe<Scalars['String']>;
};

export enum MoveTimeCriteriaType {
  CostCenter = 'COST_CENTER',
  DateRange = 'DATE_RANGE',
  Department = 'DEPARTMENT',
  Division = 'DIVISION',
  EmployeeType = 'EMPLOYEE_TYPE',
  Location = 'LOCATION',
  ServiceCenter = 'SERVICE_CENTER',
  User = 'USER'
}

export type Mutation = {
  __typename?: 'Mutation';
  _?: Maybe<Scalars['String']>;
  addClient2?: Maybe<Client>;
  addProgram2?: Maybe<ProgramResponse>;
  addProject2?: Maybe<AddProjectResponse>;
  addProjectTimesheetAccessMember2?: Maybe<Scalars['String']>;
  addProjectTimesheetAccessMembers2?: Maybe<Scalars['String']>;
  addRole2?: Maybe<Role>;
  /** @deprecated Use addSkill2, has input validation */
  addSkill?: Maybe<Skill>;
  addSkill2?: Maybe<Skill>;
  applyUserDefinedSkillModificationsForUser: ApplyUserDefinedSkillModificationsForUserResult;
  archiveProject2?: Maybe<Project>;
  assignProjectRequestsToPortfolio?: Maybe<Scalars['String']>;
  assignProjectsToPortfolio?: Maybe<Scalars['String']>;
  assignProjectsToProgram2?: Maybe<Scalars['String']>;
  beginBulkAcceptAllocationsForResourceRequest: Scalars['String'];
  beginBulkProposeAllocationsForResourceRequest: Scalars['String'];
  beginCleanupResourceUserIndex: Scalars['String'];
  beginCleanupTenantData: Scalars['String'];
  beginEnableNotifications: Scalars['String'];
  beginEnablePPM: Scalars['String'];
  beginEnablePSA: Scalars['String'];
  beginManageTaskDateUpdates: Scalars['String'];
  beginMassEditProjectBackgroundJob: BeginMassEditProjectBackgroundJobResult;
  beginMergeAndMigrateResourceAllocations: Scalars['String'];
  beginMigratePermissions: Scalars['String'];
  beginMigrateProject: Scalars['String'];
  beginMigrateTaskEnhancement: Scalars['String'];
  beginRecomputeCostScore: Scalars['String'];
  beginReplaceWithLegacyResourcingData: Scalars['String'];
  beginRescheduleProjectBackgroundJob?: Maybe<Scalars['String']>;
  beginResourceUserTaskAssignmentBulkAction: Scalars['String'];
  beginSyncDynamoToES: Scalars['String'];
  /** @deprecated Will be dropping support for dynamodb task entries */
  beginSyncTaskEntryToES?: Maybe<Scalars['String']>;
  bulkAcceptAllocationsForResourceRequest: BulkAcceptAllocationsForResourceRequestResult;
  bulkAcceptUserCertificateNudge: Praa_UserCertificateNudgesResponse;
  bulkAcceptUserSkillNudge: Praa_UserSkillNudgesResponse;
  bulkAssignResourcePoolsToUser: Scalars['Boolean'];
  bulkAssignSkillToUser: BulkAssignSkillToUserResult;
  bulkAssignTasksToResourceUser: BulkAssignTasksToResourceUserResult;
  bulkCreateAndAssignSkillsToUser: BulkCreateAndAssignSkillsToUserResult;
  bulkCreateBillFromBillingItemsBatch?: Maybe<CreateBulkInvoiceFromBillingItemsBatchResult>;
  bulkCreateNewProjectLink: BulkCreateNewProjectLinkResult;
  bulkDeleteResourceRequests2: BulkDeleteResourceRequestsResult;
  bulkMarkResourceRequestsAsAllocationRejected2: BulkMarkResourceRequestsAsAllocationRejectedResult;
  bulkMarkResourceRequestsAsComplete2: BulkMarkResourceRequestsAsCompleteResult;
  bulkMarkResourceRequestsAsDraft2: BulkMarkResourceRequestsAsDraftResult;
  bulkMarkResourceRequestsAsRejected2: BulkMarkResourceRequestsAsRejectedResult;
  bulkMarkResourceRequestsAsSubmitted2: BulkMarkResourceRequestsAsSubmittedResult;
  bulkMarkResourceRequestsAsTentative2: BulkMarkResourceRequestsAsTentativeResult;
  bulkMarkResourceRequestsAsToBeHired2: BulkMarkResourceRequestsAsToBeHiredResult;
  bulkProposeAllocationsForResourceRequest: BulkProposeAllocationsForResourceRequestResult;
  bulkPutEstimatedExpensesForProject?: Maybe<Scalars['Boolean']>;
  bulkPutProjectStage: BulkPutProjectStageResult;
  bulkPutResourceRequestAllocationForUser: BulkPutResourceRequestAllocationForUserResult;
  bulkPutUserCertificate: BulkPutUserCertificateResult;
  bulkRejectUserCertificateNudge: Praa_UserCertificateNudgesResponse;
  bulkRejectUserSkillNudge: Praa_UserSkillNudgesResponse;
  bulkReleaseResourceAllocations: BulkReleaseResourceAllocationsResult;
  bulkReleaseTaskOwnership: BulkReleaseTaskOwnershipResult;
  bulkUnassignResourcePoolsToUser: Scalars['Boolean'];
  bulkUnassignTasksToResourceUser: BulkUnassignTasksToResourceUserResult;
  cancelBackgroundJob2: Scalars['String'];
  cancelBatch?: Maybe<Scalars['Boolean']>;
  cancelBillingBatch: Scalars['Boolean'];
  cancelClosedHiringResourceRequest: CancelClosedHiringResourceRequestResult;
  cancelDeletedHiringResourceRequest: CancelDeletedHiringResourceRequestResult;
  changeResourceUser: ChangeResourceUserResult;
  changeTaskResourceUser: ChangeTaskResourceResult;
  closeTask2?: Maybe<CloseTaskResult>;
  computeScoreForResourceRequest?: Maybe<Scalars['Boolean']>;
  createBillFromBillingItems3?: Maybe<CreateBillFromBillingItemsResult>;
  createBillFromBillingItemsBatch3?: Maybe<CreateBillFromBillingItemsBatchResult>;
  /**
   * This mutation is for importing/migrating resource requests w/ or w/o allocations only.
   * Not intended to be used in any other usecase.
   */
  createFulfillResourceRequest: CreateFulfillResourceRequestResult;
  createFulfillResourceRequest2: CreateFulfillResourceRequestResult;
  createFulfilledResourceAllocationWithoutResourceRequest: CreateFulfilledResourceAllocationWithoutResourceRequestResult;
  createInvoiceItemsFromBillingItemsBatch3?: Maybe<CreateInvoiceItemsFromBillingItemsBatchResult>;
  createLineItemsFromBillingItemsForBill3?: Maybe<Scalars['String']>;
  createMassProjectInfoModificationBatch?: Maybe<Scalars['String']>;
  createNewProjectDraft: Scalars['String'];
  createNewProjectLink: ProjectLink;
  createProjectBillingContractScriptRecalculationBatch: CreateProjectBillingContractScriptRecalculationBatchResult;
  createProjectCopyBatch3?: Maybe<CopyProjectBatchResult>;
  createProjectDeleteBatch2?: Maybe<CreateProjectDeleteBatchResult>;
  createProjectInfoModificationBatch2?: Maybe<Scalars['String']>;
  createProjectRevenueForecastRecalculationBatch?: Maybe<CreateProjectRevenuePolicyScriptRecalculationBatchResult>;
  createProjectRevenuePolicyScriptRecalculationBatch2?: Maybe<CreateProjectRevenuePolicyScriptRecalculationBatchResult>;
  createResourceAllocation2: CreateResourceAllocationResult;
  /** @deprecated Use createResourceRequest2, has input validation */
  createResourceRequest: CreateResourceRequestResult;
  createResourceRequest2: CreateResourceRequestResult;
  createRevenueContractScriptRecalculationBatch2?: Maybe<CreateProjectRevenuePolicyScriptRecalculationBatchResult>;
  /** @deprecated Use createRevenueForecastRecalculationBatch2, has input validation */
  createRevenueForecastRecalculationBatch?: Maybe<CreateRevenueRunBatchResult>;
  /** @deprecated Use createRevenueForecastRecalculationBatch3, no longer uses Date scalar */
  createRevenueForecastRecalculationBatch2?: Maybe<CreateRevenueRunBatchResult>;
  createRevenueForecastRecalculationBatch3?: Maybe<CreateRevenueRunBatchResult>;
  createTask2: CreateTaskResult;
  createTaskResourceUserAllocation: CreateTaskResourceUserAllocationResult;
  createTimeEntryRevisionGroupBulkModificationBatch: Scalars['String'];
  /** @deprecated Use createUpdateRevenueRunBatch2, has input validation */
  createUpdateRevenueRunBatch?: Maybe<CreateRevenueRunBatchResult>;
  createUpdateRevenueRunBatch2?: Maybe<CreateRevenueRunBatchResult>;
  delProjectRiskTTLOverride?: Maybe<Scalars['String']>;
  deleteAttachment2: DeleteAttachmentResult;
  deleteBill2?: Maybe<Scalars['String']>;
  deleteBillPayment2?: Maybe<Scalars['String']>;
  deleteClient2?: Maybe<DeleteClientResult>;
  deleteCreditMemo2?: Maybe<Scalars['String']>;
  deleteLineItemForBill2?: Maybe<Scalars['String']>;
  deletePortfolio: DeletePortfolioResult;
  deleteProgram2?: Maybe<DeleteProgramResult>;
  deleteProject2?: Maybe<DeleteProjectResult>;
  deleteProjectLinks: DeleteProjectLinkResults;
  deleteProjectReport2: DeleteProjectReportResult;
  deleteProjectRequest?: Maybe<Scalars['String']>;
  deleteProjectRevenueRecognitionBatchUri2?: Maybe<Scalars['Boolean']>;
  deleteResourceAllocation2: DeleteResourceAllocationResult;
  deleteResourceAllocationsForResourceRequest: DeleteResourceAllocationsForResourceRequestResult;
  deleteResourceRequest2: DeleteResourceRequestResult;
  deleteResume: DeleteResumeResult;
  deleteRevenueRunBatchUri?: Maybe<Scalars['Boolean']>;
  deleteTask2: DeleteTaskResult;
  /** @deprecated Will be dropping support for dynamodb task entries */
  deleteTaskEntries2?: Maybe<Array<Maybe<Scalars['String']>>>;
  deleteTaskResourceUserAllocation: DeleteTaskResourceUserAllocationResult;
  deleteUserCertificate2?: Maybe<DeleteUserCertificateResult>;
  deleteVendor?: Maybe<DeleteVendorResult>;
  issueBill: IssueBillOutput;
  linkAttachmentToObject2: LinkAttachmentToObjectResult;
  linkAttachmentsToObject2?: Maybe<LinkAttachmentsToObjectResult>;
  markAllNotificationsAsRead?: Maybe<MarkAllNotificationsAsReadResult>;
  markAttachmentsAsRead?: Maybe<Scalars['Boolean']>;
  markNotificationAsRead?: Maybe<MarkNotificationAsReadResult>;
  markResourceRequestAsAllocationRejected2: MarkResourceRequestAsAllocationRejectedResult;
  markResourceRequestAsComplete2: MarkResourceRequestAsCompleteResult;
  markResourceRequestAsCompleteAndMerge: MarkResourceRequestAsCompleteAndMergeResult;
  markResourceRequestAsDraft2: MarkResourceRequestAsDraftResult;
  markResourceRequestAsRejected2: MarkResourceRequestAsRejectedResult;
  /** @deprecated Use markResourceRequestAsSubmitted2, has input validation */
  markResourceRequestAsSubmitted: MarkResourceRequestAsSubmittedResult;
  markResourceRequestAsSubmitted2: MarkResourceRequestAsSubmittedResult;
  markResourceRequestAsTentative2: MarkResourceRequestAsTentativeResult;
  markResourceRequestAsToBeHired2: MarkResourceRequestAsToBeHiredResult;
  markToBeHiredResourceRequestWithHiringRequestedSubStatus: MarkToBeHiredResourceRequestWithHiringRequestedSubStatusResult;
  /**
   * This mutation is for merging resource allocations during tenant migration.
   * Not intended to be used in any other usecase.
   */
  mergeAndMigrateResourceAllocations: MergeAndMigrateResourceAllocationsResult;
  modifyAssignedTagValues2?: Maybe<ModifyAssignedTagValuesResult>;
  moveTask2: MoveTaskResult;
  openBill: OpenBillOutput;
  openTask2?: Maybe<OpenTaskResult>;
  performProjectRequestWorkflowAction?: Maybe<PerformProjectRequestWorkflowActionResult>;
  predictionCacheCreateTable?: Maybe<Scalars['Boolean']>;
  predictionCachePutProjectRisk?: Maybe<Ppra_PredictionCacheProjectRiskResult>;
  proposeHiredResources: ProposeHiredResourcesResult;
  putAssignedTagValue2?: Maybe<PutAssignedTagValueResult>;
  putAvatar?: Maybe<PutAvatarResult>;
  putBill3?: Maybe<PutBillResult>;
  putBillPayment3?: Maybe<PutBillPaymentResult>;
  putBillPaymentsForBill2?: Maybe<PutBillPaymentsForBillResult>;
  putClientRates3?: Maybe<PutClientRatesResult2>;
  putCreditMemo3?: Maybe<PutCreditMemoResult>;
  putCreditMemosForBill2?: Maybe<PutCreditMemosForBillResult>;
  putExpenseCardSettings?: Maybe<ExpenseCardSettings>;
  /** @deprecated Use putInitialRevenueForProject2, has input validation */
  putInitialRevenueForProject?: Maybe<Scalars['Boolean']>;
  putInitialRevenueForProject2?: Maybe<Scalars['Boolean']>;
  putKeyValueSettings2?: Maybe<Scalars['KeyValueSettings']>;
  putLineItemForBill2?: Maybe<PutLineItemForBillResult>;
  putNotificationPolicies3?: Maybe<PutNotificationPoliciesResult>;
  putNotificationPolicy3?: Maybe<NotificationPolicy>;
  putPortfolio?: Maybe<PutPortfolioResult>;
  putPortfolioBudget?: Maybe<Scalars['String']>;
  putProject2?: Maybe<Project>;
  /** @deprecated Use putProjectBillPlans2, has input validation */
  putProjectBillPlans?: Maybe<PutProjectBillPlansResult>;
  putProjectBillPlans2?: Maybe<PutProjectBillPlansResult>;
  /** @deprecated Use putProjectBillingContract2, has input validation */
  putProjectBillingContract?: Maybe<ProjectBilling>;
  putProjectBillingContract2?: Maybe<ProjectBilling>;
  putProjectRates2?: Maybe<Array<ProjectRate3>>;
  putProjectRates3?: Maybe<PutProjectRatesResult2>;
  putProjectReport: PutProjectReportResult;
  putProjectRequest?: Maybe<PutProjectRequestResult>;
  putProjectRequestResourceAssignments: PutProjectRequestResourceAssignmentResult;
  putProjectRequestScore?: Maybe<ProjectRequestScoreResult>;
  putProjectRequestTimeline?: Maybe<ProjectRequestTimelineResult>;
  putProjectRevenueContractDetails2?: Maybe<PutProjectRevenueContractDetailsResult>;
  putProjectRevenueRecognitionContractBatchUri2?: Maybe<Scalars['Boolean']>;
  putProjectRiskTTLOverride?: Maybe<Scalars['String']>;
  putProjectStatus?: Maybe<ProjectStatusUpdate>;
  putProjectTeamMemberBillingRates3?: Maybe<Scalars['String']>;
  putProjectWorkflowChecklist3?: Maybe<ProjectWorkflowChecklist>;
  putProjectWorkflowChecklistTemplate3?: Maybe<ProjectWorkflowChecklist>;
  putProjectWorkflowState3?: Maybe<ProjectWorkflowState>;
  putResourceRequestAllocation: PutResourceRequestAllocationResult;
  /** @deprecated Use putRevenueEntryComments2, has input validation */
  putRevenueEntryComments?: Maybe<Scalars['Boolean']>;
  putRevenueEntryComments2?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use putRevenueEntryRecognizedRevenue2, has input validation */
  putRevenueEntryRecognizedRevenue?: Maybe<Scalars['Boolean']>;
  putRevenueEntryRecognizedRevenue2?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use putRevenueRunStatusAsComplete2, has input validation */
  putRevenueRunStatusAsComplete?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use putRevenueRunStatusAsComplete3, no longer uses Date scalar */
  putRevenueRunStatusAsComplete2?: Maybe<Scalars['Boolean']>;
  putRevenueRunStatusAsComplete3?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use putRevenueRunStatusAsDraft2, has input validation */
  putRevenueRunStatusAsDraft?: Maybe<Scalars['Boolean']>;
  putRevenueRunStatusAsDraft2?: Maybe<Scalars['Boolean']>;
  putSearchSettings?: Maybe<SearchSettings>;
  putTableSetting2?: Maybe<PutTableSettingResult>;
  putTaskAssignmentsForResource2?: Maybe<Scalars['String']>;
  putTaskEntries?: Maybe<Array<Maybe<TaskEntryPayload>>>;
  putTaskEntry?: Maybe<TaskEntryPayload>;
  putTaskResourceEstimate?: Maybe<PutTaskResourceEstimateResult>;
  putTimeAndExpenseSettings2?: Maybe<TimeAndExpenseSettings>;
  putUserAssignmentForVendor: UserAssignmentForVendorReference;
  putUserCertificate2?: Maybe<PutUserCertificateResult>;
  putUserResourcePools?: Maybe<PutUserResourcePoolsResult>;
  putVendor?: Maybe<Vendor>;
  recalcProjectRisk?: Maybe<Scalars['Boolean']>;
  recalculateProjectEarnedRevenue: RecalculateProjectEarnedRevenueResult;
  recalculateProjectsBillingContractClauses2: RecalculateProjectsBillingContractClausesResult;
  recomputeScoreForResourceRequest?: Maybe<Scalars['Boolean']>;
  reconfigureRevenueRuns?: Maybe<Scalars['Boolean']>;
  recordUserAccess?: Maybe<Scalars['String']>;
  /** @deprecated Use bulkReleaseResourceAllocations */
  releaseResourceAllocation?: Maybe<ReleaseResourceAllocationResult>;
  /** @deprecated Use bulkReleaseResourceAllocations */
  releaseResourceAllocations2?: Maybe<ReleaseResourceAllocationsResult>;
  releaseTaskOwners: Array<ReleaseTaskOwnersResult>;
  removeAssignedTagValue2?: Maybe<RemoveAssignedTagValueResult>;
  removeAvatar?: Maybe<RemoveAvatarResult>;
  removeProjectTimesheetAccessMember2?: Maybe<Scalars['String']>;
  removeProjectTimesheetAccessMembers2?: Maybe<Scalars['String']>;
  removeResourceUserTaskAssignment: RemoveResourceUserTaskAssignmentResult;
  removeTaskResourceAllocations?: Maybe<Scalars['String']>;
  removeTaskResourceEstimate?: Maybe<RemoveTaskResourceEstimateResult>;
  resetNotifications2?: Maybe<PutNotificationPoliciesResult>;
  sendBillByEmail: EmailBillResult;
  sendProjectReportByEmail2: EmailProjectReportResult;
  setMyDefaultRequestAttributeWeights2?: Maybe<SetMyDefaultRequestAttributeWeightsResult>;
  setOverriddenTaskStatus: SetOverriddenTaskStatusResult;
  setTaskAssignedRole2: SetTaskAssignedRoleResult;
  /** @deprecated Use setTaskAssignedUser2, has input validation */
  setTaskAssignedUser: SetTaskAssignedUserResult;
  setTaskAssignedUser2: SetTaskAssignedUserResult;
  /** @deprecated Use setTaskProgressStatus2, has input validation */
  setTaskProgressStatus: SetTaskProgressStatusResult;
  /** @deprecated Use setTaskProgressStatus3, no longer uses Date scalar */
  setTaskProgressStatus2: SetTaskProgressStatusResult;
  setTaskProgressStatus3: SetTaskProgressStatusResult;
  /** @deprecated Use mutation setTaskProgressStatus */
  setTaskStatus: SetTaskStatusResult;
  setTaskTimeEntryDateRange2: SetTaskTimeEntryDateRangeResult;
  /**
   * This mutation is for splitting completed resource requests during migration.
   * Not intended to be used in any other usecase.
   */
  splitAndMigrateResourceRequest: SplitAndMigrateResourceRequestResult;
  syncBills2?: Maybe<SyncBillsOutput>;
  syncProject?: Maybe<ProjectSynchronizeResult>;
  syncProjectStage?: Maybe<ProjectStageSynchronizeResult>;
  syncResourceAllocationsUser2?: Maybe<ResourceAllocationsUserSynchronizeResult>;
  syncResourcingDataSource?: Maybe<ResourcingDataSource>;
  syncRole2?: Maybe<RoleSynchronizeResult>;
  syncTask2: TaskSynchronizeResult;
  /** @deprecated Will be dropping support for dynamodb task entries */
  syncTaskEntryESDataSource?: Maybe<Scalars['String']>;
  syncUniqueInvoiceNumberSetting?: Maybe<InvoiceNumberUniquenessRequirements>;
  syncUser2?: Maybe<UserSynchronizeResult>;
  unassignTasksFromResourceUser: BulkUnassignTasksToResourceUserResult;
  updateBillStatusBatch: UpdateBillStatusBatchResult;
  updateClient2?: Maybe<Client>;
  updateClientBasicInfo2: UpdateClientBasicInfoResponse;
  updateClientBillingInfo2: UpdateClientBillingInfoResponse;
  updateClientRates?: Maybe<PutClientRatesResult2>;
  updateClientRepresentatives2: UpdateClientRepresentativesResponse;
  updateClientStatus2?: Maybe<UpdateClientStatusResult>;
  updateClosedOnDate2?: Maybe<TaskClosedDateResult>;
  updateCoManagers: Scalars['String'];
  updateCurrencyForBill2?: Maybe<UpdateCurrencyForBillResult>;
  updateEstimatedCostOverride?: Maybe<UpdateEstimatedCostOverrideResult>;
  updateExtensionField2?: Maybe<Scalars['String']>;
  updateLocale2?: Maybe<UpdateLocaleResult>;
  updateParentTaskDateRollupSetting: Scalars['String'];
  updateProgram2?: Maybe<ProgramResponse>;
  updateProgramStatus2?: Maybe<UpdateProgramStatusResult>;
  updateProject2?: Maybe<Project>;
  updateProjectAddresses: UpdateProjectAddressesResponse;
  updateProjectBillingRates: Project;
  updateProjectBillingSetting: UpdateProjectBillingSettingResponse;
  updateProjectContacts: UpdateProjectContactInfoResponse;
  updateProjectEarnedRevenueScriptAndRecalculate: RecalculateProjectEarnedRevenueResult;
  updateProjectRates?: Maybe<PutProjectRatesResult2>;
  updateProjectRates2?: Maybe<Array<ProjectRate3>>;
  updateProjectRequestGates?: Maybe<UpdateProjectRequestGatesResult>;
  updateProjectRequestStatus?: Maybe<UpdateProjectRequestStatusResult>;
  updateResourceAllocation2: UpdateResourceAllocationResult;
  updateResourceAllocationRole: UpdateResourceAllocationRoleResult;
  updateResourceRequest2: UpdateResourceRequestResult;
  updateResume: UpdateResumeResult;
  updateRevenueRunBatchUri?: Maybe<Scalars['Boolean']>;
  updateRoleSchedules?: Maybe<UpdateRoleSchedulesResult>;
  updateRoles2?: Maybe<UpdateRolesResult>;
  updateScoreOverrideTotal?: Maybe<ProjectRequestScoreResult>;
  /** @deprecated Use updateUserSkills */
  updateSkills?: Maybe<UpdateSkillsResult>;
  updateStatus?: Maybe<UpdateStatusResult>;
  updateTask: UpdateTaskResult;
  updateTaskResourceAllocations?: Maybe<Scalars['String']>;
  updateTaskResourceUserAllocation: UpdateTaskResourceUserAllocationResult;
  updateTransactionReferenceNumberSetting?: Maybe<Array<Maybe<Scalars['String']>>>;
  updateUserCustomFields2?: Maybe<UpdateCustomFieldResult>;
  updateUserInformation2?: Maybe<UpdateUserInformationResult>;
  /** @deprecated Use updateUserSkills2, has input validation */
  updateUserSkills?: Maybe<UpdateSkillsResult>;
  /** @deprecated Use updateUserSkills3, no longer uses Date Scalar */
  updateUserSkills2?: Maybe<UpdateSkillsResult>;
  updateUserSkills3?: Maybe<UpdateSkillsResult>;
  updateVendor?: Maybe<Vendor>;
  validateTaskName2?: Maybe<ValidateTaskNameResult>;
  voidBill: VoidBillOutput;
};


export type MutationAddClient2Args = {
  client: AddClientInput;
};


export type MutationAddProgram2Args = {
  addProgramInput: AddProgramInput;
};


export type MutationAddProject2Args = {
  projectInput?: InputMaybe<ProjectInput>;
};


export type MutationAddProjectTimesheetAccessMember2Args = {
  accessMemberId: Scalars['String'];
  isResource?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['String'];
};


export type MutationAddProjectTimesheetAccessMembers2Args = {
  accessMemberIds?: InputMaybe<Array<Scalars['String']>>;
  isResource?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['String'];
};


export type MutationAddRole2Args = {
  addRoleInput?: InputMaybe<AddRoleInput>;
};


export type MutationAddSkillArgs = {
  addSkillsInput: AddSkillsInput;
};


export type MutationAddSkill2Args = {
  addSkillsInput: AddSkillsInput;
};


export type MutationApplyUserDefinedSkillModificationsForUserArgs = {
  input: ApplyUserDefinedSkillModificationsForUserInput;
};


export type MutationArchiveProject2Args = {
  input?: InputMaybe<ArchiveProjectInput>;
};


export type MutationAssignProjectRequestsToPortfolioArgs = {
  input?: InputMaybe<AssignProjectRequestsToPortfolioInput>;
};


export type MutationAssignProjectsToPortfolioArgs = {
  input?: InputMaybe<AssignProjectsToPortfolioInput>;
};


export type MutationAssignProjectsToProgram2Args = {
  input?: InputMaybe<AssignProjectsToProgramInput>;
};


export type MutationBeginBulkAcceptAllocationsForResourceRequestArgs = {
  input: BulkAcceptAllocationsForResourceRequestInput;
};


export type MutationBeginBulkProposeAllocationsForResourceRequestArgs = {
  input: BeginBulkProposeAllocationsForResourceRequestInput;
};


export type MutationBeginManageTaskDateUpdatesArgs = {
  input: TaskDateUpdatesInput;
};


export type MutationBeginMassEditProjectBackgroundJobArgs = {
  modificationInput: ProjectInfoModificationInput;
  projectIds: Array<Scalars['String']>;
};


export type MutationBeginRescheduleProjectBackgroundJobArgs = {
  rescheduleProjectInputs: RescheduleProjectInputs;
};


export type MutationBeginResourceUserTaskAssignmentBulkActionArgs = {
  input: BeginResourceUserTaskAssignmentBulkActionInput;
};


export type MutationBulkAcceptAllocationsForResourceRequestArgs = {
  input?: InputMaybe<BulkAcceptAllocationsForResourceRequestInput>;
};


export type MutationBulkAcceptUserCertificateNudgeArgs = {
  nudgeIds: Array<Scalars['String']>;
  userUri: Scalars['String'];
};


export type MutationBulkAcceptUserSkillNudgeArgs = {
  nudgeIds: Array<Scalars['String']>;
  userUri: Scalars['String'];
};


export type MutationBulkAssignResourcePoolsToUserArgs = {
  input: BulkUpdateAvailableResourcePoolsForUserInput;
};


export type MutationBulkAssignSkillToUserArgs = {
  input: BulkAssignSkillToUserInput;
};


export type MutationBulkAssignTasksToResourceUserArgs = {
  input: BulkAssignTasksToResourceUserInput;
};


export type MutationBulkCreateAndAssignSkillsToUserArgs = {
  input: BulkCreateAndAssignSkillsToUserInput;
};


export type MutationBulkCreateBillFromBillingItemsBatchArgs = {
  input: Array<CreateBulkInvoiceFromBillingItemsBatchInput>;
};


export type MutationBulkCreateNewProjectLinkArgs = {
  input: BulkProjectLinkTargetInput;
};


export type MutationBulkDeleteResourceRequests2Args = {
  input: BulkDeleteResourceRequestsInput;
};


export type MutationBulkMarkResourceRequestsAsAllocationRejected2Args = {
  input: BulkMarkResourceRequestsAsAllocationRejectedInput;
};


export type MutationBulkMarkResourceRequestsAsComplete2Args = {
  input: BulkMarkResourceRequestsAsCompleteInput;
};


export type MutationBulkMarkResourceRequestsAsDraft2Args = {
  input: BulkMarkResourceRequestsAsDraftInput;
};


export type MutationBulkMarkResourceRequestsAsRejected2Args = {
  input: BulkMarkResourceRequestsAsRejectedInput;
};


export type MutationBulkMarkResourceRequestsAsSubmitted2Args = {
  input: BulkMarkResourceRequestsAsSubmittedInput;
};


export type MutationBulkMarkResourceRequestsAsTentative2Args = {
  input: BulkMarkResourceRequestsAsTentativeInput;
};


export type MutationBulkMarkResourceRequestsAsToBeHired2Args = {
  input: BulkMarkResourceRequestsAsToBeHiredInput;
};


export type MutationBulkProposeAllocationsForResourceRequestArgs = {
  input?: InputMaybe<BulkProposeAllocationsForResourceRequestInput>;
};


export type MutationBulkPutEstimatedExpensesForProjectArgs = {
  estimatedExpensesEntries?: InputMaybe<Array<InputMaybe<EstimatedExpensesEntryInput>>>;
  projectId: Scalars['String'];
};


export type MutationBulkPutProjectStageArgs = {
  projectIds: Array<Scalars['String']>;
  stageId: Scalars['String'];
};


export type MutationBulkPutResourceRequestAllocationForUserArgs = {
  bulkPutResourceRequestAllocationForUserInput: BulkPutResourceRequestAllocationForUserInput;
};


export type MutationBulkPutUserCertificateArgs = {
  input: BulkPutUserCertificateInput;
};


export type MutationBulkRejectUserCertificateNudgeArgs = {
  nudgeIds: Array<Scalars['String']>;
  userUri: Scalars['String'];
};


export type MutationBulkRejectUserSkillNudgeArgs = {
  nudgeIds: Array<Scalars['String']>;
  userUri: Scalars['String'];
};


export type MutationBulkReleaseResourceAllocationsArgs = {
  input: BulkReleaseResourceAllocationsInput;
};


export type MutationBulkReleaseTaskOwnershipArgs = {
  input: BulkReleaseTaskOwnershipInput;
};


export type MutationBulkUnassignResourcePoolsToUserArgs = {
  input: BulkUpdateAvailableResourcePoolsForUserInput;
};


export type MutationBulkUnassignTasksToResourceUserArgs = {
  input: BulkUnassignTasksToResourceUserInput;
};


export type MutationCancelBackgroundJob2Args = {
  jobId: Scalars['String'];
};


export type MutationCancelBatchArgs = {
  batchId: Scalars['String'];
};


export type MutationCancelBillingBatchArgs = {
  batchId: Scalars['String'];
};


export type MutationCancelClosedHiringResourceRequestArgs = {
  input: CancelClosedHiringResourceRequestInput;
};


export type MutationCancelDeletedHiringResourceRequestArgs = {
  input: CancelDeletedHiringResourceRequestInput;
};


export type MutationChangeResourceUserArgs = {
  input: ChangeResourceUserInput;
};


export type MutationChangeTaskResourceUserArgs = {
  input: ChangeTaskResourceUserInput;
};


export type MutationCloseTask2Args = {
  input: CloseTaskInput;
};


export type MutationComputeScoreForResourceRequestArgs = {
  requestStatusList: Array<ResourceRequestStatus>;
};


export type MutationCreateBillFromBillingItems3Args = {
  billInput: BillInput2;
  lineItemsFromBillingItemsInput: LineItemsFromBillingItemsForBillInput2;
};


export type MutationCreateBillFromBillingItemsBatch3Args = {
  billFromBillingItemsBatchParameter: LineItemsFromBillingItemsBatchInput2;
  billInput: BillInput2;
};


export type MutationCreateFulfillResourceRequestArgs = {
  input: CreateFulfillResourceRequestInput;
};


export type MutationCreateFulfillResourceRequest2Args = {
  input: CreateFulfillResourceRequestInput;
};


export type MutationCreateFulfilledResourceAllocationWithoutResourceRequestArgs = {
  input: CreateFulfilledResourceAllocationWithoutResourceRequestInput;
};


export type MutationCreateInvoiceItemsFromBillingItemsBatch3Args = {
  billId: Scalars['String'];
  input: LineItemsFromBillingItemsBatchInput2;
};


export type MutationCreateLineItemsFromBillingItemsForBill3Args = {
  billId: Scalars['String'];
  input: LineItemsFromBillingItemsForBillInput2;
};


export type MutationCreateMassProjectInfoModificationBatchArgs = {
  modificationInput: ProjectInfoModificationInput;
  projectIds: Array<Scalars['String']>;
};


export type MutationCreateNewProjectLinkArgs = {
  input: ProjectLinkTargetInput;
};


export type MutationCreateProjectBillingContractScriptRecalculationBatchArgs = {
  projectBillingContractScriptUris: Array<Scalars['String']>;
};


export type MutationCreateProjectCopyBatch3Args = {
  projectCopyInputs: ProjectCopyInputs2;
};


export type MutationCreateProjectDeleteBatch2Args = {
  projectIds: Array<Scalars['String']>;
};


export type MutationCreateProjectInfoModificationBatch2Args = {
  projectIds: Array<Scalars['String']>;
  projectWorkflowState: Scalars['String'];
};


export type MutationCreateProjectRevenueForecastRecalculationBatchArgs = {
  dateRange?: InputMaybe<DateRangeInput2>;
  projectId: Scalars['String'];
};


export type MutationCreateProjectRevenuePolicyScriptRecalculationBatch2Args = {
  projectId: Scalars['String'];
};


export type MutationCreateResourceAllocation2Args = {
  input: CreateResourceAllocationInput;
};


export type MutationCreateResourceRequestArgs = {
  input: CreateResourceRequestInput;
};


export type MutationCreateResourceRequest2Args = {
  input: CreateResourceRequestInput;
};


export type MutationCreateRevenueContractScriptRecalculationBatch2Args = {
  date: Scalars['Date'];
};


export type MutationCreateRevenueForecastRecalculationBatchArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
};


export type MutationCreateRevenueForecastRecalculationBatch2Args = {
  dateRange?: InputMaybe<DateRangeInput>;
};


export type MutationCreateRevenueForecastRecalculationBatch3Args = {
  dateRange?: InputMaybe<DateRangeInput2>;
};


export type MutationCreateTask2Args = {
  input: CreateTaskInput;
};


export type MutationCreateTaskResourceUserAllocationArgs = {
  input: CreateTaskResourceUserAllocationInput;
};


export type MutationCreateTimeEntryRevisionGroupBulkModificationBatchArgs = {
  input: TimeEntryRevisionGroupBulkModificationBatchInput;
};


export type MutationCreateUpdateRevenueRunBatchArgs = {
  revenueRunUri?: InputMaybe<Scalars['String']>;
};


export type MutationCreateUpdateRevenueRunBatch2Args = {
  revenueRunUri?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteAttachment2Args = {
  input: DeleteAttachmentInput;
};


export type MutationDeleteBill2Args = {
  id: Scalars['String'];
};


export type MutationDeleteBillPayment2Args = {
  id: Scalars['String'];
};


export type MutationDeleteClient2Args = {
  id: Scalars['String'];
};


export type MutationDeleteCreditMemo2Args = {
  id: Scalars['String'];
};


export type MutationDeleteLineItemForBill2Args = {
  id: Scalars['String'];
};


export type MutationDeletePortfolioArgs = {
  id: Scalars['String'];
};


export type MutationDeleteProgram2Args = {
  id: Scalars['String'];
};


export type MutationDeleteProject2Args = {
  id: Scalars['String'];
};


export type MutationDeleteProjectLinksArgs = {
  input: DeleteProjectLinksInput;
};


export type MutationDeleteProjectReport2Args = {
  input: DeleteProjectReportInput;
};


export type MutationDeleteProjectRequestArgs = {
  id: Scalars['String'];
};


export type MutationDeleteProjectRevenueRecognitionBatchUri2Args = {
  revenueRunUri: Scalars['String'];
};


export type MutationDeleteResourceAllocation2Args = {
  input: DeleteResourceAllocationInput;
};


export type MutationDeleteResourceAllocationsForResourceRequestArgs = {
  input: DeleteResourceAllocationsForResourceRequestInput;
};


export type MutationDeleteResourceRequest2Args = {
  input: DeleteResourceRequestInput;
};


export type MutationDeleteResumeArgs = {
  input: DeleteResumeInput;
};


export type MutationDeleteRevenueRunBatchUriArgs = {
  revenueRunUri: Scalars['String'];
};


export type MutationDeleteTask2Args = {
  input: DeleteTaskInput;
};


export type MutationDeleteTaskEntries2Args = {
  ids: Array<InputMaybe<Scalars['String']>>;
};


export type MutationDeleteTaskResourceUserAllocationArgs = {
  input: DeleteTaskResourceUserAllocationInput;
};


export type MutationDeleteUserCertificate2Args = {
  input: DeleteCertificateInput;
};


export type MutationDeleteVendorArgs = {
  id: Scalars['String'];
};


export type MutationIssueBillArgs = {
  issueBillInput: IssueBillInput;
};


export type MutationLinkAttachmentToObject2Args = {
  input: LinkAttachmentToObjectInput;
};


export type MutationLinkAttachmentsToObject2Args = {
  input: LinkAttachmentsToObjectInput;
};


export type MutationMarkAllNotificationsAsReadArgs = {
  userUri: Scalars['String'];
};


export type MutationMarkAttachmentsAsReadArgs = {
  input: Praa_MarkAttachmentsAsReadInput;
};


export type MutationMarkNotificationAsReadArgs = {
  id: Scalars['String'];
};


export type MutationMarkResourceRequestAsAllocationRejected2Args = {
  input: MarkResourceRequestAsAllocationRejectedInput;
};


export type MutationMarkResourceRequestAsComplete2Args = {
  input: MarkResourceRequestAsCompleteInput;
};


export type MutationMarkResourceRequestAsCompleteAndMergeArgs = {
  input: MarkResourceRequestAsCompleteAndMergeInput;
};


export type MutationMarkResourceRequestAsDraft2Args = {
  input: MarkResourceRequestAsDraftInput;
};


export type MutationMarkResourceRequestAsRejected2Args = {
  input: MarkResourceRequestAsRejectedInput;
};


export type MutationMarkResourceRequestAsSubmittedArgs = {
  input: MarkResourceRequestAsSubmittedInput;
};


export type MutationMarkResourceRequestAsSubmitted2Args = {
  input: MarkResourceRequestAsSubmittedInput;
};


export type MutationMarkResourceRequestAsTentative2Args = {
  input: MarkResourceRequestAsTentativeInput;
};


export type MutationMarkResourceRequestAsToBeHired2Args = {
  input: MarkResourceRequestAsToBeHiredInput;
};


export type MutationMarkToBeHiredResourceRequestWithHiringRequestedSubStatusArgs = {
  input: MarkToBeHiredResourceRequestWithHiringRequestedSubStatusInput;
};


export type MutationMergeAndMigrateResourceAllocationsArgs = {
  input: MergeAndMigrateResourceAllocationsInput;
};


export type MutationModifyAssignedTagValues2Args = {
  input?: InputMaybe<ModifyAssignedTagValuesInput>;
};


export type MutationMoveTask2Args = {
  input: MoveTaskInput;
};


export type MutationOpenBillArgs = {
  openBillInput: OpenBillInput;
};


export type MutationOpenTask2Args = {
  input: OpenTaskInput;
};


export type MutationPerformProjectRequestWorkflowActionArgs = {
  projectRequestId: Scalars['String'];
  statusType: ProjectRequestStatusType;
};


export type MutationPredictionCachePutProjectRiskArgs = {
  date: Scalars['String'];
  predictedDate?: InputMaybe<Scalars['PPRA_Date']>;
  projectUri: Scalars['String'];
};


export type MutationProposeHiredResourcesArgs = {
  input: ProposeHiredResourcesInput;
};


export type MutationPutAssignedTagValue2Args = {
  input?: InputMaybe<PutAssignedTagValueInput>;
};


export type MutationPutAvatarArgs = {
  input: PutAvatarDataInput;
  transformation?: InputMaybe<ImageTransformationParameters>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationPutBill3Args = {
  input: BillInput2;
};


export type MutationPutBillPayment3Args = {
  input: BillPaymentInput2;
};


export type MutationPutBillPaymentsForBill2Args = {
  input: BillPaymentsForBillInput;
};


export type MutationPutClientRates3Args = {
  clientId: Scalars['String'];
  rates?: InputMaybe<Array<ProjectRateInput2>>;
};


export type MutationPutCreditMemo3Args = {
  input: CreditMemoInput2;
};


export type MutationPutCreditMemosForBill2Args = {
  input: CreditMemosForBillInput;
};


export type MutationPutExpenseCardSettingsArgs = {
  allowBillable: Scalars['Boolean'];
  projectId: Scalars['String'];
  showActuals: Scalars['Boolean'];
};


export type MutationPutInitialRevenueForProjectArgs = {
  currencyUri: Scalars['String'];
  forecastedRevenue: Scalars['Float'];
  projectUri: Scalars['String'];
  recognizedRevenue: Scalars['Float'];
};


export type MutationPutInitialRevenueForProject2Args = {
  currencyUri: Scalars['String'];
  forecastedRevenue: Scalars['Float'];
  projectUri: Scalars['String'];
  recognizedRevenue: Scalars['Float'];
};


export type MutationPutKeyValueSettings2Args = {
  input?: InputMaybe<PutKeyValueSettingsInput>;
};


export type MutationPutLineItemForBill2Args = {
  input: LineItemForBillInput;
};


export type MutationPutNotificationPolicies3Args = {
  notificationPolicies?: InputMaybe<Array<NotificationPolicyInput2>>;
};


export type MutationPutNotificationPolicy3Args = {
  notificationPolicy: NotificationPolicyInput2;
};


export type MutationPutPortfolioArgs = {
  input: PutPortfolioInput;
};


export type MutationPutPortfolioBudgetArgs = {
  input: PutPortfolioBudgetInput;
};


export type MutationPutProject2Args = {
  projectInput?: InputMaybe<ProjectInput>;
};


export type MutationPutProjectBillPlansArgs = {
  billPlans?: InputMaybe<Array<ProjectBillPlanInput>>;
  projectId: Scalars['String'];
};


export type MutationPutProjectBillPlans2Args = {
  billPlans?: InputMaybe<Array<ProjectBillPlanInput>>;
  projectId: Scalars['String'];
};


export type MutationPutProjectBillingContractArgs = {
  billingInput: BillingContractInput;
};


export type MutationPutProjectBillingContract2Args = {
  billingInput: BillingContractInput;
};


export type MutationPutProjectRates2Args = {
  dimensionUris?: InputMaybe<Array<Scalars['String']>>;
  projectId: Scalars['String'];
  rates?: InputMaybe<Array<ProjectRateInput3>>;
  requiredDimensionUris?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationPutProjectRates3Args = {
  projectId: Scalars['String'];
  rates?: InputMaybe<Array<ProjectRateInput2>>;
};


export type MutationPutProjectReportArgs = {
  input: ProjectReportInput;
};


export type MutationPutProjectRequestArgs = {
  input: ProjectRequestInput;
};


export type MutationPutProjectRequestResourceAssignmentsArgs = {
  input: PutProjectRequestResourceAssignmentInput;
};


export type MutationPutProjectRequestScoreArgs = {
  input: PutProjectRequestScoreInput;
};


export type MutationPutProjectRequestTimelineArgs = {
  input: PutProjectRequestTimelineInput;
};


export type MutationPutProjectRevenueContractDetails2Args = {
  revenueContractDetailsInput: RevenueContractDetailsInput;
};


export type MutationPutProjectRevenueRecognitionContractBatchUri2Args = {
  revenueRecognitionBatchInput?: InputMaybe<RevenueRecognitionBatchInput>;
};


export type MutationPutProjectStatusArgs = {
  projectUri: Scalars['String'];
  statusUri: Scalars['String'];
};


export type MutationPutProjectTeamMemberBillingRates3Args = {
  billingRateIds: Array<InputMaybe<Scalars['String']>>;
  excludeBillingRateIds: Array<InputMaybe<Scalars['String']>>;
  isAllSelectEnabled: Scalars['Boolean'];
  projectId: Scalars['String'];
  resource?: InputMaybe<TeamMember>;
  textSearch?: InputMaybe<Scalars['String']>;
};


export type MutationPutProjectWorkflowChecklist3Args = {
  checklist?: InputMaybe<ProjectWorkflowChecklistDataInput>;
  projectId: Scalars['String'];
};


export type MutationPutProjectWorkflowChecklistTemplate3Args = {
  checklist?: InputMaybe<ProjectWorkflowChecklistDataInput>;
};


export type MutationPutProjectWorkflowState3Args = {
  projectId: Scalars['String'];
  projectWorkflowStateId: ProjectWorkflowStage;
};


export type MutationPutResourceRequestAllocationArgs = {
  input: PutResourceRequestAllocationInput;
};


export type MutationPutRevenueEntryCommentsArgs = {
  comment: Scalars['String'];
  revenueEntryUri: Scalars['String'];
};


export type MutationPutRevenueEntryComments2Args = {
  comment: Scalars['String'];
  revenueEntryUri: Scalars['String'];
};


export type MutationPutRevenueEntryRecognizedRevenueArgs = {
  amount: Scalars['Float'];
  currencyUri: Scalars['String'];
  revenueEntryUri: Scalars['String'];
};


export type MutationPutRevenueEntryRecognizedRevenue2Args = {
  amount: Scalars['Float'];
  currencyUri: Scalars['String'];
  revenueEntryUri: Scalars['String'];
};


export type MutationPutRevenueRunStatusAsCompleteArgs = {
  nextMonthEndDate?: InputMaybe<Scalars['DateObject']>;
  revenueRunUri: Scalars['String'];
};


export type MutationPutRevenueRunStatusAsComplete2Args = {
  nextMonthEndDate?: InputMaybe<Scalars['DateObject']>;
  revenueRunUri: Scalars['String'];
};


export type MutationPutRevenueRunStatusAsComplete3Args = {
  nextMonthEndDate?: InputMaybe<Scalars['Date2']>;
  revenueRunUri: Scalars['String'];
};


export type MutationPutRevenueRunStatusAsDraftArgs = {
  revenueRunUri: Scalars['String'];
};


export type MutationPutRevenueRunStatusAsDraft2Args = {
  revenueRunUri: Scalars['String'];
};


export type MutationPutSearchSettingsArgs = {
  input?: InputMaybe<PutSearchSettingsInput>;
};


export type MutationPutTableSetting2Args = {
  input?: InputMaybe<PutTableSettingInput>;
};


export type MutationPutTaskAssignmentsForResource2Args = {
  projectId: Scalars['String'];
  taskUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  teamMember: TeamMember;
};


export type MutationPutTaskEntriesArgs = {
  entries?: InputMaybe<Array<InputMaybe<TaskEntryInput2>>>;
};


export type MutationPutTaskEntryArgs = {
  entry?: InputMaybe<TaskEntryInput2>;
};


export type MutationPutTaskResourceEstimateArgs = {
  input: PutTaskResourceEstimateInput;
};


export type MutationPutTimeAndExpenseSettings2Args = {
  timeAndExpenseSettingsInput?: InputMaybe<TimeAndExpenseSettingsInput>;
};


export type MutationPutUserAssignmentForVendorArgs = {
  input: UserAssignmentForVendorInput;
};


export type MutationPutUserCertificate2Args = {
  input: UpdateUserCertificateInput;
};


export type MutationPutUserResourcePoolsArgs = {
  input: PutUserResourcePoolsInput;
};


export type MutationPutVendorArgs = {
  input: PutVendorInput;
};


export type MutationRecalcProjectRiskArgs = {
  projectUri: Scalars['String'];
};


export type MutationRecalculateProjectEarnedRevenueArgs = {
  projectId: Scalars['String'];
};


export type MutationRecalculateProjectsBillingContractClauses2Args = {
  projectUris?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationRecomputeScoreForResourceRequestArgs = {
  input: RecomputeScoreForResourceRequestInput;
};


export type MutationReconfigureRevenueRunsArgs = {
  startDate?: InputMaybe<Scalars['DateObject']>;
};


export type MutationRecordUserAccessArgs = {
  accessInput: UserAccessInput;
};


export type MutationReleaseResourceAllocationArgs = {
  input: ReleaseResourceAllocationInput;
};


export type MutationReleaseResourceAllocations2Args = {
  input: ReleaseResourceAllocationsInput;
};


export type MutationReleaseTaskOwnersArgs = {
  inputs: Array<SetTaskAssignedUserInput>;
};


export type MutationRemoveAssignedTagValue2Args = {
  input?: InputMaybe<RemoveAssignedTagValueInput>;
};


export type MutationRemoveAvatarArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationRemoveProjectTimesheetAccessMember2Args = {
  accessMemberId: Scalars['String'];
  isResource?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['String'];
};


export type MutationRemoveProjectTimesheetAccessMembers2Args = {
  accessMemberIds?: InputMaybe<Array<Scalars['String']>>;
  isResource?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['String'];
};


export type MutationRemoveResourceUserTaskAssignmentArgs = {
  input: RemoveResourceUserTaskAssignmentInput;
};


export type MutationRemoveTaskResourceAllocationsArgs = {
  input?: InputMaybe<RemoveTaskResourceAllocationsInput>;
};


export type MutationRemoveTaskResourceEstimateArgs = {
  input: RemoveTaskResourceEstimateInput;
};


export type MutationResetNotifications2Args = {
  input: ResetNotificationsInput;
};


export type MutationSendBillByEmailArgs = {
  sendBillEmailInput: SendBillEmailInput;
};


export type MutationSendProjectReportByEmail2Args = {
  emailProjectReportInput: EmailProjectReportInput;
};


export type MutationSetMyDefaultRequestAttributeWeights2Args = {
  input: RequestAttributeWeightsInput;
};


export type MutationSetOverriddenTaskStatusArgs = {
  input: SetOverriddenTaskStatusInput;
};


export type MutationSetTaskAssignedRole2Args = {
  input: SetTaskAssignedRoleInput;
};


export type MutationSetTaskAssignedUserArgs = {
  input: SetTaskAssignedUserInput;
};


export type MutationSetTaskAssignedUser2Args = {
  input: SetTaskAssignedUserInput;
};


export type MutationSetTaskProgressStatusArgs = {
  input: SetTaskProgressStatusInput;
};


export type MutationSetTaskProgressStatus2Args = {
  input: SetTaskProgressStatusInput;
};


export type MutationSetTaskProgressStatus3Args = {
  input: SetTaskProgressStatusInput2;
};


export type MutationSetTaskStatusArgs = {
  input: SetTaskStatusInput;
};


export type MutationSetTaskTimeEntryDateRange2Args = {
  input: SetTaskTimeEntryDateRangeInput;
};


export type MutationSplitAndMigrateResourceRequestArgs = {
  input: SplitAndMigrateResourceRequestInput;
};


export type MutationSyncBills2Args = {
  syncBillsInput: SyncBillsInput;
};


export type MutationSyncProjectArgs = {
  synchronizeInput?: InputMaybe<ProjectSynchronizeInput>;
};


export type MutationSyncProjectStageArgs = {
  synchronizeInput: ProjectStageSynchronizeInput;
};


export type MutationSyncResourceAllocationsUser2Args = {
  synchronizeInput?: InputMaybe<ResourceAllocationsUserSynchronizeInput>;
};


export type MutationSyncRole2Args = {
  synchronizeInput?: InputMaybe<RoleSynchronizeInput>;
};


export type MutationSyncTask2Args = {
  synchronizeInput?: InputMaybe<TaskSynchronizeInput>;
};


export type MutationSyncUser2Args = {
  synchronizeInput?: InputMaybe<UserSynchronizeInput>;
};


export type MutationUnassignTasksFromResourceUserArgs = {
  input: UnassignTasksFromResourceUserInput;
};


export type MutationUpdateBillStatusBatchArgs = {
  updateBillStatusBatchParameter: UpdateBillStatusBatchParameter;
};


export type MutationUpdateClient2Args = {
  client: UpdateClientInput;
};


export type MutationUpdateClientBasicInfo2Args = {
  input: UpdateClientBasicInfoInput;
};


export type MutationUpdateClientBillingInfo2Args = {
  input: UpdateClientBillingInfoInput;
};


export type MutationUpdateClientRatesArgs = {
  clientId: Scalars['String'];
  rates?: InputMaybe<Array<ProjectRateInput2>>;
};


export type MutationUpdateClientRepresentatives2Args = {
  input: UpdateClientRepresentativesInput;
};


export type MutationUpdateClientStatus2Args = {
  input: UpdateClientStatusInput;
};


export type MutationUpdateClosedOnDate2Args = {
  input: TaskClosedDateInput;
};


export type MutationUpdateCoManagersArgs = {
  projectId: Scalars['String'];
  userIds: Array<Scalars['String']>;
};


export type MutationUpdateCurrencyForBill2Args = {
  input: UpdateCurrencyForBillInput;
};


export type MutationUpdateEstimatedCostOverrideArgs = {
  input: UpdateEstimatedCostOverrideInput;
};


export type MutationUpdateExtensionField2Args = {
  objectUri: Scalars['String'];
  value: ExtensionFieldValueInput;
};


export type MutationUpdateLocale2Args = {
  input: UpdateUserLocaleInput;
};


export type MutationUpdateParentTaskDateRollupSettingArgs = {
  optionUri: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationUpdateProgram2Args = {
  updateProgramInput?: InputMaybe<UpdateProgramInput>;
};


export type MutationUpdateProgramStatus2Args = {
  input: UpdateProgramStatusInput;
};


export type MutationUpdateProject2Args = {
  projectInput?: InputMaybe<ProjectInput>;
};


export type MutationUpdateProjectAddressesArgs = {
  input: UpdateProjectAddressesInput;
};


export type MutationUpdateProjectBillingRatesArgs = {
  billingRatesInput?: InputMaybe<ProjectBillingRatesInput>;
  projectId: Scalars['String'];
};


export type MutationUpdateProjectBillingSettingArgs = {
  input: UpdateProjectBillingSettingInput;
};


export type MutationUpdateProjectContactsArgs = {
  input: UpdateProjectContactInfoInput;
};


export type MutationUpdateProjectEarnedRevenueScriptAndRecalculateArgs = {
  earnedRevenueScriptId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};


export type MutationUpdateProjectRatesArgs = {
  projectId: Scalars['String'];
  rates?: InputMaybe<Array<ProjectRateInput2>>;
};


export type MutationUpdateProjectRates2Args = {
  dimensionUris?: InputMaybe<Array<Scalars['String']>>;
  projectId: Scalars['String'];
  rates?: InputMaybe<Array<ProjectRateInput3>>;
  requiredDimensionUris?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationUpdateProjectRequestGatesArgs = {
  gates: Array<InputMaybe<ProjectRequestGateInput>>;
  projectRequestId: Scalars['String'];
};


export type MutationUpdateProjectRequestStatusArgs = {
  input: UpdateProjectRequestStatusInput;
};


export type MutationUpdateResourceAllocation2Args = {
  input: UpdateResourceAllocationInput;
};


export type MutationUpdateResourceAllocationRoleArgs = {
  input: UpdateResourceAllocationRoleInput;
};


export type MutationUpdateResourceRequest2Args = {
  input: UpdateResourceRequestInput;
};


export type MutationUpdateResumeArgs = {
  input: UpdateResumeInput;
};


export type MutationUpdateRevenueRunBatchUriArgs = {
  revenueRunBatchInput?: InputMaybe<RevenueRunBatchInput>;
};


export type MutationUpdateRoleSchedulesArgs = {
  input: UpdateUserRoleSchedulesInput;
};


export type MutationUpdateRoles2Args = {
  input: UpdateUserRolesInput;
};


export type MutationUpdateScoreOverrideTotalArgs = {
  input: UpdateScoreOverrideTotalInput;
};


export type MutationUpdateSkillsArgs = {
  userSkillsInput: UserSkillsInput;
};


export type MutationUpdateStatusArgs = {
  input: UpdateStatusInput;
};


export type MutationUpdateTaskArgs = {
  input: UpdateTaskInput;
};


export type MutationUpdateTaskResourceAllocationsArgs = {
  input?: InputMaybe<UpdateTaskResourceAllocationsInput>;
};


export type MutationUpdateTaskResourceUserAllocationArgs = {
  input: UpdateTaskResourceUserAllocationInput;
};


export type MutationUpdateTransactionReferenceNumberSettingArgs = {
  referenceNumberSetting: ReferenceNumberSettingInput;
  transactionType: BillingTransactionType;
};


export type MutationUpdateUserCustomFields2Args = {
  input: UpdateUserCustomFieldInput;
};


export type MutationUpdateUserInformation2Args = {
  input: UpdateUserInput;
};


export type MutationUpdateUserSkillsArgs = {
  input: UpdateUserSkillsInput;
};


export type MutationUpdateUserSkills2Args = {
  input: UpdateUserSkillsInput;
};


export type MutationUpdateUserSkills3Args = {
  input: UpdateUserSkillsInput2;
};


export type MutationUpdateVendorArgs = {
  input: UpdateVendorInput;
};


export type MutationValidateTaskName2Args = {
  input?: InputMaybe<ValidateTaskNameInput>;
};


export type MutationVoidBillArgs = {
  voidBillInput: VoidBillInput;
};

export enum NameCodeUniqueOption {
  Codeuniquenamenotunique = 'CODEUNIQUENAMENOTUNIQUE',
  Nameandcodeunique = 'NAMEANDCODEUNIQUE',
  Nameuniquecodeoptional = 'NAMEUNIQUECODEOPTIONAL'
}

export type Notification = {
  __typename?: 'Notification';
  createdOnTimestamp_id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  message: Scalars['String'];
  targetUrl?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  unreadOnTimestamp_id?: Maybe<Scalars['String']>;
  userUri: Scalars['String'];
};

export type NotificationConfig = {
  __typename?: 'NotificationConfig';
  isEmailNotificationEnabled: Scalars['Boolean'];
  isPushNotificationEnabled: Scalars['Boolean'];
  isWebNotificationEnabled: Scalars['Boolean'];
};

export type NotificationConfigInput = {
  isEmailNotificationEnabled: Scalars['Boolean'];
  isPushNotificationEnabled: Scalars['Boolean'];
  isWebNotificationEnabled: Scalars['Boolean'];
};

export type NotificationEmailInput = {
  ccTo?: InputMaybe<Scalars['String']>;
  emailTo: Scalars['String'];
  replyTo?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  textBody?: InputMaybe<Scalars['String']>;
};

export type NotificationPolicy = {
  __typename?: 'NotificationPolicy';
  config: NotificationConfig;
  enabled: Scalars['Boolean'];
  /** @deprecated Use eventType2 */
  eventType: Scalars['String'];
  eventType2: NotificationPolicyEvent;
  id: Scalars['String'];
  name: Scalars['String'];
  userUri: Scalars['String'];
};

export enum NotificationPolicyEvent {
  ProjectStageChanged = 'PROJECT_STAGE_CHANGED',
  ResourceAllocationAccepted = 'RESOURCE_ALLOCATION_ACCEPTED',
  ResourceAllocationProposed = 'RESOURCE_ALLOCATION_PROPOSED',
  ResourceAllocationRejected = 'RESOURCE_ALLOCATION_REJECTED',
  ResourceAllocationReleased = 'RESOURCE_ALLOCATION_RELEASED',
  ResourceRequestHired = 'RESOURCE_REQUEST_HIRED',
  ResourceRequestHiringCancelled = 'RESOURCE_REQUEST_HIRING_CANCELLED',
  ResourceRequestRejected = 'RESOURCE_REQUEST_REJECTED',
  ResourceRequestSubmitted = 'RESOURCE_REQUEST_SUBMITTED',
  ResourceRequestToBeHired = 'RESOURCE_REQUEST_TO_BE_HIRED',
  TaskAssignmentAssigned = 'TASK_ASSIGNMENT_ASSIGNED',
  TaskStatusChanged = 'TASK_STATUS_CHANGED'
}

export type NotificationPolicyInput = {
  config: NotificationConfigInput;
  eventType: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  userUri: Scalars['String'];
};

export type NotificationPolicyInput2 = {
  config: NotificationConfigInput;
  eventType: NotificationPolicyEvent;
  id?: InputMaybe<Scalars['String']>;
  userUri: Scalars['String'];
};

export type NotificationsResponse = {
  __typename?: 'NotificationsResponse';
  nextPageCursor?: Maybe<Scalars['String']>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
};

export type NumberSetting = {
  __typename?: 'NumberSetting';
  decimalDigits?: Maybe<Scalars['Int']>;
  decimalSeparator?: Maybe<Scalars['String']>;
  dotNetNegativePattern?: Maybe<Scalars['String']>;
  dotNetPositivePattern?: Maybe<Scalars['String']>;
  groupSeparator?: Maybe<Scalars['String']>;
  groupSizes?: Maybe<Array<Maybe<Scalars['Int']>>>;
  negativeSign?: Maybe<Scalars['String']>;
  positiveSign?: Maybe<Scalars['String']>;
};

export type NumberSettingGroup = {
  __typename?: 'NumberSettingGroup';
  currency?: Maybe<NumberSetting>;
  number?: Maybe<NumberSetting>;
};

export enum OsType {
  Linux = 'linux',
  Mac = 'mac',
  Windows = 'windows'
}

export enum ObjectBinding {
  Project = 'PROJECT',
  Resource = 'RESOURCE'
}

export type ObjectReference = {
  __typename?: 'ObjectReference';
  displayText: Scalars['String'];
  id: Scalars['String'];
};

export type OpenBillInput = {
  billId: Scalars['String'];
  summarizeColumnOptions?: InputMaybe<Array<InputMaybe<BillingItemColumn>>>;
};

export type OpenBillOutput = {
  __typename?: 'OpenBillOutput';
  success: Scalars['Boolean'];
};

export type OpenDateRangeInput = {
  endDate?: InputMaybe<Scalars['Date2']>;
  startDate?: InputMaybe<Scalars['Date2']>;
};

export type OpenTaskInput = {
  taskId: Scalars['String'];
};

export type OpenTaskResult = {
  __typename?: 'OpenTaskResult';
  task?: Maybe<Task>;
};

export enum Operator {
  Eq = 'EQ',
  Ge = 'GE',
  Gt = 'GT',
  Le = 'LE',
  Lt = 'LT'
}

export type OtherProjectAllocationSummaryForUserResult = {
  __typename?: 'OtherProjectAllocationSummaryForUserResult';
  periods: Array<OtherProjectAllocationUserPeriod>;
  user: ObjectReference;
};

export type OtherProjectAllocationSummaryForUsersInput = {
  endDate: Scalars['Date2'];
  periodResolution: PeriodResolutionOption;
  startDate: Scalars['Date2'];
  userUris: Array<Scalars['String']>;
};

export type OtherProjectAllocationUserPeriod = {
  __typename?: 'OtherProjectAllocationUserPeriod';
  dateRange: DateRange;
  totalHours: Scalars['Float'];
};

export type OverEstimatedProject = {
  __typename?: 'OverEstimatedProject';
  id?: Maybe<Scalars['String']>;
  project: Project;
  taskCounts?: Maybe<Scalars['Int']>;
};

export enum OverEstimatedProjectType {
  BudgetHours = 'BUDGET_HOURS',
  BudgetHoursOrCost = 'BUDGET_HOURS_OR_COST',
  EndDate = 'END_DATE'
}

export type OverEstimatedProjectsDetails = {
  __typename?: 'OverEstimatedProjectsDetails';
  overEstimatedProjects?: Maybe<Array<Maybe<OverEstimatedProject>>>;
  totalProjects?: Maybe<Scalars['Int']>;
};

export enum OverEstimatedTaskType {
  OverEstimatedCompletionDate = 'OVER_ESTIMATED_COMPLETION_DATE',
  OverEstimatedHours = 'OVER_ESTIMATED_HOURS'
}

export type OverallProgress = {
  __typename?: 'OverallProgress';
  currentProgress: Scalars['Int'];
  maximumProgress: Scalars['Int'];
};

export enum OverriddenTaskStatus {
  ManualInProgress = 'MANUAL_IN_PROGRESS',
  ManualNotStarted = 'MANUAL_NOT_STARTED'
}

export type Ppra_PredictionCacheProjectRiskResult = {
  __typename?: 'PPRA_PredictionCacheProjectRiskResult';
  date: Scalars['PPRA_Date'];
  predictedDate?: Maybe<Scalars['PPRA_Date']>;
  projectUri: Scalars['String'];
  riskScore?: Maybe<Scalars['Int']>;
};

export type Ppra_ProjectRiskModelInputResult = {
  __typename?: 'PPRA_ProjectRiskModelInputResult';
  actuals: Array<Ppra_ResourceEntry>;
  hybridML?: Maybe<Scalars['Boolean']>;
  modelTimestamp?: Maybe<Scalars['PPRA_Date']>;
  plannedEndDate?: Maybe<Scalars['PPRA_Date']>;
  plannedHours?: Maybe<Scalars['Int']>;
  plannedStartDate?: Maybe<Scalars['PPRA_Date']>;
  predictionDate?: Maybe<Scalars['PPRA_Date']>;
  resourcePlan: Array<Ppra_ResourceEntry>;
  resourceUtilization: Array<Maybe<Ppra_ResourceUtilization>>;
  unplannedTimeOff: Array<Ppra_ResourceEntry>;
};

export type Ppra_ResourceEntry = {
  __typename?: 'PPRA_ResourceEntry';
  entrydate: Scalars['PPRA_Date'];
  hours: Scalars['Float'];
};

export type Ppra_ResourceUtilization = {
  __typename?: 'PPRA_ResourceUtilization';
  entrydate: Scalars['PPRA_Date'];
  lowBillabilityPercentage: Scalars['Float'];
  timeOffPercentage: Scalars['Float'];
  underUtilizationPercentage: Scalars['Float'];
};

export type Praa_AttachmentInfo = {
  __typename?: 'PRAA_AttachmentInfo';
  id: Scalars['String'];
  notifyUser?: Maybe<Scalars['Boolean']>;
  processed?: Maybe<Scalars['Boolean']>;
};

export type Praa_AttachmentsInfoInput = {
  binaryObjectUris: Array<Scalars['String']>;
};

export type Praa_BulkResourceMatch = {
  __typename?: 'PRAA_BulkResourceMatch';
  id: Scalars['String'];
  resourceMatches?: Maybe<Array<Praa_ResourceMatch>>;
};

export type Praa_CurrentExperience = {
  __typename?: 'PRAA_CurrentExperience';
  end_date?: Maybe<Scalars['String']>;
  is_primary: Scalars['Boolean'];
  proficiency?: Maybe<Scalars['String']>;
  role_name: Scalars['String'];
  start_date?: Maybe<Scalars['String']>;
  years_of_exp: Scalars['Float'];
};

export type Praa_Education = {
  __typename?: 'PRAA_Education';
  degree?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['String']>;
};

export type Praa_MarkAttachmentsAsReadInput = {
  binaryObjectUris: Array<Scalars['String']>;
};

export type Praa_PastExperience = {
  __typename?: 'PRAA_PastExperience';
  current_role: Scalars['Boolean'];
  end_date?: Maybe<Scalars['String']>;
  experience: Scalars['String'];
  proficiency: Scalars['String'];
  role: Scalars['String'];
  start_date?: Maybe<Scalars['String']>;
  years_of_exp: Scalars['Float'];
};

export type Praa_ResourceMatch = {
  __typename?: 'PRAA_ResourceMatch';
  id: Scalars['String'];
  preferred: Scalars['Boolean'];
  role: Scalars['String'];
  score: Scalars['Int'];
  userUri: Scalars['String'];
};

export type Praa_ResourceMatchStatus = {
  __typename?: 'PRAA_ResourceMatchStatus';
  id: Scalars['String'];
  status: Praa_ResourceMatchesStatus;
};

export type Praa_ResourceMatchesFilter = {
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type Praa_ResourceMatchesInput = {
  filter?: InputMaybe<Praa_ResourceMatchesFilter>;
  orderBy?: InputMaybe<Praa_ResourceMatchesSortDirection>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  resourceRequestUris: Array<Scalars['String']>;
};

export enum Praa_ResourceMatchesSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum Praa_ResourceMatchesStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export type Praa_ResourceMatchesStatusInput = {
  resourceRequestUris: Array<Scalars['String']>;
};

export type Praa_UserCertificateNudgeError = {
  __typename?: 'PRAA_UserCertificateNudgeError';
  error: Scalars['String'];
  nudge: Praa_UserProfileCertificate;
};

export type Praa_UserCertificateNudgesResponse = {
  __typename?: 'PRAA_UserCertificateNudgesResponse';
  errors: Array<Praa_UserCertificateNudgeError>;
  nudges: Array<Praa_UserProfileCertificate>;
};

export type Praa_UserNudgeError = {
  __typename?: 'PRAA_UserNudgeError';
  error: Scalars['String'];
  nudgeId: Scalars['String'];
};

export type Praa_UserNudges = {
  __typename?: 'PRAA_UserNudges';
  certificateNudges?: Maybe<Array<Praa_UserProfileCertificate>>;
  id: Scalars['String'];
  skillNudges?: Maybe<Array<Praa_UserProfileSkill>>;
};

export type Praa_UserProfile = {
  __typename?: 'PRAA_UserProfile';
  categorized_skills?: Maybe<Scalars['PRAA_CategorizedSkills']>;
  certifications?: Maybe<Scalars['PRAA_UserProfileCertifications']>;
  certifications_with_validity?: Maybe<Scalars['PRAA_UserProfileCertifications']>;
  company_key?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  current_experience?: Maybe<Array<Maybe<Praa_CurrentExperience>>>;
  current_organization_from_resume?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  education?: Maybe<Array<Maybe<Praa_Education>>>;
  employee_type?: Maybe<Scalars['String']>;
  hourly_rate?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  location?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  past_experience?: Maybe<Array<Maybe<Praa_PastExperience>>>;
  proficiency?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  skills_with_proficiency?: Maybe<Scalars['PRAA_SkillsWithProficiency']>;
  start_date?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['PRAA_Tags']>;
  tools_with_proficiency?: Maybe<Scalars['PRAA_ToolsWithProficiency']>;
};

export type Praa_UserProfileCertificate = {
  __typename?: 'PRAA_UserProfileCertificate';
  authority?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['String']>;
  issueDate?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nudgeId: Scalars['String'];
};

export type Praa_UserProfileCertificates = {
  __typename?: 'PRAA_UserProfileCertificates';
  certificates?: Maybe<Array<Praa_UserProfileCertificate>>;
  id: Scalars['String'];
};

export type Praa_UserProfileSkill = {
  __typename?: 'PRAA_UserProfileSkill';
  categoryName: Scalars['String'];
  categoryUri?: Maybe<Scalars['String']>;
  isSkillEnabled?: Maybe<Scalars['Boolean']>;
  nudgeId: Scalars['String'];
  skillLevel?: Maybe<Scalars['Int']>;
  skillLevelName: Scalars['String'];
  skillLevelUri: Scalars['String'];
  skillName: Scalars['String'];
  skillUri?: Maybe<Scalars['String']>;
};

export type Praa_UserProfileSkills = {
  __typename?: 'PRAA_UserProfileSkills';
  id: Scalars['String'];
  skills?: Maybe<Array<Praa_UserProfileSkill>>;
};

export type Praa_UserSkillNudgeError = {
  __typename?: 'PRAA_UserSkillNudgeError';
  error: Scalars['String'];
  nudge: Praa_UserProfileSkill;
};

export type Praa_UserSkillNudgesResponse = {
  __typename?: 'PRAA_UserSkillNudgesResponse';
  errors: Array<Praa_UserSkillNudgeError>;
  nudges: Array<Praa_UserProfileSkill>;
};

export type Pti_DtmSessionMetadata = {
  __typename?: 'PTI_DtmSessionMetadata';
  session: Pti_Session;
  user?: Maybe<Pti_UserReference1>;
};

export type Pti_HuaUser = {
  __typename?: 'PTI_HuaUser';
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type Pti_Requisition = {
  __typename?: 'PTI_Requisition';
  code?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['PTI_DateTime']>;
  datePosted?: Maybe<Scalars['PTI_DateTime']>;
  hiresNeeded?: Maybe<Scalars['Int']>;
  hiringManager?: Maybe<Pti_HuaUser>;
  id: Scalars['Int'];
  jobTitle?: Maybe<Scalars['String']>;
  recruiter?: Maybe<Pti_HuaUser>;
  requisitionUrl?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type Pti_Session = {
  __typename?: 'PTI_Session';
  clientId: Scalars['String'];
  expiresAt: Scalars['String'];
  idHash: Scalars['String'];
  issuedAt: Scalars['String'];
  lastUsedAt: Scalars['String'];
  scopes: Array<Maybe<Scalars['String']>>;
  sid?: Maybe<Scalars['String']>;
  tenant: Scalars['String'];
  user: Scalars['String'];
};

export type Pti_UserReference1 = {
  __typename?: 'PTI_UserReference1';
  displayText: Scalars['String'];
  loginName: Scalars['String'];
  slug: Scalars['String'];
  uri: Scalars['String'];
};

export type PageOfProjectPortfolioInput = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type PageOfProjectRateTableRoleOptionsFilter = {
  inRateTable: Scalars['Boolean'];
  searchText?: InputMaybe<Scalars['String']>;
};

export type PageOfProjectRateTableRoleOptionsInput = {
  filter?: InputMaybe<PageOfProjectRateTableRoleOptionsFilter>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  projectId: Scalars['String'];
};

export type PageOfProjectRequestPortfoliosInput = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type PageOfProjectResourceDropdownOptionsInput = {
  assignedTaskId?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ProjectResourceDropdownOptionFilter>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  projectId: Scalars['String'];
};

export type PageOfProjectResourceDropdownOptionsResponse = {
  __typename?: 'PageOfProjectResourceDropdownOptionsResponse';
  dropdownOptions?: Maybe<Array<ProjectResourceDropdownOption>>;
  hasMore?: Maybe<Scalars['Boolean']>;
};

export type PageOfResourceUsersDropdownOptionsInput = {
  assignedTaskId?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<GetResourceUsersFilter>;
  page: Scalars['Int'];
  pagesize: Scalars['Int'];
  sort?: InputMaybe<Array<ResourceUserSort>>;
  targetCurrencyId?: InputMaybe<Scalars['String']>;
};

export type PageOfTaskAssignmentSummaryForProjectAndResourceUserInput = {
  filter?: InputMaybe<TaskAssignmentSummaryForProjectAndResourceUserFilter>;
  projectId: Scalars['String'];
  userId: Scalars['String'];
};

export type PageOfTaskAssignmentSummaryForProjectAndResourceUserResponse = {
  __typename?: 'PageOfTaskAssignmentSummaryForProjectAndResourceUserResponse';
  taskSummary: Array<TaskAssignmentSummaryForProjectAndResourceUser>;
};

export type PageOfTaskResourceUserAllocationsResult = {
  __typename?: 'PageOfTaskResourceUserAllocationsResult';
  nextPageCursor?: Maybe<Scalars['String']>;
  taskAllocations: Array<TaskResourceUserAllocation>;
};

export type PaginatedGetProjectReportsResponse = {
  __typename?: 'PaginatedGetProjectReportsResponse';
  nextPageCursor?: Maybe<Scalars['String']>;
  projectReports: Array<Maybe<ProjectReport>>;
};

export type PayCode = {
  __typename?: 'PayCode';
  displayText: Scalars['String'];
  id: Scalars['String'];
};

export type PaymentMethodReference = {
  __typename?: 'PaymentMethodReference';
  displayText: Scalars['String'];
  id: Scalars['String'];
};

export type PerformProjectRequestWorkflowActionResult = {
  __typename?: 'PerformProjectRequestWorkflowActionResult';
  projectRequestUri: Scalars['String'];
};

export type PeriodInput = {
  endDate?: InputMaybe<Scalars['Date2']>;
  startDate?: InputMaybe<Scalars['Date2']>;
};

export enum PeriodResolutionOption {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type Permission = {
  __typename?: 'Permission';
  dataAccessLevelUris?: Maybe<Array<Maybe<Scalars['String']>>>;
  permissionActionUri?: Maybe<Scalars['String']>;
};

export type PongResponse = {
  __typename?: 'PongResponse';
  message?: Maybe<Scalars['String']>;
};

export type Portfolio = {
  __typename?: 'Portfolio';
  ancestors: Array<PortfolioAncestor>;
  budget?: Maybe<PortfolioBudget>;
  canBeDeleted?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  effectiveStatus?: Maybe<PortfolioStatus>;
  hasViewAccess?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isDataRow?: Maybe<Scalars['Boolean']>;
  isEditable?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parent?: Maybe<Portfolio>;
  permittedActionUris: Array<Scalars['String']>;
  portfolioCurrency?: Maybe<Currency>;
  portfolioManager?: Maybe<ObjectReference>;
  rolledUpProjectBudgetHours?: Maybe<Scalars['Float']>;
  rolledUpProjectBudgets?: Maybe<Money>;
  rolledUpProjectBudgetsPercentage?: Maybe<Scalars['Float']>;
  rolledUpTotalActualCost?: Maybe<Money>;
  rolledUpTotalActualHours?: Maybe<Scalars['Float']>;
  rolledUpTotalEstimateAtCompletionCost?: Maybe<Money>;
  rolledUpTotalEstimateAtCompletionHours?: Maybe<Scalars['Float']>;
  slug: Scalars['String'];
  status?: Maybe<PortfolioStatus>;
};

export type PortfolioAncestor = {
  __typename?: 'PortfolioAncestor';
  displayText: Scalars['String'];
  id: Scalars['String'];
  portfolioManager?: Maybe<ObjectReference>;
};

export type PortfolioBudget = {
  __typename?: 'PortfolioBudget';
  capital?: Maybe<Money>;
  operational?: Maybe<Money>;
  total?: Maybe<Money>;
};

export enum PortfolioColumn {
  Ancestors = 'ancestors',
  Description = 'description',
  EffectiveStatus = 'effectiveStatus',
  HasViewAccess = 'hasViewAccess',
  IsEditable = 'isEditable',
  PlannedBudgetCapexInBaseCurrency = 'plannedBudgetCapexInBaseCurrency',
  PlannedBudgetInBaseCurrency = 'plannedBudgetInBaseCurrency',
  PlannedBudgetOpexInBaseCurrency = 'plannedBudgetOpexInBaseCurrency',
  Portfolio = 'portfolio',
  PortfolioManager = 'portfolioManager',
  RolledUpProjectBudgetHours = 'rolledUpProjectBudgetHours',
  RolledUpProjectBudgets = 'rolledUpProjectBudgets',
  RolledUpProjectBudgetsPercentage = 'rolledUpProjectBudgetsPercentage',
  RolledUpTotalActualCost = 'rolledUpTotalActualCost',
  RolledUpTotalActualHours = 'rolledUpTotalActualHours',
  RolledUpTotalEstimateAtCompletionCost = 'rolledUpTotalEstimateAtCompletionCost',
  RolledUpTotalEstimateAtCompletionHours = 'rolledUpTotalEstimateAtCompletionHours',
  /** @deprecated Use effectiveStatus */
  Status = 'status'
}

export type PortfolioFilter = {
  effectiveStatus?: InputMaybe<PortfolioStatus>;
  includeOnlyMyPortfolios?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

export type PortfolioForFilteringProjectRequests = {
  __typename?: 'PortfolioForFilteringProjectRequests';
  displayText: Scalars['String'];
  hasAssignment: Scalars['Boolean'];
  hierarchyLevel: Scalars['Int'];
  id: Scalars['String'];
};

export type PortfolioForFilteringProjects = {
  __typename?: 'PortfolioForFilteringProjects';
  displayText: Scalars['String'];
  hasAssignment: Scalars['Boolean'];
  hierarchyLevel: Scalars['Int'];
  id: Scalars['String'];
};

export type PortfolioInput = {
  id?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type PortfolioProjectRequestStatusEstimatedCostSummaryResult = {
  __typename?: 'PortfolioProjectRequestStatusEstimatedCostSummaryResult';
  approved?: Maybe<Scalars['Float']>;
  inReview?: Maybe<Scalars['Float']>;
  new?: Maybe<Scalars['Float']>;
  rejected?: Maybe<Scalars['Float']>;
};

export type PortfolioProjectStatusBudgetSummary = {
  __typename?: 'PortfolioProjectStatusBudgetSummary';
  archived?: Maybe<Scalars['Float']>;
  closeout?: Maybe<Scalars['Float']>;
  execution?: Maybe<Scalars['Float']>;
  initiate?: Maybe<Scalars['Float']>;
  planning?: Maybe<Scalars['Float']>;
};

export type PortfolioProjectsProgressSummary = {
  __typename?: 'PortfolioProjectsProgressSummary';
  rolledUpProjectBudgetHours?: Maybe<Scalars['Float']>;
  rolledUpProjectBudgets?: Maybe<Money>;
  rolledUpTotalActualCost?: Maybe<Money>;
  rolledUpTotalActualHours?: Maybe<Scalars['Float']>;
  rolledUpTotalEstimateAtCompletionCost?: Maybe<Money>;
  rolledUpTotalEstimateAtCompletionHours?: Maybe<Scalars['Float']>;
};

export type PortfolioReference = {
  __typename?: 'PortfolioReference';
  displayText: Scalars['String'];
  id: Scalars['String'];
  slug: Scalars['String'];
};

export enum PortfolioStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type PortfolioSummaryCountResult = {
  __typename?: 'PortfolioSummaryCountResult';
  allItems?: Maybe<Scalars['Int']>;
  inactive?: Maybe<Scalars['Int']>;
  myItems?: Maybe<Scalars['Int']>;
};

export type PortfolioSummaryFilter = {
  effectiveStatus?: InputMaybe<PortfolioStatus>;
  includeDescendants?: InputMaybe<Scalars['Boolean']>;
  includeOnlyMyPortfolios?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

export type PreviewBulkUnassignTasksToResourceUserResult = {
  __typename?: 'PreviewBulkUnassignTasksToResourceUserResult';
  hasTaskResourceAllocation: Scalars['Boolean'];
};

export type ProductivityGroupDetails = {
  __typename?: 'ProductivityGroupDetails';
  actualHours?: Maybe<Scalars['Float']>;
  displayText: Scalars['String'];
  groupId: Scalars['String'];
  targetHours?: Maybe<Scalars['Float']>;
};

export type Program = {
  __typename?: 'Program';
  billPlanOverview2?: Maybe<Scalars['BillPlansOverviewData']>;
  billPlanOverview3?: Maybe<BillPlansOverviewData2>;
  billingOverview2?: Maybe<BillingOverview>;
  budget?: Maybe<Budget>;
  canBeDeleted?: Maybe<Scalars['Boolean']>;
  costAmountSummary?: Maybe<ProgramCostAmountSummary>;
  costSeriesData?: Maybe<CostSeriesData>;
  displayText?: Maybe<Scalars['String']>;
  /** @deprecated Use endDate2 */
  endDate?: Maybe<Scalars['DateObject']>;
  endDate2?: Maybe<Scalars['Date2']>;
  hourSeriesData?: Maybe<Array<Maybe<HoursDataPoint>>>;
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  permittedActionUris?: Maybe<Array<Maybe<Scalars['String']>>>;
  programManagerReference?: Maybe<ProgramManagerReference>;
  projectsCount?: Maybe<Scalars['Int']>;
  projectsStatusCountSummary?: Maybe<ProjectsStatusCountSummary>;
  revenueAmountSummary?: Maybe<ProgramRevenueAmountSummary>;
  slug?: Maybe<Scalars['String']>;
  /** @deprecated Use startDate2 */
  startDate?: Maybe<Scalars['DateObject']>;
  startDate2?: Maybe<Scalars['Date2']>;
  timeEnteredSummary?: Maybe<ProgramTimeEnteredSummary>;
  totalActualBilling?: Maybe<Money>;
  totalActualCost?: Maybe<Money>;
  totalActualExpenseCost?: Maybe<Money>;
  totalActualHours?: Maybe<Scalars['Float']>;
  totalActualResourceCost?: Maybe<Money>;
  totalActualRevenue?: Maybe<Money>;
  totalEstimatedBilling?: Maybe<Money>;
  totalEstimatedCost?: Maybe<Money>;
  totalEstimatedHours?: Maybe<Scalars['Float']>;
  uri?: Maybe<Scalars['String']>;
};


export type ProgramBillPlanOverview2Args = {
  dateRange?: InputMaybe<DateRangeInput2>;
  overviewMode: BillPlanOverviewMode;
  periodResolutionUri?: InputMaybe<Scalars['String']>;
};


export type ProgramBillPlanOverview3Args = {
  dateRange?: InputMaybe<DateRangeInput2>;
  overviewMode: BillPlanOverviewMode;
  periodResolutionUri?: InputMaybe<Scalars['String']>;
};


export type ProgramBillingOverview2Args = {
  dateRange?: InputMaybe<DateRangeInput2>;
  periodResolutionUri?: InputMaybe<Scalars['String']>;
};


export type ProgramCostAmountSummaryArgs = {
  dateRange?: InputMaybe<DateTimeRangeInput>;
};


export type ProgramCostSeriesDataArgs = {
  costSeriesInput?: InputMaybe<CostSeriesInput>;
};


export type ProgramHourSeriesDataArgs = {
  dateRange?: InputMaybe<DateTimeRangeInput>;
};


export type ProgramRevenueAmountSummaryArgs = {
  dateRange?: InputMaybe<DateTimeRangeInput>;
};


export type ProgramTimeEnteredSummaryArgs = {
  dateRange?: InputMaybe<DateTimeRangeInput>;
};

export type ProgramCostAmountSummary = {
  __typename?: 'ProgramCostAmountSummary';
  costActual?: Maybe<Money>;
  costTotalEstimated?: Maybe<Money>;
};

export type ProgramError = {
  __typename?: 'ProgramError';
  reason?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ProgramFilter = {
  dateRange?: InputMaybe<DateRangeInput>;
  includeMyProgramsOnly?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  programManagers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type ProgramFilter2 = {
  dateRange?: InputMaybe<DateRangeInput2>;
  includeMyProgramsOnly?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  programManagers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type ProgramInput = {
  displayText?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type ProgramManager = {
  __typename?: 'ProgramManager';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};

export type ProgramManagerReference = {
  __typename?: 'ProgramManagerReference';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type ProgramManagerReferenceInput = {
  displayText?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type ProgramReference = {
  __typename?: 'ProgramReference';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  program?: Maybe<Program>;
  slug?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type ProgramReferencesList = ListResults & {
  __typename?: 'ProgramReferencesList';
  items?: Maybe<Array<Maybe<ProgramReference>>>;
  totalItems?: Maybe<Scalars['Int']>;
};

export type ProgramResponse = {
  __typename?: 'ProgramResponse';
  error?: Maybe<ProgramError>;
  program?: Maybe<Program>;
};

export type ProgramRevenueAmountSummary = {
  __typename?: 'ProgramRevenueAmountSummary';
  revenueActual?: Maybe<Money>;
};

export type ProgramSort = {
  direction: SortDirection;
  field: ProgramSortableFields;
};

export enum ProgramSortableFields {
  ActualCost = 'actualCost',
  ActualRevenue = 'actualRevenue',
  IsActive = 'isActive',
  Name = 'name',
  ProgramManagerReference = 'programManagerReference',
  ProjectsCount = 'projectsCount',
  TotalActualBilling = 'totalActualBilling',
  TotalActualCost = 'totalActualCost',
  TotalActualExpenseCost = 'totalActualExpenseCost',
  TotalActualHours = 'totalActualHours',
  TotalActualResourceCost = 'totalActualResourceCost',
  TotalEstimatedBilling = 'totalEstimatedBilling',
  TotalEstimatedCost = 'totalEstimatedCost',
  TotalEstimatedHours = 'totalEstimatedHours'
}

export type ProgramTimeEnteredSummary = {
  __typename?: 'ProgramTimeEnteredSummary';
  timeEnteredActual?: Maybe<Scalars['Float']>;
  timeEnteredTotalEstimated?: Maybe<Scalars['Float']>;
};

export type ProgramTotals = {
  __typename?: 'ProgramTotals';
  projectsCount?: Maybe<Scalars['Int']>;
  totalActualBilling?: Maybe<Money>;
  totalActualCost?: Maybe<Money>;
  totalActualExpenseCost?: Maybe<Money>;
  totalActualHours?: Maybe<Scalars['Float']>;
  totalActualResourceCost?: Maybe<Money>;
  totalActualRevenue?: Maybe<Money>;
  totalEstimatedBilling?: Maybe<Money>;
  totalEstimatedCost?: Maybe<Money>;
  totalEstimatedHours?: Maybe<Scalars['Float']>;
};

export type ProgramWithOverEstimatedProjectCount = {
  __typename?: 'ProgramWithOverEstimatedProjectCount';
  program: ProgramReference;
  projectsCount: Scalars['Int'];
};

export type ProgramsList = ListResults & {
  __typename?: 'ProgramsList';
  items?: Maybe<Array<Maybe<Program>>>;
  totalItems?: Maybe<Scalars['Int']>;
};

export type ProgramsWithOverEstimatedProjectList = ListResults & {
  __typename?: 'ProgramsWithOverEstimatedProjectList';
  items?: Maybe<Array<Maybe<ProgramWithOverEstimatedProjectCount>>>;
  totalItems?: Maybe<Scalars['Int']>;
};

export type Project = {
  __typename?: 'Project';
  actualBilling?: Maybe<Money>;
  actualBillingInProjectCurrency?: Maybe<Money>;
  actualCost?: Maybe<Money>;
  actualCostAmountInPortfolioCurrency?: Maybe<Scalars['Float']>;
  actualCostInProjectCurrency?: Maybe<Money>;
  actualExpenseCost?: Maybe<Money>;
  actualHours?: Maybe<Scalars['Float']>;
  actualResourceCost?: Maybe<Money>;
  addresses?: Maybe<Array<Address>>;
  allocationsSummary: ProjectAllocationSummaryResult;
  allocationsTotals?: Maybe<ResourcePlanTotals>;
  /** @deprecated Use assignedTaskCount2 */
  assignedTaskCount: Scalars['Int'];
  assignedTaskCount2?: Maybe<AssignedTaskCount2>;
  assignedTasksForResource?: Maybe<Array<Maybe<Scalars['String']>>>;
  billPlanOverview2?: Maybe<Scalars['BillPlansOverviewData']>;
  billPlanOverview3?: Maybe<BillPlansOverviewData2>;
  billPlans?: Maybe<ProjectBillPlans>;
  billedRevenueAmountSummary?: Maybe<RevenueAmountSummary>;
  billingContract?: Maybe<BillingContract>;
  billingDetails?: Maybe<ProjectBilling>;
  billingOverview2?: Maybe<BillingOverview>;
  billingType?: Maybe<BillingType>;
  budget?: Maybe<Budget>;
  budgetCostAmountInPortfolioCurrency?: Maybe<Scalars['Float']>;
  budgetCostUsedPercentage?: Maybe<Scalars['Float']>;
  budgetHours?: Maybe<Scalars['Float']>;
  budgetHoursRemaining?: Maybe<Scalars['Float']>;
  budgetHoursUsed?: Maybe<Scalars['Float']>;
  budgetedCost?: Maybe<Money>;
  budgetedCostInProjectCurrency?: Maybe<Money>;
  bulkResourcePlanUserActualSeriesByRole: Array<BulkResourcePlanUserActualSeriesByRoleResponse>;
  canBeDeleted?: Maybe<Scalars['Boolean']>;
  client?: Maybe<ClientReference>;
  clientBillingAllocation?: Maybe<ClientBillingAllocation>;
  clientRepresentative?: Maybe<ClientRepresentative>;
  clientSchedule?: Maybe<Array<Maybe<ClientSchedule>>>;
  clients?: Maybe<Array<Maybe<ClientCostAllocation>>>;
  coManagerCount?: Maybe<Scalars['Int']>;
  coManagers?: Maybe<Array<Maybe<User>>>;
  code?: Maybe<Scalars['String']>;
  contacts?: Maybe<Array<Contact>>;
  copyProjectJobId?: Maybe<Scalars['String']>;
  costAmountSummary?: Maybe<CostAmountSummary>;
  costCenter?: Maybe<Groups>;
  costSeriesData?: Maybe<CostSeriesData>;
  costType?: Maybe<CostType>;
  customFieldValues?: Maybe<Array<Maybe<CustomFieldValue>>>;
  defaultBillSettings?: Maybe<BillSettings>;
  defaultBillingCurrency?: Maybe<Currency>;
  defaultScheduleRule?: Maybe<DefaultScheduleRule>;
  department?: Maybe<Groups>;
  description?: Maybe<Scalars['String']>;
  displayText?: Maybe<Scalars['String']>;
  division?: Maybe<Groups>;
  earnedRevenue?: Maybe<Money>;
  earnedRevenueScript?: Maybe<Script>;
  effectiveBillingRates?: Maybe<Array<Maybe<EffectiveBillingRate>>>;
  employeeType?: Maybe<Groups>;
  /** @deprecated Use endDate2 */
  endDate?: Maybe<Scalars['Date']>;
  endDate2?: Maybe<Scalars['Date2']>;
  estimatedBilling?: Maybe<Money>;
  estimatedBillingInProjectCurrency?: Maybe<Money>;
  estimatedBudgetCostRemaining?: Maybe<Money>;
  estimatedBudgetCostRemainingInPortfolioCurrency?: Maybe<Scalars['Float']>;
  estimatedBudgetCostRemainingInProjectCurrency?: Maybe<Money>;
  estimatedBudgetHoursRemaining?: Maybe<Scalars['Float']>;
  estimatedCost?: Maybe<Money>;
  estimatedCostAtCompletion?: Maybe<Money>;
  estimatedCostAtCompletionInPortfolioCurrency?: Maybe<Scalars['Float']>;
  estimatedCostAtCompletionInProjectCurrency?: Maybe<Money>;
  estimatedExpenses?: Maybe<Money>;
  estimatedHours?: Maybe<Scalars['Float']>;
  estimatedHoursAtCompletion?: Maybe<Scalars['Float']>;
  /** @deprecated Use estimatedTaskCompletionDate2 */
  estimatedTaskCompletionDate?: Maybe<Scalars['Date']>;
  estimatedTaskCompletionDate2?: Maybe<Scalars['Date2']>;
  estimationMode?: Maybe<EstimationMode>;
  expenseBudgetedCost?: Maybe<Money>;
  expenseCodes?: Maybe<Array<Maybe<ExpenseCode>>>;
  extensionFieldValues?: Maybe<Array<Maybe<ExtensionFieldValue>>>;
  /** @deprecated Use finalTaskEndDate2 */
  finalTaskEndDate?: Maybe<Scalars['Date']>;
  finalTaskEndDate2?: Maybe<Scalars['Date2']>;
  getProjectRoleReferencedStatusInProjectRateTable?: Maybe<ProjectRoleRateTableReferenceStatus>;
  hasTaskResourceAllocation: Scalars['Boolean'];
  hourDetails?: Maybe<Array<Maybe<HoursDataPoint>>>;
  id: Scalars['String'];
  /** @deprecated Use initialTaskStartDate2 */
  initialTaskStartDate?: Maybe<Scalars['Date']>;
  initialTaskStartDate2?: Maybe<Scalars['Date2']>;
  isProjectLeaderApprovalRequired?: Maybe<Scalars['Boolean']>;
  isTaskDateRollupEnabled: Scalars['Boolean'];
  isTimeEntryAllowed?: Maybe<Scalars['Boolean']>;
  keyValues?: Maybe<Array<Maybe<KeyValues>>>;
  latestRevenueCloseDate?: Maybe<Scalars['Date2']>;
  limitIssuedBillsToTCV?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Groups>;
  name?: Maybe<Scalars['String']>;
  otherProjectAllocationSummaryForUsers: Array<OtherProjectAllocationSummaryForUserResult>;
  pageOfProjectBillingRateSchedules?: Maybe<Array<Maybe<BillingRateSchedulesResult>>>;
  pageOfProjectRate: Array<ProjectRateEntry>;
  pageOfProjectSpecificBillingRateSchedules?: Maybe<Array<Maybe<BillingRateSchedulesResult>>>;
  pageOfResourcePlanAllocatedUserTasks: Array<ResourcePlanAllocatedUserTask>;
  pageOfResources?: Maybe<PageOfAllocatedResourcesResponse>;
  pageOfRevenueEntries?: Maybe<Array<Maybe<Scalars['RevenueEntriesCustomMetadata']>>>;
  pageOfTeamMembers?: Maybe<Array<Maybe<ProjectTeamMember>>>;
  pageOfUserBillingRateSchedules?: Maybe<Array<Maybe<BillingRateSchedulesResult>>>;
  percentCompleted?: Maybe<Scalars['Int']>;
  permittedActionUris?: Maybe<Array<Maybe<Scalars['String']>>>;
  portfolio?: Maybe<ProjectPortfolio>;
  program?: Maybe<ProgramReference>;
  projectBillSettings?: Maybe<BillSettings>;
  /** @deprecated Use pageOfProjectBillingRateSchedules, has pagination logic */
  projectBillingRateSchedules?: Maybe<Array<Maybe<BillingRateSchedulesResult>>>;
  projectCurrentEffectiveBillingRates: Array<Maybe<ProjectBillingRateScheduleEntry>>;
  projectCurrentEffectiveSystemRates?: Maybe<Array<ProjectBillingRateScheduleEntry>>;
  projectEffectiveBillingRateCount: Scalars['Int'];
  projectEffectiveSystemRateCount: Scalars['Int'];
  projectEstimatedExpenseRemainingSeriesByMonth?: Maybe<ProjectExpenseRemainingSeries>;
  projectLinks?: Maybe<Array<ProjectLink>>;
  projectManagementType?: Maybe<Scalars['String']>;
  projectManager?: Maybe<User>;
  projectManagerReference?: Maybe<ProjectManagerReference>;
  projectManagerUri?: Maybe<Scalars['String']>;
  /** @deprecated Use projectRate2, no longer uses Date scalar */
  projectRate?: Maybe<ProjectRate>;
  projectRate2?: Maybe<ProjectRate>;
  projectRateCount: Scalars['Int'];
  projectRolesNotReferencedInProjectRateTable: Array<Role>;
  projectRolesNotReferencedInProjectRateTableCount: Scalars['Int'];
  projectTotalMilestoneContractAmount?: Maybe<Money>;
  rateTableDimension?: Maybe<RateTableDimensionDetails>;
  recognizedRevenueSummary?: Maybe<Money>;
  removeBillingRateErrorDetails?: Maybe<RemoveBillingRateErrorDetails>;
  report?: Maybe<ProjectReport>;
  reportSuggestions?: Maybe<ProjectReportSuggestions>;
  reports?: Maybe<PaginatedGetProjectReportsResponse>;
  rescheduleProjectJob?: Maybe<RescheduleProjectJob>;
  resourceAllocationCount?: Maybe<Scalars['Int']>;
  resourceAllocations?: Maybe<Array<Maybe<ResourceAllocation>>>;
  resourceAllocationsForEstimatedBilling: ResourceAllocationsForEstimatedBillingResult;
  resourceBudgetedCost?: Maybe<Money>;
  resourceCostSummary?: Maybe<ResourceCostSummary>;
  resourcePlanActualUsers: Array<UserReference>;
  resourcePlanActualUsersAndRoles: Array<ResourcePlanActualUserRoleReference>;
  resourcePlanAllocatedUsers: ResourcePlanAllocatedUsersResult;
  resourcePlanAllocatedUsersAndRoles: Array<ResourceAllocationUserRoleReference>;
  resourcePlanAllocatedUsersForEstimatedBilling: ResourcePlanAllocatedUsersResult;
  resourcePlanUserActualSeriesByRole: Array<ResourceUserActualSeriesByProjectRole>;
  resourceRequests?: Maybe<Array<Maybe<ResourceRequest>>>;
  resourceRequestsForProjectEstimatedBilling: ResourceRequestsForProjectEstimatedBillingResult;
  resourceRequestsTotals?: Maybe<ResourcePlanTotals>;
  /** @deprecated Use pageOfResources */
  resources?: Maybe<UsersList>;
  revenueAmountSummary?: Maybe<RevenueAmountSummary>;
  revenueContractDetails?: Maybe<ProjectRevenueContractDetails>;
  revenueForecastSummary?: Maybe<Money>;
  revenueRecognitionPolicy?: Maybe<ObjectReference>;
  /** @deprecated Use roleRates2, no longer uses Date scalar */
  roleRates?: Maybe<Array<Maybe<ProjectRate>>>;
  roleRates2?: Maybe<Array<Maybe<ProjectRate>>>;
  /** @deprecated Use roleRatesCount2, no longer uses Date scalar */
  roleRatesCount?: Maybe<Scalars['Int']>;
  roleRatesCount2?: Maybe<Scalars['Int']>;
  rolledUpCostSummary?: Maybe<RolledUpProjectCostSummary>;
  rolledUpEstimatedRemainingHours?: Maybe<Scalars['Float']>;
  rolledUpSummary?: Maybe<RolledUpProjectTimeEnteredSummary>;
  scopeHoursCompleted?: Maybe<Scalars['Float']>;
  serviceCenter?: Maybe<Groups>;
  slackChannel?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  /** @deprecated Use startDate2 */
  startDate?: Maybe<Scalars['Date']>;
  startDate2?: Maybe<Scalars['Date2']>;
  status?: Maybe<ProjectStatus>;
  tags?: Maybe<Array<Maybe<TagAssignment>>>;
  taskAllocationsForProjectEstimatedBilling: TaskAllocationsForProjectEstimatedBillingResult;
  tasks?: Maybe<Array<Maybe<Task>>>;
  tasksCount: Scalars['Int'];
  teamMemberEffectiveBillingRates?: Maybe<Array<Maybe<EffectiveBillingRate>>>;
  teamMembers?: Maybe<Array<Maybe<User>>>;
  timeAndExpenseEntryType?: Maybe<TimeAndExpenseEntry>;
  timeEnteredSummary?: Maybe<TimeEnteredSummary>;
  timeEntryRevisionGroupCount: Scalars['Int'];
  timeEntryRevisionGroupRows: Array<TimeEntryRevisionGroup>;
  timeEntryRevisionGroupTotals: TimeEntryRevisionGroupTotals;
  timesheetAccess?: Maybe<ProjectTimesheetAccess>;
  totalAllocatedHours?: Maybe<Scalars['Float']>;
  totalEstimatedContract?: Maybe<Money>;
  totalEstimatedContractInProjectCurrency?: Maybe<Money>;
  totalTaskHours?: Maybe<Scalars['Float']>;
  uri?: Maybe<Scalars['String']>;
  /** @deprecated Use pageOfUserBillingRateSchedules, has pagination logic */
  userBillingRateSchedules?: Maybe<Array<Maybe<BillingRateSchedulesResult>>>;
  userBillingRateSchedules2?: Maybe<Array<Maybe<BillingScheduleEntry>>>;
  userCurrentEffectiveRates: Array<Maybe<UserBillingRateScheduleEntry>>;
  userEffectiveBillingRateCount: Scalars['Int'];
  /** @deprecated Use userRates2, no longer uses Date scalar */
  userRates?: Maybe<Array<Maybe<ProjectRate>>>;
  userRates2?: Maybe<Array<Maybe<ProjectRate>>>;
  /** @deprecated Use userRatesCount2, no longer uses Date scalar */
  userRatesCount?: Maybe<Scalars['Int']>;
  userRatesCount2?: Maybe<Scalars['Int']>;
  workflow?: Maybe<ProjectWorkflowState>;
  workflowChecklist?: Maybe<ProjectWorkflowChecklist>;
};


export type ProjectAllocationsSummaryArgs = {
  cursor?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['String']>;
  sort: ResourceAllocationSort;
};


export type ProjectAllocationsTotalsArgs = {
  allocationStatusList?: InputMaybe<Array<ResourceAllocationStatus>>;
  filter?: InputMaybe<ProjectTotalsFilter>;
  includeActualsResourceUsers?: InputMaybe<Scalars['Boolean']>;
};


export type ProjectAssignedTaskCountArgs = {
  effectiveTimestamp: Scalars['Date2'];
  filter?: InputMaybe<AssignedTaskCountFilter>;
};


export type ProjectAssignedTaskCount2Args = {
  effectiveTimestamp: Scalars['Date2'];
  filter?: InputMaybe<AssignedTaskCountFilter>;
};


export type ProjectAssignedTasksForResourceArgs = {
  teamMember: TeamMember;
};


export type ProjectBillPlanOverview2Args = {
  dateRange?: InputMaybe<DateRangeInput2>;
  overviewMode: BillPlanOverviewMode;
  periodResolutionUri?: InputMaybe<Scalars['String']>;
};


export type ProjectBillPlanOverview3Args = {
  dateRange?: InputMaybe<DateRangeInput2>;
  overviewMode: BillPlanOverviewMode;
  periodResolutionUri?: InputMaybe<Scalars['String']>;
};


export type ProjectBillPlansArgs = {
  excludeScriptEstimatedAmounts?: InputMaybe<Scalars['Boolean']>;
};


export type ProjectBilledRevenueAmountSummaryArgs = {
  dateRange?: InputMaybe<DateTimeRangeInput>;
};


export type ProjectBillingDetailsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  textSearch?: InputMaybe<Scalars['String']>;
};


export type ProjectBillingOverview2Args = {
  dateRange?: InputMaybe<DateRangeInput2>;
  periodResolutionUri?: InputMaybe<Scalars['String']>;
};


export type ProjectBulkResourcePlanUserActualSeriesByRoleArgs = {
  dateRange: DateRangeInput;
  periodResolution: PeriodResolutionOption;
  userUris?: InputMaybe<Array<Scalars['String']>>;
};


export type ProjectCostAmountSummaryArgs = {
  dateRange?: InputMaybe<DateTimeRangeInput>;
};


export type ProjectCostSeriesDataArgs = {
  currencyId?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<DateTimeRangeInput>;
};


export type ProjectEffectiveBillingRatesArgs = {
  asOfDate?: InputMaybe<Scalars['DateObject']>;
};


export type ProjectGetProjectRoleReferencedStatusInProjectRateTableArgs = {
  input: ProjectRoleRateTableReferenceStatusInput;
};


export type ProjectHourDetailsArgs = {
  dateRange?: InputMaybe<DateTimeRangeInput>;
};


export type ProjectOtherProjectAllocationSummaryForUsersArgs = {
  input: OtherProjectAllocationSummaryForUsersInput;
};


export type ProjectPageOfProjectBillingRateSchedulesArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type ProjectPageOfProjectRateArgs = {
  dimensionUris?: InputMaybe<Array<Scalars['String']>>;
  filters?: InputMaybe<ProjectRateFilter>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  sort?: InputMaybe<Array<InputMaybe<ProjectRateSort>>>;
};


export type ProjectPageOfProjectSpecificBillingRateSchedulesArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type ProjectPageOfResourcePlanAllocatedUserTasksArgs = {
  includeTimeEnteredTasks?: InputMaybe<Scalars['Boolean']>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  userUri: Scalars['String'];
};


export type ProjectPageOfResourcesArgs = {
  filter?: InputMaybe<ProjectResourceFilter>;
  pageSize: Scalars['Int'];
  paginationToken?: InputMaybe<Scalars['PaginationTokenInput']>;
};


export type ProjectPageOfRevenueEntriesArgs = {
  filter?: InputMaybe<RevenueEntryFilter>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type ProjectPageOfTeamMembersArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  teamMemberFilter?: InputMaybe<ProjectTeamMemberFilter>;
};


export type ProjectPageOfUserBillingRateSchedulesArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type ProjectProjectBillingRateSchedulesArgs = {
  billingRateIds: Array<InputMaybe<Scalars['String']>>;
};


export type ProjectProjectCurrentEffectiveBillingRatesArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type ProjectProjectCurrentEffectiveSystemRatesArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type ProjectProjectEstimatedExpenseRemainingSeriesByMonthArgs = {
  dateRange?: InputMaybe<PeriodInput>;
};


export type ProjectProjectRateArgs = {
  effectiveDate?: InputMaybe<Scalars['DateObject']>;
  effectiveDateRange?: InputMaybe<DateRangeInput>;
};


export type ProjectProjectRate2Args = {
  effectiveDate?: InputMaybe<Scalars['Date2']>;
  effectiveDateRange?: InputMaybe<DateRangeInput2>;
};


export type ProjectProjectRateCountArgs = {
  filters?: InputMaybe<ProjectRateFilter>;
};


export type ProjectProjectRolesNotReferencedInProjectRateTableArgs = {
  pageSize: Scalars['Int'];
};


export type ProjectRecognizedRevenueSummaryArgs = {
  dateRange?: InputMaybe<DateRangeInput2>;
};


export type ProjectRemoveBillingRateErrorDetailsArgs = {
  billingRate?: InputMaybe<BillingRateInput>;
};


export type ProjectReportArgs = {
  id: Scalars['String'];
};


export type ProjectReportsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type ProjectResourceAllocationCountArgs = {
  filter?: InputMaybe<ProjectResourceAllocationCountFilter>;
};


export type ProjectResourceAllocationsForEstimatedBillingArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter: ResourceAllocationsForEstimatedBillingFilter;
  pageSize: Scalars['Int'];
};


export type ProjectResourcePlanActualUsersArgs = {
  filter: ProjectActualSummaryFilter;
  isSortByUserAscending: Scalars['Boolean'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type ProjectResourcePlanActualUsersAndRolesArgs = {
  userIds: Array<Scalars['String']>;
};


export type ProjectResourcePlanAllocatedUsersArgs = {
  filter: ResourcePlanAllocatedUsersFilter;
  isSortByUserAscending: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  paginationToken?: InputMaybe<Scalars['String']>;
};


export type ProjectResourcePlanAllocatedUsersAndRolesArgs = {
  userIds: Array<Scalars['String']>;
};


export type ProjectResourcePlanAllocatedUsersForEstimatedBillingArgs = {
  filter: ResourcePlanAllocatedUsersForEstimatedBillingFilter;
  isSortByUserAscending: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  paginationToken?: InputMaybe<Scalars['String']>;
};


export type ProjectResourcePlanUserActualSeriesByRoleArgs = {
  dateRange: DateRangeInput;
  periodResolution: PeriodResolutionOption;
  userUri: Scalars['String'];
};


export type ProjectResourceRequestsArgs = {
  requestStatusList?: InputMaybe<Array<InputMaybe<ResourceRequestStatus>>>;
};


export type ProjectResourceRequestsForProjectEstimatedBillingArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter: ResourceRequestsForProjectEstimatedBillingFilter;
  pageSize: Scalars['Int'];
};


export type ProjectResourceRequestsTotalsArgs = {
  filter?: InputMaybe<ProjectTotalsFilter>;
  requestStatusList?: InputMaybe<Array<ResourceRequestStatus>>;
};


export type ProjectResourcesArgs = {
  allocationStatusList?: InputMaybe<Array<ResourceAllocationStatus>>;
  searchPhrase?: InputMaybe<Scalars['String']>;
};


export type ProjectRevenueAmountSummaryArgs = {
  dateRange?: InputMaybe<DateTimeRangeInput>;
};


export type ProjectRevenueForecastSummaryArgs = {
  dateRange?: InputMaybe<DateRangeInput2>;
};


export type ProjectRoleRatesArgs = {
  effectiveDate?: InputMaybe<Scalars['DateObject']>;
  effectiveDateRange?: InputMaybe<DateRangeInput>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type ProjectRoleRates2Args = {
  effectiveDate?: InputMaybe<Scalars['Date2']>;
  effectiveDateRange?: InputMaybe<DateRangeInput2>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type ProjectRoleRatesCountArgs = {
  effectiveDateRange?: InputMaybe<DateRangeInput>;
};


export type ProjectRoleRatesCount2Args = {
  effectiveDateRange?: InputMaybe<DateRangeInput2>;
};


export type ProjectTaskAllocationsForProjectEstimatedBillingArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter: TaskAllocationsForProjectEstimatedBillingFilter;
  pageSize: Scalars['Int'];
};


export type ProjectTasksArgs = {
  hierarchyListDataOptionUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isMilestone?: InputMaybe<Scalars['Boolean']>;
  isOpen?: InputMaybe<Scalars['Boolean']>;
  isTimeEntryAllowed?: InputMaybe<Scalars['Boolean']>;
  maxHierarchyDepth?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  textSearch?: InputMaybe<Scalars['String']>;
};


export type ProjectTasksCountArgs = {
  hasActualHours?: InputMaybe<Scalars['Boolean']>;
  isMilestone?: InputMaybe<Scalars['Boolean']>;
  isOpen?: InputMaybe<Scalars['Boolean']>;
  textSearch?: InputMaybe<Scalars['String']>;
};


export type ProjectTeamMemberEffectiveBillingRatesArgs = {
  asOfDate?: InputMaybe<Scalars['DateObject']>;
};


export type ProjectTimeEnteredSummaryArgs = {
  dateRange?: InputMaybe<DateTimeRangeInput>;
};


export type ProjectTimeEntryRevisionGroupCountArgs = {
  filter?: InputMaybe<TimeEntryRevisionGroupFilter>;
};


export type ProjectTimeEntryRevisionGroupRowsArgs = {
  filter?: InputMaybe<TimeEntryRevisionGroupFilter>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type ProjectTimeEntryRevisionGroupTotalsArgs = {
  filter?: InputMaybe<TimeEntryRevisionGroupFilter>;
};


export type ProjectTimesheetAccessArgs = {
  policy?: InputMaybe<Scalars['String']>;
};


export type ProjectUserBillingRateSchedulesArgs = {
  userIds: Array<InputMaybe<Scalars['String']>>;
};


export type ProjectUserBillingRateSchedules2Args = {
  userUri: Scalars['String'];
};


export type ProjectUserCurrentEffectiveRatesArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type ProjectUserRatesArgs = {
  effectiveDate?: InputMaybe<Scalars['DateObject']>;
  effectiveDateRange?: InputMaybe<DateRangeInput>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type ProjectUserRates2Args = {
  effectiveDate?: InputMaybe<Scalars['Date2']>;
  effectiveDateRange?: InputMaybe<DateRangeInput2>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type ProjectUserRatesCountArgs = {
  effectiveDateRange?: InputMaybe<DateRangeInput>;
};


export type ProjectUserRatesCount2Args = {
  effectiveDateRange?: InputMaybe<DateRangeInput2>;
};

export type ProjectActualSummaryFilter = {
  resourcePools?: InputMaybe<Array<Scalars['String']>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchText?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Array<Scalars['String']>>;
};

export type ProjectAllocationFilter = {
  projectWorkflowStage?: InputMaybe<Array<ProjectWorkflowStage>>;
};

export type ProjectAllocationSummary = {
  __typename?: 'ProjectAllocationSummary';
  assignedRole?: Maybe<ObjectReference>;
  id: Scalars['String'];
  project: ObjectReference;
  resourceAllocationSummary: Array<ResourceAllocationsSummaryResult>;
  user: ObjectReference;
};


export type ProjectAllocationSummaryResourceAllocationSummaryArgs = {
  dateRange: DateRangeInput;
  periodResolution: PeriodResolutionOption;
};

export type ProjectAllocationSummaryResult = {
  __typename?: 'ProjectAllocationSummaryResult';
  entries?: Maybe<Array<ProjectAllocationSummary>>;
  nextPageCursor?: Maybe<Scalars['String']>;
};

export type ProjectBillPlan = {
  __typename?: 'ProjectBillPlan';
  description?: Maybe<Scalars['String']>;
  displayText?: Maybe<Scalars['String']>;
  estimatedAmount?: Maybe<Money>;
  id?: Maybe<Scalars['String']>;
  scripts?: Maybe<Array<Maybe<Scalars['ProjectScriptParameter']>>>;
};

export type ProjectBillPlanInput = {
  id?: InputMaybe<Scalars['String']>;
  scripts?: InputMaybe<Array<InputMaybe<Scalars['ProjectScriptParameter']>>>;
};

export type ProjectBillPlans = {
  __typename?: 'ProjectBillPlans';
  billPlans?: Maybe<Array<Maybe<ProjectBillPlan>>>;
  totalEstimatedAmount?: Maybe<Money>;
};

export type ProjectBilling = {
  __typename?: 'ProjectBilling';
  billingTypeUri?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['BillingDetails']>;
  id: Scalars['String'];
};

export type ProjectBillingContract = {
  __typename?: 'ProjectBillingContract';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type ProjectBillingContractClause = {
  __typename?: 'ProjectBillingContractClause';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  parameters?: Maybe<Array<Maybe<Scalars['ProjectScriptParameter']>>>;
  script?: Maybe<Script>;
  slug: Scalars['String'];
};

export type ProjectBillingContractInput = {
  contractId: Scalars['String'];
};

export type ProjectBillingRate = {
  __typename?: 'ProjectBillingRate';
  billingScheduleEntries?: Maybe<Array<Maybe<BillingScheduleEntry>>>;
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};

export type ProjectBillingRateInput = {
  billingRate?: InputMaybe<BillingRateInput>;
  id: Scalars['String'];
};

export type ProjectBillingRateScheduleEntry = {
  __typename?: 'ProjectBillingRateScheduleEntry';
  asOfDate?: Maybe<Scalars['Date']>;
  billingRate: BillingRate;
  id: Scalars['String'];
  rate: Money;
};

export type ProjectBillingRatesInput = {
  dirtyBillingRates?: InputMaybe<Array<InputMaybe<ProjectBillingRateInput>>>;
  newAddedBillingRates?: InputMaybe<Array<InputMaybe<ProjectBillingRateInput>>>;
  removedBillingRates?: InputMaybe<Array<InputMaybe<ProjectBillingRateInput>>>;
};

export type ProjectBillingScript = {
  __typename?: 'ProjectBillingScript';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export enum ProjectCodeSettingOption {
  AutoIncrement = 'AUTO_INCREMENT',
  UserEntered = 'USER_ENTERED'
}

export type ProjectCodeSettings = {
  __typename?: 'ProjectCodeSettings';
  nextProjectCode?: Maybe<Scalars['Int']>;
  projectCodeSettingOption?: Maybe<ProjectCodeSettingOption>;
};

export type ProjectContractDetails = {
  __typename?: 'ProjectContractDetails';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type ProjectCopyInputs2 = {
  clients?: InputMaybe<Array<InputMaybe<ClientsAllocation>>>;
  earnedRevenueScriptId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date2']>;
  isCopyBillPlanChecked?: InputMaybe<Scalars['Boolean']>;
  isCopyResourceRequestsChecked?: InputMaybe<Scalars['Boolean']>;
  isCopyTasksChecked?: InputMaybe<Scalars['Boolean']>;
  linksToAdd?: InputMaybe<Array<AddProjectLinkInput>>;
  newProjectCode?: InputMaybe<Scalars['String']>;
  newProjectName?: InputMaybe<Scalars['String']>;
  portfolioId?: InputMaybe<Scalars['String']>;
  programId?: InputMaybe<Scalars['String']>;
  projectManagementType?: InputMaybe<Scalars['String']>;
  projectManagerId?: InputMaybe<Scalars['String']>;
  rateCardCopyOption?: InputMaybe<RateCardCopyOption>;
  shiftByProjectStartDateOffset?: InputMaybe<Scalars['Boolean']>;
  sourceProjectId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date2']>;
  taskCopyOption?: InputMaybe<TaskCopyOption>;
};

export type ProjectCountSummary = {
  __typename?: 'ProjectCountSummary';
  onTrack: Scalars['Int'];
  overBudgetHours: Scalars['Int'];
  overEndDate: Scalars['Int'];
  overEstimated: Scalars['Int'];
  overHoursOrCostBudget: Scalars['Int'];
  total: Scalars['Int'];
};

export type ProjectExpenseRemainingSeries = {
  __typename?: 'ProjectExpenseRemainingSeries';
  dataPoints: Array<ProjectExpenseRemainingSeriesDataPoint>;
};

export type ProjectExpenseRemainingSeriesDataPoint = {
  __typename?: 'ProjectExpenseRemainingSeriesDataPoint';
  estimatedExpensesInProjectCurrency?: Maybe<Money>;
  period: DataPointPeriod;
};

export type ProjectExpenseSeriesDataPoint = {
  __typename?: 'ProjectExpenseSeriesDataPoint';
  billableAmount?: Maybe<Scalars['Float']>;
  nonBillableAmount?: Maybe<Scalars['Float']>;
  period?: Maybe<DataPointPeriod>;
};

export type ProjectExpenseSeriesResult = {
  __typename?: 'ProjectExpenseSeriesResult';
  currency?: Maybe<Currency>;
  dataPoints?: Maybe<Array<Maybe<ProjectExpenseSeriesDataPoint>>>;
  expenseCode?: Maybe<ExpenseCode>;
};

export type ProjectExpenseSummaryResult = {
  __typename?: 'ProjectExpenseSummaryResult';
  billableAmount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Currency>;
  expenseCode?: Maybe<ExpenseCode>;
  nonBillableAmount?: Maybe<Scalars['Float']>;
};

export type ProjectFilter = {
  baseProject?: InputMaybe<Scalars['String']>;
  clients?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  costCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateRange?: InputMaybe<DateRangeInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  employeeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludePortfolios?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludePrograms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  executionPhase?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includeBaseLinkFilter?: InputMaybe<Scalars['Boolean']>;
  includeMyProjectsOnly?: InputMaybe<Scalars['Boolean']>;
  includeSubPortfolios?: InputMaybe<Scalars['Boolean']>;
  inverseLinkFilter?: InputMaybe<Scalars['Boolean']>;
  isInDataAccessLevels?: InputMaybe<Array<Scalars['String']>>;
  isManaged?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overbudget?: InputMaybe<Scalars['Overbudget']>;
  portfolios?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  programs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  project?: InputMaybe<Scalars['String']>;
  projectCoManagers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projectLinkTypes?: InputMaybe<Array<ProjectLinkType>>;
  projectManagers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  revenueRecognitionPolicies?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  serviceCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tags?: InputMaybe<Array<TagFilterInput>>;
  tasks?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type ProjectFilter2 = {
  baseProject?: InputMaybe<Scalars['String']>;
  clients?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  costCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateRange?: InputMaybe<DateRangeInput2>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  effectiveTimestamp?: InputMaybe<Scalars['Date2']>;
  employeeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludePortfolios?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludePrograms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludeProjectStatus?: InputMaybe<Array<Scalars['String']>>;
  executionPhase?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includeBaseLinkFilter?: InputMaybe<Scalars['Boolean']>;
  includeMyProjectsOnly?: InputMaybe<Scalars['Boolean']>;
  includeSubPortfolios?: InputMaybe<Scalars['Boolean']>;
  inverseLinkFilter?: InputMaybe<Scalars['Boolean']>;
  isInDataAccessLevels?: InputMaybe<Array<Scalars['String']>>;
  isManaged?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overbudget?: InputMaybe<Scalars['Overbudget']>;
  portfolios?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  programs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  project?: InputMaybe<Scalars['String']>;
  projectCoManagers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projectLinkTypes?: InputMaybe<Array<ProjectLinkType>>;
  projectManagers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projects?: InputMaybe<Array<Scalars['String']>>;
  revenueRecognitionPolicies?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchType?: InputMaybe<ProjectSearchType>;
  serviceCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tags?: InputMaybe<Array<TagFilterInput>>;
  tasks?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type ProjectInfoModificationBatchResult = {
  __typename?: 'ProjectInfoModificationBatchResult';
  results: Array<Maybe<ProjectInfoModificationResult>>;
};

export type ProjectInfoModificationInput = {
  clientRepresentativeUri?: InputMaybe<Scalars['String']>;
  clientUri?: InputMaybe<Scalars['String']>;
  costCenterUri?: InputMaybe<Scalars['String']>;
  costTypeUri?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<Array<Scalars['CustomFieldValueInput']>>;
  defaultBillingCurrencyUri?: InputMaybe<Scalars['String']>;
  departmentUri?: InputMaybe<Scalars['String']>;
  divisionUri?: InputMaybe<Scalars['String']>;
  employeeTypeUri?: InputMaybe<Scalars['String']>;
  extensionFieldValues?: InputMaybe<Array<ExtensionFieldValueInput>>;
  isProjectLeaderApprovalRequired?: InputMaybe<Scalars['Boolean']>;
  isTimeEntryAllowed?: InputMaybe<Scalars['Boolean']>;
  locationUri?: InputMaybe<Scalars['String']>;
  programUri?: InputMaybe<Scalars['String']>;
  projectManagerUri?: InputMaybe<Scalars['String']>;
  projectWorkflowState?: InputMaybe<Scalars['String']>;
  serviceCenterUri?: InputMaybe<Scalars['String']>;
  timeAndExpenseEntryTypeUri?: InputMaybe<Scalars['String']>;
};

export type ProjectInfoModificationResult = {
  __typename?: 'ProjectInfoModificationResult';
  notifications?: Maybe<Array<Maybe<RepliconValidationError>>>;
  project: ProjectReference;
};

export type ProjectInput = {
  billingContract?: InputMaybe<ProjectBillingContractInput>;
  billingType?: InputMaybe<BillingTypeInput>;
  budget?: InputMaybe<BudgetInput>;
  budgetHours?: InputMaybe<Scalars['Float']>;
  budgetedCost?: InputMaybe<MoneyInput>;
  clientBillingAllocation?: InputMaybe<ClientBillingAllocationInput>;
  clientRepresentative?: InputMaybe<ClientRepresentativeInput>;
  clientSchedule?: InputMaybe<Array<InputMaybe<ClientScheduleInput>>>;
  clients?: InputMaybe<Array<InputMaybe<ClientInput>>>;
  coManagers?: InputMaybe<Array<InputMaybe<ProjectManagerReferenceInput>>>;
  code?: InputMaybe<Scalars['String']>;
  costCenter?: InputMaybe<GroupInput>;
  costType?: InputMaybe<CostTypeInput>;
  customFieldValues?: InputMaybe<Array<InputMaybe<Scalars['CustomFieldValueInput']>>>;
  defaultBillingCurrency?: InputMaybe<CurrencyInput>;
  department?: InputMaybe<GroupInput>;
  description?: InputMaybe<Scalars['String']>;
  displayText?: InputMaybe<Scalars['String']>;
  division?: InputMaybe<GroupInput>;
  earnedRevenueScriptId?: InputMaybe<Scalars['String']>;
  employeeType?: InputMaybe<GroupInput>;
  endDate?: InputMaybe<Scalars['Date']>;
  estimatedCost?: InputMaybe<MoneyInput>;
  estimatedExpenses?: InputMaybe<MoneyInput>;
  estimatedHours?: InputMaybe<Scalars['Float']>;
  estimationMode?: InputMaybe<EstimationModeInput>;
  expenseBudgetedCost?: InputMaybe<MoneyInput>;
  expenseCodes?: InputMaybe<Array<InputMaybe<ExpenseCodeInput>>>;
  extensionFieldValues?: InputMaybe<Array<InputMaybe<ExtensionFieldValueInput>>>;
  isProjectLeaderApprovalRequired?: InputMaybe<Scalars['Boolean']>;
  isTimeEntryAllowed?: InputMaybe<Scalars['Boolean']>;
  keyValues?: InputMaybe<Array<InputMaybe<KeyValuesInput>>>;
  limitIssuedBillsToTCV?: InputMaybe<Scalars['Boolean']>;
  linksToAdd?: InputMaybe<Array<AddProjectLinkInput>>;
  location?: InputMaybe<GroupInput>;
  name?: InputMaybe<Scalars['String']>;
  percentCompleted?: InputMaybe<Scalars['Int']>;
  portfolioId?: InputMaybe<Scalars['String']>;
  program?: InputMaybe<ProgramInput>;
  projectManagementType?: InputMaybe<Scalars['String']>;
  projectManagerReference?: InputMaybe<ProjectManagerReferenceInput>;
  projectUri?: InputMaybe<Scalars['String']>;
  resourceBudgetedCost?: InputMaybe<MoneyInput>;
  serviceCenter?: InputMaybe<GroupInput>;
  slug?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  statusUri?: InputMaybe<Scalars['String']>;
  timeAndExpenseEntryType?: InputMaybe<TimeAndExpenseEntryInput>;
  totalEstimatedContract?: InputMaybe<MoneyInput>;
};

export type ProjectLink = {
  __typename?: 'ProjectLink';
  baseProject: ProjectReference;
  id: Scalars['String'];
  linkType: ProjectLinkType;
  reverseLinkId: Scalars['String'];
  targetProject: ProjectReference;
};

export type ProjectLinkTargetInput = {
  baseProjectId: Scalars['String'];
  linkType: ProjectLinkType;
  targetProjectId: Scalars['String'];
};

export enum ProjectLinkType {
  Changerequest = 'CHANGEREQUEST',
  Changerequestfor = 'CHANGEREQUESTFOR',
  Hasphase = 'HASPHASE',
  Phaseof = 'PHASEOF',
  Relatesto = 'RELATESTO'
}

export enum ProjectManagementType {
  Managed = 'MANAGED',
  Unmanaged = 'UNMANAGED'
}

export type ProjectManager = {
  __typename?: 'ProjectManager';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  user?: Maybe<User>;
};

export type ProjectManagerReference = {
  __typename?: 'ProjectManagerReference';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type ProjectManagerReferenceInput = {
  displayText?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type ProjectOrClientBillingDefaults = {
  __typename?: 'ProjectOrClientBillingDefaults';
  billLineItemsBy?: Maybe<Array<Maybe<LineItemColumnOptions>>>;
  billingContactInfo?: Maybe<ContactInfo>;
  defaultInvoicePaymentTerm?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  invoiceCurrency?: Maybe<Currency>;
  invoiceTemplate?: Maybe<InvoiceTemplate>;
  poNumber?: Maybe<Scalars['String']>;
  showComments?: Maybe<Scalars['Boolean']>;
  taxProfile?: Maybe<TaxProfile>;
};

export type ProjectPortfolio = {
  __typename?: 'ProjectPortfolio';
  ancestors?: Maybe<Array<ObjectReference>>;
  displayText: Scalars['String'];
  hierarchyLevel?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  isAssignable?: Maybe<Scalars['Boolean']>;
};

export type ProjectRate = {
  __typename?: 'ProjectRate';
  billingScheduleEntries?: Maybe<Array<Maybe<RateScheduleEntry>>>;
  companyBillingRateReference?: Maybe<ObjectReference>;
  costScheduleEntries?: Maybe<Array<Maybe<RateScheduleEntry>>>;
  effectiveBillingRate: RateScheduleEntry;
  effectiveBillingRate2: RateScheduleEntry;
  id: Scalars['String'];
  rateType: RateType;
  roleReference?: Maybe<ObjectReference>;
  userReference?: Maybe<ObjectReference>;
};


export type ProjectRateEffectiveBillingRateArgs = {
  effectiveDateRange: DateRangeInput;
};


export type ProjectRateEffectiveBillingRate2Args = {
  effectiveDateRange: DateRangeInput2;
};

export type ProjectRate2 = {
  __typename?: 'ProjectRate2';
  billingScheduleEntries?: Maybe<Array<Maybe<RateScheduleEntry>>>;
  costScheduleEntries?: Maybe<Array<Maybe<RateScheduleEntry>>>;
  id: Scalars['String'];
  rateType: RateType;
  roleReference?: Maybe<ObjectReference>;
  userReference?: Maybe<ObjectReference>;
};

export type ProjectRate3 = {
  __typename?: 'ProjectRate3';
  dimensions?: Maybe<Array<ProjectRateDimension>>;
  id: Scalars['String'];
  scheduleEntries?: Maybe<Array<RateScheduleEntry>>;
};

export type ProjectRateDimension = {
  __typename?: 'ProjectRateDimension';
  dimensionUri?: Maybe<Scalars['String']>;
  objectUri?: Maybe<Scalars['String']>;
};

export type ProjectRateDimension2 = {
  __typename?: 'ProjectRateDimension2';
  dimensionUri: Scalars['String'];
  dimensionValueReference?: Maybe<ObjectReference>;
};

export type ProjectRateDimensionInput = {
  dimensionUri?: InputMaybe<Scalars['String']>;
  objectUri?: InputMaybe<Scalars['String']>;
};

export type ProjectRateEntry = {
  __typename?: 'ProjectRateEntry';
  amount: Money;
  dimensions?: Maybe<Array<ProjectRateDimension2>>;
  effectiveDate?: Maybe<Scalars['Date2']>;
  id: Scalars['String'];
  project: ObjectReference;
};

export type ProjectRateFilter = {
  effectiveDateRange?: InputMaybe<DateRangeInput>;
};

export type ProjectRateInput = {
  billingScheduleEntries: Array<ProjectRateScheduleEntryInput>;
  costScheduleEntries: Array<ProjectRateScheduleEntryInput>;
  rateType: RateType;
  roleId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type ProjectRateInput2 = {
  billingScheduleEntries: Array<ProjectRateScheduleEntryInput2>;
  costScheduleEntries: Array<ProjectRateScheduleEntryInput2>;
  rateType: RateType;
  roleId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type ProjectRateInput3 = {
  dimensions?: InputMaybe<Array<ProjectRateDimensionInput>>;
  entries: Array<ProjectRateScheduleEntryInput2>;
};

export type ProjectRateScheduleEntryInput = {
  amount: MoneyInput;
  effectiveDate?: InputMaybe<Scalars['DateObject']>;
};

export type ProjectRateScheduleEntryInput2 = {
  amount: MoneyInput;
  effectiveDate?: InputMaybe<Scalars['Date2']>;
};

export type ProjectRateSort = {
  dimensionUri: Scalars['String'];
  direction: SortDirection;
};

export type ProjectReference = {
  __typename?: 'ProjectReference';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type ProjectReport = {
  __typename?: 'ProjectReport';
  comment?: Maybe<Scalars['String']>;
  cost?: Maybe<Money>;
  /** @deprecated Use createdTimestamp2 */
  createdTimestamp: Scalars['Date'];
  createdTimestamp2: Scalars['DateTime'];
  estCostAtCompletion?: Maybe<Money>;
  /** @deprecated Use estEndDate2 */
  estEndDate: Scalars['MidnightDateTime'];
  estEndDate2: Scalars['Date2'];
  estHoursAtCompletion: Scalars['Float'];
  hoursWorked: Scalars['Float'];
  id: Scalars['String'];
  project?: Maybe<Project>;
  projectUri: Scalars['String'];
  score: Scalars['Int'];
  /** @deprecated Use submittedTimestamp2 */
  submittedTimestamp: Scalars['Date'];
  submittedTimestamp2: Scalars['DateTime'];
  user?: Maybe<User>;
  userUri: Scalars['String'];
  version: Scalars['Int'];
};

export type ProjectReportInput = {
  comment?: InputMaybe<Scalars['String']>;
  cost?: InputMaybe<MoneyInput>;
  createdTimestamp: Scalars['DateTime'];
  estCostAtCompletion?: InputMaybe<MoneyInput>;
  estEndDate: Scalars['Date2'];
  estHoursAtCompletion: Scalars['Float'];
  hoursWorked: Scalars['Float'];
  id?: InputMaybe<Scalars['String']>;
  projectUri: Scalars['String'];
  score: Scalars['Int'];
};

export type ProjectReportSuggestions = {
  __typename?: 'ProjectReportSuggestions';
  cost?: Maybe<Money>;
  estCostAtCompletion?: Maybe<Money>;
  estEndDate?: Maybe<Scalars['MidnightDateTime']>;
  estHoursAtCompletion?: Maybe<Scalars['Float']>;
  hoursWorked?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Int']>;
};

export type ProjectRequest = {
  __typename?: 'ProjectRequest';
  createdBy?: Maybe<ObjectReference>;
  description: Scalars['String'];
  estimatedCost?: Maybe<Money>;
  estimatedCostInBaseCurrency?: Maybe<Money>;
  estimatedCostInPortfolioCurrency?: Maybe<Scalars['Float']>;
  estimatedCostOverride?: Maybe<Money>;
  id: Scalars['String'];
  name: Scalars['String'];
  permittedActionUris: Array<Maybe<Scalars['String']>>;
  portfolio?: Maybe<ProjectRequestPortfolio>;
  requestedBy?: Maybe<Scalars['String']>;
  resourceAssignments: Array<ProjectRequestResourceAssignment>;
  resourceAssignmentsCount?: Maybe<Scalars['Float']>;
  score?: Maybe<ProjectRequestScore>;
  startDate?: Maybe<Scalars['Date2']>;
  status?: Maybe<ProjectRequestStatus>;
  statusGates: Array<ProjectRequestStatusGates>;
  timelineDuration?: Maybe<ProjectRequestTimelineDuration>;
};


export type ProjectRequestResourceAssignmentsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export enum ProjectRequestColumn {
  CreatedBy = 'createdBy',
  Description = 'description',
  EffectiveTotal = 'effectiveTotal',
  EstimatedCostInBaseCurrency = 'estimatedCostInBaseCurrency',
  EstimatedCostInPortfolioCurrency = 'estimatedCostInPortfolioCurrency',
  EstimatedDuration = 'estimatedDuration',
  Investment = 'investment',
  Name = 'name',
  Portfolio = 'portfolio',
  RequestedBy = 'requestedBy',
  ResourceAssignmentsCount = 'resourceAssignmentsCount',
  Risk = 'risk',
  StartDate = 'startDate',
  Status = 'status',
  Value = 'value'
}

export type ProjectRequestFilter = {
  excludePortfolios?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includeSubPortfolios?: InputMaybe<Scalars['Boolean']>;
  investment?: InputMaybe<ScoreMetricFilterRange>;
  portfolios?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projectRequests?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  risk?: InputMaybe<ScoreMetricFilterRange>;
  statusType?: InputMaybe<ProjectRequestStatusType>;
  text?: InputMaybe<Scalars['String']>;
  totalScore?: InputMaybe<TotalScoreFilterRange>;
  value?: InputMaybe<ScoreMetricFilterRange>;
};

export type ProjectRequestGate = {
  __typename?: 'ProjectRequestGate';
  displayText: Scalars['String'];
  isDefault: Scalars['Boolean'];
  uri: Scalars['String'];
  value: ProjectRequestGateValue;
};

export type ProjectRequestGateInput = {
  displayText: Scalars['String'];
  uri: Scalars['String'];
  value: ProjectRequestGateValue;
};

export enum ProjectRequestGateValue {
  Met = 'MET',
  Pending = 'PENDING',
  Unmet = 'UNMET'
}

export type ProjectRequestInput = {
  description: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  portfolioId?: InputMaybe<Scalars['String']>;
  requestedBy?: InputMaybe<Scalars['String']>;
};

export enum ProjectRequestPeriodResolution {
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type ProjectRequestPortfolio = {
  __typename?: 'ProjectRequestPortfolio';
  ancestors?: Maybe<Array<ObjectReference>>;
  displayText: Scalars['String'];
  hierarchyLevel?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  isAssignable?: Maybe<Scalars['Boolean']>;
  portfolioCurrency?: Maybe<Currency>;
};

export type ProjectRequestResourceAssignment = {
  __typename?: 'ProjectRequestResourceAssignment';
  id: Scalars['String'];
  quantity: Scalars['Float'];
  role: Role;
};

export type ProjectRequestResourceAssignmentInput = {
  assignmentUri?: InputMaybe<Scalars['String']>;
  parameterCorrelationId?: InputMaybe<Scalars['String']>;
  projectRoleUri: Scalars['String'];
  quantity: Scalars['Float'];
};

export type ProjectRequestScore = {
  __typename?: 'ProjectRequestScore';
  effectiveTotal?: Maybe<Scalars['Float']>;
  investment?: Maybe<Scalars['Int']>;
  overrideTotal?: Maybe<Scalars['Float']>;
  risk?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Int']>;
};

export type ProjectRequestScoreResult = {
  __typename?: 'ProjectRequestScoreResult';
  projectRequestUri: Scalars['String'];
};

export type ProjectRequestScoreScale = {
  __typename?: 'ProjectRequestScoreScale';
  label: Scalars['String'];
  scale: Scalars['Int'];
};

export type ProjectRequestScoreScaleDetails = {
  __typename?: 'ProjectRequestScoreScaleDetails';
  investment?: Maybe<Array<Maybe<ProjectRequestScoreScale>>>;
  risk?: Maybe<Array<Maybe<ProjectRequestScoreScale>>>;
  value?: Maybe<Array<Maybe<ProjectRequestScoreScale>>>;
};

export type ProjectRequestSort = {
  direction: SortDirection;
  field: ProjectRequestColumn;
};

export type ProjectRequestStatus = {
  __typename?: 'ProjectRequestStatus';
  name: Scalars['String'];
  type: ProjectRequestStatusType;
};

export type ProjectRequestStatusGates = {
  __typename?: 'ProjectRequestStatusGates';
  gates?: Maybe<Array<Maybe<ProjectRequestGate>>>;
  status: ProjectRequestStatus;
};

export enum ProjectRequestStatusType {
  Approved = 'APPROVED',
  InReview = 'IN_REVIEW',
  New = 'NEW',
  Rejected = 'REJECTED'
}

export type ProjectRequestTimelineDuration = {
  __typename?: 'ProjectRequestTimelineDuration';
  periodQuantity?: Maybe<Scalars['Int']>;
  periodResolution?: Maybe<ProjectRequestPeriodResolution>;
};

export type ProjectRequestTimelineDurationInput = {
  periodQuantity: Scalars['Int'];
  periodResolution: ProjectRequestPeriodResolution;
};

export type ProjectRequestTimelineResult = {
  __typename?: 'ProjectRequestTimelineResult';
  projectRequestUri: Scalars['String'];
};

export type ProjectRequestTotals = {
  __typename?: 'ProjectRequestTotals';
  estimatedCostInBaseCurrency?: Maybe<Money>;
  estimatedCostInPortfolioCurrency?: Maybe<Scalars['Float']>;
  resourceAssignmentsCount?: Maybe<Scalars['Float']>;
};

export type ProjectRequestsByStatusTypeCountSummary = {
  __typename?: 'ProjectRequestsByStatusTypeCountSummary';
  all?: Maybe<Scalars['Int']>;
  approved?: Maybe<Scalars['Int']>;
  inReview?: Maybe<Scalars['Int']>;
  new?: Maybe<Scalars['Int']>;
  rejected?: Maybe<Scalars['Int']>;
};

export type ProjectResourceAllocationCountFilter = {
  allocationStatusList?: InputMaybe<Array<ResourceAllocationStatus>>;
};

export type ProjectResourceDropdownOption = {
  __typename?: 'ProjectResourceDropdownOption';
  displayText: Scalars['String'];
  id: Scalars['String'];
  isAllocatedResource: Scalars['Boolean'];
  isAssignedToTask?: Maybe<Scalars['Boolean']>;
  netAvailableDuration?: Maybe<Scalars['Float']>;
  roles?: Maybe<Array<Maybe<UserProjectRole>>>;
  userRateInProjectCurrency?: Maybe<Money>;
};

export type ProjectResourceDropdownOptionFilter = {
  availabilityPercentageInRange?: InputMaybe<AvailabilityPercentageInRangeInput>;
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type ProjectResourceFilter = {
  allocationStatusList?: InputMaybe<Array<ResourceAllocationStatus>>;
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type ProjectRevenueContractDetails = {
  __typename?: 'ProjectRevenueContractDetails';
  description?: Maybe<Scalars['String']>;
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  projectScriptParameters?: Maybe<Array<Maybe<Scalars['ProjectScriptParameter']>>>;
  scripts?: Maybe<Array<Maybe<Scalars['ProjectScriptParameter']>>>;
};

export type ProjectRevenueRecognitionBatchUriInProgressResult = {
  __typename?: 'ProjectRevenueRecognitionBatchUriInProgressResult';
  batchStatus?: Maybe<Scalars['String']>;
  batchUri?: Maybe<Scalars['String']>;
};

export type ProjectRole = {
  __typename?: 'ProjectRole';
  displayText?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type ProjectRoleRateTableReferenceStatus = {
  __typename?: 'ProjectRoleRateTableReferenceStatus';
  isReferenced: Scalars['Boolean'];
  roleUri?: Maybe<Scalars['String']>;
};

export type ProjectRoleRateTableReferenceStatusInput = {
  resourceEstimateSummary: Scalars['Boolean'];
  roleUri?: InputMaybe<Scalars['String']>;
  taskUri: Scalars['String'];
};

export type ProjectRoleWithAllocations = {
  __typename?: 'ProjectRoleWithAllocations';
  resourceAllocationReference?: Maybe<Array<ResourceAllocationReference>>;
  role?: Maybe<ObjectReference>;
};

export enum ProjectSearchType {
  AssignedProjects = 'ASSIGNED_PROJECTS'
}

export type ProjectSort = {
  direction: SortDirection;
  field: ProjectSortableFields;
};

export enum ProjectSortableFields {
  ActualBilling = 'actualBilling',
  ActualBillingInProjectCurrency = 'actualBillingInProjectCurrency',
  ActualCost = 'actualCost',
  ActualCostInProjectCurrency = 'actualCostInProjectCurrency',
  ActualExpenseCost = 'actualExpenseCost',
  ActualHours = 'actualHours',
  ActualResourceCost = 'actualResourceCost',
  BillingContract = 'billingContract',
  BillingType = 'billingType',
  BudgetCostUsedPercentage = 'budgetCostUsedPercentage',
  BudgetHours = 'budgetHours',
  BudgetHoursRemaining = 'budgetHoursRemaining',
  BudgetHoursUsed = 'budgetHoursUsed',
  BudgetedCost = 'budgetedCost',
  BudgetedCostInProjectCurrency = 'budgetedCostInProjectCurrency',
  Client = 'client',
  ClientBillingAllocation = 'clientBillingAllocation',
  Code = 'code',
  CostCenter = 'costCenter',
  Department = 'department',
  Division = 'division',
  EmployeeType = 'employeeType',
  EndDate = 'endDate',
  EstimatedBilling = 'estimatedBilling',
  EstimatedBillingInProjectCurrency = 'estimatedBillingInProjectCurrency',
  EstimatedBudgetCostRemaining = 'estimatedBudgetCostRemaining',
  EstimatedBudgetHoursRemaining = 'estimatedBudgetHoursRemaining',
  EstimatedCost = 'estimatedCost',
  EstimatedCostAtCompletion = 'estimatedCostAtCompletion',
  EstimatedHours = 'estimatedHours',
  EstimatedHoursAtCompletion = 'estimatedHoursAtCompletion',
  EstimatedTaskCompletionDate = 'estimatedTaskCompletionDate',
  EstimationMode = 'estimationMode',
  FinalTaskEndDate = 'finalTaskEndDate',
  InitialTaskStartDate = 'initialTaskStartDate',
  Location = 'location',
  Name = 'name',
  Portfolio = 'portfolio',
  Program = 'program',
  ProjectManager = 'projectManager',
  ProjectManagerReference = 'projectManagerReference',
  RevenueRecognitionPolicy = 'revenueRecognitionPolicy',
  RolledUpEstimatedRemainingHours = 'rolledUpEstimatedRemainingHours',
  ScopeHoursCompleted = 'scopeHoursCompleted',
  ServiceCenter = 'serviceCenter',
  StartDate = 'startDate',
  Status = 'status',
  TotalEstimatedContract = 'totalEstimatedContract',
  TotalEstimatedContractInProjectCurrency = 'totalEstimatedContractInProjectCurrency',
  TotalTaskHours = 'totalTaskHours'
}

export type ProjectStageSynchronizeInput = {
  isNewProject: Scalars['Boolean'];
  projectUri: Scalars['String'];
};

export type ProjectStageSynchronizeResult = {
  __typename?: 'ProjectStageSynchronizeResult';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ProjectStatus = {
  __typename?: 'ProjectStatus';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type ProjectStatusUpdate = {
  __typename?: 'ProjectStatusUpdate';
  projectUri?: Maybe<Scalars['String']>;
  statusUri?: Maybe<Scalars['String']>;
};

export type ProjectSynchronizeInput = {
  projectUri?: InputMaybe<Scalars['String']>;
};

export type ProjectSynchronizeResult = {
  __typename?: 'ProjectSynchronizeResult';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ProjectTeamBillingRate = {
  __typename?: 'ProjectTeamBillingRate';
  asOfDate?: Maybe<Scalars['Date']>;
  billingRate?: Maybe<BillingRate>;
  id: Scalars['String'];
  rate?: Maybe<Money>;
};

export type ProjectTeamMember = {
  __typename?: 'ProjectTeamMember';
  id?: Maybe<Scalars['String']>;
  user?: Maybe<UserReference>;
};

export type ProjectTeamMemberFilter = {
  searchTerm?: InputMaybe<Scalars['String']>;
  teamMemberTypes?: InputMaybe<Array<ProjectTeamMemberType>>;
};

export enum ProjectTeamMemberType {
  CostCenter = 'COST_CENTER',
  Department = 'DEPARTMENT',
  DepartmentGroup = 'DEPARTMENT_GROUP',
  Division = 'DIVISION',
  EmployeetypeGroup = 'EMPLOYEETYPE_GROUP',
  Location = 'LOCATION',
  ResourcePlaceholder = 'RESOURCE_PLACEHOLDER',
  ServiceCenter = 'SERVICE_CENTER',
  User = 'USER'
}

export type ProjectTimesheetAccess = {
  __typename?: 'ProjectTimesheetAccess';
  allUsers?: Maybe<ProjectTimesheetAccessAllUsers>;
  costCenters?: Maybe<Array<Maybe<Group>>>;
  departments?: Maybe<Array<Maybe<Group>>>;
  divisions?: Maybe<Array<Maybe<Group>>>;
  employeeTypes?: Maybe<Array<Maybe<Group>>>;
  locations?: Maybe<Array<Maybe<Group>>>;
  resources?: Maybe<Array<Maybe<ProjectTimesheetAccessResourceMember>>>;
  serviceCenters?: Maybe<Array<Maybe<Group>>>;
};

export type ProjectTimesheetAccessAllUsers = {
  __typename?: 'ProjectTimesheetAccessAllUsers';
  assignedBillingRates?: Maybe<Array<Maybe<ProjectTeamBillingRate>>>;
  assignedTaskCount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isAssigned?: Maybe<Scalars['Boolean']>;
};


export type ProjectTimesheetAccessAllUsersAssignedTaskCountArgs = {
  taskAssignmentsFilter?: InputMaybe<TaskAssignmentsFilter>;
};

export type ProjectTimesheetAccessResourceMember = {
  __typename?: 'ProjectTimesheetAccessResourceMember';
  assignedBillingRates?: Maybe<Array<Maybe<ProjectTeamBillingRate>>>;
  assignedTaskCount?: Maybe<Scalars['Int']>;
  displayText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};


export type ProjectTimesheetAccessResourceMemberAssignedTaskCountArgs = {
  taskAssignmentsFilter?: InputMaybe<TaskAssignmentsFilter>;
};

export type ProjectTotals = {
  __typename?: 'ProjectTotals';
  totalActualBilling?: Maybe<Money>;
  totalActualCost?: Maybe<Money>;
  totalActualCostAmountInPortfolioCurrency?: Maybe<Scalars['Float']>;
  totalActualExpenseCost?: Maybe<Money>;
  totalActualHours?: Maybe<Scalars['Float']>;
  totalActualResourceCost?: Maybe<Money>;
  totalActualRevenue?: Maybe<Money>;
  totalBudgetCostAmountInPortfolioCurrency?: Maybe<Scalars['Float']>;
  totalBudgetCostUsedPercentage?: Maybe<Scalars['Float']>;
  totalBudgetHours?: Maybe<Scalars['Float']>;
  totalBudgetHoursRemaining?: Maybe<Scalars['Float']>;
  totalBudgetHoursUsed?: Maybe<Scalars['Float']>;
  totalBudgetedCost?: Maybe<Money>;
  totalEstimatedBilling?: Maybe<Money>;
  totalEstimatedBudgetCostRemaining?: Maybe<Money>;
  totalEstimatedBudgetCostRemainingInPortfolioCurrency?: Maybe<Scalars['Float']>;
  totalEstimatedBudgetHoursRemaining?: Maybe<Scalars['Float']>;
  totalEstimatedContract?: Maybe<Money>;
  totalEstimatedCost?: Maybe<Money>;
  totalEstimatedCostAtCompletion?: Maybe<Money>;
  totalEstimatedCostAtCompletionInPortfolioCurrency?: Maybe<Scalars['Float']>;
  totalEstimatedHours?: Maybe<Scalars['Float']>;
  totalEstimatedHoursAtCompletion?: Maybe<Scalars['Float']>;
  totalRolledUpEstimatedRemainingHours?: Maybe<Scalars['Float']>;
  totalScopeHoursCompleted?: Maybe<Scalars['Float']>;
  totalTaskHours?: Maybe<Scalars['Float']>;
};

export type ProjectTotalsFilter = {
  resourcePoolIds?: InputMaybe<Array<Scalars['String']>>;
  roleUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchText?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type ProjectWorkflowChecklist = {
  __typename?: 'ProjectWorkflowChecklist';
  /** @deprecated Use checklist2 */
  checklist?: Maybe<Scalars['ProjectWorkflowChecklistData']>;
  checklist2?: Maybe<ProjectWorkflowChecklistData2>;
  id: Scalars['String'];
};

export type ProjectWorkflowChecklistData2 = {
  __typename?: 'ProjectWorkflowChecklistData2';
  closeOut?: Maybe<Array<Maybe<ProjectWorkflowChecklistItem>>>;
  execution?: Maybe<Array<Maybe<ProjectWorkflowChecklistItem>>>;
  initiate?: Maybe<Array<Maybe<ProjectWorkflowChecklistItem>>>;
  planning?: Maybe<Array<Maybe<ProjectWorkflowChecklistItem>>>;
};

export type ProjectWorkflowChecklistDataInput = {
  closeOut?: InputMaybe<Array<InputMaybe<ProjectWorkflowChecklistItemInput>>>;
  execution?: InputMaybe<Array<InputMaybe<ProjectWorkflowChecklistItemInput>>>;
  initiate?: InputMaybe<Array<InputMaybe<ProjectWorkflowChecklistItemInput>>>;
  planning?: InputMaybe<Array<InputMaybe<ProjectWorkflowChecklistItemInput>>>;
};

export type ProjectWorkflowChecklistItem = {
  __typename?: 'ProjectWorkflowChecklistItem';
  checked: Scalars['Boolean'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ProjectWorkflowChecklistItemInput = {
  checked: Scalars['Boolean'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ProjectWorkflowOption = {
  __typename?: 'ProjectWorkflowOption';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export enum ProjectWorkflowStage {
  Archived = 'ARCHIVED',
  Closeout = 'CLOSEOUT',
  Execution = 'EXECUTION',
  Initiate = 'INITIATE',
  Planning = 'PLANNING'
}

export type ProjectWorkflowState = {
  __typename?: 'ProjectWorkflowState';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<ProjectWorkflowOption>>>;
  /** @deprecated Use uri2 */
  uri?: Maybe<Scalars['String']>;
  uri2?: Maybe<ProjectWorkflowStage>;
};

export type ProjectsOverbudgetCount = {
  __typename?: 'ProjectsOverbudgetCount';
  compDateOverdueCount?: Maybe<Scalars['Int']>;
  eitherOverHoursOrCostBudgetCount?: Maybe<Scalars['Int']>;
  overHoursBudgetCount?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type ProjectsStatusCountSummary = {
  __typename?: 'ProjectsStatusCountSummary';
  archived?: Maybe<Scalars['Int']>;
  closed?: Maybe<Scalars['Int']>;
  execution?: Maybe<Scalars['Int']>;
  initiate?: Maybe<Scalars['Int']>;
  planning?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type ProposeAllocationsForResourceRequestInput = {
  resourceRequestId: Scalars['String'];
  userIds: Array<Scalars['String']>;
};

export type ProposeAllocationsForResourceRequestResult = {
  __typename?: 'ProposeAllocationsForResourceRequestResult';
  resourceAllocations: Array<ResourceAllocation>;
  resourceRequest: ResourceRequest;
};

export type ProposeHiredResourcesInput = {
  resourceRequestId: Scalars['String'];
  userUris: Array<Scalars['String']>;
};

export type ProposeHiredResourcesResult = {
  __typename?: 'ProposeHiredResourcesResult';
  resourceAllocations: Array<ResourceAllocation>;
  resourceRequest: ResourceRequest;
};

export type PutAssignedTagValueInput = {
  objectId: Scalars['String'];
  tagId?: InputMaybe<Scalars['String']>;
  tagName?: InputMaybe<Scalars['String']>;
  tagValue?: InputMaybe<Scalars['String']>;
  tagValueId?: InputMaybe<Scalars['String']>;
};

export type PutAssignedTagValueResult = {
  __typename?: 'PutAssignedTagValueResult';
  assignment?: Maybe<TagAssignment>;
  error?: Maybe<Error>;
};

export type PutAvatarDataInput = {
  base64?: InputMaybe<Scalars['String']>;
};

export type PutAvatarResult = {
  __typename?: 'PutAvatarResult';
  avatar: Avatar;
};

export type PutBillPaymentResult = {
  __typename?: 'PutBillPaymentResult';
  paymentUri: Scalars['String'];
};

export type PutBillPaymentsForBillResult = {
  __typename?: 'PutBillPaymentsForBillResult';
  billUri: Scalars['String'];
};

export type PutBillResult = {
  __typename?: 'PutBillResult';
  billUri: Scalars['String'];
};

export type PutClientRatesResult = {
  __typename?: 'PutClientRatesResult';
  client: Client;
  clientRates?: Maybe<Array<Maybe<ProjectRate>>>;
};

export type PutClientRatesResult2 = {
  __typename?: 'PutClientRatesResult2';
  client: Client;
  clientRates: Array<Maybe<ClientRate2>>;
  clientUri: Scalars['String'];
};

export type PutCreditMemoResult = {
  __typename?: 'PutCreditMemoResult';
  creditMemoUri: Scalars['String'];
};

export type PutCreditMemosForBillResult = {
  __typename?: 'PutCreditMemosForBillResult';
  billUri: Scalars['String'];
};

export type PutKeyValueSettingsInput = {
  key: Scalars['String'];
  settings?: InputMaybe<Scalars['KeyValueSettings']>;
};

export type PutLineItemForBillResult = {
  __typename?: 'PutLineItemForBillResult';
  billItemUri: Scalars['String'];
};

export type PutNotificationPoliciesResult = {
  __typename?: 'PutNotificationPoliciesResult';
  notificationPolicies?: Maybe<Array<Maybe<NotificationPolicy>>>;
};

export type PutPortfolioBudgetInput = {
  budgetCurrency: CurrencyInput;
  capitalBudgetAmount?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  operationalBudgetAmount?: InputMaybe<Scalars['Float']>;
  totalBudgetAmount?: InputMaybe<Scalars['Float']>;
};

export type PutPortfolioInput = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['String']>;
  portfolioManager?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PortfolioStatus>;
};

export type PutPortfolioResult = {
  __typename?: 'PutPortfolioResult';
  portfolioSlug?: Maybe<Scalars['String']>;
  portfolioUri?: Maybe<Scalars['String']>;
};

export type PutProjectBillPlansResult = {
  __typename?: 'PutProjectBillPlansResult';
  billingContractRecalcBatchUri: Scalars['String'];
  project?: Maybe<Project>;
};

export type PutProjectRatesResult = {
  __typename?: 'PutProjectRatesResult';
  project?: Maybe<Project>;
  projectRates?: Maybe<Array<Maybe<ProjectRate>>>;
};

export type PutProjectRatesResult2 = {
  __typename?: 'PutProjectRatesResult2';
  project: Project;
  projectRates: Array<Maybe<ProjectRate2>>;
  projectUri: Scalars['String'];
};

export type PutProjectReportResult = {
  __typename?: 'PutProjectReportResult';
  projectReport: ProjectReport;
};

export type PutProjectRequestResourceAssignmentInput = {
  projectRequestId: Scalars['String'];
  resourceAssignmentsToUpdate: Array<ProjectRequestResourceAssignmentInput>;
  resourceAssignmentsUrisToRemove: Array<Scalars['String']>;
};

export type PutProjectRequestResourceAssignmentResult = {
  __typename?: 'PutProjectRequestResourceAssignmentResult';
  added: Array<UpdateProjectRequestAssignmentResultEntry>;
  projectRequestId: Scalars['String'];
};

export type PutProjectRequestResult = {
  __typename?: 'PutProjectRequestResult';
  projectRequestUri: Scalars['String'];
};

export type PutProjectRequestScoreInput = {
  id: Scalars['String'];
  investment?: InputMaybe<Scalars['Int']>;
  risk?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type PutProjectRequestTimelineInput = {
  id: Scalars['String'];
  startDate?: InputMaybe<Scalars['Date2']>;
  timelineDuration?: InputMaybe<ProjectRequestTimelineDurationInput>;
};

export type PutProjectRevenueContractDetailsResult = {
  __typename?: 'PutProjectRevenueContractDetailsResult';
  batchUris?: Maybe<Array<Maybe<Scalars['String']>>>;
  project?: Maybe<Project>;
};

export type PutResourceAllocationInput = {
  comment?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isAdjustedLoading?: InputMaybe<Scalars['Boolean']>;
  load: Scalars['Float'];
  projectUri: Scalars['String'];
  requestedRoleUri?: InputMaybe<Scalars['String']>;
  resourceRequestId?: InputMaybe<Scalars['String']>;
  scheduleRules: Array<ScheduleRuleInput>;
  totalHours?: InputMaybe<Scalars['Float']>;
  user: ResourceAllocationUserInput;
};

export type PutResourceRequestAllocationInput = {
  resourceAllocationsInput?: InputMaybe<Array<PutResourceAllocationInput>>;
  resourceRequestInput?: InputMaybe<PutResourceRequestInput>;
};

export type PutResourceRequestAllocationResult = {
  __typename?: 'PutResourceRequestAllocationResult';
  resourceAllocations?: Maybe<Array<ResourceAllocation>>;
  resourceRequest?: Maybe<ResourceRequest>;
};

export type PutResourceRequestInput = {
  comment?: InputMaybe<Scalars['String']>;
  costCenterUri?: InputMaybe<Scalars['String']>;
  currencyUri?: InputMaybe<Scalars['String']>;
  departmentUri?: InputMaybe<Scalars['String']>;
  divisionUri?: InputMaybe<Scalars['String']>;
  employeeTypeUri?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isAdjustedLoading?: InputMaybe<Scalars['Boolean']>;
  load?: InputMaybe<Scalars['Float']>;
  locationUri?: InputMaybe<Scalars['String']>;
  preferredResourceUris?: InputMaybe<Array<Scalars['String']>>;
  projectUri: Scalars['String'];
  quantity: Scalars['Int'];
  requestAttributeWeights?: InputMaybe<RequestAttributeWeightsInput>;
  resourcePoolUris?: InputMaybe<Array<Scalars['String']>>;
  resourceRequestStatus?: InputMaybe<ResourceRequestStatus>;
  roleRate?: InputMaybe<Scalars['Float']>;
  roleUri?: InputMaybe<Scalars['String']>;
  scheduleRules: Array<ScheduleRuleInput>;
  serviceCenterUri?: InputMaybe<Scalars['String']>;
  skills?: InputMaybe<Array<RequestSkillInput>>;
  sourceMetadata?: InputMaybe<SourceMetadataInput>;
  tags?: InputMaybe<Array<RequestTagInput>>;
  totalHours?: InputMaybe<Scalars['Float']>;
};

export type PutSearchSettingsInput = {
  key: Scalars['String'];
  settings?: InputMaybe<SearchSettingsInput>;
};

export type PutTableSettingInput = {
  columns?: InputMaybe<Array<Scalars['String']>>;
  sort?: InputMaybe<SortSettingInput>;
  tableKey: Scalars['String'];
};

export type PutTableSettingResult = {
  __typename?: 'PutTableSettingResult';
  tableSetting?: Maybe<TableSetting>;
};

export type PutTaskResourceEstimateAllocationInput = {
  allocatedHours: Scalars['Float'];
  endDate: Scalars['Date2'];
  projectId: Scalars['String'];
  startDate: Scalars['Date2'];
};

export type PutTaskResourceEstimateInput = {
  initialEstimatedHours?: InputMaybe<Scalars['Float']>;
  projectRoleId?: InputMaybe<Scalars['String']>;
  resourceUserId?: InputMaybe<Scalars['String']>;
  taskId: Scalars['String'];
  taskResourceEstimateAllocationInput?: InputMaybe<PutTaskResourceEstimateAllocationInput>;
  taskResourceEstimateId?: InputMaybe<Scalars['String']>;
};

export type PutTaskResourceEstimateResult = {
  __typename?: 'PutTaskResourceEstimateResult';
  taskResourceEstimateId: Scalars['String'];
};

export type PutUserCertificateResult = {
  __typename?: 'PutUserCertificateResult';
  certificate?: Maybe<Certificate>;
  error?: Maybe<Error>;
};

export type PutUserResourcePoolsInput = {
  resourcePoolUris: Array<Scalars['String']>;
  userUri: Scalars['String'];
};

export type PutUserResourcePoolsResult = {
  __typename?: 'PutUserResourcePoolsResult';
  userUri: Scalars['String'];
};

export type PutVendorInput = {
  closedDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  _?: Maybe<Scalars['String']>;
  activeClients?: Maybe<Array<ClientReference>>;
  activeInvoiceTemplates?: Maybe<Array<Maybe<InvoiceTemplate>>>;
  activePrograms?: Maybe<Array<ProgramReference>>;
  activeRoles?: Maybe<Array<Maybe<Role>>>;
  activeUsersCount?: Maybe<ActiveUserCount>;
  allProjectTaskIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  assignedClientManagers?: Maybe<Array<Maybe<ClientManager>>>;
  attachmentInfo: Array<Praa_AttachmentInfo>;
  attachments: Array<Attachment>;
  attachmentsCount: Scalars['Int'];
  availableCreditMemosForBill?: Maybe<Array<Maybe<AvailableCreditMemo>>>;
  availableEarnedRevenueScripts?: Maybe<Array<Maybe<Script>>>;
  availablePaymentsForBill?: Maybe<Array<Maybe<AvailablePayment>>>;
  avatar?: Maybe<Avatar>;
  avatars?: Maybe<Array<Maybe<Avatar>>>;
  billPlanOverview2?: Maybe<Scalars['BillPlansOverviewData']>;
  billPlanOverview3?: Maybe<BillPlansOverviewData2>;
  billSnapshot?: Maybe<BillSnapshot>;
  billSubStatus: Array<BillSubStatus>;
  billingAggregationRowCount2?: Maybe<Scalars['Int']>;
  billingAggregationTotals2?: Maybe<BillingAggregationTotals>;
  billingContractClauses?: Maybe<Array<Maybe<ProjectBillingContractClause>>>;
  billingContracts?: Maybe<Array<Maybe<ProjectBillingContract>>>;
  billingItemsCount?: Maybe<Scalars['Int']>;
  billingOverview2?: Maybe<BillingOverview>;
  billingTransactionRowCounts2?: Maybe<Scalars['Int']>;
  billingTransactionSummary?: Maybe<BillingTransactionSummaryResult>;
  bulkGetProjectOrClientBillingDefaultsForAvailableToBill: Array<ProjectOrClientBillingDefaults>;
  canDeleteProjects?: Maybe<DeleteProjects>;
  childPortfolios: Array<PortfolioReference>;
  client?: Maybe<Client>;
  clientOverviewProjectCountSummary2?: Maybe<ProjectCountSummary>;
  clientRepresentatives?: Maybe<Array<Maybe<User>>>;
  clientTotals?: Maybe<ClientTotals>;
  clients?: Maybe<ClientsList>;
  clientsSummary?: Maybe<SummaryItems>;
  clientsTotalActualCostAmountSeries?: Maybe<CostSeriesData>;
  clientsTotalActualRevenueAmountSeries?: Maybe<CostSeriesData>;
  /** @deprecated Use clientsWithOverEstimatedProjects2, no longer uses Date scalar */
  clientsWithOverEstimatedProjects?: Maybe<ClientWithOverEstimatedProjectsList>;
  clientsWithOverEstimatedProjects2?: Maybe<ClientWithOverEstimatedProjectsList>;
  costCenter?: Maybe<Group>;
  costCenters?: Maybe<Array<Maybe<Group>>>;
  countries?: Maybe<Array<Maybe<Country>>>;
  currencies?: Maybe<Array<Maybe<Currency>>>;
  currency?: Maybe<Currency>;
  customFieldDefinition?: Maybe<CustomFieldDefinition>;
  customProjectStatusNames?: Maybe<Array<Maybe<CustomProjectStatusName>>>;
  department?: Maybe<Group>;
  departments?: Maybe<Array<Maybe<Group>>>;
  division?: Maybe<Group>;
  divisions?: Maybe<Array<Maybe<Group>>>;
  eligibleClientManagers?: Maybe<Array<Maybe<ClientManager>>>;
  employeeType?: Maybe<Group>;
  employeeTypes?: Maybe<Array<Maybe<Group>>>;
  enabledBillingRates?: Maybe<Array<Maybe<BillingRate>>>;
  enabledCustomFields?: Maybe<Array<Maybe<CustomFieldDefinition>>>;
  enabledSkillLevels?: Maybe<Array<Maybe<SkillLevel>>>;
  enabledSkills?: Maybe<Array<Maybe<Skill>>>;
  estimatedExpensesSeries?: Maybe<Array<Maybe<ProjectExpenseSeriesResult>>>;
  estimatedExpensesSummary?: Maybe<Array<Maybe<ProjectExpenseSummaryResult>>>;
  expenseActualsSeries?: Maybe<Array<Maybe<ProjectExpenseSeriesResult>>>;
  expenseActualsSummary?: Maybe<Array<Maybe<ProjectExpenseSummaryResult>>>;
  expenseCardSettings?: Maybe<ExpenseCardSettings>;
  extensionFieldDefinitions?: Maybe<Array<Maybe<ExtensionFieldDefinition>>>;
  extensionFieldTags?: Maybe<Array<Maybe<ExtensionFieldTag>>>;
  financialOverviewSeriesData2?: Maybe<FinancialOverviewSeriesData>;
  financialOverviewTotals2?: Maybe<FinancialOverviewTotals>;
  getActiveTasksSummary?: Maybe<ActiveTasksSummary>;
  getAllProgramManagersAssignedToPrograms?: Maybe<Array<Maybe<ProgramManager>>>;
  getAvailableBillingItemsTotal2?: Maybe<BillingItemSummary>;
  getAvailableToBillTotals2?: Maybe<AvailableToBillTotal>;
  getBackgroundJob?: Maybe<BackgroundJob>;
  getBatchStatus?: Maybe<GetBatchStatusResponse>;
  getBill?: Maybe<Bill>;
  getBillPayment?: Maybe<BillPayment>;
  getBillingBatchStatus?: Maybe<GetBatchStatusResponse>;
  getBillingItemsSummary2?: Maybe<BillingItemSummary>;
  getBillingTransactionTotals2?: Maybe<BillingTransactionTotal>;
  getBulkCreateBillFromBillingItemsBatchResult?: Maybe<Array<Maybe<CreateBulkBillFromBillingItemsBatchResult>>>;
  /** @deprecated Use clientRepresentatives */
  getClientRepresentatives?: Maybe<Array<Maybe<ClientReference>>>;
  getCreateBillFromBillingItemsBatchResults?: Maybe<CreateBillFromBillingItemsBatchExecutionResult>;
  getCreditMemo?: Maybe<CreditMemo>;
  getCurrentBillingRateForUser?: Maybe<UserRate>;
  getDownloadUrl?: Maybe<DownloadUrl>;
  getDtmSessionMetadata?: Maybe<Array<Maybe<Pti_DtmSessionMetadata>>>;
  getEligiblePortfolioManagers: Array<ObjectReference>;
  getExportUri?: Maybe<ExportUri>;
  getFilteredTaskResourceAllocationUserIds: Array<Scalars['String']>;
  getInvoiceStatusUpdateBatchResult?: Maybe<InvoiceStatusUpdateBatchResult>;
  getNotificationPolicyForEventType?: Maybe<Array<Maybe<NotificationPolicy>>>;
  getPageOfAssociatedBillPaymentsForBill?: Maybe<GetPageOfAssociatedBillPaymentsForBillResponse>;
  getPageOfAssociatedBillsForBillPayment?: Maybe<GetPageOfAssociatedBillsForBillPaymentResponse>;
  getPageOfAssociatedBillsForCreditMemo?: Maybe<GetPageOfAssociatedBillsForCreditMemoResponse>;
  getPageOfAssociatedCreditMemosForBill?: Maybe<GetPageOfAssociatedCreditMemosForBillResponse>;
  getPageOfAvailableBillingItemDetails2?: Maybe<Array<Maybe<BillingItem>>>;
  getPageOfAvailableToBill2?: Maybe<Array<Maybe<AvailableToBill>>>;
  getPageOfBillingItems2?: Maybe<Array<Maybe<BillingItem2>>>;
  getPageOfBillingTransactions?: Maybe<Array<Maybe<BillingTransaction>>>;
  getPageOfLineItemsForBill?: Maybe<GetPageOfLineItemsForBillResponse>;
  getPageOfLineItemsForCreditMemo?: Maybe<GetPageOfLineItemsForCreditMemoResponse>;
  getPageOfProjectsAvailableForFilteringBillingItems?: Maybe<Array<Maybe<Project>>>;
  getPageOfProjectsFilteredByDataAccessLevels?: Maybe<Array<Maybe<Project>>>;
  getPageOfResourceUserMatchesForResourceRequest?: Maybe<Array<Maybe<ResourceUser>>>;
  getPaymentMethod?: Maybe<PaymentMethodReference>;
  getPaymentMethods?: Maybe<Array<Maybe<PaymentMethodReference>>>;
  getProgramManagers?: Maybe<Array<Maybe<ProgramManager>>>;
  getRequisitionData?: Maybe<Pti_Requisition>;
  getResourcePlansForCurrentTenant: GetResourcePlansResult;
  getScheduleDurationByDayForUsers?: Maybe<Array<Maybe<ScheduleDurationByDayForUser>>>;
  getScheduleDurationForUser: Scalars['Float'];
  getTaskResourceUserAllocationsSummaryForUser?: Maybe<TaskResourceUserAllocationsSummaryForUser>;
  getTimeEntryRevisionGroupBulkModificationBatchResults?: Maybe<TimeEntryRevisionGroupBulkModificationBatchResults>;
  getUserBeatAppDownloadUrl?: Maybe<UserBeatAppDownloadUrl>;
  getUserProfile?: Maybe<Praa_UserProfile>;
  getUserScheduleRulesForDateRange: Array<ScheduleRule>;
  hiringStatusSummaryCount: HiringStatusSummary;
  initialRevenuePeriodStartDate?: Maybe<Scalars['Date2']>;
  invoiceDefaultTemplate?: Maybe<InvoiceTemplate>;
  isBillDataReflectedInAvailableToBillData?: Maybe<Scalars['Boolean']>;
  isProjectRiskTTLOverrideEnabled?: Maybe<Scalars['Boolean']>;
  keyValueSettings?: Maybe<Scalars['KeyValueSettings']>;
  languages?: Maybe<Array<Maybe<Language>>>;
  location?: Maybe<Group>;
  locations?: Maybe<Array<Maybe<Group>>>;
  me?: Maybe<Me>;
  myActiveClients?: Maybe<Array<Maybe<Client>>>;
  myActivePrograms?: Maybe<Array<Maybe<Program>>>;
  notificationPolicies?: Maybe<Array<Maybe<NotificationPolicy>>>;
  overEstimatedTasksProjects?: Maybe<OverEstimatedProjectsDetails>;
  overdueBillBalanceAmount2?: Maybe<Array<Maybe<OverdueBillBalanceAmountResult>>>;
  overdueBillBalanceAmountRowCount2?: Maybe<Scalars['Int']>;
  pageOfAvailableRateTableDimensions?: Maybe<Array<Maybe<RateTableDimension>>>;
  pageOfAvailableTaxProfiles?: Maybe<Array<Maybe<TaxProfile>>>;
  pageOfBillingAggregation2?: Maybe<Array<Maybe<BillingAggregation>>>;
  pageOfClientsAvailableForFilteringProjects?: Maybe<Array<Maybe<Client>>>;
  pageOfPayCodeAvailableForBillingRatesAssignment: Array<PayCode>;
  pageOfPortfoliosAvailableForFilteringProjectRequest: Array<PortfolioForFilteringProjectRequests>;
  pageOfPortfoliosAvailableForFilteringProjects: Array<PortfolioForFilteringProjects>;
  pageOfPortfoliosAvailableForProjectAssignment: Array<ProjectPortfolio>;
  pageOfPortfoliosAvailableForProjectRequestAssignment: Array<ProjectRequestPortfolio>;
  pageOfProgramsAvailableForFilteringProjects?: Maybe<Array<Maybe<Program>>>;
  pageOfProjectRateTableRoleOptions: Array<Role>;
  pageOfProjectResourceDropdownOptions: PageOfProjectResourceDropdownOptionsResponse;
  pageOfResourceUsersDropdownOptions: Array<Maybe<ResourceUsersDropdownOption>>;
  pageOfRevenueAggregation2?: Maybe<Array<Maybe<RevenueAggregation>>>;
  pageOfRevenueEntries2?: Maybe<Array<Maybe<Scalars['RevenueEntriesCustomMetadata']>>>;
  pageOfRevenueEntry2?: Maybe<Array<Maybe<RevenueEntry>>>;
  pageOfTaskAssignmentSummaryForProjectAndResourceUser?: Maybe<PageOfTaskAssignmentSummaryForProjectAndResourceUserResponse>;
  pageOfTaskResourceUserAllocations?: Maybe<PageOfTaskResourceUserAllocationsResult>;
  portfolio?: Maybe<Portfolio>;
  portfolioAncestryDetails: Array<PortfolioAncestor>;
  portfolioProjectRequestStatusEstimatedCostSummary?: Maybe<PortfolioProjectRequestStatusEstimatedCostSummaryResult>;
  portfolioProjectStatusBudgetSummary?: Maybe<PortfolioProjectStatusBudgetSummary>;
  portfolioProjectsProgressSummary?: Maybe<PortfolioProjectsProgressSummary>;
  portfolios?: Maybe<Array<Maybe<Portfolio>>>;
  portfoliosSummaryCount: PortfolioSummaryCountResult;
  predictionCacheProjectRisk?: Maybe<Ppra_PredictionCacheProjectRiskResult>;
  previewBulkUnassignTasksToResourceUser: PreviewBulkUnassignTasksToResourceUserResult;
  program?: Maybe<Program>;
  programOverviewProjectCountSummary2?: Maybe<ProjectCountSummary>;
  /** @deprecated Use programTotals2, no longer uses Date scalar */
  programTotals?: Maybe<ProgramTotals>;
  programTotals2?: Maybe<ProgramTotals>;
  /** @deprecated Use programs2, no longer uses Date scalar */
  programs?: Maybe<ProgramsList>;
  programs2?: Maybe<ProgramsList>;
  programsSummary?: Maybe<SummaryItems>;
  programsTotalActualCostAmountSeries?: Maybe<CostSeriesData>;
  programsTotalActualRevenueAmountSeries?: Maybe<CostSeriesData>;
  /** @deprecated Use programsWithOverEstimatedProjects2, no longer uses Date scalar */
  programsWithOverEstimatedProjects?: Maybe<ProgramsWithOverEstimatedProjectList>;
  programsWithOverEstimatedProjects2?: Maybe<ProgramsWithOverEstimatedProjectList>;
  project?: Maybe<Project>;
  projectClients?: Maybe<ClientReferencesList>;
  projectCodeSettings?: Maybe<ProjectCodeSettings>;
  projectCountSummary2?: Maybe<ProjectCountSummary>;
  projectDeleteBatchResults?: Maybe<DeleteProjectBatchResult>;
  projectInfoModificationBatchResults?: Maybe<ProjectInfoModificationBatchResult>;
  /** @deprecated Use projectManagersFilteredBySearch */
  projectManagers?: Maybe<Array<Maybe<ProjectManager>>>;
  projectManagersFilteredBySearch?: Maybe<Array<Maybe<ProjectManager>>>;
  projectPrograms?: Maybe<ProgramReferencesList>;
  projectRequest?: Maybe<ProjectRequest>;
  projectRequestRevisions?: Maybe<AuditTrail_ProjectRequestRevisionResult>;
  projectRequestTotals?: Maybe<ProjectRequestTotals>;
  projectRequests?: Maybe<Array<Maybe<ProjectRequest>>>;
  projectRequestsByStatusTypeCountSummary?: Maybe<ProjectRequestsByStatusTypeCountSummary>;
  projectRevenueRecognitionBatchUriInProgress2?: Maybe<ProjectRevenueRecognitionBatchUriInProgressResult>;
  projectRiskModelInput?: Maybe<Ppra_ProjectRiskModelInputResult>;
  projectStatuses?: Maybe<Array<Maybe<ProjectStatus>>>;
  projectTeamMemberBillingRateAssignmentRevisions?: Maybe<AuditTrail_ProjectTeamMemberBillingRateAssignmentResult>;
  projectTotals?: Maybe<ProjectTotals>;
  projectWorkflowChecklistTemplate?: Maybe<ProjectWorkflowChecklist>;
  projects?: Maybe<Array<Maybe<Project>>>;
  projects2?: Maybe<Array<Maybe<Project>>>;
  projectsFilteredByResourceRequestStatus?: Maybe<ResourceRequestsProjectsDetails>;
  projectsFilteredByResourceRequestStatus2?: Maybe<ResourceRequestsProjectsDetails>;
  projectsOverbudgetCount?: Maybe<ProjectsOverbudgetCount>;
  projectsStatusCountSummary?: Maybe<ProjectsStatusCountSummary>;
  recognizableRevenueCarryOverSummary?: Maybe<Array<Maybe<RecognizableRevenueCarryOverSummary>>>;
  resource?: Maybe<ResourceDetails>;
  resourceAllocation?: Maybe<ResourceAllocation>;
  resourceAllocationCount?: Maybe<Scalars['Int']>;
  resourceAllocationSeriesData?: Maybe<Array<Maybe<ResourceAllocationSeriesData>>>;
  /**
   * Currently, it is effectively not behind any permission checks.
   * TODO: Add appropriate permission checks.
   */
  resourceAllocations?: Maybe<ResourceAllocationsResponse>;
  resourceAllocationsSummary?: Maybe<ResourceAllocationsSummaryResult>;
  resourceDetails?: Maybe<Array<Maybe<ResourceDetails>>>;
  resourceMatches: Array<Maybe<Praa_BulkResourceMatch>>;
  resourceMatchesStatus: Array<Maybe<Praa_ResourceMatchStatus>>;
  resourcePlanDefaults?: Maybe<ResourcePlanDefaults>;
  resourcePlansSummaryForCurrentTenant?: Maybe<ResourcePlansSummary>;
  resourcePools: Array<ResourcePool>;
  resourceRequest?: Maybe<ResourceRequest>;
  resourceRequestUsermatch?: Maybe<ResourceRequestUserMatch>;
  resourceRequestUsermatches?: Maybe<ResourceRequestUserMatchesResponse>;
  resourceRequests?: Maybe<ResourceRequestsResponse>;
  resourceRequestsSeriesData?: Maybe<Array<Maybe<ResourceRequestsSummary>>>;
  resourceRequestsStatusCountSummary?: Maybe<ResourceRequestsStatusCountSummary>;
  resourceRequestsSummaryForProjectManager?: Maybe<ResourceRequestsStatusCountSummary>;
  resourceUserAvailabilityHoursSeriesForDateRange: Array<ResourceUserAvailabilityHours>;
  resourceUserAvailabilitySeries?: Maybe<Array<Maybe<ResourceUserAvailabilitySeries>>>;
  resourceUserAvailabilitySeriesTotals?: Maybe<ResourceUserAvailabilitySeriesTotals>;
  resourceUserTaskAssignmentSummary: ResourceUserTaskAssignmentSummaryResult;
  /** @deprecated Use resourceUsers2, supports sorting array */
  resourceUsers?: Maybe<Array<Maybe<ResourceUser>>>;
  resourceUsers2?: Maybe<Array<Maybe<ResourceUser>>>;
  resourceUsersCount: ResourceUsersCount;
  /** @deprecated Use resourceDetails instead */
  resources?: Maybe<Array<Maybe<ResourceDetails>>>;
  revenueAggregationRowCount2?: Maybe<Scalars['Int']>;
  revenueAggregationTotals2?: Maybe<RevenueAggregationTotals>;
  revenueContractClauses?: Maybe<Array<Maybe<ContractClause>>>;
  revenueContracts?: Maybe<Array<Maybe<ProjectContractDetails>>>;
  revenueEntryTotals2?: Maybe<RevenueEntryTotals>;
  revenueRunBatchUriInProgress?: Maybe<Scalars['String']>;
  revenueRunLists?: Maybe<Array<Maybe<GetRevenueRunListResult>>>;
  /** @deprecated Use revenueRunScheduleSeries2, no longer uses Date scalar */
  revenueRunScheduleSeries?: Maybe<RevenueRunScheduleSeriesResult>;
  revenueRunScheduleSeries2?: Maybe<RevenueRunScheduleSeriesResult>;
  role?: Maybe<Role>;
  scheduleDurationSeriesForUsers: Array<ScheduleDurationSeriesForUser>;
  searchSettings?: Maybe<SearchSettings>;
  serviceCenter?: Maybe<Group>;
  serviceCenters?: Maybe<Array<Maybe<Group>>>;
  sessionTimeoutRemaining?: Maybe<TimeoutDuration>;
  skillCategories?: Maybe<Array<Maybe<Category>>>;
  skillDistributionForUsers?: Maybe<Array<Maybe<SkillDistributionForUsersSummary>>>;
  skillSettings?: Maybe<Array<Maybe<SkillSetting>>>;
  smartFitResourceAvailabilityHoursOptionsByTotalHoursAndDateRange: SmartFitResourceAvailabilityOption;
  smartFitResourceAvailablityHoursOptions: SmartFitResourceAvailabilityOption;
  tableSetting?: Maybe<TableSetting>;
  tag?: Maybe<Tag>;
  tagId?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  task?: Maybe<Task>;
  taskBurndownData?: Maybe<Array<Maybe<TaskBurndownData>>>;
  /** @deprecated Use taskEntries3 */
  taskEntries2?: Maybe<TaskEntriesResponse>;
  taskEntries3: Array<TaskEntry>;
  /** @deprecated Will be dropping support for dynamodb task entries */
  taskEntriesCount?: Maybe<Scalars['Int']>;
  /** @deprecated Will be dropping support for dynamodb task entries */
  taskEntry?: Maybe<TaskEntry>;
  taskProgress: Array<TaskEntryProgress>;
  taskResourceEstimateDetails?: Maybe<TaskResourceEstimateDetails>;
  taskResourceUserAllocationsForUser: Array<TaskResourceUserAllocation>;
  tasksStatusCountSummary?: Maybe<TasksStatusCountSummary>;
  taxRatesForTaxProfile2?: Maybe<Array<Maybe<TaxRatesForTaxProfile>>>;
  timeAndExpense2?: Maybe<Scalars['TimeAndExpense']>;
  timeAndExpenseEntryTypes?: Maybe<Array<Maybe<TimeAndExpenseEntryType>>>;
  timeAndExpenseSettings?: Maybe<TimeAndExpenseSettings>;
  timeZones?: Maybe<Array<Maybe<TimeZone>>>;
  transactionNextReferenceNumberSetting?: Maybe<TransactionNextReferenceNumberSetting>;
  transactionNextReferenceNumberText?: Maybe<Scalars['String']>;
  transactionReferenceNumberSetting?: Maybe<TransactionReferenceNumberSetting>;
  unavailableSkillLevel?: Maybe<SkillLevel>;
  unreadNotifications?: Maybe<Array<Maybe<Notification>>>;
  unreadNotificationsCount: Scalars['String'];
  user?: Maybe<User>;
  userDefinedSkills?: Maybe<Array<Maybe<UserDefinedSkill>>>;
  userNudges: Praa_UserNudges;
  userPermissionSetRevisions?: Maybe<AuditTrail_UserPermissionSetRevisionResult>;
  users?: Maybe<Array<Maybe<User>>>;
  usersAvailableForVendorAssignment?: Maybe<Array<ResourceDetails>>;
  validateInvoiceAmountLimit: ValidateInvoiceAmountLimitOutput;
  validateProgramName?: Maybe<Array<Maybe<ValidationNotificationSummary>>>;
  validateProjectName?: Maybe<Array<Maybe<ValidationNotificationSummary>>>;
  vendor?: Maybe<Vendor>;
  vendors?: Maybe<VendorsList>;
  vendorsSummaryCount?: Maybe<VendorsSummaryCount>;
};


export type QueryActiveRolesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryActiveUsersCountArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
};


export type QueryAllProjectTaskIdsArgs = {
  hierarchyListDataOptionUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isMilestone?: InputMaybe<Scalars['Boolean']>;
  isOpen?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['String'];
  textSearch?: InputMaybe<Scalars['String']>;
};


export type QueryAttachmentInfoArgs = {
  input: Praa_AttachmentsInfoInput;
};


export type QueryAttachmentsArgs = {
  objectUri: Scalars['String'];
};


export type QueryAttachmentsCountArgs = {
  objectUri: Scalars['String'];
};


export type QueryAvailableCreditMemosForBillArgs = {
  billId: Scalars['String'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryAvailablePaymentsForBillArgs = {
  billId: Scalars['String'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryAvatarArgs = {
  userId: Scalars['String'];
};


export type QueryAvatarsArgs = {
  userIds: Array<Scalars['String']>;
};


export type QueryBillPlanOverview2Args = {
  dateRange?: InputMaybe<DateRangeInput2>;
  overviewMode: BillPlanOverviewMode;
  periodResolutionUri?: InputMaybe<Scalars['String']>;
};


export type QueryBillPlanOverview3Args = {
  dateRange?: InputMaybe<DateRangeInput2>;
  overviewMode: BillPlanOverviewMode;
  periodResolutionUri?: InputMaybe<Scalars['String']>;
};


export type QueryBillSnapshotArgs = {
  billId: Scalars['String'];
};


export type QueryBillSubStatusArgs = {
  billStatus: BillStatus;
};


export type QueryBillingAggregationRowCount2Args = {
  columns?: InputMaybe<Array<InputMaybe<BillingAggregationColumn>>>;
  filter?: InputMaybe<BillingAggregationFilter2>;
};


export type QueryBillingAggregationTotals2Args = {
  filter?: InputMaybe<BillingAggregationFilter2>;
};


export type QueryBillingItemsCountArgs = {
  projectId?: InputMaybe<Scalars['String']>;
};


export type QueryBillingOverview2Args = {
  dateRange?: InputMaybe<DateRangeInput2>;
  periodResolutionUri?: InputMaybe<Scalars['String']>;
};


export type QueryBillingTransactionRowCounts2Args = {
  filter?: InputMaybe<BillingTransactionFilter2>;
};


export type QueryBillingTransactionSummaryArgs = {
  filter?: InputMaybe<BillingTransactionFilter2>;
};


export type QueryBulkGetProjectOrClientBillingDefaultsForAvailableToBillArgs = {
  filters?: InputMaybe<Array<AvailableToBillFilter2>>;
};


export type QueryCanDeleteProjectsArgs = {
  projectIds: Array<Scalars['String']>;
};


export type QueryChildPortfoliosArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  parentId: Scalars['String'];
};


export type QueryClientArgs = {
  slug?: InputMaybe<Scalars['String']>;
  uri?: InputMaybe<Scalars['String']>;
};


export type QueryClientOverviewProjectCountSummary2Args = {
  clientFilter?: InputMaybe<ClientFilter2>;
};


export type QueryClientRepresentativesArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  searchText?: InputMaybe<Scalars['String']>;
};


export type QueryClientTotalsArgs = {
  clientFilter?: InputMaybe<ClientFilter2>;
};


export type QueryClientsArgs = {
  clientFilter?: InputMaybe<ClientFilter2>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  sort?: InputMaybe<ClientSort>;
};


export type QueryClientsSummaryArgs = {
  clientFilter?: InputMaybe<ClientFilter2>;
};


export type QueryClientsTotalActualCostAmountSeriesArgs = {
  clientFilter?: InputMaybe<ClientFilter2>;
  dateRange: DateRangeInput2;
  periodResolutionOption: PeriodResolutionOption;
};


export type QueryClientsTotalActualRevenueAmountSeriesArgs = {
  clientFilter?: InputMaybe<ClientFilter2>;
  dateRange: DateRangeInput2;
  periodResolutionOption: PeriodResolutionOption;
};


export type QueryClientsWithOverEstimatedProjectsArgs = {
  clientFilter?: InputMaybe<ClientFilter>;
  overEstimatedProjectType: OverEstimatedProjectType;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type QueryClientsWithOverEstimatedProjects2Args = {
  clientFilter?: InputMaybe<ClientFilter2>;
  overEstimatedProjectType: OverEstimatedProjectType;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type QueryCostCenterArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryCostCentersArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  policy?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryCurrencyArgs = {
  id: Scalars['String'];
};


export type QueryCustomFieldDefinitionArgs = {
  groupId: Scalars['String'];
  id: Scalars['String'];
};


export type QueryDepartmentArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryDepartmentsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  policy?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryDivisionArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryDivisionsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  policy?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryEligibleClientManagersArgs = {
  clientId: Scalars['String'];
};


export type QueryEmployeeTypeArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryEmployeeTypesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  policy?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryEnabledBillingRatesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['String'];
  textSearch?: InputMaybe<Scalars['String']>;
};


export type QueryEnabledCustomFieldsArgs = {
  groupName?: InputMaybe<Scalars['String']>;
};


export type QueryEnabledSkillsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryEstimatedExpensesSeriesArgs = {
  currencyId?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<DateRangeInput2>;
  projectId: Scalars['String'];
};


export type QueryEstimatedExpensesSummaryArgs = {
  currencyId?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<DateRangeInput2>;
  projectId: Scalars['String'];
};


export type QueryExpenseActualsSeriesArgs = {
  currencyId?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<DateRangeInput2>;
  projectId: Scalars['String'];
};


export type QueryExpenseActualsSummaryArgs = {
  currencyId?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<DateRangeInput2>;
  projectId: Scalars['String'];
};


export type QueryExpenseCardSettingsArgs = {
  projectId: Scalars['String'];
};


export type QueryExtensionFieldDefinitionsArgs = {
  bindingContext: BindingContext;
};


export type QueryExtensionFieldTagsArgs = {
  searchPhrase?: InputMaybe<Scalars['String']>;
  tagId: Scalars['String'];
};


export type QueryFinancialOverviewSeriesData2Args = {
  dateRange?: InputMaybe<DateRangeInput2>;
  periodResolutionUri: Scalars['String'];
};


export type QueryFinancialOverviewTotals2Args = {
  dateRange?: InputMaybe<DateRangeInput2>;
};


export type QueryGetActiveTasksSummaryArgs = {
  projectFilter?: InputMaybe<ProjectFilter2>;
};


export type QueryGetAllProgramManagersAssignedToProgramsArgs = {
  showEnabled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetAvailableBillingItemsTotal2Args = {
  input: AvailableBillingItemInput2;
};


export type QueryGetAvailableToBillTotals2Args = {
  filter?: InputMaybe<AvailableToBillFilter2>;
};


export type QueryGetBackgroundJobArgs = {
  jobId: Scalars['String'];
};


export type QueryGetBatchStatusArgs = {
  batchId: Scalars['String'];
};


export type QueryGetBillArgs = {
  id: Scalars['String'];
};


export type QueryGetBillPaymentArgs = {
  id: Scalars['String'];
};


export type QueryGetBillingBatchStatusArgs = {
  batchId: Scalars['String'];
};


export type QueryGetBillingItemsSummary2Args = {
  filter?: InputMaybe<BillingItemFilter2>;
  summaryCurrencyUri?: InputMaybe<Scalars['String']>;
};


export type QueryGetBillingTransactionTotals2Args = {
  filter?: InputMaybe<BillingTransactionFilter2>;
};


export type QueryGetBulkCreateBillFromBillingItemsBatchResultArgs = {
  batchId: Scalars['String'];
};


export type QueryGetClientRepresentativesArgs = {
  clientUri: Scalars['String'];
};


export type QueryGetCreateBillFromBillingItemsBatchResultsArgs = {
  batchId: Scalars['String'];
};


export type QueryGetCreditMemoArgs = {
  id: Scalars['String'];
};


export type QueryGetCurrentBillingRateForUserArgs = {
  userId: Scalars['String'];
};


export type QueryGetDownloadUrlArgs = {
  exportUri: Scalars['String'];
  tableKey: Scalars['String'];
};


export type QueryGetExportUriArgs = {
  activeColumnNameOverrides?: InputMaybe<Array<InputMaybe<ColumnNameOverrides>>>;
  activeColumns: Array<InputMaybe<Scalars['String']>>;
  billingFilter?: InputMaybe<BillingFilter>;
  dateRange?: InputMaybe<DateRangeInput>;
  filename?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ExportTableFilter>;
  periodResolution?: InputMaybe<PeriodResolutionOption>;
  tableKey: Scalars['String'];
};


export type QueryGetFilteredTaskResourceAllocationUserIdsArgs = {
  taskId: Scalars['String'];
  userIds: Array<Scalars['String']>;
};


export type QueryGetInvoiceStatusUpdateBatchResultArgs = {
  batchId: Scalars['String'];
};


export type QueryGetNotificationPolicyForEventTypeArgs = {
  eventType: Scalars['String'];
};


export type QueryGetPageOfAssociatedBillPaymentsForBillArgs = {
  billId: Scalars['String'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type QueryGetPageOfAssociatedBillsForBillPaymentArgs = {
  billPaymentId: Scalars['String'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type QueryGetPageOfAssociatedBillsForCreditMemoArgs = {
  creditMemoId: Scalars['String'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type QueryGetPageOfAssociatedCreditMemosForBillArgs = {
  billId: Scalars['String'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type QueryGetPageOfAvailableBillingItemDetails2Args = {
  input: AvailableBillingItemInput2;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryGetPageOfAvailableToBill2Args = {
  filter?: InputMaybe<AvailableToBillFilter2>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryGetPageOfBillingItems2Args = {
  billingAmountCurrencyUri?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<BillingItemFilter2>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryGetPageOfBillingTransactionsArgs = {
  filter?: InputMaybe<BillingTransactionFilter>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<BillingTransactionSort>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetPageOfLineItemsForBillArgs = {
  billId: Scalars['String'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  summarizeColumn?: InputMaybe<Array<InputMaybe<BillingItemColumn>>>;
};


export type QueryGetPageOfLineItemsForCreditMemoArgs = {
  creditMemoId: Scalars['String'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type QueryGetPageOfProjectsAvailableForFilteringBillingItemsArgs = {
  clientUri?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryGetPageOfProjectsFilteredByDataAccessLevelsArgs = {
  dataAccessLevels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryGetPageOfResourceUserMatchesForResourceRequestArgs = {
  additionalColumns?: InputMaybe<ResourceUserColumns>;
  filter?: InputMaybe<ResourceUserMatchesFilter>;
  page: Scalars['Int'];
  pagesize: Scalars['Int'];
  resourceRequestId: Scalars['String'];
  sort?: InputMaybe<Array<ResourceUserSort>>;
  source: ResourceUserMatchSource;
};


export type QueryGetPaymentMethodArgs = {
  id: Scalars['String'];
};


export type QueryGetProgramManagersArgs = {
  programUri: Scalars['String'];
};


export type QueryGetRequisitionDataArgs = {
  resourceRequestUri: Scalars['String'];
};


export type QueryGetResourcePlansForCurrentTenantArgs = {
  filter?: InputMaybe<ResourcePlanFilter>;
  groupBy?: InputMaybe<ResourcePlanGroupBy>;
  pageSize: Scalars['Int'];
  paginationToken?: InputMaybe<Scalars['String']>;
  requestAccessLevel?: InputMaybe<ResourceRequestAccessLevel>;
};


export type QueryGetScheduleDurationByDayForUsersArgs = {
  dateRange: DateRangeInput;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetScheduleDurationForUserArgs = {
  dateRange: DateRangeInput;
  userUri: Scalars['String'];
};


export type QueryGetTaskResourceUserAllocationsSummaryForUserArgs = {
  filter?: InputMaybe<TaskResourceUserAllocationsSummaryForUserFilter>;
  userId: Scalars['String'];
};


export type QueryGetTimeEntryRevisionGroupBulkModificationBatchResultsArgs = {
  batchId: Scalars['String'];
};


export type QueryGetUserBeatAppDownloadUrlArgs = {
  os: OsType;
};


export type QueryGetUserProfileArgs = {
  userUri: Scalars['String'];
};


export type QueryGetUserScheduleRulesForDateRangeArgs = {
  dateRange: DateRangeInput;
  userUri: Scalars['String'];
};


export type QueryHiringStatusSummaryCountArgs = {
  filter?: InputMaybe<HiringStatusSummaryFilter>;
  requestAccessLevel?: InputMaybe<ResourceRequestAccessLevel>;
};


export type QueryIsBillDataReflectedInAvailableToBillDataArgs = {
  billId: Scalars['String'];
};


export type QueryKeyValueSettingsArgs = {
  key: Scalars['String'];
};


export type QueryLocationArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryLocationsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  policy?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryMyActiveClientsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type QueryMyActiveProgramsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryNotificationPoliciesArgs = {
  eventType: Scalars['String'];
};


export type QueryOverEstimatedTasksProjectsArgs = {
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overEstimatedTaskType?: InputMaybe<OverEstimatedTaskType>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  projectFilter?: InputMaybe<ProjectFilter2>;
};


export type QueryOverdueBillBalanceAmount2Args = {
  dateRange?: InputMaybe<BillingDateRangeInput2>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryOverdueBillBalanceAmountRowCount2Args = {
  dateRange?: InputMaybe<BillingDateRangeInput2>;
};


export type QueryPageOfAvailableRateTableDimensionsArgs = {
  filter?: InputMaybe<RateTableDimensionFilter>;
  page: Scalars['Int'];
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryPageOfAvailableTaxProfilesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  textSearch?: InputMaybe<Scalars['String']>;
};


export type QueryPageOfBillingAggregation2Args = {
  columns?: InputMaybe<Array<InputMaybe<BillingAggregationColumn>>>;
  filter?: InputMaybe<BillingAggregationFilter2>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  sort?: InputMaybe<BillingAggregationSort>;
};


export type QueryPageOfClientsAvailableForFilteringProjectsArgs = {
  clientFilter?: InputMaybe<ClientFilter>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type QueryPageOfPayCodeAvailableForBillingRatesAssignmentArgs = {
  page: Scalars['Int'];
  pagesize: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryPageOfPortfoliosAvailableForFilteringProjectRequestArgs = {
  input?: InputMaybe<PageOfProjectRequestPortfoliosInput>;
};


export type QueryPageOfPortfoliosAvailableForFilteringProjectsArgs = {
  input?: InputMaybe<PageOfProjectPortfolioInput>;
};


export type QueryPageOfPortfoliosAvailableForProjectAssignmentArgs = {
  input?: InputMaybe<PageOfProjectPortfolioInput>;
};


export type QueryPageOfPortfoliosAvailableForProjectRequestAssignmentArgs = {
  input?: InputMaybe<PageOfProjectRequestPortfoliosInput>;
};


export type QueryPageOfProgramsAvailableForFilteringProjectsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  programFilter?: InputMaybe<ProgramFilter2>;
};


export type QueryPageOfProjectRateTableRoleOptionsArgs = {
  input: PageOfProjectRateTableRoleOptionsInput;
};


export type QueryPageOfProjectResourceDropdownOptionsArgs = {
  input?: InputMaybe<PageOfProjectResourceDropdownOptionsInput>;
};


export type QueryPageOfResourceUsersDropdownOptionsArgs = {
  input: PageOfResourceUsersDropdownOptionsInput;
};


export type QueryPageOfRevenueAggregation2Args = {
  columns?: InputMaybe<Array<InputMaybe<RevenueAggregationColumn>>>;
  filter?: InputMaybe<RevenueAggregationFilter2>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  sort?: InputMaybe<RevenueAggregationSort>;
};


export type QueryPageOfRevenueEntries2Args = {
  filter?: InputMaybe<RevenueEntryFilter>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryPageOfRevenueEntry2Args = {
  columns?: InputMaybe<Array<InputMaybe<RevenueEntryColumn>>>;
  filter?: InputMaybe<RevenueEntryFilter2>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<RevenueEntrySort>;
};


export type QueryPageOfTaskAssignmentSummaryForProjectAndResourceUserArgs = {
  input?: InputMaybe<PageOfTaskAssignmentSummaryForProjectAndResourceUserInput>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type QueryPageOfTaskResourceUserAllocationsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TaskResourceUserAllocationsFilter>;
  limit: Scalars['Int'];
};


export type QueryPortfolioArgs = {
  input: PortfolioInput;
};


export type QueryPortfolioAncestryDetailsArgs = {
  id: Scalars['String'];
};


export type QueryPortfolioProjectRequestStatusEstimatedCostSummaryArgs = {
  portfolioId: Scalars['String'];
};


export type QueryPortfolioProjectStatusBudgetSummaryArgs = {
  portfolioId: Scalars['String'];
};


export type QueryPortfolioProjectsProgressSummaryArgs = {
  portfolioId: Scalars['String'];
};


export type QueryPortfoliosArgs = {
  columns?: InputMaybe<Array<InputMaybe<PortfolioColumn>>>;
  filter?: InputMaybe<PortfolioFilter>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type QueryPortfoliosSummaryCountArgs = {
  filter?: InputMaybe<PortfolioSummaryFilter>;
};


export type QueryPredictionCacheProjectRiskArgs = {
  projectUri: Scalars['String'];
};


export type QueryPreviewBulkUnassignTasksToResourceUserArgs = {
  input: BulkUnassignTasksToResourceUserInput;
};


export type QueryProgramArgs = {
  programSlug: Scalars['String'];
};


export type QueryProgramOverviewProjectCountSummary2Args = {
  programFilter?: InputMaybe<ProgramFilter2>;
};


export type QueryProgramTotalsArgs = {
  programFilter?: InputMaybe<ProgramFilter>;
};


export type QueryProgramTotals2Args = {
  programFilter?: InputMaybe<ProgramFilter2>;
};


export type QueryProgramsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  programFilter?: InputMaybe<ProgramFilter>;
  sort?: InputMaybe<ProgramSort>;
};


export type QueryPrograms2Args = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  programFilter?: InputMaybe<ProgramFilter2>;
  sort?: InputMaybe<ProgramSort>;
};


export type QueryProgramsSummaryArgs = {
  programFilter?: InputMaybe<ProgramFilter2>;
};


export type QueryProgramsTotalActualCostAmountSeriesArgs = {
  dateRange: DateRangeInput2;
  periodResolutionOption: PeriodResolutionOption;
  programFilter?: InputMaybe<ProgramFilter2>;
};


export type QueryProgramsTotalActualRevenueAmountSeriesArgs = {
  dateRange: DateRangeInput2;
  periodResolutionOption: PeriodResolutionOption;
  programFilter?: InputMaybe<ProgramFilter2>;
};


export type QueryProgramsWithOverEstimatedProjectsArgs = {
  overEstimatedProjectType: OverEstimatedProjectType;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  programFilter?: InputMaybe<ProgramFilter>;
};


export type QueryProgramsWithOverEstimatedProjects2Args = {
  overEstimatedProjectType: OverEstimatedProjectType;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  programFilter?: InputMaybe<ProgramFilter2>;
};


export type QueryProjectArgs = {
  projectId?: InputMaybe<Scalars['String']>;
  projectSlug?: InputMaybe<Scalars['String']>;
};


export type QueryProjectClientsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryProjectCountSummary2Args = {
  clientFilter?: InputMaybe<ClientFilter2>;
};


export type QueryProjectDeleteBatchResultsArgs = {
  batchId: Scalars['String'];
};


export type QueryProjectInfoModificationBatchResultsArgs = {
  batchId: Scalars['String'];
};


export type QueryProjectManagersFilteredBySearchArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryProjectProgramsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryProjectRequestArgs = {
  id: Scalars['String'];
};


export type QueryProjectRequestRevisionsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<AuditTrail_ProjectRequestFilter>;
  limit: Scalars['Int'];
  sortOrder?: InputMaybe<AuditTrail_SortOrder>;
};


export type QueryProjectRequestTotalsArgs = {
  columns?: InputMaybe<Array<InputMaybe<ProjectRequestColumn>>>;
  filter?: InputMaybe<ProjectRequestFilter>;
};


export type QueryProjectRequestsArgs = {
  columns?: InputMaybe<Array<InputMaybe<ProjectRequestColumn>>>;
  filter?: InputMaybe<ProjectRequestFilter>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  sort?: InputMaybe<ProjectRequestSort>;
};


export type QueryProjectRequestsByStatusTypeCountSummaryArgs = {
  filter?: InputMaybe<ProjectRequestFilter>;
};


export type QueryProjectRevenueRecognitionBatchUriInProgress2Args = {
  revenueRunUri: Scalars['String'];
};


export type QueryProjectRiskModelInputArgs = {
  date: Scalars['PPRA_Date'];
  projectUri: Scalars['String'];
};


export type QueryProjectTeamMemberBillingRateAssignmentRevisionsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<AuditTrail_ProjectTeamMemberBillingRateAssignmentFilter>;
  limit: Scalars['Int'];
};


export type QueryProjectTotalsArgs = {
  isManaged?: InputMaybe<Scalars['Boolean']>;
  projectFilter?: InputMaybe<ProjectFilter2>;
};


export type QueryProjectsArgs = {
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isManaged?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  pagesize?: InputMaybe<Scalars['Int']>;
  projectFilter?: InputMaybe<ProjectFilter2>;
  sort?: InputMaybe<ProjectSort>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryProjects2Args = {
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isManaged?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  pagesize?: InputMaybe<Scalars['Int']>;
  projectFilter?: InputMaybe<ProjectFilter2>;
  sort?: InputMaybe<ProjectSort>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryProjectsFilteredByResourceRequestStatusArgs = {
  pageSize?: InputMaybe<Scalars['Int']>;
  paginationToken?: InputMaybe<Scalars['PaginationTokenInput']>;
  projectFilter?: InputMaybe<ProjectFilter>;
  resourceRequestStatus?: InputMaybe<ResourceRequestStatus>;
};


export type QueryProjectsFilteredByResourceRequestStatus2Args = {
  pageSize?: InputMaybe<Scalars['Int']>;
  paginationToken?: InputMaybe<Scalars['PaginationTokenInput']>;
  projectFilter?: InputMaybe<ProjectFilter2>;
  resourceRequestStatus?: InputMaybe<ResourceRequestStatus>;
};


export type QueryProjectsOverbudgetCountArgs = {
  isManaged?: InputMaybe<Scalars['Boolean']>;
  projectFilter?: InputMaybe<ProjectFilter2>;
};


export type QueryProjectsStatusCountSummaryArgs = {
  isManaged?: InputMaybe<Scalars['Boolean']>;
  projectFilter?: InputMaybe<ProjectFilter2>;
};


export type QueryRecognizableRevenueCarryOverSummaryArgs = {
  revenueEntryId: Scalars['String'];
};


export type QueryResourceArgs = {
  userId?: InputMaybe<Scalars['String']>;
  userSlug?: InputMaybe<Scalars['String']>;
};


export type QueryResourceAllocationArgs = {
  id: Scalars['String'];
};


export type QueryResourceAllocationCountArgs = {
  allocationStatusList?: InputMaybe<Array<InputMaybe<ResourceAllocationStatus>>>;
  projectFilter?: InputMaybe<ProjectFilter>;
};


export type QueryResourceAllocationSeriesDataArgs = {
  dateRange: DateRangeInput;
  filter?: InputMaybe<ResourceAllocationSeriesFilter>;
  periodResolution: PeriodResolutionOption;
  requestAccessLevel?: InputMaybe<ResourceRequestAccessLevel>;
  workWeekStartDay?: InputMaybe<DayOfWeekValue>;
};


export type QueryResourceAllocationsArgs = {
  allocationStatusList?: InputMaybe<Array<InputMaybe<ResourceAllocationStatus>>>;
  consistentRead?: InputMaybe<Scalars['Boolean']>;
  cursor?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ResourceAllocationFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  projectName?: InputMaybe<Scalars['String']>;
  projectUri?: InputMaybe<Scalars['String']>;
  resourceRequestId?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<ResourceAllocationSort>;
  startDate?: InputMaybe<Scalars['String']>;
  userUri?: InputMaybe<Scalars['String']>;
};


export type QueryResourceAllocationsSummaryArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  dateRange: DateRangeInput;
  limit?: InputMaybe<Scalars['Int']>;
  periodResolution: PeriodResolutionOption;
  projectWorkflowStages?: InputMaybe<Array<ProjectWorkflowStage>>;
  sort?: InputMaybe<ResourceAllocationSort>;
  userUri: Scalars['String'];
};


export type QueryResourceDetailsArgs = {
  customFieldUris?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<ResourceDetailsFilter>;
  page?: InputMaybe<Scalars['Int']>;
  pagesize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ResourceSort>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryResourceMatchesArgs = {
  input: Praa_ResourceMatchesInput;
};


export type QueryResourceMatchesStatusArgs = {
  input: Praa_ResourceMatchesStatusInput;
};


export type QueryResourcePlanDefaultsArgs = {
  projectUri: Scalars['String'];
};


export type QueryResourcePlansSummaryForCurrentTenantArgs = {
  filter?: InputMaybe<ResourcePlanFilter>;
  requestAccessLevel?: InputMaybe<ResourceRequestAccessLevel>;
};


export type QueryResourcePoolsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  searchFilter: ResourcePoolSearchFilter;
};


export type QueryResourceRequestArgs = {
  id: Scalars['String'];
};


export type QueryResourceRequestUsermatchArgs = {
  resourceRequestId: Scalars['String'];
  userId: Scalars['String'];
};


export type QueryResourceRequestUsermatchesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  matchFilter: ResourceRequestUserMatchFilterInput;
  orderBy?: InputMaybe<SortDirection>;
};


export type QueryResourceRequestsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ResourceRequestsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  minimumLimit?: InputMaybe<Scalars['Int']>;
  projectUri?: InputMaybe<Scalars['String']>;
  requestAccessLevel?: InputMaybe<ResourceRequestAccessLevel>;
  requestStatusList?: InputMaybe<Array<InputMaybe<ResourceRequestStatus>>>;
  roleUri?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<ResourceRequestSort>;
};


export type QueryResourceRequestsSeriesDataArgs = {
  dateRanges?: InputMaybe<Array<InputMaybe<DateRangeInput>>>;
  projectFilter?: InputMaybe<ProjectFilter>;
};


export type QueryResourceRequestsStatusCountSummaryArgs = {
  costCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  employeeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  requestAccessLevel?: InputMaybe<ResourceRequestAccessLevel>;
  resourcePools?: InputMaybe<Array<Scalars['String']>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  serviceCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryResourceRequestsSummaryForProjectManagerArgs = {
  projectFilter?: InputMaybe<ProjectFilter>;
};


export type QueryResourceUserAvailabilityHoursSeriesForDateRangeArgs = {
  dateRange: DateRangeInput;
  userUri: Scalars['String'];
};


export type QueryResourceUserAvailabilitySeriesArgs = {
  dateRange: DateRangeInput;
  filter?: InputMaybe<ResourceUserAvailabilitySeriesFilter>;
  groupBy: ResourceUserAvailabilityGroupType;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  periodResolution: PeriodResolutionOption;
  sort: ResourceUserAvailabilitySort;
};


export type QueryResourceUserAvailabilitySeriesTotalsArgs = {
  dateRange: DateRangeInput;
  filter?: InputMaybe<ResourceUserAvailabilitySeriesFilter>;
  groupBy: ResourceUserAvailabilityGroupType;
  periodResolution: PeriodResolutionOption;
};


export type QueryResourceUserTaskAssignmentSummaryArgs = {
  input: ResourceUserTaskAssignmentSummaryInput;
};


export type QueryResourceUsersArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  filter?: InputMaybe<GetResourceUsersFilter>;
  page?: InputMaybe<Scalars['Int']>;
  pagesize?: InputMaybe<Scalars['Int']>;
  periodResolution?: InputMaybe<PeriodResolutionOption>;
  resourceRequestId?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<ResourceUserSort>;
};


export type QueryResourceUsers2Args = {
  customFieldUris?: InputMaybe<Array<Scalars['String']>>;
  dateRange?: InputMaybe<DateRangeInput>;
  filter?: InputMaybe<GetResourceUsersFilter>;
  page?: InputMaybe<Scalars['Int']>;
  pagesize?: InputMaybe<Scalars['Int']>;
  periodResolution?: InputMaybe<PeriodResolutionOption>;
  resourceRequestId?: InputMaybe<Scalars['String']>;
  scoreComputeType?: InputMaybe<ScoreComputeType>;
  skipMerge?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Array<ResourceUserSort>>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryResourceUsersCountArgs = {
  filter?: InputMaybe<GetResourceUsersFilter>;
};


export type QueryResourcesArgs = {
  customFieldUris?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<ResourcePoolFilter>;
  page?: InputMaybe<Scalars['Int']>;
  pagesize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ResourceSort>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryRevenueAggregationRowCount2Args = {
  columns?: InputMaybe<Array<InputMaybe<RevenueAggregationColumn>>>;
  filter?: InputMaybe<RevenueAggregationFilter2>;
};


export type QueryRevenueAggregationTotals2Args = {
  filter?: InputMaybe<RevenueAggregationFilter2>;
};


export type QueryRevenueEntryTotals2Args = {
  columns?: InputMaybe<Array<InputMaybe<RevenueEntryColumn>>>;
  filter?: InputMaybe<RevenueEntryFilter2>;
};


export type QueryRevenueRunBatchUriInProgressArgs = {
  revenueRunUri: Scalars['String'];
};


export type QueryRevenueRunListsArgs = {
  columns?: InputMaybe<Array<InputMaybe<RevenueRunListColumns>>>;
  filter?: InputMaybe<RevenueRunListFilter>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryRevenueRunScheduleSeriesArgs = {
  dateRange: DateRangeInput;
};


export type QueryRevenueRunScheduleSeries2Args = {
  dateRange: DateRangeInput2;
};


export type QueryRoleArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryScheduleDurationSeriesForUsersArgs = {
  dateRange: DateRangeInput;
  periodResolution: PeriodResolutionOption;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QuerySearchSettingsArgs = {
  key: Scalars['String'];
};


export type QueryServiceCenterArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryServiceCentersArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  policy?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QuerySessionTimeoutRemainingArgs = {
  touchSession?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySkillDistributionForUsersArgs = {
  dataAccessLevels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filter?: InputMaybe<SkillDistributionForUsersSummaryFilter>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type QuerySmartFitResourceAvailabilityHoursOptionsByTotalHoursAndDateRangeArgs = {
  input: SmartFitResourceAvailabilityHoursOptionsByTotalHoursAndDateRangeInput;
};


export type QuerySmartFitResourceAvailablityHoursOptionsArgs = {
  periodResolution: PeriodResolutionOption;
  scheduleRules: Array<ScheduleRuleInput>;
  userUri: Scalars['String'];
};


export type QueryTableSettingArgs = {
  tableKey: Scalars['String'];
};


export type QueryTagArgs = {
  id: Scalars['String'];
};


export type QueryTagIdArgs = {
  slug: Scalars['String'];
};


export type QueryTagsArgs = {
  objectBinding?: InputMaybe<ObjectBinding>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryTaskArgs = {
  taskId: Scalars['String'];
};


export type QueryTaskBurndownDataArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  taskId: Scalars['String'];
};


export type QueryTaskEntries2Args = {
  approvalStatus?: InputMaybe<TaskEntryApprovalStatus>;
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TaskEntryFilter2>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<TaskEntrySort>;
};


export type QueryTaskEntries3Args = {
  filter?: InputMaybe<TaskEntryFilter2>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  sort?: InputMaybe<Array<TaskEntrySort>>;
};


export type QueryTaskEntriesCountArgs = {
  approvalStatus: TaskEntryApprovalStatus;
  filter?: InputMaybe<TaskEntryFilter2>;
  projectFilter?: InputMaybe<ProjectFilter2>;
};


export type QueryTaskEntryArgs = {
  taskEntryId: Scalars['String'];
};


export type QueryTaskProgressArgs = {
  ids: Array<Scalars['String']>;
};


export type QueryTaskResourceEstimateDetailsArgs = {
  resourceEstimateUri: Scalars['String'];
};


export type QueryTaskResourceUserAllocationsForUserArgs = {
  filter?: InputMaybe<TaskResourceUserAllocationsForUserFilter>;
};


export type QueryTasksStatusCountSummaryArgs = {
  projectId: Scalars['String'];
};


export type QueryTaxRatesForTaxProfile2Args = {
  asOfDate?: InputMaybe<Scalars['Date2']>;
  taxProfileUri?: InputMaybe<Scalars['String']>;
};


export type QueryTimeAndExpense2Args = {
  timeAndExpenseInput?: InputMaybe<TimeAndExpenseInput2>;
};


export type QueryTimeAndExpenseSettingsArgs = {
  id: Scalars['String'];
};


export type QueryTransactionNextReferenceNumberSettingArgs = {
  transactionType: BillingTransactionType;
};


export type QueryTransactionNextReferenceNumberTextArgs = {
  transactionType: BillingTransactionType;
};


export type QueryUnreadNotificationsArgs = {
  count?: InputMaybe<Scalars['Int']>;
  userUri: Scalars['String'];
};


export type QueryUnreadNotificationsCountArgs = {
  userUri: Scalars['String'];
};


export type QueryUserArgs = {
  id: Scalars['String'];
};


export type QueryUserDefinedSkillsArgs = {
  userId: Scalars['String'];
};


export type QueryUserNudgesArgs = {
  userUri: Scalars['String'];
};


export type QueryUserPermissionSetRevisionsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<AuditTrail_UserPermissionSetRevisionFilter>;
  limit: Scalars['Int'];
};


export type QueryUsersArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  pagesize?: InputMaybe<Scalars['Int']>;
  policyId?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  userAccessRoleUri?: InputMaybe<Scalars['String']>;
};


export type QueryUsersAvailableForVendorAssignmentArgs = {
  filter?: InputMaybe<UsersAvailableForVendorAssignmentFilter>;
  page: Scalars['Int'];
  pagesize: Scalars['Int'];
};


export type QueryValidateInvoiceAmountLimitArgs = {
  id: Scalars['String'];
};


export type QueryValidateProgramNameArgs = {
  originalProgramName?: InputMaybe<Scalars['String']>;
  programOrDraftUri?: InputMaybe<Scalars['String']>;
  updatedProgramName: Scalars['String'];
};


export type QueryValidateProjectNameArgs = {
  originalProjectName?: InputMaybe<Scalars['String']>;
  projectOrDraftUri?: InputMaybe<Scalars['String']>;
  updatedProjectName: Scalars['String'];
};


export type QueryVendorArgs = {
  id: Scalars['String'];
};


export type QueryVendorsArgs = {
  filter?: InputMaybe<VendorFilter>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type QueryVendorsSummaryCountArgs = {
  filter?: InputMaybe<VendorFilter>;
};

export enum RateCardCopyOption {
  CopyFromClient = 'COPY_FROM_CLIENT',
  CopyFromProject = 'COPY_FROM_PROJECT'
}

export type RateScheduleEntry = {
  __typename?: 'RateScheduleEntry';
  amount: Money;
  /** @deprecated Use effectiveDate2 */
  effectiveDate?: Maybe<Scalars['DateObject']>;
  effectiveDate2?: Maybe<Scalars['Date2']>;
};

export type RateTableDimension = {
  __typename?: 'RateTableDimension';
  displayText: Scalars['String'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  objectType?: Maybe<DimensionObjectType>;
  slug?: Maybe<Scalars['String']>;
};

export type RateTableDimensionDetails = {
  __typename?: 'RateTableDimensionDetails';
  dimensions?: Maybe<Array<RateTableDimension>>;
  id: Scalars['String'];
  requiredDimensions?: Maybe<Array<RateTableDimension>>;
};

export type RateTableDimensionFilter = {
  textSearch?: InputMaybe<Scalars['String']>;
};

export enum RateType {
  Project = 'PROJECT',
  Resource = 'RESOURCE',
  Role = 'ROLE'
}

export type RecognizableRevenueCarryOverSummary = {
  __typename?: 'RecognizableRevenueCarryOverSummary';
  amount?: Maybe<Money>;
  revenuePeriod?: Maybe<RevenuePeriod>;
  type?: Maybe<CarryOverType>;
};

export type RecomputeScoreForResourceRequestInput = {
  resourceRequestId: Scalars['String'];
};

export type ReferenceNumberSetting = {
  __typename?: 'ReferenceNumberSetting';
  autoGeneratedNumber?: Maybe<Scalars['Boolean']>;
  canUseNumberSetting?: Maybe<Scalars['Boolean']>;
  editAutoGeneratedNumber?: Maybe<Scalars['Boolean']>;
  hasLeadingZero?: Maybe<Scalars['Boolean']>;
  minimumDigits?: Maybe<Scalars['Int']>;
  nextNumber?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
};

export type ReferenceNumberSettingInput = {
  autoGeneratedNumber?: InputMaybe<Scalars['Boolean']>;
  canUseNumberSetting?: InputMaybe<Scalars['Boolean']>;
  editAutoGeneratedNumber?: InputMaybe<Scalars['Boolean']>;
  hasLeadingZero?: InputMaybe<Scalars['Boolean']>;
  minimumDigits?: InputMaybe<Scalars['Int']>;
  nextNumber?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
};

export type ReleaseBehaviorOptions = {
  includeReleaseTaskByStatus?: InputMaybe<IncludeReleaseTaskByStatusType>;
  taskAssignmentBehavior?: InputMaybe<TaskAssignmentBehaviorType>;
};

export type ReleaseResourceAllocationInput = {
  allocationId: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
  releaseDate?: InputMaybe<Scalars['Date']>;
  releaseType: ReleaseResourceAllocationType;
};

export type ReleaseResourceAllocationResult = {
  __typename?: 'ReleaseResourceAllocationResult';
  resourceAllocation?: Maybe<ResourceAllocation>;
};

export enum ReleaseResourceAllocationType {
  Asof = 'ASOF',
  Entirely = 'ENTIRELY'
}

export type ReleaseResourceAllocationsInput = {
  allocationIds: Array<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  releaseDate?: InputMaybe<Scalars['Date']>;
  releaseType: ReleaseResourceAllocationType;
  resourceRequestId: Scalars['String'];
};

export type ReleaseResourceAllocationsResult = {
  __typename?: 'ReleaseResourceAllocationsResult';
  resourceAllocations: Array<ResourceAllocation>;
  resourceRequest?: Maybe<ResourceRequest>;
};

export type ReleaseTaskOwnersResult = {
  __typename?: 'ReleaseTaskOwnersResult';
  taskId: Scalars['String'];
};

export type RemoveAssignedTagValueInput = {
  tagAssignmentId: Scalars['String'];
};

export type RemoveAssignedTagValueResult = {
  __typename?: 'RemoveAssignedTagValueResult';
  tagAssignmentId: Scalars['String'];
};

export type RemoveAvatarResult = {
  __typename?: 'RemoveAvatarResult';
  userId?: Maybe<Scalars['String']>;
};

export type RemoveBillingRateErrorDetails = {
  __typename?: 'RemoveBillingRateErrorDetails';
  billingRate?: Maybe<BillingRate>;
  resourcesAssignedToBillingRate?: Maybe<Array<Maybe<ResourceAssignedToBillingRate>>>;
};

export type RemoveResourceUserTaskAssignmentInput = {
  projectId: Scalars['String'];
  taskId: Scalars['String'];
  userId: Scalars['String'];
};

export type RemoveResourceUserTaskAssignmentResult = {
  __typename?: 'RemoveResourceUserTaskAssignmentResult';
  syncedResourceAllocation?: Maybe<ResourceAllocation>;
  taskId: Scalars['String'];
  userId: Scalars['String'];
};

export type RemoveTaskResourceAllocationsInput = {
  resourceAllocations: Array<TaskResourceAllocationInput>;
  taskId: Scalars['String'];
};

export type RemoveTaskResourceEstimateInput = {
  taskId: Scalars['String'];
  taskResourceEstimateId: Scalars['String'];
};

export type RemoveTaskResourceEstimateResult = {
  __typename?: 'RemoveTaskResourceEstimateResult';
  taskResourceEstimateId: Scalars['String'];
};

export type RepliconValidationError = {
  __typename?: 'RepliconValidationError';
  displayText?: Maybe<Scalars['String']>;
  failureUri?: Maybe<Scalars['String']>;
  severityUri?: Maybe<Scalars['String']>;
};

export enum RequestAttributeWeightage {
  Important = 'Important',
  NiceToHave = 'NiceToHave',
  Normal = 'Normal',
  Required = 'Required',
  Useful = 'Useful'
}

export type RequestAttributeWeights = {
  __typename?: 'RequestAttributeWeights';
  costCenter?: Maybe<RequestAttributeWeightage>;
  department?: Maybe<RequestAttributeWeightage>;
  division?: Maybe<RequestAttributeWeightage>;
  employeeType?: Maybe<RequestAttributeWeightage>;
  location?: Maybe<RequestAttributeWeightage>;
  preferredResources?: Maybe<RequestAttributeWeightage>;
  requestedCostRate?: Maybe<RequestAttributeWeightage>;
  resourcePools?: Maybe<RequestAttributeWeightage>;
  role?: Maybe<RequestAttributeWeightage>;
  serviceCenter?: Maybe<RequestAttributeWeightage>;
  skills?: Maybe<RequestAttributeWeightage>;
  tags?: Maybe<RequestAttributeWeightage>;
};

export type RequestAttributeWeightsInput = {
  costCenter?: InputMaybe<RequestAttributeWeightage>;
  department?: InputMaybe<RequestAttributeWeightage>;
  division?: InputMaybe<RequestAttributeWeightage>;
  employeeType?: InputMaybe<RequestAttributeWeightage>;
  location?: InputMaybe<RequestAttributeWeightage>;
  preferredResources?: InputMaybe<RequestAttributeWeightage>;
  requestedCostRate?: InputMaybe<RequestAttributeWeightage>;
  resourcePools?: InputMaybe<RequestAttributeWeightage>;
  role?: InputMaybe<RequestAttributeWeightage>;
  serviceCenter?: InputMaybe<RequestAttributeWeightage>;
  skills?: InputMaybe<RequestAttributeWeightage>;
  tags?: InputMaybe<RequestAttributeWeightage>;
};

export type RequestSkill = {
  __typename?: 'RequestSkill';
  category?: Maybe<Category>;
  certificate?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  displayText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  skillCustomMetadata?: Maybe<Array<Maybe<SkillCustomMetadata>>>;
  skillLevel?: Maybe<SkillLevel>;
  uri?: Maybe<Scalars['String']>;
};

export type RequestSkillInput = {
  skillLevelUri: Scalars['String'];
  skillUri: Scalars['String'];
};

export type RequestTagInput = {
  uri: Scalars['String'];
  value: Scalars['String'];
};

export type RescheduleProjectInputs = {
  isAdjustWorkDaysChecked?: InputMaybe<Scalars['Boolean']>;
  isRescheduleBillPlanChecked?: InputMaybe<Scalars['Boolean']>;
  isRescheduleResourceAllocationsChecked?: InputMaybe<Scalars['Boolean']>;
  isRescheduleResourceRequestsChecked?: InputMaybe<Scalars['Boolean']>;
  isRescheduleTasksChecked?: InputMaybe<Scalars['Boolean']>;
  newStartDate?: InputMaybe<Scalars['Date2']>;
  originalStartDate?: InputMaybe<Scalars['Date2']>;
  projectId?: InputMaybe<Scalars['String']>;
  resourceAllocationsToReschedule?: InputMaybe<ResourceAllocationsToReschedule>;
  resourceRequestsToRescheduleByStatus?: InputMaybe<ResourceRequestsToRescheduleByStatus>;
  resourceRequestsToRescheduleByStatus2?: InputMaybe<ResourceRequestsToRescheduleByStatus2>;
  tasksToReschedule?: InputMaybe<TasksToReschedule>;
};

export type RescheduleProjectJob = {
  __typename?: 'RescheduleProjectJob';
  jobId: Scalars['String'];
  projectId: Scalars['String'];
};

export enum RescheduleTaskModificationOption {
  RemoveAllAllocations = 'REMOVE_ALL_ALLOCATIONS'
}

export type ResetNotificationsInput = {
  enableForChannels: Array<Channels>;
  userUris: Array<Scalars['String']>;
};

export type ResourceAllocatedHoursByDateRange = {
  __typename?: 'ResourceAllocatedHoursByDateRange';
  dateRange: DateRange;
  resourceAllocatedHours: Scalars['Float'];
};

export type ResourceAllocation = {
  __typename?: 'ResourceAllocation';
  allocationStatus: ResourceAllocationStatus;
  comment?: Maybe<Scalars['String']>;
  creationDateTime?: Maybe<Scalars['DateTime']>;
  endDate: Scalars['Date'];
  exchangeRateValues?: Maybe<AllocationExchangeRateValues>;
  id: Scalars['String'];
  isAdjustedLoading?: Maybe<Scalars['Boolean']>;
  load: Scalars['Float'];
  project?: Maybe<Project>;
  projectManagementType?: Maybe<ProjectManagementType>;
  projectUri: Scalars['String'];
  requestedRoleUri?: Maybe<Scalars['String']>;
  resourceRequestId?: Maybe<Scalars['String']>;
  role?: Maybe<Role>;
  roleCostExchangeRateValues?: Maybe<AllocationExchangeRateValues>;
  scheduleRules: Array<ScheduleRule>;
  scheduledHours?: Maybe<Scalars['Float']>;
  startDate: Scalars['Date'];
  totalHours?: Maybe<Scalars['Float']>;
  totalHoursWorked?: Maybe<Scalars['Float']>;
  totalRoleCostByCurrency?: Maybe<AllocationTotalCostByCurrency>;
  totalUserCostByCurrency?: Maybe<AllocationTotalCostByCurrency>;
  user: ResourceAllocationUser;
};


export type ResourceAllocationScheduledHoursArgs = {
  effectiveDate?: InputMaybe<Scalars['Date']>;
};

export type ResourceAllocationAllocatedProjectsResult = {
  __typename?: 'ResourceAllocationAllocatedProjectsResult';
  allocatedProjects: Array<ResourceAllocationProjectRoleReference>;
  paginationToken?: Maybe<Scalars['String']>;
};

export type ResourceAllocationDefaults = {
  __typename?: 'ResourceAllocationDefaults';
  allocationStatuses?: Maybe<Array<Maybe<ResourceAllocationStatus>>>;
  maxDate?: Maybe<Scalars['Date2']>;
  minDate?: Maybe<Scalars['Date2']>;
};

export type ResourceAllocationFilter = {
  allocationType?: InputMaybe<ResourceAllocationType>;
  projects?: InputMaybe<Array<Scalars['String']>>;
  resourceAllocationIds?: InputMaybe<Array<Scalars['String']>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchText?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Array<Scalars['String']>>;
};

export type ResourceAllocationForEstimatedBilling = {
  __typename?: 'ResourceAllocationForEstimatedBilling';
  id: Scalars['String'];
  projectId: Scalars['String'];
  requestedRoleId?: Maybe<Scalars['String']>;
  scheduleRules?: Maybe<Array<ScheduleRule>>;
  userId: Scalars['String'];
};

export type ResourceAllocationProjectRoleReference = {
  __typename?: 'ResourceAllocationProjectRoleReference';
  assignedTasksCount?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  project: ObjectReference;
  roles?: Maybe<Array<ProjectRoleWithAllocations>>;
};

export type ResourceAllocationReference = {
  __typename?: 'ResourceAllocationReference';
  id: Scalars['String'];
  resourceRequestIds: Array<Scalars['String']>;
};

export type ResourceAllocationSeriesData = {
  __typename?: 'ResourceAllocationSeriesData';
  allocated?: Maybe<Scalars['Float']>;
  dateRange?: Maybe<DateRange>;
  holiday?: Maybe<Scalars['Float']>;
  overAllocated?: Maybe<Scalars['Float']>;
  proposed?: Maybe<Scalars['Float']>;
  requested?: Maybe<Scalars['Float']>;
  timeoff?: Maybe<Scalars['Float']>;
  toBeHired?: Maybe<Scalars['Float']>;
  totalAvailable?: Maybe<Scalars['Float']>;
  totalSchedule?: Maybe<Scalars['Float']>;
};

export type ResourceAllocationSeriesFilter = {
  costCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  employeeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  primaryRoles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resourcePools?: InputMaybe<Array<Scalars['String']>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  serviceCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tags?: InputMaybe<Array<TagFilterInput>>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type ResourceAllocationSort = {
  direction: SortDirection;
  field: ResourceAllocationSortableFields;
};

export enum ResourceAllocationSortableFields {
  ProjectName = 'projectName',
  RoleName = 'roleName',
  UserName = 'userName'
}

export enum ResourceAllocationStatus {
  Committed = 'COMMITTED',
  Draft = 'DRAFT',
  Proposed = 'PROPOSED',
  Rejected = 'REJECTED'
}

export type ResourceAllocationSummaryByDateRange = {
  __typename?: 'ResourceAllocationSummaryByDateRange';
  resourceAllocatedHoursByDateRange: Array<ResourceAllocatedHoursByDateRange>;
  resourceAllocation: ResourceAllocation;
};

export enum ResourceAllocationType {
  Direct = 'DIRECT',
  ResourceRequest = 'RESOURCE_REQUEST'
}

export type ResourceAllocationUser = {
  __typename?: 'ResourceAllocationUser';
  costCurrency?: Maybe<Currency>;
  costCurrencyUri?: Maybe<Scalars['String']>;
  costRate?: Maybe<Scalars['Float']>;
  holidays?: Maybe<Array<Holiday>>;
  primaryRoleCostCurrency?: Maybe<Currency>;
  primaryRoleCostCurrencyUri?: Maybe<Scalars['String']>;
  primaryRoleCostRate?: Maybe<Scalars['Float']>;
  scheduleDurationByDay?: Maybe<Array<Maybe<DurationDate>>>;
  scheduleDurationSeries: Array<ScheduleDurationSeriesDataPoint>;
  timeoffs?: Maybe<Array<Timeoff>>;
  user?: Maybe<User>;
  userAllocationId: Scalars['String'];
  userType?: Maybe<ResourceAllocationUserType>;
  userUri?: Maybe<Scalars['String']>;
};


export type ResourceAllocationUserHolidaysArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
};


export type ResourceAllocationUserScheduleDurationByDayArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
};


export type ResourceAllocationUserScheduleDurationSeriesArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  periodResolution: PeriodResolutionOption;
};


export type ResourceAllocationUserTimeoffsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
};

export type ResourceAllocationUserInput = {
  costCurrencyUri?: InputMaybe<Scalars['String']>;
  costRate?: InputMaybe<Scalars['Float']>;
  userType?: InputMaybe<ResourceAllocationUserType>;
  userUri?: InputMaybe<Scalars['String']>;
};

export type ResourceAllocationUserRoleReference = {
  __typename?: 'ResourceAllocationUserRoleReference';
  assignedTasksCount?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  roles?: Maybe<Array<ProjectRoleWithAllocations>>;
  user: UserReference;
};

export enum ResourceAllocationUserType {
  Assigned = 'ASSIGNED',
  Tobehired = 'TOBEHIRED',
  Unassigned = 'UNASSIGNED'
}

export type ResourceAllocationsForEstimatedBillingFilter = {
  dateRange: DateRangeInput2;
  userId?: InputMaybe<Scalars['String']>;
};

export type ResourceAllocationsForEstimatedBillingResult = {
  __typename?: 'ResourceAllocationsForEstimatedBillingResult';
  items: Array<ResourceAllocationForEstimatedBilling>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type ResourceAllocationsResponse = {
  __typename?: 'ResourceAllocationsResponse';
  nextPageCursor?: Maybe<Scalars['String']>;
  resourceAllocations?: Maybe<Array<Maybe<ResourceAllocation>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ResourceAllocationsSummaryResult = {
  __typename?: 'ResourceAllocationsSummaryResult';
  nextPageCursor?: Maybe<Scalars['String']>;
  resourceAllocationSummaryByDateRange: Array<ResourceAllocationSummaryByDateRange>;
  totalCount: Scalars['Float'];
};

export enum ResourceAllocationsToReschedule {
  ReleaseAllResources = 'RELEASE_ALL_RESOURCES',
  RemoveAllocatedTime = 'REMOVE_ALLOCATED_TIME'
}

export type ResourceAllocationsUserSynchronizeInput = {
  userUri?: InputMaybe<Scalars['String']>;
};

export type ResourceAllocationsUserSynchronizeResult = {
  __typename?: 'ResourceAllocationsUserSynchronizeResult';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ResourceAssignedToBillingRate = {
  __typename?: 'ResourceAssignedToBillingRate';
  resourceType?: Maybe<ResourceType>;
  user?: Maybe<UserReference>;
};

export enum ResourceCostModeType {
  Rolecost = 'ROLECOST',
  Usercost = 'USERCOST'
}

export type ResourceCostSummary = {
  __typename?: 'ResourceCostSummary';
  actualResourceCost?: Maybe<Money>;
  allocatedResourceCost?: Maybe<Money>;
  budgetedResourceCost?: Maybe<Money>;
  estimatedResourceCost?: Maybe<Money>;
  estimatedResourceCostAtCompletion?: Maybe<Money>;
};

export type ResourceDetails = {
  __typename?: 'ResourceDetails';
  allResourcePools?: Maybe<Array<ResourcePool>>;
  assignedResourcePoolCount?: Maybe<Scalars['Int']>;
  availableResourcePools?: Maybe<Array<Maybe<ResourcePool>>>;
  certificates?: Maybe<Array<Maybe<Certificate>>>;
  costCenter?: Maybe<Array<Maybe<Groups>>>;
  currentCostCenter?: Maybe<Groups>;
  currentDepartment?: Maybe<Groups>;
  currentDivision?: Maybe<Groups>;
  currentEmployeeType?: Maybe<Groups>;
  currentLocation?: Maybe<Groups>;
  currentServiceCenter?: Maybe<Groups>;
  customFieldValues?: Maybe<Array<Maybe<CustomFieldValue>>>;
  department?: Maybe<Scalars['String']>;
  departmentGroup?: Maybe<Array<Maybe<Groups>>>;
  displayText?: Maybe<Scalars['String']>;
  division?: Maybe<Array<Maybe<Groups>>>;
  effectiveRoles?: Maybe<Array<Maybe<UserProjectRoleWithEffectiveDate>>>;
  email?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['String']>;
  employeeType?: Maybe<Scalars['String']>;
  employeeTypeGroup?: Maybe<Array<Maybe<Groups>>>;
  endDate?: Maybe<Scalars['Date']>;
  firstName?: Maybe<Scalars['String']>;
  holidays?: Maybe<Array<Maybe<Holiday>>>;
  id: Scalars['String'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  locale?: Maybe<ResourceLocaleDetails>;
  location?: Maybe<Array<Maybe<Groups>>>;
  permittedActions?: Maybe<Array<Maybe<Scalars['String']>>>;
  resourcePools?: Maybe<Array<ResourcePool>>;
  resourceSkill?: Maybe<Array<Maybe<ResourceSkillDetails>>>;
  roleDetails?: Maybe<Array<Maybe<UserProjectRole>>>;
  roleScheduleDetails?: Maybe<Array<Maybe<UserProjectRoleSchedule>>>;
  roleSchedulesAsOfDate?: Maybe<RoleScheduleAsOfDateResponse>;
  roles?: Maybe<Array<Maybe<UserProjectRole>>>;
  serviceCenter?: Maybe<Array<Maybe<Groups>>>;
  slug?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  supervisor?: Maybe<Supervisor>;
  supervisorAssignment?: Maybe<SupervisorAssignment>;
  supervisorAssignments?: Maybe<Array<Maybe<SupervisorAssignment>>>;
  supervisors?: Maybe<Array<Maybe<Supervisor>>>;
  tags?: Maybe<Array<Maybe<TagAssignment>>>;
  timeoffs?: Maybe<Array<Maybe<Timeoff>>>;
  uri?: Maybe<Scalars['String']>;
  userDefinedSkills?: Maybe<Array<UserDefinedSkill>>;
};


export type ResourceDetailsAssignedResourcePoolCountArgs = {
  searchFilter: ResourcePoolSearchFilter;
};


export type ResourceDetailsAvailableResourcePoolsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  searchFilter: ResourcePoolSearchFilter;
};


export type ResourceDetailsCertificatesArgs = {
  includeExpired?: InputMaybe<Scalars['Boolean']>;
};


export type ResourceDetailsHolidaysArgs = {
  dateRange: DateRangeInput;
};


export type ResourceDetailsResourcePoolsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  searchFilter: ResourcePoolSearchFilter;
};


export type ResourceDetailsRoleSchedulesAsOfDateArgs = {
  asOfDate?: InputMaybe<Scalars['Date2']>;
};


export type ResourceDetailsTimeoffsArgs = {
  dateRange: DateRangeInput;
};

export type ResourceDetailsFilter = {
  costCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  employeeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  primaryRoles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resourcePools?: InputMaybe<Array<Scalars['String']>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  serviceCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tags?: InputMaybe<Array<TagFilterInput>>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type ResourceEstimatesSummary = {
  __typename?: 'ResourceEstimatesSummary';
  resourceEstimatesCount: Scalars['Int'];
  resourceEstimatesWithUsersCount: Scalars['Int'];
  totalResourceEstimateHours?: Maybe<Scalars['Float']>;
};

export type ResourceLocaleDetails = {
  __typename?: 'ResourceLocaleDetails';
  id?: Maybe<Scalars['String']>;
  language?: Maybe<Language>;
  timeZone?: Maybe<TimeZone>;
};

export type ResourceMatch = {
  __typename?: 'ResourceMatch';
  availabilityPercentageInDateRange?: Maybe<Scalars['Float']>;
  displayText: Scalars['String'];
  id: Scalars['String'];
  preferred: Scalars['Boolean'];
  role?: Maybe<Scalars['String']>;
  score: Scalars['Int'];
  userUri: Scalars['String'];
};

export enum ResourceMatchesStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export type ResourcePlan = {
  __typename?: 'ResourcePlan';
  count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  planName?: Maybe<Scalars['String']>;
  planUri?: Maybe<Scalars['String']>;
  requestTotalCost?: Maybe<Array<Maybe<Money>>>;
  requestTotalHours: Scalars['Float'];
};

export type ResourcePlanActualUserRoleReference = {
  __typename?: 'ResourcePlanActualUserRoleReference';
  id: Scalars['String'];
  roles?: Maybe<Array<Maybe<ObjectReference>>>;
  user: UserReference;
};

export type ResourcePlanAllocatedUserTask = {
  __typename?: 'ResourcePlanAllocatedUserTask';
  estimateUri?: Maybe<Scalars['String']>;
  fullPath?: Maybe<Array<TaskReference>>;
  hasTimeEntered?: Maybe<Scalars['Boolean']>;
  isUnassigned?: Maybe<Scalars['Boolean']>;
  projectRole?: Maybe<ObjectReference>;
  task: TaskReference;
};

export type ResourcePlanAllocatedUsersFilter = {
  resourcePools?: InputMaybe<Array<Scalars['String']>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchText?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Array<Scalars['String']>>;
};

export type ResourcePlanAllocatedUsersForEstimatedBillingFilter = {
  dateRange: DateRangeInput2;
  resourcePools?: InputMaybe<Array<Scalars['String']>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchText?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Array<Scalars['String']>>;
};

export type ResourcePlanAllocatedUsersResult = {
  __typename?: 'ResourcePlanAllocatedUsersResult';
  allocatedUsers: Array<UserReference>;
  paginationToken?: Maybe<Scalars['String']>;
};

export type ResourcePlanDefaults = {
  __typename?: 'ResourcePlanDefaults';
  resourceAllocations?: Maybe<ResourceAllocationDefaults>;
  resourceRequests?: Maybe<ResourceRequestDefaults>;
};

export type ResourcePlanFilter = {
  costCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  employeeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludedHiringStatuses?: InputMaybe<Array<HiringStatus>>;
  hiringStatuses?: InputMaybe<Array<HiringStatus>>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  planStatus?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resourcePools?: InputMaybe<Array<Scalars['String']>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  serviceCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text?: InputMaybe<Scalars['String']>;
};

export enum ResourcePlanGroupBy {
  Project = 'PROJECT',
  Role = 'ROLE'
}

export enum ResourcePlanStatus {
  All = 'ALL',
  Pending = 'PENDING',
  Proposed = 'PROPOSED',
  Tobehired = 'TOBEHIRED'
}

export type ResourcePlanTotals = {
  __typename?: 'ResourcePlanTotals';
  totalCost?: Maybe<Money>;
  totalHours?: Maybe<Scalars['Float']>;
};

export type ResourcePlanUserActualTotalsByRole = {
  __typename?: 'ResourcePlanUserActualTotalsByRole';
  totalsByRole: Array<ResourcePlanUserRoleActualTotals>;
  user: UserReference;
};

export type ResourcePlanUserRoleActualTotals = {
  __typename?: 'ResourcePlanUserRoleActualTotals';
  role?: Maybe<ObjectReference>;
  totalCost?: Maybe<Money>;
  totalHours?: Maybe<Duration>;
};

export type ResourcePlansSummary = {
  __typename?: 'ResourcePlansSummary';
  allocationRejectedCount?: Maybe<Scalars['Int']>;
  pendingCount?: Maybe<Scalars['Int']>;
  proposedCount?: Maybe<Scalars['Int']>;
  toBeHiredCount?: Maybe<Scalars['Int']>;
};

export type ResourcePool = {
  __typename?: 'ResourcePool';
  displayText: Scalars['String'];
  id: Scalars['String'];
  slug: Scalars['String'];
  uri: Scalars['String'];
};

export type ResourcePoolFilter = {
  costCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  employeeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  primaryRoles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  serviceCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tags?: InputMaybe<Array<TagFilterInput>>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type ResourcePoolSearchFilter = {
  includeOnlyEnabled: Scalars['Boolean'];
  searchTextParam?: InputMaybe<Scalars['String']>;
};

export type ResourcePoolsMetaData = {
  __typename?: 'ResourcePoolsMetaData';
  matchingResourcePoolsCount: Scalars['Int'];
  requestedResourcePoolsCount: Scalars['Int'];
};

export type ResourceRequest = {
  __typename?: 'ResourceRequest';
  comment?: Maybe<Scalars['String']>;
  costCenter?: Maybe<Group>;
  costCenterUri?: Maybe<Scalars['String']>;
  creationDateTime: Scalars['Date'];
  currency?: Maybe<Currency>;
  currencyUri?: Maybe<Scalars['String']>;
  department?: Maybe<Group>;
  departmentUri?: Maybe<Scalars['String']>;
  division?: Maybe<Group>;
  divisionUri?: Maybe<Scalars['String']>;
  employeeType?: Maybe<Group>;
  employeeTypeUri?: Maybe<Scalars['String']>;
  endDate: Scalars['Date'];
  exchangeRateValues?: Maybe<ResourceRequestExchangeRateValues>;
  id: Scalars['String'];
  isAdjustedLoading?: Maybe<Scalars['Boolean']>;
  load?: Maybe<Scalars['Float']>;
  location?: Maybe<Group>;
  locationUri?: Maybe<Scalars['String']>;
  mergedResourceRequests?: Maybe<Array<ResourceRequest>>;
  preferredResources?: Maybe<Array<UserReference>>;
  project?: Maybe<Project>;
  projectUri: Scalars['String'];
  quantity: Scalars['Int'];
  requestAttributeWeights?: Maybe<RequestAttributeWeights>;
  requestStatus: ResourceRequestStatus;
  resourceAllocations?: Maybe<Array<Maybe<ResourceAllocation>>>;
  resourceMatches?: Maybe<Array<ResourceMatch>>;
  resourceMatchesStatus?: Maybe<ResourceMatchesStatus>;
  resourcePools?: Maybe<Array<ResourcePool>>;
  role?: Maybe<Role>;
  roleRate?: Maybe<Scalars['Float']>;
  roleUri?: Maybe<Scalars['String']>;
  scheduleRules: Array<ScheduleRule>;
  serviceCenter?: Maybe<Group>;
  serviceCenterUri?: Maybe<Scalars['String']>;
  skills?: Maybe<Array<Maybe<RequestSkill>>>;
  sourceMetadata?: Maybe<SourceMetadata>;
  startDate: Scalars['Date'];
  tags?: Maybe<Array<Maybe<TagAssignment>>>;
  taskResourceEstimateUri?: Maybe<Scalars['String']>;
  totalHours?: Maybe<Scalars['Float']>;
  totalHoursByPeriod: ResourceRequestHoursByPeriodResponse;
  totalRequestedCostByCurrency?: Maybe<ResourceRequestTotalCostByCurrency>;
};


export type ResourceRequestResourceMatchesArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type ResourceRequestTotalHoursByPeriodArgs = {
  input: ResourceRequestHoursByPeriodInput;
};

export enum ResourceRequestAccessLevel {
  All = 'ALL',
  ResourceManager = 'RESOURCE_MANAGER'
}

export type ResourceRequestDefaults = {
  __typename?: 'ResourceRequestDefaults';
  maxDate?: Maybe<Scalars['Date2']>;
  minDate?: Maybe<Scalars['Date2']>;
  requestStatuses?: Maybe<Array<Maybe<ResourceRequestStatus>>>;
};

export type ResourceRequestExchangeRateValues = {
  __typename?: 'ResourceRequestExchangeRateValues';
  baseCurrency?: Maybe<ExchangeRate>;
  projectBudgetCurrency?: Maybe<ExchangeRate>;
};

export type ResourceRequestForProjectEstimatedBilling = {
  __typename?: 'ResourceRequestForProjectEstimatedBilling';
  requestId: Scalars['String'];
};

export type ResourceRequestHoursByPeriodEntry = {
  __typename?: 'ResourceRequestHoursByPeriodEntry';
  dateRange: DateRange;
  hours: Scalars['Float'];
};

export type ResourceRequestHoursByPeriodInput = {
  dateRange: DateRangeInput;
  periodResolution: PeriodResolutionOption;
};

export type ResourceRequestHoursByPeriodResponse = {
  __typename?: 'ResourceRequestHoursByPeriodResponse';
  entries: Array<ResourceRequestHoursByPeriodEntry>;
};

export type ResourceRequestMatchingCompletedFilter = {
  resourceRequestUris?: InputMaybe<Array<Scalars['String']>>;
};

export type ResourceRequestMatchingCompletedResult = {
  __typename?: 'ResourceRequestMatchingCompletedResult';
  id: Scalars['String'];
  resourceMatches?: Maybe<Array<ResourceMatch>>;
  resourceMatchesStatus?: Maybe<ResourceMatchesStatus>;
};

export type ResourceRequestSort = {
  direction: SortDirection;
  field: ResourceRequestSortableFields;
};

export enum ResourceRequestSortableFields {
  RoleName = 'roleName',
  UserName = 'userName'
}

export enum ResourceRequestStatus {
  Allocationrejected = 'ALLOCATIONREJECTED',
  ArchivedReleased = 'ARCHIVED_RELEASED',
  Complete = 'COMPLETE',
  Draft = 'DRAFT',
  MergedArchived = 'MERGED_ARCHIVED',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED',
  Tentative = 'TENTATIVE',
  Tobehired = 'TOBEHIRED'
}

export type ResourceRequestTotalCostByCurrency = {
  __typename?: 'ResourceRequestTotalCostByCurrency';
  baseCurrency?: Maybe<MoneyValue>;
  projectBudgetCurrency?: Maybe<MoneyValue>;
};

export type ResourceRequestUserMatch = {
  __typename?: 'ResourceRequestUserMatch';
  id: Scalars['String'];
  matchScore?: Maybe<Scalars['Float']>;
  metaData?: Maybe<ResourceRequestUserMatchMetaData>;
  resourceRequestId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ResourceRequestUserMatchFilterInput = {
  resourceRequestId: Scalars['String'];
  scoreFilter?: InputMaybe<ScoreFilterInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ResourceRequestUserMatchMetaData = {
  __typename?: 'ResourceRequestUserMatchMetaData';
  matchingDimensions: Array<Maybe<Scalars['String']>>;
  resourcePools?: Maybe<ResourcePoolsMetaData>;
  skills?: Maybe<SkillsMetaData>;
  tags?: Maybe<TagsMetaData>;
  totalCost?: Maybe<Money>;
  unMatchedDimensions: Array<Maybe<Scalars['String']>>;
};

export type ResourceRequestUserMatchesResponse = {
  __typename?: 'ResourceRequestUserMatchesResponse';
  computeStatus?: Maybe<Scalars['String']>;
  matches?: Maybe<Array<Maybe<ResourceRequestUserMatch>>>;
  nextPageCursor?: Maybe<Scalars['String']>;
};

export type ResourceRequestsFilter = {
  costCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  employeeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludedHiringStatuses?: InputMaybe<Array<HiringStatus>>;
  hiringStatuses?: InputMaybe<Array<HiringStatus>>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resourcePools?: InputMaybe<Array<Scalars['String']>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  serviceCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ResourceRequestsForProjectEstimatedBillingFilter = {
  dateRange: DateRangeInput2;
};

export type ResourceRequestsForProjectEstimatedBillingResult = {
  __typename?: 'ResourceRequestsForProjectEstimatedBillingResult';
  items: Array<ResourceRequestForProjectEstimatedBilling>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type ResourceRequestsProject = {
  __typename?: 'ResourceRequestsProject';
  project: Project;
  requestCounts?: Maybe<Scalars['Int']>;
};

export type ResourceRequestsProjectsDetails = {
  __typename?: 'ResourceRequestsProjectsDetails';
  paginationToken?: Maybe<Scalars['PaginationTokenResponse']>;
  resourceRequestsProjects?: Maybe<Array<Maybe<ResourceRequestsProject>>>;
};

export type ResourceRequestsResponse = {
  __typename?: 'ResourceRequestsResponse';
  nextPageCursor?: Maybe<Scalars['String']>;
  resourceRequests?: Maybe<Array<Maybe<ResourceRequest>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ResourceRequestsStatusCountSummary = {
  __typename?: 'ResourceRequestsStatusCountSummary';
  allocationRejected?: Maybe<Scalars['Int']>;
  completed?: Maybe<Scalars['Int']>;
  draft?: Maybe<Scalars['Int']>;
  proposed?: Maybe<Scalars['Int']>;
  rejected?: Maybe<Scalars['Int']>;
  submitted?: Maybe<Scalars['Int']>;
  toBeHired?: Maybe<Scalars['Int']>;
};

export type ResourceRequestsSummary = {
  __typename?: 'ResourceRequestsSummary';
  completed?: Maybe<ResourcesRequestStatusSummary>;
  draft?: Maybe<ResourcesRequestStatusSummary>;
  pending?: Maybe<ResourcesRequestStatusSummary>;
  proposed?: Maybe<ResourcesRequestStatusSummary>;
  rejected?: Maybe<ResourcesRequestStatusSummary>;
  toBeHired?: Maybe<ResourcesRequestStatusSummary>;
  total?: Maybe<Scalars['Int']>;
};

export enum ResourceRequestsToRescheduleByStatus {
  ReleaseAndRescheduleAllRequests = 'RELEASE_AND_RESCHEDULE_ALL_REQUESTS',
  WithoutAcceptedResourcesRequests = 'WITHOUT_ACCEPTED_RESOURCES_REQUESTS',
  WithoutProposedOrAcceptedResourcesRequests = 'WITHOUT_PROPOSED_OR_ACCEPTED_RESOURCES_REQUESTS'
}

export enum ResourceRequestsToRescheduleByStatus2 {
  AllResourceRequests = 'ALL_RESOURCE_REQUESTS',
  WithoutProposedResourceRequests = 'WITHOUT_PROPOSED_RESOURCE_REQUESTS'
}

export type ResourceScoreComputedSubsriptionResult = {
  __typename?: 'ResourceScoreComputedSubsriptionResult';
  resourceRequestId?: Maybe<Scalars['String']>;
};

export type ResourceSkillDetails = {
  __typename?: 'ResourceSkillDetails';
  category?: Maybe<Category>;
  skillAssignments?: Maybe<Array<Maybe<Skill>>>;
};

export type ResourceSort = {
  customFieldUri?: InputMaybe<Scalars['String']>;
  direction: SortDirection;
  field: ResourceSortableFields;
};

export enum ResourceSortableFields {
  CurrentCostCenter = 'currentCostCenter',
  CurrentDepartment = 'currentDepartment',
  CurrentDivision = 'currentDivision',
  CurrentEmployeeType = 'currentEmployeeType',
  CurrentLocation = 'currentLocation',
  CurrentServiceCenter = 'currentServiceCenter',
  CustomField = 'customField',
  Department = 'department',
  DisplayText = 'displayText',
  EmployeeId = 'employeeId',
  EmployeeType = 'employeeType',
  EndDate = 'endDate',
  IsEnabled = 'isEnabled',
  Roles = 'roles',
  StartDate = 'startDate',
  SupervisorAssignment = 'supervisorAssignment'
}

export type ResourceType = {
  __typename?: 'ResourceType';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};

export type ResourceUser = {
  __typename?: 'ResourceUser';
  actuals?: Maybe<Array<Maybe<ResourceUserActualPeriodSummary>>>;
  allResourcePools?: Maybe<Array<ResourcePool>>;
  allocatedDuration?: Maybe<Scalars['Float']>;
  allocationCount?: Maybe<Scalars['Int']>;
  allocationsSummary: ResourceUserAllocationSummaryResult;
  assignedTasks: Array<Task>;
  assignedTasksCount: Scalars['Int'];
  availabilityPercentage?: Maybe<Scalars['Float']>;
  availableDuration?: Maybe<Scalars['Float']>;
  changeResourceUserTaskAssignmentSummary: ChangeResourceUserTaskAssignmentSummaryResult;
  costRateAsOf?: Maybe<Money>;
  currentBillingRate?: Maybe<Money>;
  currentCostCenter?: Maybe<Groups>;
  currentCostRate?: Maybe<Money>;
  currentCostRateInTargetCurrency?: Maybe<Money>;
  currentDepartment?: Maybe<Groups>;
  currentDivision?: Maybe<Groups>;
  currentEmployeeType?: Maybe<Groups>;
  currentLocation?: Maybe<Groups>;
  currentServiceCenter?: Maybe<Groups>;
  customFieldValues?: Maybe<Array<Maybe<CustomFieldValue>>>;
  displayText: Scalars['String'];
  employeeId?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  holidayDuration?: Maybe<Scalars['Float']>;
  holidays?: Maybe<Array<Maybe<Holiday>>>;
  id: Scalars['String'];
  impactedTaskSummary: ImpactedTasksSummary;
  matchScore?: Maybe<MatchScore>;
  pageOfActualsProjectAndRoles: Array<ResourceUserActualsProjectRoleReference>;
  primaryRoleCostRate?: Maybe<Money>;
  projectActualSeriesByProjectRole: Array<ResourceUserActualSeriesByProjectRole>;
  projectActualSeriesByTask: Array<ResourceUserActualSeriesByTask>;
  projectAllocationSummary?: Maybe<ResourceUserProjectAllocationSummaryResult>;
  resourceAllocationAllocatedProjects: ResourceAllocationAllocatedProjectsResult;
  resourceAllocations?: Maybe<Array<Maybe<ResourceAllocation>>>;
  resourceAvailabilitySummarySeries?: Maybe<Array<Maybe<AvailabilityPeriod>>>;
  resourceSkills?: Maybe<Array<ResourceSkillDetails>>;
  resourceUserScheduleSvg: ResourceUserScheduleSvgResponse;
  roleSchedules?: Maybe<Array<Maybe<UserProjectRoleSchedule>>>;
  roleSchedulesAsOfDate?: Maybe<RoleScheduleAsOfDateResponse>;
  roles?: Maybe<Array<Maybe<UserProjectRole>>>;
  scheduleDuration?: Maybe<Scalars['Float']>;
  scheduleDurationByDay?: Maybe<Array<Maybe<DurationDate>>>;
  scheduleDurationSeries: Array<ScheduleDurationSeriesDataPoint>;
  scheduledDuration?: Maybe<Scalars['Float']>;
  slug: Scalars['String'];
  startDate?: Maybe<Scalars['Date']>;
  supervisorAssignment?: Maybe<SupervisorAssignment>;
  tags?: Maybe<Array<Maybe<TagAssignment>>>;
  timeOffDuration?: Maybe<Scalars['Float']>;
  timeoffs?: Maybe<Array<Maybe<Timeoff>>>;
  uri: Scalars['String'];
};


export type ResourceUserActualsArgs = {
  dateRange: DateRangeInput;
  periodResolution: PeriodResolutionOption;
};


export type ResourceUserAllocationCountArgs = {
  projectId: Scalars['String'];
};


export type ResourceUserAllocationsSummaryArgs = {
  cursor?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['String']>;
  sort: ResourceAllocationSort;
};


export type ResourceUserAssignedTasksArgs = {
  includeClosedTasks?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['String'];
};


export type ResourceUserAssignedTasksCountArgs = {
  assignedTasksCountInput?: InputMaybe<AssignedTasksCountInput>;
};


export type ResourceUserChangeResourceUserTaskAssignmentSummaryArgs = {
  asOfDate?: InputMaybe<Scalars['Date2']>;
  existingResourceUserId: Scalars['String'];
  newResourceUserId: Scalars['String'];
  projectId: Scalars['String'];
};


export type ResourceUserCostRateAsOfArgs = {
  date: Scalars['Date'];
};


export type ResourceUserCurrentBillingRateArgs = {
  asOfDate?: InputMaybe<Scalars['DateObject']>;
};


export type ResourceUserCurrentCostRateInTargetCurrencyArgs = {
  targetCurrencyId?: InputMaybe<Scalars['String']>;
};


export type ResourceUserHolidaysArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
};


export type ResourceUserImpactedTaskSummaryArgs = {
  projectId: Scalars['String'];
  releaseDate?: InputMaybe<Scalars['Date2']>;
};


export type ResourceUserPageOfActualsProjectAndRolesArgs = {
  isSortByProjectAscending: Scalars['Boolean'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  projectWorkflowStages?: InputMaybe<Array<ProjectWorkflowStage>>;
};


export type ResourceUserPrimaryRoleCostRateArgs = {
  date: Scalars['Date'];
};


export type ResourceUserProjectActualSeriesByProjectRoleArgs = {
  dateRange: DateRangeInput;
  periodResolution: PeriodResolutionOption;
  projectUri: Scalars['String'];
};


export type ResourceUserProjectActualSeriesByTaskArgs = {
  dateRange: DateRangeInput;
  periodResolution: PeriodResolutionOption;
  projectUri: Scalars['String'];
  taskUris?: InputMaybe<Array<Scalars['String']>>;
};


export type ResourceUserProjectAllocationSummaryArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter: ResourceUserProjectAllocationSummaryFilter;
  pageSize: Scalars['Int'];
};


export type ResourceUserResourceAllocationAllocatedProjectsArgs = {
  isSortByProjectAscending: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  paginationToken?: InputMaybe<Scalars['String']>;
  projectWorkflowStages?: InputMaybe<Array<ProjectWorkflowStage>>;
};


export type ResourceUserResourceAllocationsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
};


export type ResourceUserResourceAvailabilitySummarySeriesArgs = {
  dateRange: DateRangeInput;
  periodResolution: PeriodResolutionOption;
};


export type ResourceUserResourceUserScheduleSvgArgs = {
  dateRange: DateRangeInput;
  periodResolution: PeriodResolutionOption;
};


export type ResourceUserRoleSchedulesAsOfDateArgs = {
  asOfDate?: InputMaybe<Scalars['Date2']>;
};


export type ResourceUserScheduleDurationByDayArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
};


export type ResourceUserScheduleDurationSeriesArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  periodResolution: PeriodResolutionOption;
};


export type ResourceUserScheduledDurationArgs = {
  dateRange: DateRangeInput;
};


export type ResourceUserTimeoffsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
};

export type ResourceUserActualPeriodSummary = {
  __typename?: 'ResourceUserActualPeriodSummary';
  cost: Money;
  dateRange: DateRange;
  hours: Duration;
};

export type ResourceUserActualSeriesByProjectRole = {
  __typename?: 'ResourceUserActualSeriesByProjectRole';
  periods: Array<ResourceUserActualPeriodSummary>;
  role?: Maybe<ObjectReference>;
};

export type ResourceUserActualSeriesByTask = {
  __typename?: 'ResourceUserActualSeriesByTask';
  periods: Array<ResourceUserActualPeriodSummary>;
  task?: Maybe<ObjectReference>;
};

export type ResourceUserActualsProjectRoleReference = {
  __typename?: 'ResourceUserActualsProjectRoleReference';
  assignedTasksCount?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  project: ObjectReference;
  roles?: Maybe<Array<Maybe<ObjectReference>>>;
};

export type ResourceUserAllocationSummary = {
  __typename?: 'ResourceUserAllocationSummary';
  assignedRole?: Maybe<ObjectReference>;
  id: Scalars['String'];
  project: ObjectReference;
  resourceAllocationSummary: Array<ResourceAllocationsSummaryResult>;
  user: ObjectReference;
};


export type ResourceUserAllocationSummaryResourceAllocationSummaryArgs = {
  dateRange: DateRangeInput;
  periodResolution: PeriodResolutionOption;
};

export type ResourceUserAllocationSummaryResult = {
  __typename?: 'ResourceUserAllocationSummaryResult';
  entries?: Maybe<Array<ResourceUserAllocationSummary>>;
  nextPageCursor?: Maybe<Scalars['String']>;
};

export enum ResourceUserAvailabilityGroupType {
  CostCenter = 'costCenter',
  Department = 'department',
  Division = 'division',
  EmployeeType = 'employeeType',
  Location = 'location',
  Role = 'role',
  ServiceCenter = 'serviceCenter'
}

export type ResourceUserAvailabilityHours = {
  __typename?: 'ResourceUserAvailabilityHours';
  date: Scalars['Date2'];
  hours: Scalars['Float'];
};

export type ResourceUserAvailabilitySeries = {
  __typename?: 'ResourceUserAvailabilitySeries';
  costCenter?: Maybe<Group>;
  count?: Maybe<Scalars['Int']>;
  department?: Maybe<Group>;
  division?: Maybe<Group>;
  employeeType?: Maybe<Group>;
  id: Scalars['String'];
  location?: Maybe<Group>;
  periods?: Maybe<Array<Maybe<AvailabilityPeriod>>>;
  role?: Maybe<UserRole>;
  serviceCenter?: Maybe<Group>;
};

export type ResourceUserAvailabilitySeriesFilter = {
  costCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  employeeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  primaryRoles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resourcePools?: InputMaybe<Array<Scalars['String']>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  serviceCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tags?: InputMaybe<Array<TagFilterInput>>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type ResourceUserAvailabilitySeriesTotals = {
  __typename?: 'ResourceUserAvailabilitySeriesTotals';
  count?: Maybe<Scalars['Int']>;
  periods?: Maybe<Array<Maybe<AvailabilityPeriod>>>;
};

export type ResourceUserAvailabilitySort = {
  direction: SortDirection;
  field: ResourceUserAvailabilitySortableFields;
};

export enum ResourceUserAvailabilitySortableFields {
  CostCenter = 'costCenter',
  Department = 'department',
  Division = 'division',
  EmployeeType = 'employeeType',
  Location = 'location',
  Role = 'role',
  ServiceCenter = 'serviceCenter'
}

export type ResourceUserColumns = {
  customFieldUris?: InputMaybe<Array<Scalars['String']>>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
};

export enum ResourceUserMatchSource {
  AiMatch = 'AI_MATCH',
  Core = 'CORE'
}

export type ResourceUserMatchesFilter = {
  availabilityPercentageInRange?: InputMaybe<AvailabilityPercentageInRangeInput>;
  costCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  employeeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  primaryRoles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resourcePools?: InputMaybe<Array<Scalars['String']>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  serviceCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tags?: InputMaybe<Array<TagFilterInput>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ResourceUserProjectAllocationSummary = {
  __typename?: 'ResourceUserProjectAllocationSummary';
  allocationStatus: ResourceAllocationStatus;
  project: ObjectReference;
  totalHours: Scalars['Float'];
};

export type ResourceUserProjectAllocationSummaryFilter = {
  endDate?: InputMaybe<Scalars['Date2']>;
  projectUris?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Scalars['Date2']>;
};

export type ResourceUserProjectAllocationSummaryResult = {
  __typename?: 'ResourceUserProjectAllocationSummaryResult';
  entries: Array<ResourceUserProjectAllocationSummary>;
  nextPageCursor?: Maybe<Scalars['String']>;
};

export type ResourceUserScheduleSeriesFilter = {
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type ResourceUserScheduleSvgResponse = {
  __typename?: 'ResourceUserScheduleSvgResponse';
  svgContent: Scalars['String'];
};

export type ResourceUserSort = {
  direction: SortDirection;
  field: ResourceUserSortableFields;
};

export type ResourceUserSortWithPeriod = {
  dateRange?: InputMaybe<DateRangeInput>;
  direction: SortDirection;
  field: ResourceUserSortablePeriodFields;
};

export enum ResourceUserSortableFields {
  AvailabilityPercentage = 'availabilityPercentage',
  AvailableDuration = 'availableDuration',
  CurrentCostCenter = 'currentCostCenter',
  CurrentDepartment = 'currentDepartment',
  CurrentDivision = 'currentDivision',
  CurrentEmployeeType = 'currentEmployeeType',
  CurrentLocation = 'currentLocation',
  CurrentServiceCenter = 'currentServiceCenter',
  DisplayText = 'displayText',
  EmployeeId = 'employeeId',
  EndDate = 'endDate',
  NetAvailableDuration = 'netAvailableDuration',
  Roles = 'roles',
  Score = 'score',
  StartDate = 'startDate',
  SupervisorAssignment = 'supervisorAssignment'
}

export enum ResourceUserSortablePeriodFields {
  AllocatedHours = 'allocatedHours',
  DisplayText = 'displayText',
  OverAllocatedHours = 'overAllocatedHours',
  ScheduledHours = 'scheduledHours'
}

export type ResourceUserTaskAssignmentBulkActionTaskFilter = {
  textSearch?: InputMaybe<Scalars['String']>;
};

export type ResourceUserTaskAssignmentSummaryInput = {
  projectId: Scalars['String'];
  taskId: Scalars['String'];
  userId: Scalars['String'];
};

export type ResourceUserTaskAssignmentSummaryResult = {
  __typename?: 'ResourceUserTaskAssignmentSummaryResult';
  resourceEstimate?: Maybe<TaskAssignmentSummaryResourceEstimate>;
  taskId: Scalars['String'];
  taskResourceUserAllocation?: Maybe<TaskResourceUserAllocation>;
  taskResourceUserCostProgressSummary?: Maybe<TaskResourceUserCostProgressSummary>;
  taskResourceUserHoursProgressSummary?: Maybe<TaskResourceUserHoursProgressSummary>;
  userId: Scalars['String'];
};

export type ResourceUsersCount = {
  __typename?: 'ResourceUsersCount';
  count: Scalars['Int'];
};

export type ResourceUsersDropdownOption = {
  __typename?: 'ResourceUsersDropdownOption';
  displayText: Scalars['String'];
  id: Scalars['String'];
  isAssignedToTask?: Maybe<Scalars['Boolean']>;
  netAvailableDuration?: Maybe<Scalars['Float']>;
  roles?: Maybe<Array<Maybe<UserProjectRole>>>;
  userRateInTargetCurrency?: Maybe<Money>;
};

export type ResourcesRequestStatusSummary = {
  __typename?: 'ResourcesRequestStatusSummary';
  requestCounts?: Maybe<Scalars['Int']>;
  requestedResourcesCount?: Maybe<Scalars['Int']>;
};

export enum ResourcingDataSource {
  ExternalResourceAllocations = 'externalResourceAllocations',
  Legacy = 'legacy'
}

export type ResumeInput = {
  linkName?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  uploadUri: Scalars['String'];
};

export type ResumeLink = {
  __typename?: 'ResumeLink';
  fileExtension?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['String']>;
  linkName?: Maybe<Scalars['String']>;
  linkUri?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  uploadUri: Scalars['String'];
  uploadedBy?: Maybe<User>;
  uploadedOn: Scalars['String'];
};

export type ResumeParsingProcessCompletedSubsriptionResult = {
  __typename?: 'ResumeParsingProcessCompletedSubsriptionResult';
  id: Scalars['String'];
  userSlug: Scalars['String'];
};

export type RevenueAggregation = {
  __typename?: 'RevenueAggregation';
  /** @deprecated Use deferredRevenue */
  adjustment?: Maybe<Money>;
  client?: Maybe<ObjectReference>;
  costCenter?: Maybe<Groups>;
  deferredRevenue?: Maybe<Money>;
  department?: Maybe<Groups>;
  division?: Maybe<Groups>;
  employeeType?: Maybe<Groups>;
  forecastRevenue?: Maybe<Money>;
  location?: Maybe<Groups>;
  program?: Maybe<ObjectReference>;
  project?: Maybe<ObjectReference>;
  recognizableRevenue?: Maybe<Money>;
  recognizedRevenue?: Maybe<Money>;
  serviceCenter?: Maybe<Groups>;
};

export enum RevenueAggregationColumn {
  /** @deprecated Use DEFERREDREVENUE */
  Adjustment = 'ADJUSTMENT',
  Client = 'CLIENT',
  Costcenter = 'COSTCENTER',
  Deferredrevenue = 'DEFERREDREVENUE',
  Department = 'DEPARTMENT',
  Division = 'DIVISION',
  Employeetype = 'EMPLOYEETYPE',
  Forecastrevenue = 'FORECASTREVENUE',
  Location = 'LOCATION',
  Program = 'PROGRAM',
  Project = 'PROJECT',
  Recognizablerevenue = 'RECOGNIZABLEREVENUE',
  Recognizedrevenue = 'RECOGNIZEDREVENUE',
  Servicecenter = 'SERVICECENTER'
}

export type RevenueAggregationFilter = {
  dateRange?: InputMaybe<DateRangeInput>;
};

export type RevenueAggregationFilter2 = {
  dateRange?: InputMaybe<DateRangeInput2>;
};

export type RevenueAggregationSort = {
  direction: SortDirection;
  field: RevenueAggregationColumn;
};

export type RevenueAggregationTotals = {
  __typename?: 'RevenueAggregationTotals';
  /** @deprecated Use deferredRevenue */
  adjustment?: Maybe<Money>;
  deferredRevenue?: Maybe<Money>;
  forecastRevenue?: Maybe<Money>;
  recognizableRevenue?: Maybe<Money>;
  recognizedRevenue?: Maybe<Money>;
};

export type RevenueAmountSummary = {
  __typename?: 'RevenueAmountSummary';
  revenueActual?: Maybe<Money>;
};

export type RevenueContractDetailsInput = {
  contractId: Scalars['String'];
  projectId: Scalars['String'];
  scriptId?: InputMaybe<Scalars['String']>;
  scripts?: InputMaybe<Array<InputMaybe<Scalars['ProjectScriptParameter']>>>;
};

export type RevenueDateRange = {
  endDate?: InputMaybe<Scalars['DateObject']>;
  startDate?: InputMaybe<Scalars['DateObject']>;
};

export type RevenueDateRange2 = {
  endDate?: InputMaybe<Scalars['Date2']>;
  startDate?: InputMaybe<Scalars['Date2']>;
};

export type RevenueEntry = {
  __typename?: 'RevenueEntry';
  /** @deprecated Use deferredRevenue */
  adjustment?: Maybe<Money>;
  client?: Maybe<ObjectReference>;
  comment?: Maybe<Scalars['String']>;
  costCenter?: Maybe<Groups>;
  deferredRevenue?: Maybe<Money>;
  department?: Maybe<Groups>;
  division?: Maybe<Groups>;
  employeeType?: Maybe<Groups>;
  forecastRevenue?: Maybe<Money>;
  hasCarryOver?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  initialForecastedRevenue?: Maybe<Money>;
  initialRecognizedRevenue?: Maybe<Money>;
  location?: Maybe<Groups>;
  pendingRevenue?: Maybe<Money>;
  previouslyRecognizedRevenue?: Maybe<Money>;
  program?: Maybe<ObjectReference>;
  project?: Maybe<ObjectReference>;
  projectCode?: Maybe<Scalars['String']>;
  projectLeader?: Maybe<ObjectReference>;
  projectStatus?: Maybe<ObjectReference>;
  recognizableRevenue?: Maybe<Money>;
  recognizedRevenue?: Maybe<Money>;
  recognizedRevenueYTD?: Maybe<Money>;
  revenuePeriod?: Maybe<RevenuePeriod>;
  revenueRecognitionPolicy?: Maybe<ObjectReference>;
  revenueRunStatus?: Maybe<ObjectReference>;
  serviceCenter?: Maybe<Groups>;
  totalContractAmount?: Maybe<Money>;
};

export enum RevenueEntryColumn {
  /** @deprecated Use DEFERREDREVENUE */
  Adjustment = 'ADJUSTMENT',
  Client = 'CLIENT',
  Comment = 'COMMENT',
  Costcenter = 'COSTCENTER',
  Deferredrevenue = 'DEFERREDREVENUE',
  Department = 'DEPARTMENT',
  Division = 'DIVISION',
  Employeetype = 'EMPLOYEETYPE',
  Forecastrevenue = 'FORECASTREVENUE',
  Initialforecastedrevenue = 'INITIALFORECASTEDREVENUE',
  Initialrecognizedrevenue = 'INITIALRECOGNIZEDREVENUE',
  Location = 'LOCATION',
  Pendingrevenue = 'PENDINGREVENUE',
  Previouslyrecognizedrevenue = 'PREVIOUSLYRECOGNIZEDREVENUE',
  Program = 'PROGRAM',
  Project = 'PROJECT',
  Projectcode = 'PROJECTCODE',
  Projectleader = 'PROJECTLEADER',
  Projectstatus = 'PROJECTSTATUS',
  Recognizablerevenue = 'RECOGNIZABLEREVENUE',
  Recognizedrevenue = 'RECOGNIZEDREVENUE',
  Recognizedrevenueytd = 'RECOGNIZEDREVENUEYTD',
  Revenueentry = 'REVENUEENTRY',
  Revenueperiod = 'REVENUEPERIOD',
  Revenuerecognitionpolicy = 'REVENUERECOGNITIONPOLICY',
  Revenuerunstatus = 'REVENUERUNSTATUS',
  Servicecenter = 'SERVICECENTER',
  Totalcontractamount = 'TOTALCONTRACTAMOUNT'
}

export type RevenueEntryFilter = {
  clients?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  costCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateRange?: InputMaybe<RevenueDateRange>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  employeeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  programs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projectLeaders?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  revenueRecognitionPolicies?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  revenueRunUri?: InputMaybe<Scalars['String']>;
  serviceCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statusUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type RevenueEntryFilter2 = {
  clients?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  costCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateRange?: InputMaybe<RevenueDateRange2>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  employeeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  programs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projectLeaders?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projectStatusPolicies?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  revenueRecognitionPolicies?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  revenueRunUri?: InputMaybe<Scalars['String']>;
  serviceCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statusUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type RevenueEntrySort = {
  direction: SortDirection;
  field: RevenueEntryColumn;
};

export type RevenueEntryTotals = {
  __typename?: 'RevenueEntryTotals';
  /** @deprecated Use deferredRevenue */
  adjustment?: Maybe<Array<Maybe<Money>>>;
  /** @deprecated Not using anymore */
  deferredRevenue?: Maybe<Array<Maybe<Money>>>;
  forecastRevenue?: Maybe<Array<Maybe<Money>>>;
  /** @deprecated Not using anymore */
  previouslyRecognizedRevenue?: Maybe<Array<Maybe<Money>>>;
  /** @deprecated Not using anymore */
  recognizableRevenue?: Maybe<Array<Maybe<Money>>>;
  recognizedRevenue?: Maybe<Array<Maybe<Money>>>;
  /** @deprecated Not using anymore */
  recognizedRevenueYTD?: Maybe<Array<Maybe<Money>>>;
};

export type RevenueInput = {
  contractId: Scalars['String'];
  projectId: Scalars['String'];
  projectScripts?: InputMaybe<Array<InputMaybe<Scalars['ProjectScriptParameter']>>>;
};

export type RevenuePeriod = {
  __typename?: 'RevenuePeriod';
  /** @deprecated Use endDate2 */
  endDate?: Maybe<Scalars['DateObject']>;
  endDate2?: Maybe<Scalars['Date2']>;
  /** @deprecated Use startDate2 */
  startDate?: Maybe<Scalars['DateObject']>;
  startDate2?: Maybe<Scalars['Date2']>;
};

export type RevenueRecognitionBatchInput = {
  batchUri: Scalars['String'];
  revenueRunUri: Scalars['String'];
};

export type RevenueRunAmountSeries = {
  __typename?: 'RevenueRunAmountSeries';
  dataPoints?: Maybe<Array<Maybe<RevenueRunAmountSeriesDataPoint>>>;
};

export type RevenueRunAmountSeriesData = {
  __typename?: 'RevenueRunAmountSeriesData';
  series?: Maybe<RevenueRunAmountSeries>;
  summary?: Maybe<RevenueRunAmountSummary>;
};

export type RevenueRunAmountSeriesDataPoint = {
  __typename?: 'RevenueRunAmountSeriesDataPoint';
  amount?: Maybe<Money>;
  /** @deprecated Use date2 */
  date?: Maybe<Scalars['Date']>;
  date2?: Maybe<Scalars['Date2']>;
  period?: Maybe<DataPointPeriod>;
  revenueRunId?: Maybe<Scalars['String']>;
};

export type RevenueRunAmountSummary = {
  __typename?: 'RevenueRunAmountSummary';
  amount?: Maybe<Money>;
};

export type RevenueRunBatchInput = {
  batchUri: Scalars['String'];
  revenueRunUri: Scalars['String'];
};

export enum RevenueRunListColumns {
  Asofdate = 'ASOFDATE',
  Creationdate = 'CREATIONDATE',
  Creator = 'CREATOR',
  Description = 'DESCRIPTION',
  Lastrecalculatedtime = 'LASTRECALCULATEDTIME',
  Previouslyrecognizedrevenue = 'PREVIOUSLYRECOGNIZEDREVENUE',
  Revenuerun = 'REVENUERUN',
  Status = 'STATUS',
  Statuslastupdatedtime = 'STATUSLASTUPDATEDTIME',
  Totalamount = 'TOTALAMOUNT'
}

export type RevenueRunListFilter = {
  dateRange?: InputMaybe<DateRangeInput2>;
  status?: InputMaybe<Scalars['String']>;
};

export type RevenueRunScheduleSeriesResult = {
  __typename?: 'RevenueRunScheduleSeriesResult';
  /** @deprecated Use deferredRevenue */
  adjustments?: Maybe<RevenueRunAmountSeriesData>;
  deferredRevenue?: Maybe<RevenueRunAmountSeriesData>;
  recognizableRevenue?: Maybe<RevenueRunAmountSeriesData>;
  recognizedRevenue?: Maybe<RevenueRunAmountSeriesData>;
  revenueForecast?: Maybe<RevenueRunAmountSeriesData>;
  revenueVariance?: Maybe<RevenueRunAmountSeriesData>;
  status?: Maybe<RevenueRunStatusSeriesData>;
};

export type RevenueRunStatus = {
  __typename?: 'RevenueRunStatus';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};

export type RevenueRunStatusSeries = {
  __typename?: 'RevenueRunStatusSeries';
  dataPoints?: Maybe<Array<Maybe<RevenueRunStatusSeriesDataPoint>>>;
};

export type RevenueRunStatusSeriesData = {
  __typename?: 'RevenueRunStatusSeriesData';
  series?: Maybe<RevenueRunStatusSeries>;
};

export type RevenueRunStatusSeriesDataPoint = {
  __typename?: 'RevenueRunStatusSeriesDataPoint';
  /** @deprecated Use asOfDate2 */
  asOfDate?: Maybe<Scalars['Date']>;
  asOfDate2?: Maybe<Scalars['Date2']>;
  /** @deprecated Use date2 */
  date?: Maybe<Scalars['Date']>;
  date2?: Maybe<Scalars['Date2']>;
  inProgressBatchUri?: Maybe<Scalars['String']>;
  period?: Maybe<DataPointPeriod>;
  revenueRunId?: Maybe<Scalars['String']>;
  status?: Maybe<RevenueRunStatus>;
};

export type Role = {
  __typename?: 'Role';
  billingScheduleEntries?: Maybe<Array<Maybe<RateScheduleEntry>>>;
  costScheduleEntries?: Maybe<Array<Maybe<RateScheduleEntry>>>;
  currentRate?: Maybe<Money>;
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  skills?: Maybe<Array<Maybe<Skill>>>;
  uri?: Maybe<Scalars['String']>;
};


export type RoleCurrentRateArgs = {
  targetCurrencyId?: InputMaybe<Scalars['String']>;
};

export type RoleInput = {
  isPrimary: Scalars['Boolean'];
  uri: Scalars['String'];
};

export type RoleScheduleAsOfDateResponse = {
  __typename?: 'RoleScheduleAsOfDateResponse';
  effectiveRoleSchedule?: Maybe<UserProjectRoleSchedule>;
};

export type RoleScheduleInput = {
  effectiveDate?: InputMaybe<Scalars['Date']>;
  projectRoles: Array<RoleInput>;
};

export type RoleSkillInput = {
  skillLevelUri?: InputMaybe<Scalars['String']>;
  skillUri?: InputMaybe<Scalars['String']>;
};

export type RoleSynchronizeInput = {
  roleUri?: InputMaybe<Scalars['String']>;
};

export type RoleSynchronizeResult = {
  __typename?: 'RoleSynchronizeResult';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type RolledUpProjectCostSummary = {
  __typename?: 'RolledUpProjectCostSummary';
  actualCostInProjectCurrency?: Maybe<Money>;
  budgetedCostInProjectCurrency?: Maybe<Money>;
  expensesRemainingInProjectCurrency?: Maybe<Money>;
  totalEstimatedAtCompletionCostInProjectCurrency?: Maybe<Money>;
  totalEstimatedExpensesInProjectCurrency?: Maybe<Money>;
  totalEstimatedRemainingCostInProjectCurrency?: Maybe<Money>;
  totalExpensesInProjectCurrency?: Maybe<Money>;
  totalProjectTasksEstimatedAtCompletionCostInProjectCurrency?: Maybe<Money>;
};

export type RolledUpProjectTimeEnteredSummary = {
  __typename?: 'RolledUpProjectTimeEnteredSummary';
  actualHours?: Maybe<Scalars['Float']>;
  earliestTimeEntryDate?: Maybe<Scalars['Date2']>;
  estimatedCompletionDate?: Maybe<Scalars['Date2']>;
  id?: Maybe<Scalars['String']>;
  totalEstimatedAtCompletionHours?: Maybe<Scalars['Float']>;
  totalEstimatedRemainingHours?: Maybe<Scalars['Float']>;
  totalProjectTasksEstimatedAtCompletionHours?: Maybe<Scalars['Float']>;
};

export type RolledUpTaskCostSummary = {
  __typename?: 'RolledUpTaskCostSummary';
  actualCostInProjectCurrency?: Maybe<Money>;
  id: Scalars['String'];
  initialEstimatedCostInProjectCurrency?: Maybe<Money>;
  totalEstimatedAtCompletionCostInProjectCurrency?: Maybe<Money>;
  totalEstimatedRemainingCostInProjectCurrency?: Maybe<Money>;
};

export type RolledUpTimeEnteredSummary = {
  __typename?: 'RolledUpTimeEnteredSummary';
  actualHours?: Maybe<Scalars['Float']>;
  earliestTimeEntryDate?: Maybe<Scalars['Date2']>;
  estimatedCompletionDate?: Maybe<Scalars['Date2']>;
  id?: Maybe<Scalars['String']>;
  totalEstimatedAtCompletionHours?: Maybe<Scalars['Float']>;
  totalEstimatedRemainingHours?: Maybe<Scalars['Float']>;
};

export enum Rows {
  Billableamount = 'billableamount',
  Billablehours = 'billablehours',
  Client = 'client',
  Costamount = 'costamount',
  Entrydate = 'entrydate',
  Expenseamount = 'expenseamount',
  Program = 'program',
  Projectname = 'projectname',
  Resourcecostamount = 'resourcecostamount',
  Task = 'task',
  Username = 'username'
}

export type ScheduleDurationByDayForUser = {
  __typename?: 'ScheduleDurationByDayForUser';
  scheduleDurationByDay: Array<Maybe<DurationDate>>;
  userId: Scalars['String'];
};

export type ScheduleDurationSeriesDataPoint = {
  __typename?: 'ScheduleDurationSeriesDataPoint';
  dateRange: DateRange;
  hours: Scalars['Float'];
};

export type ScheduleDurationSeriesForUser = {
  __typename?: 'ScheduleDurationSeriesForUser';
  scheduleDurationSeris: Array<ScheduleDurationSeriesDataPoint>;
  userId: Scalars['String'];
};

export type ScheduleRule = {
  __typename?: 'ScheduleRule';
  dateRange: DateRange;
  do: Scalars['ScheduleRuleDo'];
};

export type ScheduleRuleDo2 = {
  __typename?: 'ScheduleRuleDo2';
  excludeWeekdays: Array<WeekdaysAbbreviation>;
  load?: Maybe<Scalars['Float']>;
  setHours: Scalars['Float'];
};

export type ScheduleRuleDoInput = {
  excludeWeekdays: Array<WeekdaysAbbreviation>;
  load?: InputMaybe<Scalars['Float']>;
  setHours: Scalars['Float'];
};

export type ScheduleRuleInput = {
  dateRange: DateRangeInput;
  do: Scalars['ScheduleRuleDo'];
};

export type ScheduleRuleInput2 = {
  dateRange: DateRangeInput;
  do: ScheduleRuleDoInput;
};

export type ScheduledAndTotalHoursWorkedForDate = {
  __typename?: 'ScheduledAndTotalHoursWorkedForDate';
  date?: Maybe<Scalars['Date']>;
  scheduledHours?: Maybe<Scalars['Float']>;
  totalHoursWorked?: Maybe<Scalars['Float']>;
};

export enum ScoreComputeStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export enum ScoreComputeType {
  Cost = 'COST',
  Default = 'DEFAULT'
}

export type ScoreFilterInput = {
  operator: Operator;
  score: Scalars['Int'];
};

export type ScoreMetricFilterRange = {
  maxValue?: InputMaybe<Scalars['Int']>;
  minValue?: InputMaybe<Scalars['Int']>;
};

export type Script = {
  __typename?: 'Script';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type SearchSettings = {
  __typename?: 'SearchSettings';
  criterions?: Maybe<Scalars['SearchCriterionSettings']>;
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SearchSettingsInput = {
  criterions?: InputMaybe<Scalars['SearchCriterionSettings']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SelectedUser = {
  displayText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type SendBillEmailInput = {
  billId: Scalars['String'];
  notificationEmailInput: NotificationEmailInput;
};

export type SeriesObject = {
  __typename?: 'SeriesObject';
  outputPath?: Maybe<Scalars['String']>;
  result?: Maybe<BillingOverviewAmountSeries2>;
};

export type SetMyDefaultRequestAttributeWeightsResult = {
  __typename?: 'SetMyDefaultRequestAttributeWeightsResult';
  me?: Maybe<Me>;
};

export type SetOverriddenTaskStatusInput = {
  projectId: Scalars['String'];
  status?: InputMaybe<OverriddenTaskStatus>;
  taskId: Scalars['String'];
};

export type SetOverriddenTaskStatusResult = {
  __typename?: 'SetOverriddenTaskStatusResult';
  task?: Maybe<Task>;
};

export type SetTaskAssignedRoleInput = {
  roleId?: InputMaybe<Scalars['String']>;
  taskId: Scalars['String'];
};

export type SetTaskAssignedRoleResult = {
  __typename?: 'SetTaskAssignedRoleResult';
  dummy?: Maybe<Scalars['String']>;
};

export type SetTaskAssignedUserInput = {
  taskId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
  userRoleId?: InputMaybe<Scalars['String']>;
};

export type SetTaskAssignedUserResult = {
  __typename?: 'SetTaskAssignedUserResult';
  dummy?: Maybe<Scalars['String']>;
};

export type SetTaskProgressStatusInput = {
  effectiveTimestamp: Scalars['Date'];
  status: TaskProgressStatus;
  taskId: Scalars['String'];
};

export type SetTaskProgressStatusInput2 = {
  effectiveTimestamp: Scalars['DateTime'];
  status: TaskProgressStatus;
  taskId: Scalars['String'];
};

export type SetTaskProgressStatusResult = {
  __typename?: 'SetTaskProgressStatusResult';
  task: Task;
};

export type SetTaskStatusInput = {
  effectiveTimestamp: Scalars['Date'];
  status: Scalars['String'];
  taskId: Scalars['String'];
};

export type SetTaskStatusResult = {
  __typename?: 'SetTaskStatusResult';
  task: Task;
};

export type SetTaskTimeEntryDateRangeInput = {
  endDate?: InputMaybe<Scalars['Date']>;
  rescheduleTaskModificationOption?: InputMaybe<RescheduleTaskModificationOption>;
  shouldRollupTaskDates?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['Date']>;
  taskId: Scalars['String'];
};

export type SetTaskTimeEntryDateRangeResult = {
  __typename?: 'SetTaskTimeEntryDateRangeResult';
  dummy?: Maybe<Scalars['String']>;
};

export type Skill = {
  __typename?: 'Skill';
  category?: Maybe<Category>;
  certificate?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  displayText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  skillCustomMetadata?: Maybe<Array<Maybe<SkillCustomMetadata>>>;
  skillLevel?: Maybe<SkillLevel>;
  uri?: Maybe<Scalars['String']>;
};

export type SkillCategoryParameterError = {
  __typename?: 'SkillCategoryParameterError';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type SkillCustomMetadata = {
  __typename?: 'SkillCustomMetadata';
  /** @deprecated Use date2 */
  date?: Maybe<Scalars['Date']>;
  date2?: Maybe<Scalars['Date2']>;
  displayText?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Float']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type SkillCustomMetadataParameterError = {
  __typename?: 'SkillCustomMetadataParameterError';
  date?: Maybe<Scalars['Date2']>;
  displayText?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Float']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uri: Scalars['String'];
};

export type SkillDistributionForUsersSummary = {
  __typename?: 'SkillDistributionForUsersSummary';
  category?: Maybe<Category>;
  skill: Skill;
  userCount: Scalars['Int'];
};

export type SkillDistributionForUsersSummaryFilter = {
  costCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  employeeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  primaryRoles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resourcePools?: InputMaybe<Array<Scalars['String']>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  serviceCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tags?: InputMaybe<Array<TagFilterInput>>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type SkillInput = {
  certificate?: InputMaybe<Scalars['String']>;
  skillCustomMetadata: Array<CustomMetadataInput>;
  skillLevelUri: Scalars['String'];
  skillUri: Scalars['String'];
};

export type SkillLevel = {
  __typename?: 'SkillLevel';
  displayText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  uri?: Maybe<Scalars['String']>;
};

export type SkillParameter = {
  category: UserSkillCategoryInput;
  certificate?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  skillCustomMetadata: Array<CustomMetadataInput2>;
  skillLevelUri: Scalars['String'];
  skillUri?: InputMaybe<Scalars['String']>;
};

export type SkillParameterError = {
  __typename?: 'SkillParameterError';
  category: SkillCategoryParameterError;
  certificate?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  skillCustomMetadata: Array<SkillCustomMetadataParameterError>;
  skillLevelUri: Scalars['String'];
  skillUri?: Maybe<Scalars['String']>;
};

export type SkillReference = {
  __typename?: 'SkillReference';
  category: Category;
  displayText: Scalars['String'];
  uri: Scalars['String'];
};

export type SkillSetting = {
  __typename?: 'SkillSetting';
  displayText?: Maybe<Scalars['String']>;
  dropDownOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type SkillsMetaData = {
  __typename?: 'SkillsMetaData';
  matchingSkillsCount: Scalars['Int'];
  requestedSkillsCount: Scalars['Int'];
};

export enum SmartFitAllocationMode {
  Allocatefull = 'ALLOCATEFULL',
  Allocatewhatfits = 'ALLOCATEWHATFITS',
  Extendallocation = 'EXTENDALLOCATION',
  Redestributeallocation = 'REDESTRIBUTEALLOCATION'
}

export type SmartFitResourceAvailabilityHoursOptionsByTotalHoursAndDateRangeInput = {
  dateRange: DateRangeInput2;
  hoursPerPeriod: Scalars['Float'];
  periodType: AllocationPeriodType;
  userUri: Scalars['String'];
};

export type SmartFitResourceAvailabilityOption = {
  __typename?: 'SmartFitResourceAvailabilityOption';
  allocateFullHours: Scalars['Float'];
  allocateFullScheduleRules: Array<ScheduleRule>;
  availableHoursWhatFits: Scalars['Float'];
  availableScheduleRulesWhatFits: Array<ScheduleRule>;
  extendAllocationScheduleRules: Array<ScheduleRule>;
  extendedHours?: Maybe<Scalars['Float']>;
  redistributeAllocationScheduleRules: Array<ScheduleRule>;
  redistributeHours?: Maybe<Scalars['Float']>;
  requestedHours: Scalars['Float'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortSetting = {
  __typename?: 'SortSetting';
  customFieldUri?: Maybe<Scalars['String']>;
  direction: SortDirection;
  field: Scalars['String'];
};

export type SortSettingInput = {
  customFieldUri?: InputMaybe<Scalars['String']>;
  direction: SortDirection;
  field: Scalars['String'];
};

export type SourceMetadata = {
  __typename?: 'SourceMetadata';
  hiringStatus?: Maybe<HiringStatus>;
  sourcedFromAI: Scalars['Boolean'];
};

export type SourceMetadataInput = {
  hiringStatus?: InputMaybe<HiringStatus>;
  sourcedFromAI: Scalars['Boolean'];
};

export type SplitAndMigrateResourceRequestInput = {
  resourceRequestId: Scalars['String'];
};

export type SplitAndMigrateResourceRequestResult = {
  __typename?: 'SplitAndMigrateResourceRequestResult';
  splitResourceRequestIds?: Maybe<Array<Scalars['String']>>;
};

export type Subscription = {
  __typename?: 'Subscription';
  _?: Maybe<Scalars['String']>;
  notificationCreated?: Maybe<Notification>;
  pingPong?: Maybe<PongResponse>;
  projectSOWParsingCompleted?: Maybe<ProjectReference>;
  rescheduleProjectStarted?: Maybe<BackgroundJob>;
  resourceAllocationAdded: ResourceAllocation;
  resourceAllocationDeleted: DeletedResourceAllocation;
  resourceAllocationUpdated: ResourceAllocation;
  resourceRequestAdded: ResourceRequest;
  resourceRequestDeleted: DeletedResourceRequest;
  resourceRequestMatchingCompleted?: Maybe<ResourceRequestMatchingCompletedResult>;
  resourceRequestModified: ResourceRequest;
  resourceRequestSubmitted: ResourceRequest;
  resourceRequestUnsubmitted: ResourceRequest;
  resourceScoreComputed?: Maybe<ResourceScoreComputedSubsriptionResult>;
  resumeParsingProcessingCompleted?: Maybe<ResumeParsingProcessCompletedSubsriptionResult>;
  taskEntryAddedForManager?: Maybe<TaskEntry>;
  taskEntryAddedForOwner?: Maybe<TaskEntry>;
  taskEntryUpdatedForManager?: Maybe<TaskEntry>;
  taskEntryUpdatedForOwner?: Maybe<TaskEntry>;
};


export type SubscriptionPingPongArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type SubscriptionProjectSowParsingCompletedArgs = {
  userUri: Scalars['String'];
};


export type SubscriptionResourceRequestMatchingCompletedArgs = {
  filter?: InputMaybe<ResourceRequestMatchingCompletedFilter>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type SubscriptionResourceScoreComputedArgs = {
  resourceRequestId: Scalars['String'];
  scoreComputeType: ScoreComputeType;
};


export type SubscriptionResumeParsingProcessingCompletedArgs = {
  userUri: Scalars['String'];
};

export type SubstituteUserMetadata = {
  __typename?: 'SubstituteUserMetadata';
  actionHref?: Maybe<Scalars['String']>;
  actionText?: Maybe<Scalars['String']>;
  bannerText?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type SummaryItems = {
  __typename?: 'SummaryItems';
  allItems?: Maybe<Scalars['Int']>;
  inActive?: Maybe<Scalars['Int']>;
  myItems?: Maybe<Scalars['Int']>;
};

export type Supervisor = {
  __typename?: 'Supervisor';
  displayText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loginName?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type SupervisorAssignment = {
  __typename?: 'SupervisorAssignment';
  effectiveDate?: Maybe<Scalars['Date']>;
  supervisor?: Maybe<Supervisor>;
};

export type SyncBillsInput = {
  allSelected?: InputMaybe<Scalars['Boolean']>;
  excludeBillIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filter?: InputMaybe<BillingTransactionFilter>;
  includeBillIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SyncBillsOutput = {
  __typename?: 'SyncBillsOutput';
  completed?: Maybe<Scalars['Int']>;
  failed?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type TableSetting = {
  __typename?: 'TableSetting';
  columns: Array<Scalars['String']>;
  id: Scalars['String'];
  sort?: Maybe<SortSetting>;
};

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['String'];
  name: Scalars['String'];
  values?: Maybe<Array<Maybe<TagValue>>>;
};


export type TagValuesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type TagAssignment = {
  __typename?: 'TagAssignment';
  id: Scalars['String'];
  tag: Tag;
  value?: Maybe<TagValue>;
};

export type TagFilterInput = {
  keyUri?: InputMaybe<Scalars['String']>;
  valueUri?: InputMaybe<Scalars['String']>;
};

export type TagInput = {
  uri?: InputMaybe<Scalars['String']>;
};

export type TagValue = {
  __typename?: 'TagValue';
  id: Scalars['String'];
  tag: Tag;
  value: Scalars['String'];
};

export type TagsMetaData = {
  __typename?: 'TagsMetaData';
  matchingTagsCount: Scalars['Int'];
  requestedTagsCount: Scalars['Int'];
};

export type Task = {
  __typename?: 'Task';
  /** @deprecated Use field progressStatus */
  additionalData?: Maybe<EnhancedTaskData>;
  allocatedEntries?: Maybe<Array<Maybe<AllocatedTimeEntry>>>;
  ancestors?: Maybe<Array<Maybe<TaskAncestors>>>;
  assignedRole?: Maybe<Role>;
  assignedRoleUri?: Maybe<Scalars['String']>;
  assignedUser?: Maybe<User>;
  assignedUserRoleId?: Maybe<Scalars['String']>;
  assignedUserUri?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Maybe<Task>>>;
  /** @deprecated Use closedOnDate2 */
  closedOnDate?: Maybe<Scalars['Date']>;
  closedOnDate2?: Maybe<Scalars['Date2']>;
  code?: Maybe<Scalars['String']>;
  /** @deprecated Use completionDate2 */
  completionDate?: Maybe<Scalars['Date']>;
  /** @deprecated Will be dropping support for dynamodb task entries */
  completionDate2?: Maybe<Scalars['Date2']>;
  costTypeUri?: Maybe<Scalars['String']>;
  currentUserTaskEstimates?: Maybe<UserTaskEstimates>;
  customFields?: Maybe<Array<Maybe<CustomFieldValue>>>;
  description?: Maybe<Scalars['String']>;
  displayText?: Maybe<Scalars['String']>;
  /** @deprecated Use effectiveClosedOnDate2 */
  effectiveClosedOnDate?: Maybe<Scalars['Date']>;
  effectiveClosedOnDate2?: Maybe<Scalars['Date2']>;
  /** @deprecated Use effectiveStartDate2 */
  effectiveStartDate?: Maybe<Scalars['Date']>;
  effectiveStartDate2?: Maybe<Scalars['Date2']>;
  endDate?: Maybe<Scalars['Date']>;
  /** @deprecated Use estimatedCompletionDate2 */
  estimatedCompletionDate?: Maybe<Scalars['Date']>;
  estimatedCompletionDate2?: Maybe<Scalars['Date2']>;
  estimatedCompletionHours?: Maybe<Scalars['Float']>;
  extensionFieldValues?: Maybe<Array<Maybe<ExtensionFieldValue>>>;
  fullPath?: Maybe<Array<Maybe<TaskReference>>>;
  hasChildren: Scalars['Boolean'];
  id: Scalars['String'];
  initialEstimatedCost?: Maybe<Money>;
  initialEstimatedHours?: Maybe<Scalars['Float']>;
  isClosed?: Maybe<Scalars['Boolean']>;
  isClosedByTaskInheritance?: Maybe<Scalars['Boolean']>;
  isMilestone?: Maybe<Scalars['Boolean']>;
  isTimeEntryAllowed?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  overriddenTaskStatus?: Maybe<OverriddenTaskStatus>;
  parent?: Maybe<TaskReference>;
  /** @deprecated Will be dropping support for dynamodb task entries */
  pendingTaskEntryCount?: Maybe<Scalars['Int']>;
  /** @deprecated Use progressStatus2 */
  progressStatus?: Maybe<TaskProgressStatus>;
  progressStatus2?: Maybe<TaskProgressStatus>;
  project?: Maybe<Project>;
  projectReference?: Maybe<ProjectReference>;
  resourceAllocationSummary?: Maybe<TaskResourceAllocationSummary>;
  resourceAllocations?: Maybe<Array<TaskResourceAllocation>>;
  resourceEstimates?: Maybe<Array<TaskResourceEstimateDetails>>;
  resourceEstimatesSummary?: Maybe<ResourceEstimatesSummary>;
  rolledUpCostSummary?: Maybe<RolledUpTaskCostSummary>;
  rolledUpSummary?: Maybe<RolledUpTimeEnteredSummary>;
  slug?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  /** @deprecated Unsupported field */
  suggestedCompletionDate?: Maybe<Scalars['Date']>;
  /** @deprecated Unsupported field */
  suggestedCompletionDate2?: Maybe<Scalars['Date2']>;
  /** @deprecated Use taskEntries2 */
  taskEntries?: Maybe<Array<Maybe<TaskEntry>>>;
  taskEntries2?: Maybe<Array<Maybe<TaskEntry>>>;
  taskStatus?: Maybe<TaskStatus>;
  timeAndExpenseEntryType?: Maybe<TimeAndExpenseEntryType>;
  timesheetAccessAssignments?: Maybe<Array<Maybe<TimesheetAccessAssignment>>>;
  totalActualHours?: Maybe<Scalars['Float']>;
  /** @deprecated Use totalWorkToDate2 */
  totalWorkToDate?: Maybe<Scalars['Float']>;
  totalWorkToDate2?: Maybe<Scalars['Float']>;
  uri?: Maybe<Scalars['String']>;
  /** @deprecated Unsupported field */
  workRemainingToDate?: Maybe<Scalars['Float']>;
  /** @deprecated Unsupported field */
  workRemainingToDate2?: Maybe<Scalars['Float']>;
};


export type TaskAdditionalDataArgs = {
  effectiveTimestamp?: InputMaybe<Scalars['Date']>;
};


export type TaskAllocatedEntriesArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type TaskChildrenArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type TaskProgressStatusArgs = {
  effectiveTimestamp?: InputMaybe<Scalars['Date']>;
};


export type TaskProgressStatus2Args = {
  effectiveTimestamp?: InputMaybe<Scalars['Date2']>;
};


export type TaskResourceAllocationsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type TaskResourceEstimatesArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type TaskSuggestedCompletionDateArgs = {
  effectiveTimestamp?: InputMaybe<Scalars['Date']>;
};


export type TaskSuggestedCompletionDate2Args = {
  effectiveTimestamp?: InputMaybe<Scalars['DateTime']>;
};


export type TaskTaskEntriesArgs = {
  effectiveTimestamp?: InputMaybe<Scalars['Date']>;
};


export type TaskTaskEntries2Args = {
  effectiveTimestamp?: InputMaybe<Scalars['DateTime']>;
};


export type TaskTotalWorkToDateArgs = {
  effectiveTimestamp?: InputMaybe<Scalars['Date']>;
};


export type TaskTotalWorkToDate2Args = {
  effectiveTimestamp?: InputMaybe<Scalars['DateTime']>;
};


export type TaskWorkRemainingToDateArgs = {
  effectiveTimestamp?: InputMaybe<Scalars['Date']>;
};


export type TaskWorkRemainingToDate2Args = {
  effectiveTimestamp?: InputMaybe<Scalars['DateTime']>;
};

export type TaskAllocationForProjectEstimatedBilling = {
  __typename?: 'TaskAllocationForProjectEstimatedBilling';
  allocationId: Scalars['String'];
  id: Scalars['String'];
  roleId?: Maybe<Scalars['String']>;
  scheduleRules?: Maybe<Array<ScheduleRule>>;
  taskId: Scalars['String'];
  userId: Scalars['String'];
};

export type TaskAllocationsForProjectEstimatedBillingFilter = {
  dateRange: DateRangeInput2;
  userId?: InputMaybe<Scalars['String']>;
};

export type TaskAllocationsForProjectEstimatedBillingResult = {
  __typename?: 'TaskAllocationsForProjectEstimatedBillingResult';
  items: Array<TaskAllocationForProjectEstimatedBilling>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type TaskAncestors = Project | Task;

export enum TaskAssignmentBehaviorType {
  KeepAssignment = 'KEEP_ASSIGNMENT',
  ReleaseAssignment = 'RELEASE_ASSIGNMENT'
}

export enum TaskAssignmentBulkActionType {
  AssignTasks = 'ASSIGN_TASKS',
  UnassignTasks = 'UNASSIGN_TASKS'
}

export type TaskAssignmentSummaryForProjectAndResourceUser = {
  __typename?: 'TaskAssignmentSummaryForProjectAndResourceUser';
  resourceEstimate?: Maybe<TaskAssignmentSummaryResourceEstimate>;
  task: TaskAssignmentSummaryTask;
};

export type TaskAssignmentSummaryForProjectAndResourceUserFilter = {
  isOpen?: InputMaybe<Scalars['Boolean']>;
  textSearch?: InputMaybe<Scalars['String']>;
};

export type TaskAssignmentSummaryResourceEstimate = {
  __typename?: 'TaskAssignmentSummaryResourceEstimate';
  estimateId?: Maybe<Scalars['String']>;
  initialEstimatedCost?: Maybe<Money>;
  initialEstimatedHours?: Maybe<Scalars['Float']>;
  projectRole?: Maybe<ObjectReference>;
};

export type TaskAssignmentSummaryTask = {
  __typename?: 'TaskAssignmentSummaryTask';
  assignedRole?: Maybe<ObjectReference>;
  displayText: Scalars['String'];
  endDate?: Maybe<Scalars['Date2']>;
  estimatedHours?: Maybe<Scalars['Float']>;
  fullPath?: Maybe<Array<TaskReference>>;
  hasChildren: Scalars['Boolean'];
  id: Scalars['String'];
  isMilestone: Scalars['Boolean'];
  slug: Scalars['String'];
  startDate?: Maybe<Scalars['Date2']>;
  totalResourceEstimateHours?: Maybe<Scalars['Float']>;
};

export type TaskAssignmentsFilter = {
  includeClosedTasks?: InputMaybe<Scalars['Boolean']>;
};

export type TaskBurndownData = {
  __typename?: 'TaskBurndownData';
  date: Scalars['Date2'];
  estimatedCompletionDate?: Maybe<Scalars['Date2']>;
  estimatedHoursAtCompletion?: Maybe<Scalars['Float']>;
  estimatedRemainingHours?: Maybe<Scalars['Float']>;
  hoursWorked?: Maybe<Scalars['Float']>;
  totalHoursWorkedToDate?: Maybe<Scalars['Float']>;
};

export type TaskClosedDateInput = {
  date: Scalars['Date'];
  taskId: Scalars['String'];
};

export type TaskClosedDateResult = {
  __typename?: 'TaskClosedDateResult';
  task?: Maybe<Task>;
};

export enum TaskCopyOption {
  CopyTaskOnly = 'COPY_TASK_ONLY',
  CopyTaskResourceAssignments = 'COPY_TASK_RESOURCE_ASSIGNMENTS',
  CopyTaskWithAssignmentsAsPlaceholders = 'COPY_TASK_WITH_ASSIGNMENTS_AS_PLACEHOLDERS'
}

export type TaskDateUpdatesInput = {
  endDate: Scalars['Date2'];
  startDate: Scalars['Date2'];
  taskId: Scalars['String'];
};

export type TaskEntriesResponse = {
  __typename?: 'TaskEntriesResponse';
  nextPageCursor?: Maybe<Scalars['String']>;
  taskEntries?: Maybe<Array<Maybe<TaskEntry>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TaskEntry = {
  __typename?: 'TaskEntry';
  approvalStatus_timestamp?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  /** @deprecated Use entryDate2 */
  entryDate?: Maybe<Scalars['Date']>;
  entryDate2?: Maybe<Scalars['Date2']>;
  /** @deprecated Use estimatedCompletionDate2 */
  estimatedCompletionDate?: Maybe<Scalars['Date']>;
  estimatedCompletionDate2?: Maybe<Scalars['Date2']>;
  estimatedDataAsOfTimestamp?: Maybe<Scalars['DateTime']>;
  flagged?: Maybe<Scalars['Boolean']>;
  hoursRemaining?: Maybe<Scalars['Float']>;
  hoursWorked?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  override?: Maybe<TaskEntryOverride>;
  project?: Maybe<Project>;
  projectUri?: Maybe<Scalars['String']>;
  quality?: Maybe<Scalars['String']>;
  revisionGroupUri?: Maybe<Scalars['String']>;
  rowNumber?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  statusUpdatedDate?: Maybe<Scalars['String']>;
  /** @deprecated Use submittedTimestamp2 */
  submittedTimestamp?: Maybe<Scalars['Date']>;
  submittedTimestamp2?: Maybe<Scalars['DateTime']>;
  task?: Maybe<Task>;
  taskUri?: Maybe<Scalars['String']>;
  totalWorkToDate?: Maybe<Scalars['Float']>;
  user?: Maybe<User>;
  userUri?: Maybe<Scalars['String']>;
};

export enum TaskEntryApprovalStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING'
}

export type TaskEntryFilter2 = {
  endDate?: InputMaybe<Scalars['Date2']>;
  hasComment?: InputMaybe<Scalars['Boolean']>;
  projectUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  qualities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startDate?: InputMaybe<Scalars['Date2']>;
  taskUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text?: InputMaybe<Scalars['String']>;
  userUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TaskEntryInput2 = {
  comment?: InputMaybe<Scalars['String']>;
  entryDate: Scalars['Date2'];
  estimatedCompletionDate?: InputMaybe<Scalars['Date2']>;
  estimatedDataAsOfTimestamp?: InputMaybe<Scalars['DateTime']>;
  flagged?: InputMaybe<Scalars['Boolean']>;
  hoursRemaining?: InputMaybe<Scalars['Float']>;
  hoursWorked?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  projectUri?: InputMaybe<Scalars['String']>;
  quality?: InputMaybe<Scalars['String']>;
  revisionGroupUri?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  submittedTimestamp?: InputMaybe<Scalars['DateTime']>;
  taskUri: Scalars['String'];
  userUri?: InputMaybe<Scalars['String']>;
};

export type TaskEntryOverride = {
  __typename?: 'TaskEntryOverride';
  comment?: Maybe<Scalars['String']>;
  /** @deprecated Use estimatedCompletionDate2 */
  estimatedCompletionDate?: Maybe<Scalars['Date']>;
  estimatedCompletionDate2?: Maybe<Scalars['Date2']>;
  flagged?: Maybe<Scalars['Boolean']>;
  hoursRemaining?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  quality?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  /** @deprecated Use submittedTimestamp2 */
  submittedTimestamp?: Maybe<Scalars['Date']>;
  submittedTimestamp2?: Maybe<Scalars['DateTime']>;
  taskEntryId: Scalars['String'];
  taskUri?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userUri?: Maybe<Scalars['String']>;
};

export type TaskEntryPayload = {
  __typename?: 'TaskEntryPayload';
  errors?: Maybe<Array<Maybe<ErrorWithMessage>>>;
  taskEntry?: Maybe<TaskEntry>;
};

export type TaskEntryProgress = {
  __typename?: 'TaskEntryProgress';
  actualHoursToDate?: Maybe<Scalars['Float']>;
  calculatedEstimatedCompletionDate?: Maybe<Scalars['Date2']>;
  calculatedHoursRemaining?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  initialEstimate?: Maybe<Scalars['Float']>;
};

export type TaskEntrySort = {
  direction: SortDirection;
  field: TaskEntrySortableField;
};

export enum TaskEntrySortableField {
  EntryDate = 'entryDate',
  TaskName = 'taskName',
  UserName = 'userName'
}

export type TaskFilter = {
  hasActualHours?: InputMaybe<Scalars['Boolean']>;
  isMilestone?: InputMaybe<Scalars['Boolean']>;
  isOpen?: InputMaybe<Scalars['Boolean']>;
  projectUri?: InputMaybe<Scalars['String']>;
  textSearch?: InputMaybe<Scalars['String']>;
};

export enum TaskProgressStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type TaskReference = {
  __typename?: 'TaskReference';
  code?: Maybe<Scalars['String']>;
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  task?: Maybe<Task>;
  uri?: Maybe<Scalars['String']>;
};

export type TaskReferenceInput = {
  displayText?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type TaskResourceAllocation = {
  __typename?: 'TaskResourceAllocation';
  allocatedHours?: Maybe<Scalars['Float']>;
  resource: UserReference;
};

export type TaskResourceAllocationInput = {
  allocatedHours?: InputMaybe<Scalars['Float']>;
  resourceId: Scalars['String'];
};

export type TaskResourceAllocationSummary = {
  __typename?: 'TaskResourceAllocationSummary';
  count: Scalars['Int'];
  totalAllocatedHours?: Maybe<Scalars['Float']>;
};

export type TaskResourceEstimateDetails = {
  __typename?: 'TaskResourceEstimateDetails';
  id: Scalars['String'];
  initialEstimatedCost?: Maybe<Money>;
  initialEstimatedHours?: Maybe<Scalars['Float']>;
  projectRole?: Maybe<ObjectReference>;
  resourceUser?: Maybe<UserReference>;
  taskId: Scalars['String'];
  taskResourceEstimateId?: Maybe<Scalars['String']>;
  taskResourceUserAllocation?: Maybe<TaskResourceUserAllocation>;
  taskResourceUserCostProgressSummary?: Maybe<TaskResourceUserCostProgressSummary>;
  taskResourceUserHoursProgressSummary?: Maybe<TaskResourceUserHoursProgressSummary>;
};

export type TaskResourceUserAllocation = {
  __typename?: 'TaskResourceUserAllocation';
  allocationUserUri: Scalars['String'];
  endDate: Scalars['Date2'];
  id: Scalars['String'];
  projectUri: Scalars['String'];
  resourceAllocationUri?: Maybe<Scalars['String']>;
  roleUri?: Maybe<Scalars['String']>;
  scheduleRules: Array<ScheduleRule>;
  startDate: Scalars['Date2'];
  taskResourceEstimateUri?: Maybe<Scalars['String']>;
  taskUri: Scalars['String'];
  totalHours?: Maybe<Scalars['Float']>;
};

export enum TaskResourceUserAllocationEditMode {
  Full = 'FULL',
  Partial = 'PARTIAL'
}

export type TaskResourceUserAllocationsFilter = {
  taskUri?: InputMaybe<Scalars['String']>;
};

export type TaskResourceUserAllocationsForUserFilter = {
  projectUri: Scalars['String'];
  taskUris: Array<Scalars['String']>;
  userUri: Scalars['String'];
};

export type TaskResourceUserAllocationsSummaryForUser = {
  __typename?: 'TaskResourceUserAllocationsSummaryForUser';
  endDate: Scalars['Date2'];
  scheduleRules: Array<ScheduleRule>;
  startDate: Scalars['Date2'];
  totalHours: Scalars['Float'];
  userId: Scalars['String'];
};

export type TaskResourceUserAllocationsSummaryForUserFilter = {
  dateRange?: InputMaybe<DateRangeInput2>;
  excludeTaskAllocationId?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
};

export type TaskResourceUserCostProgressSummary = {
  __typename?: 'TaskResourceUserCostProgressSummary';
  actualCost?: Maybe<Money>;
  estimatedAtCompletionCost?: Maybe<Money>;
  estimatedRemainingCost?: Maybe<Money>;
  resourceUser: UserReference;
};

export type TaskResourceUserHoursProgressSummary = {
  __typename?: 'TaskResourceUserHoursProgressSummary';
  actualHours?: Maybe<Scalars['Float']>;
  estimatedAtCompletionHours?: Maybe<Scalars['Float']>;
  estimatedRemainingHours?: Maybe<Scalars['Float']>;
  resourceUser: UserReference;
};

export enum TaskStatus {
  Completed = 'COMPLETED',
  Inprogress = 'INPROGRESS',
  Notstarted = 'NOTSTARTED'
}

export type TaskSynchronizeInput = {
  taskUri: Scalars['String'];
};

export type TaskSynchronizeResult = {
  __typename?: 'TaskSynchronizeResult';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum TaskTimeAndExpenseEntryType {
  Billable = 'BILLABLE',
  BillableAndNonBillable = 'BILLABLE_AND_NON_BILLABLE',
  NonBillable = 'NON_BILLABLE'
}

export type TaskTimesheetAccessInput = {
  allUsers?: InputMaybe<Scalars['String']>;
  costCenterUris?: InputMaybe<Array<Scalars['String']>>;
  departmentGroupUris?: InputMaybe<Array<Scalars['String']>>;
  divisionUris?: InputMaybe<Array<Scalars['String']>>;
  employeeTypeGroupUris?: InputMaybe<Array<Scalars['String']>>;
  locationUris?: InputMaybe<Array<Scalars['String']>>;
  serviceCenterUris?: InputMaybe<Array<Scalars['String']>>;
};

export type TasksStatusCountSummary = {
  __typename?: 'TasksStatusCountSummary';
  completedTasksCount: Scalars['Int'];
  inProgressTasksCount: Scalars['Int'];
  notStartedTasksCount: Scalars['Int'];
};

export enum TasksToReschedule {
  AllTasks = 'allTasks',
  InProgress = 'inProgress',
  NotStarted = 'notStarted'
}

export type TaxProfile = {
  __typename?: 'TaxProfile';
  description?: Maybe<Scalars['String']>;
  displayText?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
};

export type TaxRatesForTaxProfile = {
  __typename?: 'TaxRatesForTaxProfile';
  effectiveDate2?: Maybe<Scalars['Date2']>;
  endDate2?: Maybe<Scalars['Date2']>;
  taxRateKeyValues?: Maybe<Array<Maybe<Scalars['TaxRateKeyValue']>>>;
};

export type TeamMember = {
  groupType?: InputMaybe<TeamMemberGroup>;
  id?: InputMaybe<Scalars['String']>;
};

export enum TeamMemberGroup {
  AllUsers = 'allUsers',
  CostCenters = 'costCenters',
  Departments = 'departments',
  Divisions = 'divisions',
  EmployeeTypes = 'employeeTypes',
  Locations = 'locations',
  Resources = 'resources',
  ServiceCenters = 'serviceCenters'
}

export enum TenantType {
  Production = 'PRODUCTION',
  Sandbox = 'SANDBOX',
  Trial = 'TRIAL'
}

export type TimeAndExpenseEntry = {
  __typename?: 'TimeAndExpenseEntry';
  displayText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
};

export type TimeAndExpenseEntryInput = {
  displayText?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type TimeAndExpenseEntryType = {
  __typename?: 'TimeAndExpenseEntryType';
  displayText?: Maybe<Scalars['String']>;
  /** @deprecated Use uri2 */
  uri?: Maybe<Scalars['String']>;
  uri2?: Maybe<TaskTimeAndExpenseEntryType>;
};

export type TimeAndExpenseInput2 = {
  billingFilter: BillingFilter;
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  groupings?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  rows?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type TimeAndExpenseSettings = {
  __typename?: 'TimeAndExpenseSettings';
  columns?: Maybe<Array<Maybe<Scalars['String']>>>;
  groupings?: Maybe<Array<Maybe<Scalars['String']>>>;
  projectTimeAndExpenseDateRange?: Maybe<DateRange>;
  rows?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type TimeAndExpenseSettingsInput = {
  columns?: InputMaybe<Array<InputMaybe<Columns>>>;
  groupings?: InputMaybe<Array<InputMaybe<Groupings>>>;
  id: Scalars['String'];
  rows?: InputMaybe<Array<InputMaybe<Rows>>>;
};

export type TimeEnteredSummary = {
  __typename?: 'TimeEnteredSummary';
  timeEnteredActual?: Maybe<Scalars['Float']>;
  timeEnteredAllocatedResourceActual?: Maybe<Scalars['Float']>;
  timeEnteredEstimatedToDate?: Maybe<Scalars['Float']>;
  timeEnteredTaskActual?: Maybe<Scalars['Float']>;
  timeEnteredTaskEstimatedAtCompletion?: Maybe<Scalars['Float']>;
  timeEnteredTotalEstimated?: Maybe<Scalars['Float']>;
};

export type TimeEntryCustomMetadataInput = {
  key: TimeEntryMetadataKey;
  value: TimeEntryCustomMetadataValueInput;
};

export type TimeEntryCustomMetadataValueInput = {
  bool?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Scalars['String']>;
};

export enum TimeEntryMetadataKey {
  BillingRate = 'BILLING_RATE',
  IsBillable = 'IS_BILLABLE',
  Project = 'PROJECT',
  Task = 'TASK'
}

export type TimeEntryRevisionGroup = {
  __typename?: 'TimeEntryRevisionGroup';
  entryDate: Scalars['Date2'];
  hours: Scalars['Float'];
  id: Scalars['String'];
  project: ObjectReference;
  task?: Maybe<ObjectReference>;
  user: ObjectReference;
};

export type TimeEntryRevisionGroupBulkModificationBatchInput = {
  filter: TimeEntryRevisionGroupBulkModificationFilter;
  modifications: TimeEntryRevisionGroupModification;
};

export type TimeEntryRevisionGroupBulkModificationBatchResults = {
  __typename?: 'TimeEntryRevisionGroupBulkModificationBatchResults';
  errors?: Maybe<Array<Maybe<TimeEntryRevisionGroupBulkModificationError>>>;
  modified?: Maybe<Array<Scalars['String']>>;
};

export type TimeEntryRevisionGroupBulkModificationError = {
  __typename?: 'TimeEntryRevisionGroupBulkModificationError';
  message?: Maybe<Scalars['String']>;
  timeEntryRevisionGroupId?: Maybe<Scalars['String']>;
};

export type TimeEntryRevisionGroupBulkModificationFilter = {
  costCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateRange?: InputMaybe<OpenDateRangeInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  employeeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  projectId: Scalars['String'];
  serviceCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  taskId?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TimeEntryRevisionGroupFilter = {
  costCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateRange?: InputMaybe<OpenDateRangeInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  employeeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  serviceCenters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  taskId?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TimeEntryRevisionGroupModification = {
  customMetadataKeysToRemove?: InputMaybe<Array<TimeEntryMetadataKey>>;
  customMetadataToAddOrUpdate?: InputMaybe<Array<TimeEntryCustomMetadataInput>>;
};

export type TimeEntryRevisionGroupTotals = {
  __typename?: 'TimeEntryRevisionGroupTotals';
  totalHours?: Maybe<Scalars['Float']>;
};

export type TimeOffBalance = {
  __typename?: 'TimeOffBalance';
  days?: Maybe<Scalars['Float']>;
  displayFormat?: Maybe<TimeOffDisplayFormat>;
  hours?: Maybe<Scalars['Float']>;
  timeOffType?: Maybe<TimeOffType>;
  trackingOption?: Maybe<TimeOffBalanceTrackingOption>;
};

export enum TimeOffBalanceTrackingOption {
  Donottrackbalance = 'DONOTTRACKBALANCE',
  Tracktimeremaining = 'TRACKTIMEREMAINING',
  Tracktimeremainingforperiod = 'TRACKTIMEREMAININGFORPERIOD',
  Tracktimetaken = 'TRACKTIMETAKEN'
}

export type TimeOffBooking = {
  __typename?: 'TimeOffBooking';
  endDate2?: Maybe<Scalars['Date2']>;
  id?: Maybe<Scalars['String']>;
  startDate2?: Maybe<Scalars['Date2']>;
  timeOffStatus?: Maybe<TimeOffStatus>;
  timeOffType?: Maybe<TimeOffType>;
};

export enum TimeOffDisplayFormat {
  Days = 'DAYS',
  Hours = 'HOURS'
}

export type TimeOffEntryByDay = {
  __typename?: 'TimeOffEntryByDay';
  date: Scalars['Date'];
  days?: Maybe<Scalars['Float']>;
  hours: Scalars['Float'];
};

export type TimeOffInfo = {
  __typename?: 'TimeOffInfo';
  bookTimeOffUrl?: Maybe<Scalars['String']>;
  timeOffBalances2?: Maybe<Array<TimeOffBalance>>;
  timeOffBookings2?: Maybe<Array<TimeOffBooking>>;
  viewTimeOffBalanceUrl?: Maybe<Scalars['String']>;
};


export type TimeOffInfoTimeOffBalances2Args = {
  effectiveDate: Scalars['Date2'];
};


export type TimeOffInfoTimeOffBookings2Args = {
  effectiveDate: Scalars['Date2'];
};

export enum TimeOffMeasurementUnitType {
  Days = 'DAYS',
  Hours = 'HOURS'
}

export type TimeOffStatus = {
  __typename?: 'TimeOffStatus';
  displayText?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type TimeOffType = {
  __typename?: 'TimeOffType';
  displayText: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  uri: Scalars['String'];
};

export type TimeZone = {
  __typename?: 'TimeZone';
  displayText?: Maybe<Scalars['String']>;
  ianaName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  offsetDisplayText?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type Timeoff = {
  __typename?: 'Timeoff';
  dateRange: DateRange;
  days?: Maybe<Scalars['Float']>;
  entries?: Maybe<Array<Maybe<TimeOffEntryByDay>>>;
  hours?: Maybe<Scalars['Float']>;
  timeOffType?: Maybe<TimeOffType>;
  units?: Maybe<TimeOffMeasurementUnitType>;
};

export type TimeoutDuration = {
  __typename?: 'TimeoutDuration';
  days?: Maybe<Scalars['Int']>;
  hours?: Maybe<Scalars['Int']>;
  milliseconds?: Maybe<Scalars['Int']>;
  minutes?: Maybe<Scalars['Int']>;
  seconds?: Maybe<Scalars['Int']>;
};

export type TimesheetAccessAssignment = {
  __typename?: 'TimesheetAccessAssignment';
  displayText: Scalars['String'];
  group: TimesheetAccessGroup;
  id: Scalars['String'];
};

export type TimesheetAccessGroup = {
  __typename?: 'TimesheetAccessGroup';
  displayText: Scalars['String'];
  id: Scalars['String'];
};

export type TimesheetCountForStatus = {
  __typename?: 'TimesheetCountForStatus';
  count: Scalars['Int'];
  statusSlug?: Maybe<Scalars['String']>;
  webDeepLinkUrl?: Maybe<Scalars['String']>;
};

export type TimesheetDetails = {
  __typename?: 'TimesheetDetails';
  dateRange?: Maybe<DateRange>;
  dueDate2?: Maybe<Scalars['Date2']>;
  id?: Maybe<Scalars['String']>;
  isBeatsEntrySupported: Scalars['Boolean'];
  statusUri?: Maybe<Scalars['String']>;
  webDeepLinkUrl?: Maybe<Scalars['String']>;
};

export type TimesheetPeriod = {
  __typename?: 'TimesheetPeriod';
  endDate?: Maybe<Scalars['DateObject']>;
  startDate?: Maybe<Scalars['DateObject']>;
};

export type TotalScoreFilterRange = {
  maxValue?: InputMaybe<Scalars['Float']>;
  minValue?: InputMaybe<Scalars['Float']>;
};

export type TransactionNextReferenceNumberSetting = {
  __typename?: 'TransactionNextReferenceNumberSetting';
  isAllowEditAutoGeneratedNumber?: Maybe<Scalars['Boolean']>;
  isAutoGeneratedReferenceNumber?: Maybe<Scalars['Boolean']>;
};

export type TransactionPolicyValue = {
  __typename?: 'TransactionPolicyValue';
  bill?: Maybe<ReferenceNumberSetting>;
  creditMemo?: Maybe<ReferenceNumberSetting>;
  payment?: Maybe<ReferenceNumberSetting>;
};

export type TransactionReferenceNumberSetting = {
  __typename?: 'TransactionReferenceNumberSetting';
  displayText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  policyValues?: Maybe<TransactionPolicyValue>;
};

export type UnassignTasksFromResourceUserInput = {
  projectId: Scalars['String'];
  resourceUserId: Scalars['String'];
  taskIds: Array<Scalars['String']>;
};

export type UpdateBillStatusBatchParameter = {
  billStatus: BillStatus;
  syncBillsInput: SyncBillsInput;
};

export type UpdateBillStatusBatchResult = {
  __typename?: 'UpdateBillStatusBatchResult';
  batchUri: Scalars['String'];
};

export type UpdateClientBasicInfoInput = {
  clientManagerUri?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  comanagerUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  comment?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  invoiceCurrencyUri?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateClientBasicInfoResponse = {
  __typename?: 'UpdateClientBasicInfoResponse';
  client?: Maybe<Client>;
};

export type UpdateClientBillingInfoInput = {
  billFrequency?: InputMaybe<BillingFrequency>;
  billFrequencyAbsoluteDate?: InputMaybe<Scalars['Date2']>;
  billFrequencyRelativeDate?: InputMaybe<Scalars['Date2']>;
  billLineItemsBy?: InputMaybe<Array<InputMaybe<LineItemColumnOptions>>>;
  consolidateBillsBy?: InputMaybe<ConsolidateBillsBy>;
  defaultInvoicePaymentTerm?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  internalNotes?: InputMaybe<Scalars['String']>;
  invoiceCurrencyUri?: InputMaybe<Scalars['String']>;
  invoiceTemplateUri?: InputMaybe<Scalars['String']>;
  showComments?: InputMaybe<Scalars['Boolean']>;
  taxProfileUri?: InputMaybe<Scalars['String']>;
};

export type UpdateClientBillingInfoResponse = {
  __typename?: 'UpdateClientBillingInfoResponse';
  client?: Maybe<Client>;
};

export type UpdateClientInput = {
  billingContactInfo?: InputMaybe<ContactInfoInput>;
  clientManagerUri?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  contactInfo?: InputMaybe<ContactInfoInput>;
  contactName?: InputMaybe<Scalars['String']>;
  customFieldValues?: InputMaybe<Array<InputMaybe<Scalars['CustomFieldValueInput']>>>;
  id: Scalars['String'];
  invoiceCurrencyUri?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateClientRepresentativesInput = {
  clientRepresentativeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id: Scalars['String'];
};

export type UpdateClientRepresentativesResponse = {
  __typename?: 'UpdateClientRepresentativesResponse';
  client?: Maybe<Client>;
};

export type UpdateClientStatusInput = {
  clientId: Scalars['String'];
  status: Scalars['Boolean'];
};

export type UpdateClientStatusResult = {
  __typename?: 'UpdateClientStatusResult';
  status: Scalars['Boolean'];
};

export type UpdateCurrencyForBillInput = {
  billId: Scalars['String'];
  currencyId: Scalars['String'];
};

export type UpdateCurrencyForBillResult = {
  __typename?: 'UpdateCurrencyForBillResult';
  batchUri: Scalars['String'];
};

export type UpdateCustomFieldResult = {
  __typename?: 'UpdateCustomFieldResult';
  customFieldValues?: Maybe<Array<Maybe<CustomFieldValue>>>;
};

export type UpdateEstimatedCostOverrideInput = {
  estimatedCostOverride?: InputMaybe<MoneyInput>;
  projectRequestId: Scalars['String'];
};

export type UpdateEstimatedCostOverrideResult = {
  __typename?: 'UpdateEstimatedCostOverrideResult';
  projectRequestId: Scalars['String'];
};

export type UpdateLocaleResult = {
  __typename?: 'UpdateLocaleResult';
  resourceLocale: ResourceLocaleDetails;
};

export type UpdateProgramInput = {
  budget?: InputMaybe<BudgetInput>;
  endDate?: InputMaybe<Scalars['DateObject']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  programManagerReference?: InputMaybe<ProgramManagerReferenceInput>;
  startDate?: InputMaybe<Scalars['DateObject']>;
};

export type UpdateProgramStatusInput = {
  programId: Scalars['String'];
  status: Scalars['Boolean'];
};

export type UpdateProgramStatusResult = {
  __typename?: 'UpdateProgramStatusResult';
  status: Scalars['Boolean'];
};

export type UpdateProjectAddressesInput = {
  addresses: Array<AddressInput>;
  projectId: Scalars['String'];
};

export type UpdateProjectAddressesResponse = {
  __typename?: 'UpdateProjectAddressesResponse';
  project?: Maybe<Project>;
};

export type UpdateProjectBillingSettingInput = {
  billLineItemsBy?: InputMaybe<Array<InputMaybe<LineItemColumnOptions>>>;
  defaultInvoicePaymentTerm?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  internalNotes?: InputMaybe<Scalars['String']>;
  invoiceCurrencyUri?: InputMaybe<Scalars['String']>;
  invoiceTemplateUri?: InputMaybe<Scalars['String']>;
  poNumber?: InputMaybe<Scalars['String']>;
  showComments?: InputMaybe<Scalars['Boolean']>;
  taxProfileUri?: InputMaybe<Scalars['String']>;
};

export type UpdateProjectBillingSettingResponse = {
  __typename?: 'UpdateProjectBillingSettingResponse';
  project?: Maybe<Project>;
};

export type UpdateProjectContactInfoInput = {
  contacts: Array<ContactInput>;
  projectId: Scalars['String'];
};

export type UpdateProjectContactInfoResponse = {
  __typename?: 'UpdateProjectContactInfoResponse';
  project?: Maybe<Project>;
};

export type UpdateProjectRequestAssignmentResultEntry = {
  __typename?: 'UpdateProjectRequestAssignmentResultEntry';
  assignmentUri: Scalars['String'];
  parameterCorrelationId: Scalars['String'];
};

export type UpdateProjectRequestGatesResult = {
  __typename?: 'UpdateProjectRequestGatesResult';
  projectRequestId: Scalars['String'];
};

export type UpdateProjectRequestStatusInput = {
  id: Scalars['String'];
  type: ProjectRequestStatusType;
};

export type UpdateProjectRequestStatusResult = {
  __typename?: 'UpdateProjectRequestStatusResult';
  projectRequestUri: Scalars['String'];
};

export type UpdateResourceAllocationInput = {
  allocationHoursInDateRange?: InputMaybe<AllocationHoursInDateRangeInput>;
  allocationUpdateBehaviour?: InputMaybe<AllocationUpdateBehaviour>;
  comment?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isAdjustedLoading?: InputMaybe<Scalars['Boolean']>;
  load?: InputMaybe<Scalars['Float']>;
  requestedRoleUri?: InputMaybe<Scalars['String']>;
  scheduleRules?: InputMaybe<Array<ScheduleRuleInput>>;
  totalHours?: InputMaybe<Scalars['Float']>;
  user: ResourceAllocationUserInput;
};

export type UpdateResourceAllocationResult = {
  __typename?: 'UpdateResourceAllocationResult';
  resourceAllocation: ResourceAllocation;
};

export type UpdateResourceAllocationRoleInput = {
  allocationId: Scalars['String'];
  requestedRoleId?: InputMaybe<Scalars['String']>;
};

export type UpdateResourceAllocationRoleResult = {
  __typename?: 'UpdateResourceAllocationRoleResult';
  resourceAllocation: ResourceAllocation;
};

export type UpdateResourceRequestInput = {
  comment?: InputMaybe<Scalars['String']>;
  costCenterUri?: InputMaybe<Scalars['String']>;
  currencyUri?: InputMaybe<Scalars['String']>;
  departmentUri?: InputMaybe<Scalars['String']>;
  divisionUri?: InputMaybe<Scalars['String']>;
  employeeTypeUri?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isAdjustedLoading?: InputMaybe<Scalars['Boolean']>;
  load?: InputMaybe<Scalars['Float']>;
  locationUri?: InputMaybe<Scalars['String']>;
  preferredResourceUris?: InputMaybe<Array<Scalars['String']>>;
  projectUri?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requestAttributeWeights?: InputMaybe<RequestAttributeWeightsInput>;
  resourcePoolUris?: InputMaybe<Array<Scalars['String']>>;
  roleRate?: InputMaybe<Scalars['Float']>;
  roleUri?: InputMaybe<Scalars['String']>;
  scheduleRules?: InputMaybe<Array<ScheduleRuleInput>>;
  serviceCenterUri?: InputMaybe<Scalars['String']>;
  skills?: InputMaybe<Array<InputMaybe<RequestSkillInput>>>;
  tags?: InputMaybe<Array<InputMaybe<RequestTagInput>>>;
  totalHours?: InputMaybe<Scalars['Float']>;
};

export type UpdateResourceRequestResult = {
  __typename?: 'UpdateResourceRequestResult';
  resourceRequest: ResourceRequest;
};

export type UpdateResumeInput = {
  resume: ResumeInput;
  userUri: Scalars['String'];
};

export type UpdateResumeResult = {
  __typename?: 'UpdateResumeResult';
  resume: ResumeLink;
  userUri: Scalars['String'];
};

export type UpdateRoleSchedulesResult = {
  __typename?: 'UpdateRoleSchedulesResult';
  roleSchedules: Array<Maybe<UserProjectRoleSchedule>>;
};

export type UpdateRolesResult = {
  __typename?: 'UpdateRolesResult';
  roles: Array<Maybe<UserProjectRole>>;
};

export type UpdateScoreOverrideTotalInput = {
  id: Scalars['String'];
  overrideTotal?: InputMaybe<Scalars['Float']>;
};

export type UpdateSkillsResult = {
  __typename?: 'UpdateSkillsResult';
  skills?: Maybe<Array<Maybe<ResourceSkillDetails>>>;
};

export type UpdateStatusInput = {
  id: Scalars['String'];
  status: PortfolioStatus;
};

export type UpdateStatusResult = {
  __typename?: 'UpdateStatusResult';
  status?: Maybe<PortfolioStatus>;
};

export type UpdateTaskInput = {
  assignedRoleUri?: InputMaybe<Scalars['String']>;
  assignedTimesheetAccessUris?: InputMaybe<TaskTimesheetAccessInput>;
  assignedUserRoleId?: InputMaybe<Scalars['String']>;
  assignedUserUri?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  costTypeUri?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<Array<InputMaybe<Scalars['CustomFieldValueInput']>>>;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date2']>;
  extensionFieldValues?: InputMaybe<Array<InputMaybe<ExtensionFieldValueInput>>>;
  initialEstimatedCost?: InputMaybe<MoneyInput>;
  initialEstimatedHours?: InputMaybe<Scalars['Float']>;
  isMilestone?: InputMaybe<Scalars['Boolean']>;
  isTimeEntryAllowed?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  resourceAllocationsToAdd?: InputMaybe<Array<TaskResourceAllocationInput>>;
  resourceAllocationsToRemove?: InputMaybe<Array<TaskResourceAllocationInput>>;
  shouldRollupTaskDates?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['Date2']>;
  taskUri: Scalars['String'];
  timeAndExpenseEntryType?: InputMaybe<TaskTimeAndExpenseEntryType>;
  unAssignedTimesheetAccessUris?: InputMaybe<TaskTimesheetAccessInput>;
};

export type UpdateTaskResourceAllocationsInput = {
  resourceAllocations: Array<TaskResourceAllocationInput>;
  taskId: Scalars['String'];
};

export type UpdateTaskResourceUserAllocationInput = {
  allocationEditMode?: InputMaybe<TaskResourceUserAllocationEditMode>;
  /** TODO: Remove ScheduleRules, allocationHours and dateRange must be required */
  allocationHours?: InputMaybe<Scalars['Float']>;
  dateRange?: InputMaybe<DateRangeInput2>;
  projectUri: Scalars['String'];
  roleUri?: InputMaybe<Scalars['String']>;
  scheduleRules?: InputMaybe<Array<ScheduleRuleInput>>;
  taskAllocationId: Scalars['String'];
  taskUri: Scalars['String'];
};

export type UpdateTaskResourceUserAllocationResult = {
  __typename?: 'UpdateTaskResourceUserAllocationResult';
  syncedResourceAllocation?: Maybe<ResourceAllocation>;
  taskResourceUserAllocation: TaskResourceUserAllocation;
};

export type UpdateTaskResult = {
  __typename?: 'UpdateTaskResult';
  error?: Maybe<Error>;
  task?: Maybe<Task>;
};

export type UpdateUserCertificateInput = {
  certificate: CertificateInput;
  userUri: Scalars['String'];
};

export type UpdateUserCustomFieldInput = {
  customFieldValues?: InputMaybe<Array<InputMaybe<Scalars['CustomFieldValueInput']>>>;
  userUri: Scalars['String'];
};

export type UpdateUserDefinedSkillInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  skillLevelId: Scalars['String'];
};

export type UpdateUserInformationResult = {
  __typename?: 'UpdateUserInformationResult';
  resourceUser: ResourceDetails;
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  userUri: Scalars['String'];
};

export type UpdateUserLocaleInput = {
  languageUri?: InputMaybe<Scalars['String']>;
  timeZoneFormatUri?: InputMaybe<Scalars['String']>;
  userUri: Scalars['String'];
};

export type UpdateUserRoleSchedulesInput = {
  scheduleEntries: Array<RoleScheduleInput>;
  userUri: Scalars['String'];
};

export type UpdateUserRolesInput = {
  roles: Array<RoleInput>;
  userUri: Scalars['String'];
};

export type UpdateUserSkillsInput = {
  skills?: InputMaybe<Array<UserSkillInput>>;
  userUri: Scalars['String'];
};

export type UpdateUserSkillsInput2 = {
  skills?: InputMaybe<Array<UserSkillInput2>>;
  userUri: Scalars['String'];
};

export type UpdateVendorInput = {
  closedDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};

export type UpdatedInvoiceStatusResult = {
  __typename?: 'UpdatedInvoiceStatusResult';
  invoice: ObjectReference;
};

export type User = {
  __typename?: 'User';
  displayText?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loginName?: Maybe<Scalars['String']>;
  managedProjects?: Maybe<Array<Maybe<Project>>>;
  permittedActionUris?: Maybe<Array<Maybe<Scalars['String']>>>;
  projectRoles?: Maybe<Array<Maybe<UserProjectRole>>>;
  resume?: Maybe<ResumeLink>;
  roleSchedules?: Maybe<Array<Maybe<UserProjectRoleSchedule>>>;
  roles?: Maybe<Array<Maybe<UserProjectRole>>>;
  slug?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};


export type UserManagedProjectsArgs = {
  searchTerm?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type UserRolesArgs = {
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type UserAccessInput = {
  accessType: UserAccessType;
};

export enum UserAccessType {
  Activity = 'ACTIVITY',
  Login = 'LOGIN'
}

export type UserAssignmentForVendorInput = {
  userUri: Scalars['String'];
  vendorUri?: InputMaybe<Scalars['String']>;
};

export type UserAssignmentForVendorReference = {
  __typename?: 'UserAssignmentForVendorReference';
  userRef: Scalars['String'];
  vendorRef?: Maybe<Scalars['String']>;
};

export type UserBeatAppDownloadUrl = {
  __typename?: 'UserBeatAppDownloadUrl';
  url?: Maybe<Scalars['String']>;
};

export type UserBillingRateScheduleEntry = {
  __typename?: 'UserBillingRateScheduleEntry';
  asOfDate?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  rate: Money;
  user: UserReference;
};

export type UserDefinedSkill = {
  __typename?: 'UserDefinedSkill';
  displayText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  skillLevel?: Maybe<SkillLevel>;
  uri?: Maybe<Scalars['String']>;
};

export type UserEffectiveGroup = {
  __typename?: 'UserEffectiveGroup';
  options: Array<Maybe<Scalars['String']>>;
  userGroupDataAccessScopeOption: Scalars['String'];
};

export type UserEffectiveGroupPolicy = {
  __typename?: 'UserEffectiveGroupPolicy';
  costCenter?: Maybe<UserEffectiveGroup>;
  department?: Maybe<UserEffectiveGroup>;
  division?: Maybe<UserEffectiveGroup>;
  employeeType?: Maybe<UserEffectiveGroup>;
  location?: Maybe<UserEffectiveGroup>;
  serviceCenter?: Maybe<UserEffectiveGroup>;
};

export type UserExpenseSummary = {
  __typename?: 'UserExpenseSummary';
  addExpenseDeepLinkUrl?: Maybe<Scalars['String']>;
  approved?: Maybe<ExpenseSummary>;
  awaitingReimbursement?: Maybe<ExpenseSummary>;
  notSubmitted?: Maybe<ExpenseSummary>;
  rejected?: Maybe<ExpenseSummary>;
  waitingForApproval?: Maybe<ExpenseSummary>;
};

export type UserProductivityTargetHoursSummary = {
  __typename?: 'UserProductivityTargetHoursSummary';
  company?: Maybe<ProductivityGroupDetails>;
  costCenter?: Maybe<ProductivityGroupDetails>;
  department?: Maybe<ProductivityGroupDetails>;
  departmentGroup?: Maybe<ProductivityGroupDetails>;
  division?: Maybe<ProductivityGroupDetails>;
  employeeTypeGroup?: Maybe<ProductivityGroupDetails>;
  location?: Maybe<ProductivityGroupDetails>;
  serviceCenter?: Maybe<ProductivityGroupDetails>;
  user?: Maybe<ProductivityGroupDetails>;
};

export type UserProjectRole = {
  __typename?: 'UserProjectRole';
  isPrimary: Scalars['Boolean'];
  projectRole: ProjectRole;
};

export type UserProjectRoleSchedule = {
  __typename?: 'UserProjectRoleSchedule';
  /** @deprecated Use effectiveDate2 */
  effectiveDate?: Maybe<Scalars['DateObject']>;
  effectiveDate2?: Maybe<Scalars['Date2']>;
  projectRoles: Array<Maybe<UserProjectRole>>;
};

export type UserProjectRoleWithEffectiveDate = {
  __typename?: 'UserProjectRoleWithEffectiveDate';
  effectiveDate?: Maybe<Scalars['Date']>;
  isPrimary: Scalars['Boolean'];
  projectRole: ProjectRole;
};

export type UserRate = {
  __typename?: 'UserRate';
  id: Scalars['String'];
  rate: Money;
};

export type UserReference = {
  __typename?: 'UserReference';
  displayText: Scalars['String'];
  id: Scalars['String'];
  slug: Scalars['String'];
  uri: Scalars['String'];
};

export type UserRole = {
  __typename?: 'UserRole';
  displayText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type UserSkillCategoryInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UserSkillInput = {
  category?: InputMaybe<UserSkillCategoryInput>;
  certificate?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  skillCustomMetadata?: InputMaybe<Array<InputMaybe<CustomMetadataInput>>>;
  skillLevelUri?: InputMaybe<Scalars['String']>;
  skillUri?: InputMaybe<Scalars['String']>;
};

export type UserSkillInput2 = {
  category?: InputMaybe<UserSkillCategoryInput>;
  certificate?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  skillCustomMetadata: Array<InputMaybe<CustomMetadataInput2>>;
  skillLevelUri: Scalars['String'];
  skillUri: Scalars['String'];
};

export type UserSkillsInput = {
  skills: Array<InputMaybe<SkillInput>>;
  userUri: Scalars['String'];
};

export type UserSynchronizeInput = {
  userUri?: InputMaybe<Scalars['String']>;
};

export type UserSynchronizeResult = {
  __typename?: 'UserSynchronizeResult';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type UserTaskEstimates = {
  __typename?: 'UserTaskEstimates';
  estimatedCompletionDate?: Maybe<Scalars['Date2']>;
  estimatedHours?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  initialEstimate?: Maybe<Scalars['Float']>;
};

export type UserTimesheetSummary = {
  __typename?: 'UserTimesheetSummary';
  current2?: Maybe<TimesheetDetails>;
  overdue?: Maybe<TimesheetCountForStatus>;
  rejected?: Maybe<TimesheetCountForStatus>;
  viewAllTimesheet?: Maybe<ViewAllTimesheet>;
};


export type UserTimesheetSummaryCurrent2Args = {
  effectiveDate: Scalars['Date2'];
};

export type UsersAvailableForVendorAssignmentFilter = {
  searchText?: InputMaybe<Scalars['String']>;
};

export type UsersList = ListResults & {
  __typename?: 'UsersList';
  items?: Maybe<Array<Maybe<User>>>;
  totalItems?: Maybe<Scalars['Int']>;
};

export type ValidateInvoiceAmountLimitOutput = {
  __typename?: 'ValidateInvoiceAmountLimitOutput';
  failedLineItems?: Maybe<Array<Maybe<LineItemReference>>>;
  success: Scalars['Boolean'];
};

export type ValidateTaskNameInput = {
  parentId: Scalars['String'];
  taskName: Scalars['String'];
};

export type ValidateTaskNameResult = {
  __typename?: 'ValidateTaskNameResult';
  isValid?: Maybe<Scalars['Boolean']>;
};

export type ValidationNotificationSummary = {
  __typename?: 'ValidationNotificationSummary';
  displayText?: Maybe<Scalars['String']>;
  failureUri?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  severityUri?: Maybe<Scalars['String']>;
};

export type Vendor = {
  __typename?: 'Vendor';
  canBeDeleted?: Maybe<Scalars['Boolean']>;
  closedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  userAssignments?: Maybe<Array<ResourceDetails>>;
};


export type VendorUserAssignmentsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type VendorDateTimeRangeInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type VendorFilter = {
  closedDate?: InputMaybe<VendorDateTimeRangeInput>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type VendorsList = ListResults & {
  __typename?: 'VendorsList';
  items?: Maybe<Array<Maybe<Vendor>>>;
  totalItems?: Maybe<Scalars['Int']>;
};

export type VendorsSummaryCount = {
  __typename?: 'VendorsSummaryCount';
  activeItems?: Maybe<Scalars['Int']>;
  inactiveItems?: Maybe<Scalars['Int']>;
  totalItems?: Maybe<Scalars['Int']>;
};

export type ViewAllTimesheet = {
  __typename?: 'ViewAllTimesheet';
  webDeepLinkUrl?: Maybe<Scalars['String']>;
};

export type VoidBillInput = {
  billId: Scalars['String'];
  voidBillDescription?: InputMaybe<Scalars['String']>;
};

export type VoidBillOutput = {
  __typename?: 'VoidBillOutput';
  success: Scalars['Boolean'];
};

export enum WeekdaysAbbreviation {
  Fr = 'fr',
  Mo = 'mo',
  Sa = 'sa',
  Su = 'su',
  Th = 'th',
  Tu = 'tu',
  We = 'we'
}

export type WorkWeek = {
  __typename?: 'WorkWeek';
  displayText?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type CreateBillFromBillingItemsBatchResult = {
  __typename?: 'createBillFromBillingItemsBatchResult';
  batchUri: Scalars['String'];
};

export type OverdueBillBalanceAmountResult = {
  __typename?: 'overdueBillBalanceAmountResult';
  amount?: Maybe<Money>;
  client?: Maybe<ClientReference>;
};

export type PageOfAllocatedResourcesResponse = {
  __typename?: 'pageOfAllocatedResourcesResponse';
  items?: Maybe<Array<Maybe<User>>>;
  paginationToken?: Maybe<Scalars['PaginationTokenResponse']>;
};

export type RecalculateProjectEarnedRevenueResult = {
  __typename?: 'recalculateProjectEarnedRevenueResult';
  batchUri: Scalars['String'];
  project: Project;
};

export type RecalculateProjectsBillingContractClausesResult = {
  __typename?: 'recalculateProjectsBillingContractClausesResult';
  batchUri: Scalars['String'];
};

export type ClientQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type ClientQuery = { __typename?: 'Query', client?: { __typename?: 'Client', id?: string | null | undefined, displayText?: string | null | undefined, slug?: string | null | undefined, defaultInvoicePaymentTerm?: number | null | undefined, clientManager?: { __typename?: 'ClientManager', id?: string | null | undefined } | null | undefined, comanagers?: Array<{ __typename?: 'User', id?: string | null | undefined } | null | undefined> | null | undefined, invoiceCurrency?: { __typename?: 'Currency', id?: string | null | undefined, displayText?: string | null | undefined, symbol?: string | null | undefined } | null | undefined, invoiceTemplate?: { __typename?: 'InvoiceTemplate', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined } | null | undefined };

export type ClientRatesFragment = { __typename?: 'Client', projectRate?: { __typename?: 'ClientRate', id: string, billingScheduleEntries?: Array<{ __typename?: 'RateScheduleEntry', effectiveDate?: any | null | undefined, amount: { __typename?: 'Money', amount?: number | null | undefined, currency?: { __typename?: 'Currency', id?: string | null | undefined, symbol?: string | null | undefined, displayText?: string | null | undefined } | null | undefined } } | null | undefined> | null | undefined } | null | undefined, roleRates?: Array<{ __typename?: 'ClientRate', id: string, roleReference?: { __typename?: 'ObjectReference', id: string, displayText: string } | null | undefined, billingScheduleEntries?: Array<{ __typename?: 'RateScheduleEntry', effectiveDate?: any | null | undefined, amount: { __typename?: 'Money', amount?: number | null | undefined, currency?: { __typename?: 'Currency', id?: string | null | undefined, symbol?: string | null | undefined, displayText?: string | null | undefined } | null | undefined } } | null | undefined> | null | undefined } | null | undefined> | null | undefined, userRates?: Array<{ __typename?: 'ClientRate', id: string, userReference?: { __typename?: 'ObjectReference', id: string, displayText: string } | null | undefined, billingScheduleEntries?: Array<{ __typename?: 'RateScheduleEntry', effectiveDate?: any | null | undefined, amount: { __typename?: 'Money', amount?: number | null | undefined, currency?: { __typename?: 'Currency', id?: string | null | undefined, symbol?: string | null | undefined, displayText?: string | null | undefined } | null | undefined } } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type GetClientRatesQueryVariables = Exact<{
  uri: Scalars['String'];
  roleRatePage?: Maybe<Scalars['Int']>;
  roleRatePageSize?: Maybe<Scalars['Int']>;
  resourceRatePage?: Maybe<Scalars['Int']>;
  resourceRatePageSize?: Maybe<Scalars['Int']>;
}>;


export type GetClientRatesQuery = { __typename?: 'Query', client?: { __typename?: 'Client', id?: string | null | undefined, roleRatesCount?: number | null | undefined, userRatesCount?: number | null | undefined, projectRate?: { __typename?: 'ClientRate', id: string, billingScheduleEntries?: Array<{ __typename?: 'RateScheduleEntry', effectiveDate?: any | null | undefined, amount: { __typename?: 'Money', amount?: number | null | undefined, currency?: { __typename?: 'Currency', id?: string | null | undefined, symbol?: string | null | undefined, displayText?: string | null | undefined } | null | undefined } } | null | undefined> | null | undefined } | null | undefined, roleRates?: Array<{ __typename?: 'ClientRate', id: string, roleReference?: { __typename?: 'ObjectReference', id: string, displayText: string } | null | undefined, billingScheduleEntries?: Array<{ __typename?: 'RateScheduleEntry', effectiveDate?: any | null | undefined, amount: { __typename?: 'Money', amount?: number | null | undefined, currency?: { __typename?: 'Currency', id?: string | null | undefined, symbol?: string | null | undefined, displayText?: string | null | undefined } | null | undefined } } | null | undefined> | null | undefined } | null | undefined> | null | undefined, userRates?: Array<{ __typename?: 'ClientRate', id: string, userReference?: { __typename?: 'ObjectReference', id: string, displayText: string } | null | undefined, billingScheduleEntries?: Array<{ __typename?: 'RateScheduleEntry', effectiveDate?: any | null | undefined, amount: { __typename?: 'Money', amount?: number | null | undefined, currency?: { __typename?: 'Currency', id?: string | null | undefined, symbol?: string | null | undefined, displayText?: string | null | undefined } | null | undefined } } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type PutClientRatesMutationVariables = Exact<{
  clientId: Scalars['String'];
  rates?: Maybe<Array<ProjectRateInput2> | ProjectRateInput2>;
}>;


export type PutClientRatesMutation = { __typename?: 'Mutation', putClientRates?: { __typename?: 'PutClientRatesResult2', client: { __typename?: 'Client', id?: string | null | undefined, projectRate?: { __typename?: 'ClientRate', id: string, billingScheduleEntries?: Array<{ __typename?: 'RateScheduleEntry', effectiveDate?: any | null | undefined, amount: { __typename?: 'Money', amount?: number | null | undefined, currency?: { __typename?: 'Currency', id?: string | null | undefined, symbol?: string | null | undefined, displayText?: string | null | undefined } | null | undefined } } | null | undefined> | null | undefined } | null | undefined, roleRates?: Array<{ __typename?: 'ClientRate', id: string, roleReference?: { __typename?: 'ObjectReference', id: string, displayText: string } | null | undefined, billingScheduleEntries?: Array<{ __typename?: 'RateScheduleEntry', effectiveDate?: any | null | undefined, amount: { __typename?: 'Money', amount?: number | null | undefined, currency?: { __typename?: 'Currency', id?: string | null | undefined, symbol?: string | null | undefined, displayText?: string | null | undefined } | null | undefined } } | null | undefined> | null | undefined } | null | undefined> | null | undefined, userRates?: Array<{ __typename?: 'ClientRate', id: string, userReference?: { __typename?: 'ObjectReference', id: string, displayText: string } | null | undefined, billingScheduleEntries?: Array<{ __typename?: 'RateScheduleEntry', effectiveDate?: any | null | undefined, amount: { __typename?: 'Money', amount?: number | null | undefined, currency?: { __typename?: 'Currency', id?: string | null | undefined, symbol?: string | null | undefined, displayText?: string | null | undefined } | null | undefined } } | null | undefined> | null | undefined } | null | undefined> | null | undefined } } | null | undefined };

export type ClientBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type ClientBySlugQuery = { __typename?: 'Query', client?: { __typename?: 'Client', permittedActionUris?: Array<string | null | undefined> | null | undefined, id?: string | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, code?: string | null | undefined, isActive?: boolean | null | undefined, comment?: string | null | undefined, defaultInvoicePaymentTerm?: number | null | undefined, contactName?: string | null | undefined, invoiceCurrency?: { __typename?: 'Currency', id?: string | null | undefined, symbol?: string | null | undefined } | null | undefined, taxProfile?: { __typename?: 'TaxProfile', id: string, displayText?: string | null | undefined } | null | undefined, invoiceTemplate?: { __typename?: 'InvoiceTemplate', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined, clientManager?: { __typename?: 'ClientManager', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined, contactInfo?: { __typename?: 'ContactInfo', address?: string | null | undefined, city?: string | null | undefined, email?: string | null | undefined, faxNumber?: string | null | undefined, phoneNumber?: string | null | undefined, stateProvince?: string | null | undefined, website?: string | null | undefined, zipPostalCode?: string | null | undefined, country?: { __typename?: 'ContactInfoCountry', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined } | null | undefined, billingContactInfo?: { __typename?: 'ContactInfo', address?: string | null | undefined, city?: string | null | undefined, email?: string | null | undefined, faxNumber?: string | null | undefined, phoneNumber?: string | null | undefined, stateProvince?: string | null | undefined, website?: string | null | undefined, zipPostalCode?: string | null | undefined, country?: { __typename?: 'ContactInfoCountry', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined } | null | undefined, clientRepresentatives?: Array<{ __typename?: 'User', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined> | null | undefined, comanagers?: Array<{ __typename?: 'User', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined> | null | undefined, customFieldValues?: Array<{ __typename?: 'CustomFieldValue', text?: string | null | undefined, date?: any | null | undefined, dropDownOptionUri?: string | null | undefined, number?: number | null | undefined, customField?: { __typename?: 'CustomFieldDefinitionReference', id?: string | null | undefined, uri?: string | null | undefined, displayText?: string | null | undefined, groupUri?: string | null | undefined } | null | undefined, customFieldType?: { __typename?: 'CustomFieldType', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined, customFieldDefinition?: { __typename?: 'CustomFieldDefinition', id?: string | null | undefined, uri?: string | null | undefined, displayText?: string | null | undefined, isEnabled?: boolean | null | undefined, isRequired?: boolean | null | undefined, isVisible?: boolean | null | undefined, type?: { __typename?: 'CustomFieldType', displayText?: string | null | undefined, uri?: string | null | undefined } | null | undefined, textConfiguration?: { __typename?: 'CustomFieldTextConfiguration', defaultTextValue?: string | null | undefined, maximumLength?: number | null | undefined } | null | undefined, dateConfiguration?: { __typename?: 'CustomFieldDateConfiguration', maximumDate?: any | null | undefined, minimumDate?: any | null | undefined, defaults?: { __typename?: 'CustomFieldDateDefaultsConfiguration', useTodayAsDefault?: boolean | null | undefined, value?: any | null | undefined } | null | undefined } | null | undefined, numericConfiguration?: { __typename?: 'CustomFieldNumericConfiguration', decimalPlaces?: number | null | undefined, defaultNumericValue?: number | null | undefined, maximumNumericValue?: number | null | undefined, minimumNumericValue?: number | null | undefined } | null | undefined, defaultDropDownValue?: { __typename?: 'CustomFieldDropdownOption', id?: string | null | undefined, displayText?: string | null | undefined, isDefaultValue?: boolean | null | undefined, isEnabled?: boolean | null | undefined, uri?: string | null | undefined } | null | undefined, dropDownOptions?: Array<{ __typename?: 'CustomFieldDropdownOption', id?: string | null | undefined, displayText?: string | null | undefined, isDefaultValue?: boolean | null | undefined, isEnabled?: boolean | null | undefined, uri?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined> | null | undefined, projectsStatusCountSummary?: { __typename?: 'ProjectsStatusCountSummary', initiate?: number | null | undefined, planning?: number | null | undefined, execution?: number | null | undefined, closed?: number | null | undefined, total?: number | null | undefined } | null | undefined, billingSettings?: { __typename?: 'BillingSettings', billLineItemsBy?: Array<LineItemColumnOptions | null | undefined> | null | undefined, description?: string | null | undefined, internalNotes?: string | null | undefined, showComments?: boolean | null | undefined, billFrequency?: BillingFrequency | null | undefined, billFrequencyAbsoluteDate?: any | null | undefined, consolidateBillsBy?: ConsolidateBillsBy | null | undefined } | null | undefined } | null | undefined };

export type ClientFragment = { __typename?: 'Client', id?: string | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, code?: string | null | undefined, isActive?: boolean | null | undefined, comment?: string | null | undefined, defaultInvoicePaymentTerm?: number | null | undefined, contactName?: string | null | undefined, invoiceCurrency?: { __typename?: 'Currency', id?: string | null | undefined, symbol?: string | null | undefined } | null | undefined, taxProfile?: { __typename?: 'TaxProfile', id: string, displayText?: string | null | undefined } | null | undefined, invoiceTemplate?: { __typename?: 'InvoiceTemplate', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined, clientManager?: { __typename?: 'ClientManager', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined, contactInfo?: { __typename?: 'ContactInfo', address?: string | null | undefined, city?: string | null | undefined, email?: string | null | undefined, faxNumber?: string | null | undefined, phoneNumber?: string | null | undefined, stateProvince?: string | null | undefined, website?: string | null | undefined, zipPostalCode?: string | null | undefined, country?: { __typename?: 'ContactInfoCountry', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined } | null | undefined, billingContactInfo?: { __typename?: 'ContactInfo', address?: string | null | undefined, city?: string | null | undefined, email?: string | null | undefined, faxNumber?: string | null | undefined, phoneNumber?: string | null | undefined, stateProvince?: string | null | undefined, website?: string | null | undefined, zipPostalCode?: string | null | undefined, country?: { __typename?: 'ContactInfoCountry', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined } | null | undefined, clientRepresentatives?: Array<{ __typename?: 'User', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined> | null | undefined, comanagers?: Array<{ __typename?: 'User', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined> | null | undefined, customFieldValues?: Array<{ __typename?: 'CustomFieldValue', text?: string | null | undefined, date?: any | null | undefined, dropDownOptionUri?: string | null | undefined, number?: number | null | undefined, customField?: { __typename?: 'CustomFieldDefinitionReference', id?: string | null | undefined, uri?: string | null | undefined, displayText?: string | null | undefined, groupUri?: string | null | undefined } | null | undefined, customFieldType?: { __typename?: 'CustomFieldType', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined, customFieldDefinition?: { __typename?: 'CustomFieldDefinition', id?: string | null | undefined, uri?: string | null | undefined, displayText?: string | null | undefined, isEnabled?: boolean | null | undefined, isRequired?: boolean | null | undefined, isVisible?: boolean | null | undefined, type?: { __typename?: 'CustomFieldType', displayText?: string | null | undefined, uri?: string | null | undefined } | null | undefined, textConfiguration?: { __typename?: 'CustomFieldTextConfiguration', defaultTextValue?: string | null | undefined, maximumLength?: number | null | undefined } | null | undefined, dateConfiguration?: { __typename?: 'CustomFieldDateConfiguration', maximumDate?: any | null | undefined, minimumDate?: any | null | undefined, defaults?: { __typename?: 'CustomFieldDateDefaultsConfiguration', useTodayAsDefault?: boolean | null | undefined, value?: any | null | undefined } | null | undefined } | null | undefined, numericConfiguration?: { __typename?: 'CustomFieldNumericConfiguration', decimalPlaces?: number | null | undefined, defaultNumericValue?: number | null | undefined, maximumNumericValue?: number | null | undefined, minimumNumericValue?: number | null | undefined } | null | undefined, defaultDropDownValue?: { __typename?: 'CustomFieldDropdownOption', id?: string | null | undefined, displayText?: string | null | undefined, isDefaultValue?: boolean | null | undefined, isEnabled?: boolean | null | undefined, uri?: string | null | undefined } | null | undefined, dropDownOptions?: Array<{ __typename?: 'CustomFieldDropdownOption', id?: string | null | undefined, displayText?: string | null | undefined, isDefaultValue?: boolean | null | undefined, isEnabled?: boolean | null | undefined, uri?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined> | null | undefined, projectsStatusCountSummary?: { __typename?: 'ProjectsStatusCountSummary', initiate?: number | null | undefined, planning?: number | null | undefined, execution?: number | null | undefined, closed?: number | null | undefined, total?: number | null | undefined } | null | undefined, billingSettings?: { __typename?: 'BillingSettings', billLineItemsBy?: Array<LineItemColumnOptions | null | undefined> | null | undefined, description?: string | null | undefined, internalNotes?: string | null | undefined, showComments?: boolean | null | undefined, billFrequency?: BillingFrequency | null | undefined, billFrequencyAbsoluteDate?: any | null | undefined, consolidateBillsBy?: ConsolidateBillsBy | null | undefined } | null | undefined };

export type CustomFieldDefinitionFragment = { __typename?: 'CustomFieldDefinition', id?: string | null | undefined, uri?: string | null | undefined, displayText?: string | null | undefined, isEnabled?: boolean | null | undefined, isRequired?: boolean | null | undefined, isVisible?: boolean | null | undefined, type?: { __typename?: 'CustomFieldType', displayText?: string | null | undefined, uri?: string | null | undefined } | null | undefined, textConfiguration?: { __typename?: 'CustomFieldTextConfiguration', defaultTextValue?: string | null | undefined, maximumLength?: number | null | undefined } | null | undefined, dateConfiguration?: { __typename?: 'CustomFieldDateConfiguration', maximumDate?: any | null | undefined, minimumDate?: any | null | undefined, defaults?: { __typename?: 'CustomFieldDateDefaultsConfiguration', useTodayAsDefault?: boolean | null | undefined, value?: any | null | undefined } | null | undefined } | null | undefined, numericConfiguration?: { __typename?: 'CustomFieldNumericConfiguration', decimalPlaces?: number | null | undefined, defaultNumericValue?: number | null | undefined, maximumNumericValue?: number | null | undefined, minimumNumericValue?: number | null | undefined } | null | undefined, defaultDropDownValue?: { __typename?: 'CustomFieldDropdownOption', id?: string | null | undefined, displayText?: string | null | undefined, isDefaultValue?: boolean | null | undefined, isEnabled?: boolean | null | undefined, uri?: string | null | undefined } | null | undefined, dropDownOptions?: Array<{ __typename?: 'CustomFieldDropdownOption', id?: string | null | undefined, displayText?: string | null | undefined, isDefaultValue?: boolean | null | undefined, isEnabled?: boolean | null | undefined, uri?: string | null | undefined } | null | undefined> | null | undefined };

export type CustomFieldValueFragment = { __typename?: 'CustomFieldValue', text?: string | null | undefined, date?: any | null | undefined, dropDownOptionUri?: string | null | undefined, number?: number | null | undefined, customField?: { __typename?: 'CustomFieldDefinitionReference', id?: string | null | undefined, uri?: string | null | undefined, displayText?: string | null | undefined, groupUri?: string | null | undefined } | null | undefined, customFieldType?: { __typename?: 'CustomFieldType', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined, customFieldDefinition?: { __typename?: 'CustomFieldDefinition', id?: string | null | undefined, uri?: string | null | undefined, displayText?: string | null | undefined, isEnabled?: boolean | null | undefined, isRequired?: boolean | null | undefined, isVisible?: boolean | null | undefined, type?: { __typename?: 'CustomFieldType', displayText?: string | null | undefined, uri?: string | null | undefined } | null | undefined, textConfiguration?: { __typename?: 'CustomFieldTextConfiguration', defaultTextValue?: string | null | undefined, maximumLength?: number | null | undefined } | null | undefined, dateConfiguration?: { __typename?: 'CustomFieldDateConfiguration', maximumDate?: any | null | undefined, minimumDate?: any | null | undefined, defaults?: { __typename?: 'CustomFieldDateDefaultsConfiguration', useTodayAsDefault?: boolean | null | undefined, value?: any | null | undefined } | null | undefined } | null | undefined, numericConfiguration?: { __typename?: 'CustomFieldNumericConfiguration', decimalPlaces?: number | null | undefined, defaultNumericValue?: number | null | undefined, maximumNumericValue?: number | null | undefined, minimumNumericValue?: number | null | undefined } | null | undefined, defaultDropDownValue?: { __typename?: 'CustomFieldDropdownOption', id?: string | null | undefined, displayText?: string | null | undefined, isDefaultValue?: boolean | null | undefined, isEnabled?: boolean | null | undefined, uri?: string | null | undefined } | null | undefined, dropDownOptions?: Array<{ __typename?: 'CustomFieldDropdownOption', id?: string | null | undefined, displayText?: string | null | undefined, isDefaultValue?: boolean | null | undefined, isEnabled?: boolean | null | undefined, uri?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type ActiveRolesQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
  targetCurrencyId?: Maybe<Scalars['String']>;
  isCurrentRateEnabled: Scalars['Boolean'];
  includeSkills: Scalars['Boolean'];
  includeBillingScheduleEntries?: Maybe<Scalars['Boolean']>;
}>;


export type ActiveRolesQuery = { __typename?: 'Query', activeRoles?: Array<{ __typename?: 'Role', id: string, displayText?: string | null | undefined, currentRate?: { __typename?: 'Money', amount?: number | null | undefined, currency?: { __typename?: 'Currency', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined } | null | undefined, skills?: Array<{ __typename?: 'Skill', id?: string | null | undefined, displayText?: string | null | undefined, category?: { __typename?: 'Category', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined, skillLevel?: { __typename?: 'SkillLevel', id?: string | null | undefined, rating?: number | null | undefined } | null | undefined } | null | undefined> | null | undefined, billingScheduleEntries?: Array<{ __typename?: 'RateScheduleEntry', effectiveDate?: any | null | undefined, amount: { __typename?: 'Money', amount?: number | null | undefined, currency?: { __typename?: 'Currency', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined } } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type GetDailyAllocationHoursSummaryForDateRangeQueryVariables = Exact<{
  input: DailyMyAllocationHoursSummaryForDateRangeInput;
}>;


export type GetDailyAllocationHoursSummaryForDateRangeQuery = { __typename?: 'Query', me?: { __typename?: 'Me', id: string, dailyAllocationHoursSummaryForDateRange: { __typename?: 'DailyAllocationHoursSummaryForDateRangeResponse', hasMoreAllocations: boolean, projects: Array<{ __typename?: 'DailyMyAllocationHoursSummaryForDateRange', project: { __typename?: 'ProjectReference', displayText?: string | null | undefined, name?: string | null | undefined, slug?: string | null | undefined }, days: Array<{ __typename?: 'DailyMyAllocationHoursSummaryForDate', date: any, allocatedHours: number, actualHours: number }>, tasks: Array<{ __typename?: 'DailyMyTaskAllocationHoursSummary', task: { __typename?: 'TaskReference', id: string, uri?: string | null | undefined, displayText?: string | null | undefined, name?: string | null | undefined }, fullPath: Array<{ __typename?: 'TaskReference', displayText?: string | null | undefined, name?: string | null | undefined }>, days: Array<{ __typename?: 'DailyMyAllocationHoursSummaryForDate', date: any, allocatedHours: number, actualHours: number }> }> }> } } | null | undefined };

export type GetKeyValueSettingsQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type GetKeyValueSettingsQuery = { __typename?: 'Query', keyValueSettings?: any | null | undefined };

export type GetUserBeatAppDownloadUrlQueryVariables = Exact<{
  os: OsType;
}>;


export type GetUserBeatAppDownloadUrlQuery = { __typename?: 'Query', getUserBeatAppDownloadUrl?: { __typename?: 'UserBeatAppDownloadUrl', url?: string | null | undefined } | null | undefined };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me?: { __typename?: 'Me', id: string, displayText?: string | null | undefined, loginName?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, slug?: string | null | undefined, uri?: string | null | undefined, servicesUrl: string, billingProcessType?: string | null | undefined, isExpenseProductEnabled?: boolean | null | undefined, legacyDepartmentDisabled?: boolean | null | undefined, legacyEmployeeTypeDisabled?: boolean | null | undefined, helpUrl?: string | null | undefined, userAccessRoles?: Array<string | null | undefined> | null | undefined, companyKey?: string | null | undefined, tenantSlug?: string | null | undefined, logoutHref?: string | null | undefined, uiRootPath?: string | null | undefined, emailAddress?: string | null | undefined, cpoUrl?: string | null | undefined, zeroTimeUrl: string, gainsightTagKey?: string | null | undefined, projectNameAndCodeUniqueness?: NameCodeUniqueOption | null | undefined, clientNameAndCodeUniqueness?: NameCodeUniqueOption | null | undefined, serverNodeEnv?: string | null | undefined, swimlane?: string | null | undefined, tenantType?: TenantType | null | undefined, resourceCostMode?: ResourceCostModeType | null | undefined, resourcePlanningLimitInYears?: number | null | undefined, isRolledUpTaskEstimateCalculationMethodEnabled: boolean, currentTimeInUserTimeZone: any, isTimePunchAllowedFromAnyPunchSource?: boolean | null | undefined, isLogToSentryEnabled: boolean, isFipsEnabled: boolean, isGainsightDisabled: boolean, hasEditTargetBillableHours: boolean, hasViewClientBillingData: boolean, hasEditProjectBillingContracts: boolean, hasViewProjectBillingRates: boolean, hasViewProjectBillingOptions: boolean, hasViewProjectCostType: boolean, hasViewTaxProfile: boolean, hasClientManagerRole: boolean, hasClientRepresentativeRole: boolean, locale?: { __typename?: 'Locale', dateTimeSettings?: { __typename?: 'DateTimeSetting', shortDateFormat?: { __typename?: 'DateTimeFormat', dotNetPattern?: string | null | undefined } | null | undefined, shortTimeFormat?: { __typename?: 'DateTimeFormat', dotNetPattern?: string | null | undefined } | null | undefined } | null | undefined, numberSettings?: { __typename?: 'NumberSettingGroup', number?: { __typename?: 'NumberSetting', decimalDigits?: number | null | undefined, decimalSeparator?: string | null | undefined, dotNetNegativePattern?: string | null | undefined, dotNetPositivePattern?: string | null | undefined, groupSeparator?: string | null | undefined, groupSizes?: Array<number | null | undefined> | null | undefined, negativeSign?: string | null | undefined, positiveSign?: string | null | undefined } | null | undefined, currency?: { __typename?: 'NumberSetting', decimalDigits?: number | null | undefined, decimalSeparator?: string | null | undefined, dotNetNegativePattern?: string | null | undefined, dotNetPositivePattern?: string | null | undefined, groupSeparator?: string | null | undefined, groupSizes?: Array<number | null | undefined> | null | undefined, negativeSign?: string | null | undefined, positiveSign?: string | null | undefined } | null | undefined } | null | undefined, language?: { __typename?: 'Language', cultureCode?: string | null | undefined, displayText?: string | null | undefined, uri?: string | null | undefined, languageCode?: string | null | undefined } | null | undefined, timeZone?: { __typename?: 'TimeZone', displayText?: string | null | undefined, ianaName?: string | null | undefined, offsetDisplayText?: string | null | undefined, uri?: string | null | undefined } | null | undefined, customTerms?: Array<{ __typename?: 'CustomTerm', originalTerm?: string | null | undefined, customTerm?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, defaultRequestAttributeWeights?: { __typename?: 'RequestAttributeWeights', location?: RequestAttributeWeightage | null | undefined, division?: RequestAttributeWeightage | null | undefined, serviceCenter?: RequestAttributeWeightage | null | undefined, costCenter?: RequestAttributeWeightage | null | undefined, department?: RequestAttributeWeightage | null | undefined, employeeType?: RequestAttributeWeightage | null | undefined, role?: RequestAttributeWeightage | null | undefined, skills?: RequestAttributeWeightage | null | undefined, tags?: RequestAttributeWeightage | null | undefined, requestedCostRate?: RequestAttributeWeightage | null | undefined, resourcePools?: RequestAttributeWeightage | null | undefined, preferredResources?: RequestAttributeWeightage | null | undefined } | null | undefined, featureFlags?: { __typename?: 'FeatureFlags', isPsaEarnedRevenueEnabled?: boolean | null | undefined, isPsaPrpAccessibilityIssuesEnabled?: boolean | null | undefined, isPsaPrpAccessabilityEnhancements2025Enabled?: boolean | null | undefined, isPsaPrp2023q3BugFixesEnabled?: boolean | null | undefined, isPsaPrpInvoiceBillingRateEnabled?: boolean | null | undefined, isPsaPrpEmbedSchedulesInPolarisEnabled?: boolean | null | undefined, isPsaPrpPreventZeroAmountEnabled?: boolean | null | undefined, isPsaPrpAddContactDetailsToTheProjectEnabled?: boolean | null | undefined, isPsaPrpBillUiEnhancementsEnabled?: boolean | null | undefined, isPsaPrpManualTaskStatusEnabled?: boolean | null | undefined, isPSATaskEstimateRollUpMobileViewEnabled?: boolean | null | undefined, isWBSEnabled?: boolean | null | undefined, isPSAQuickAllocationDemandEnabled?: boolean | null | undefined, isPsaProjectRiskEnabled?: boolean | null | undefined, isPsaFPOvertimeBillingEnabled?: boolean | null | undefined, isPsaRescheduleProjectHintEnabled?: boolean | null | undefined, isPsaPrpTaskBeatUpdates2Enabled?: boolean | null | undefined, PSAPRPTaskEstimateCalculation?: string | null | undefined, isPsaPrpWcagFixesQ4Enabled?: boolean | null | undefined, isPsaFpAdvancedRateCardEnabled?: boolean | null | undefined, isPsaPrpProjectStatusChangeNotificationEnabled?: boolean | null | undefined, isPsaPrpVendorUiEnabled?: boolean | null | undefined, isPsaPrpRiskScoreEnabled?: boolean | null | undefined, isPsaRmpTaskAllocation1Enabled?: boolean | null | undefined, isRmpTaskAllocationPhase2Enabled?: boolean | null | undefined, isRmpTaskAllocationEnhancement1?: boolean | null | undefined, isRmp2025Q4Enhancements?: boolean | null | undefined, isRmp2026Q1PerfFixesEnabled?: boolean | null | undefined, isRmp2026Q1Enhancements?: boolean | null | undefined, repliconAssistant?: string | null | undefined, projectRiskSummary?: string | null | undefined, isPsaPrpRenameProjectStatus2Enabled?: boolean | null | undefined, isPsaPswatBillingDraftSubStatusEnabled?: boolean | null | undefined, isPsaPraaResourceMatchingEnabled?: boolean | null | undefined, isPsaPrpAddProjectColumnOnAvailableToBillEnabled?: boolean | null | undefined, isPsaDtmRequisitionEnabled?: boolean | null | undefined, isPsaPrpMoveTimeEnabled?: boolean | null | undefined, isPsaPrpExpenseAmountChangeInLoopFixEnabled?: boolean | null | undefined, isPsaPraaUserProfileNudgesEnabled?: boolean | null | undefined, isPsaPrpRoleFilterOnTasksEnabled?: boolean | null | undefined, isPsaPrpExpenseCardPerformanceFixEnabled?: boolean | null | undefined, isPsaPrpCustomLineItemParityFlagEnabled?: boolean | null | undefined, isPsaPrpMassEditBackgroundJobEnabled?: boolean | null | undefined, isPsaPrpGainsightEnabled?: boolean | null | undefined, isPsaRmp2025Q3WcagEnabled?: boolean | null | undefined, isPsaRmp2025Q4WcagEnabled?: boolean | null | undefined, isDecoupleCostDataPermissionEnabled?: boolean | null | undefined, isPsaRmpSkillAnalyticsEnabled?: boolean | null | undefined, isPsaPrpUnisysResourceManagementHiddenEnabled?: boolean | null | undefined, isPsaRmpDesktopAppLinkRemovalEnabled?: boolean | null | undefined, isPsaRmpSetResourceAllocationEnabled?: boolean | null | undefined } | null | undefined, groupSettings?: { __typename?: 'GroupSettings', location?: { __typename?: 'GroupSetting', isEnabled: boolean, pluralName?: string | null | undefined, singularName?: string | null | undefined } | null | undefined, department?: { __typename?: 'GroupSetting', isEnabled: boolean, pluralName?: string | null | undefined, singularName?: string | null | undefined } | null | undefined, division?: { __typename?: 'GroupSetting', isEnabled: boolean, pluralName?: string | null | undefined, singularName?: string | null | undefined } | null | undefined, employeeType?: { __typename?: 'GroupSetting', isEnabled: boolean, pluralName?: string | null | undefined, singularName?: string | null | undefined } | null | undefined, costCenter?: { __typename?: 'GroupSetting', isEnabled: boolean, pluralName?: string | null | undefined, singularName?: string | null | undefined } | null | undefined, serviceCenter?: { __typename?: 'GroupSetting', isEnabled: boolean, pluralName?: string | null | undefined, singularName?: string | null | undefined } | null | undefined } | null | undefined, permissions?: Array<{ __typename?: 'Permission', permissionActionUri?: string | null | undefined, dataAccessLevelUris?: Array<string | null | undefined> | null | undefined } | null | undefined> | null | undefined, sessionTimeoutDuration?: { __typename?: 'TimeoutDuration', days?: number | null | undefined, hours?: number | null | undefined, minutes?: number | null | undefined, seconds?: number | null | undefined, milliseconds?: number | null | undefined } | null | undefined, baseCurrency?: { __typename?: 'Currency', id?: string | null | undefined, uri?: string | null | undefined, name?: string | null | undefined, symbol?: string | null | undefined, displayText?: string | null | undefined } | null | undefined, workWeekStartDay?: { __typename?: 'WorkWeek', displayText?: string | null | undefined, uri?: string | null | undefined } | null | undefined, substituteUserMetadata?: { __typename?: 'SubstituteUserMetadata', actionHref?: string | null | undefined, actionText?: string | null | undefined, bannerText?: string | null | undefined, userName?: string | null | undefined } | null | undefined, substituteUsers?: Array<{ __typename?: 'User', id?: string | null | undefined, uri?: string | null | undefined, displayText?: string | null | undefined } | null | undefined> | null | undefined, projectRequestScoreScaleDetails?: { __typename?: 'ProjectRequestScoreScaleDetails', value?: Array<{ __typename?: 'ProjectRequestScoreScale', scale: number, label: string } | null | undefined> | null | undefined, risk?: Array<{ __typename?: 'ProjectRequestScoreScale', scale: number, label: string } | null | undefined> | null | undefined, investment?: Array<{ __typename?: 'ProjectRequestScoreScale', scale: number, label: string } | null | undefined> | null | undefined } | null | undefined } | null | undefined };

export type ProgramStatusFragment = { __typename?: 'Program', isActive?: boolean | null | undefined };

export type GetProgramBySlugQueryVariables = Exact<{
  programSlug: Scalars['String'];
}>;


export type GetProgramBySlugQuery = { __typename?: 'Query', program?: { __typename?: 'Program', id: string, uri?: string | null | undefined, slug?: string | null | undefined, name?: string | null | undefined, displayText?: string | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, permittedActionUris?: Array<string | null | undefined> | null | undefined, isActive?: boolean | null | undefined, programManagerReference?: { __typename?: 'ProgramManagerReference', id: string, uri?: string | null | undefined, displayText?: string | null | undefined } | null | undefined, budget?: { __typename?: 'Budget', capital?: { __typename?: 'Money', amount?: number | null | undefined, currency?: { __typename?: 'Currency', id?: string | null | undefined, displayText?: string | null | undefined, symbol?: string | null | undefined } | null | undefined } | null | undefined, operational?: { __typename?: 'Money', amount?: number | null | undefined, currency?: { __typename?: 'Currency', id?: string | null | undefined, displayText?: string | null | undefined, symbol?: string | null | undefined } | null | undefined } | null | undefined, total?: { __typename?: 'Money', amount?: number | null | undefined, currency?: { __typename?: 'Currency', id?: string | null | undefined, displayText?: string | null | undefined, symbol?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, projectsStatusCountSummary?: { __typename?: 'ProjectsStatusCountSummary', initiate?: number | null | undefined, planning?: number | null | undefined, execution?: number | null | undefined, closed?: number | null | undefined, total?: number | null | undefined } | null | undefined } | null | undefined };

export type CreateProjectBillingContractScriptRecalculationBatchMutationVariables = Exact<{
  projectBillingContractScriptUris: Array<Scalars['String']> | Scalars['String'];
}>;


export type CreateProjectBillingContractScriptRecalculationBatchMutation = { __typename?: 'Mutation', createProjectBillingContractScriptRecalculationBatch: { __typename?: 'CreateProjectBillingContractScriptRecalculationBatchResult', batchUri: string } };

export type ResourceRoleScheduleFragment = { __typename?: 'ResourceDetails', id: string, roleScheduleDetails?: Array<{ __typename?: 'UserProjectRoleSchedule', effectiveDate?: any | null | undefined, projectRoles: Array<{ __typename?: 'UserProjectRole', isPrimary: boolean, projectRole: { __typename?: 'ProjectRole', uri?: string | null | undefined, name?: string | null | undefined } } | null | undefined> } | null | undefined> | null | undefined };

export type GetMyDefaultRequestAttributeWeightsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyDefaultRequestAttributeWeightsQuery = { __typename?: 'Query', me?: { __typename?: 'Me', id: string, defaultRequestAttributeWeights?: { __typename?: 'RequestAttributeWeights', location?: RequestAttributeWeightage | null | undefined, division?: RequestAttributeWeightage | null | undefined, serviceCenter?: RequestAttributeWeightage | null | undefined, costCenter?: RequestAttributeWeightage | null | undefined, department?: RequestAttributeWeightage | null | undefined, employeeType?: RequestAttributeWeightage | null | undefined, role?: RequestAttributeWeightage | null | undefined, skills?: RequestAttributeWeightage | null | undefined, tags?: RequestAttributeWeightage | null | undefined, requestedCostRate?: RequestAttributeWeightage | null | undefined, resourcePools?: RequestAttributeWeightage | null | undefined, preferredResources?: RequestAttributeWeightage | null | undefined } | null | undefined } | null | undefined };

export type RequestAttributeWeightsFragment = { __typename?: 'RequestAttributeWeights', location?: RequestAttributeWeightage | null | undefined, division?: RequestAttributeWeightage | null | undefined, serviceCenter?: RequestAttributeWeightage | null | undefined, costCenter?: RequestAttributeWeightage | null | undefined, department?: RequestAttributeWeightage | null | undefined, employeeType?: RequestAttributeWeightage | null | undefined, role?: RequestAttributeWeightage | null | undefined, skills?: RequestAttributeWeightage | null | undefined, tags?: RequestAttributeWeightage | null | undefined, requestedCostRate?: RequestAttributeWeightage | null | undefined, resourcePools?: RequestAttributeWeightage | null | undefined, preferredResources?: RequestAttributeWeightage | null | undefined };

export type SetMyDefaultRequestAttributeWeightsMutationVariables = Exact<{
  input: RequestAttributeWeightsInput;
}>;


export type SetMyDefaultRequestAttributeWeightsMutation = { __typename?: 'Mutation', setMyDefaultRequestAttributeWeights2?: { __typename?: 'SetMyDefaultRequestAttributeWeightsResult', me?: { __typename?: 'Me', id: string, defaultRequestAttributeWeights?: { __typename?: 'RequestAttributeWeights', location?: RequestAttributeWeightage | null | undefined, division?: RequestAttributeWeightage | null | undefined, serviceCenter?: RequestAttributeWeightage | null | undefined, costCenter?: RequestAttributeWeightage | null | undefined, department?: RequestAttributeWeightage | null | undefined, employeeType?: RequestAttributeWeightage | null | undefined, role?: RequestAttributeWeightage | null | undefined, skills?: RequestAttributeWeightage | null | undefined, tags?: RequestAttributeWeightage | null | undefined, requestedCostRate?: RequestAttributeWeightage | null | undefined, resourcePools?: RequestAttributeWeightage | null | undefined, preferredResources?: RequestAttributeWeightage | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type SpecificResourceRequestFragment = { __typename?: 'ResourceRequest', id: string, projectUri: string, quantity: number, comment?: string | null | undefined, startDate: any, endDate: any, load?: number | null | undefined, isAdjustedLoading?: boolean | null | undefined, roleRate?: number | null | undefined, requestStatus: ResourceRequestStatus, currencyUri?: string | null | undefined, totalHours?: number | null | undefined, role?: { __typename?: 'Role', id: string, displayText?: string | null | undefined, currentRate?: { __typename?: 'Money', amount?: number | null | undefined, currency?: { __typename?: 'Currency', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, resourcePools?: Array<{ __typename?: 'ResourcePool', id: string, displayText: string }> | null | undefined, location?: { __typename?: 'Group', id: string, displayText?: string | null | undefined } | null | undefined, division?: { __typename?: 'Group', id: string, displayText?: string | null | undefined } | null | undefined, serviceCenter?: { __typename?: 'Group', id: string, displayText?: string | null | undefined } | null | undefined, costCenter?: { __typename?: 'Group', id: string, displayText?: string | null | undefined } | null | undefined, employeeType?: { __typename?: 'Group', id: string, displayText?: string | null | undefined } | null | undefined, department?: { __typename?: 'Group', id: string, displayText?: string | null | undefined } | null | undefined, scheduleRules: Array<{ __typename?: 'ScheduleRule', do: any, dateRange: { __typename?: 'DateRange', startDate: any, endDate: any } }>, currency?: { __typename?: 'Currency', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined, skills?: Array<{ __typename?: 'RequestSkill', id?: string | null | undefined, displayText?: string | null | undefined, category?: { __typename?: 'Category', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined, skillLevel?: { __typename?: 'SkillLevel', id?: string | null | undefined, rating?: number | null | undefined } | null | undefined } | null | undefined> | null | undefined, tags?: Array<{ __typename?: 'TagAssignment', id: string, tag: { __typename?: 'Tag', id: string, name: string, values?: Array<{ __typename?: 'TagValue', value: string, id: string } | null | undefined> | null | undefined }, value?: { __typename?: 'TagValue', id: string, value: string } | null | undefined } | null | undefined> | null | undefined, requestAttributeWeights?: { __typename?: 'RequestAttributeWeights', location?: RequestAttributeWeightage | null | undefined, division?: RequestAttributeWeightage | null | undefined, serviceCenter?: RequestAttributeWeightage | null | undefined, costCenter?: RequestAttributeWeightage | null | undefined, department?: RequestAttributeWeightage | null | undefined, employeeType?: RequestAttributeWeightage | null | undefined, role?: RequestAttributeWeightage | null | undefined, skills?: RequestAttributeWeightage | null | undefined, tags?: RequestAttributeWeightage | null | undefined, requestedCostRate?: RequestAttributeWeightage | null | undefined, resourcePools?: RequestAttributeWeightage | null | undefined, preferredResources?: RequestAttributeWeightage | null | undefined } | null | undefined, exchangeRateValues?: { __typename?: 'ResourceRequestExchangeRateValues', projectBudgetCurrency?: { __typename?: 'ExchangeRate', currencyId?: string | null | undefined, rate?: number | null | undefined } | null | undefined, baseCurrency?: { __typename?: 'ExchangeRate', currencyId?: string | null | undefined, rate?: number | null | undefined } | null | undefined } | null | undefined, preferredResources?: Array<{ __typename?: 'UserReference', id: string, displayText: string }> | null | undefined, sourceMetadata?: { __typename?: 'SourceMetadata', sourcedFromAI: boolean, hiringStatus?: HiringStatus | null | undefined } | null | undefined };

export type Eager_GetPageOfResourceUserMatchesForResourceRequestQueryVariables = Exact<{
  page: Scalars['Int'];
  pagesize: Scalars['Int'];
  resourceRequestId: Scalars['String'];
  source: ResourceUserMatchSource;
  additionalColumns?: Maybe<ResourceUserColumns>;
  filter?: Maybe<ResourceUserMatchesFilter>;
  isAvailabilityEnabled: Scalars['Boolean'];
  dateRange: DateRangeInput;
  startDate: Scalars['Date'];
  periodResolution: PeriodResolutionOption;
  includeCurrentDepartment: Scalars['Boolean'];
  includeResourcePools: Scalars['Boolean'];
  includeCurrentEmployeeType: Scalars['Boolean'];
  includeCurrentCostCenter: Scalars['Boolean'];
  includeCurrentServiceCenter: Scalars['Boolean'];
  includeCurrentDivision: Scalars['Boolean'];
  includeCurrentLocation: Scalars['Boolean'];
  includeSupervisorAssignment: Scalars['Boolean'];
  includeEmployeeId: Scalars['Boolean'];
  includeTags: Scalars['Boolean'];
  includeCustomFields: Scalars['Boolean'];
  sort?: Maybe<Array<ResourceUserSort> | ResourceUserSort>;
}>;


export type Eager_GetPageOfResourceUserMatchesForResourceRequestQuery = { __typename?: 'Query', getPageOfResourceUserMatchesForResourceRequest?: Array<{ __typename?: 'ResourceUser', id: string, uri: string, slug: string, displayText: string, startDate?: any | null | undefined, endDate?: any | null | undefined, employeeId?: string | null | undefined, availabilityPercentage?: number | null | undefined, primaryRoleCostRate?: { __typename?: 'Money', amount?: number | null | undefined, currency?: { __typename?: 'Currency', id?: string | null | undefined, symbol?: string | null | undefined, displayText?: string | null | undefined } | null | undefined } | null | undefined, costRateAsOf?: { __typename?: 'Money', amount?: number | null | undefined, currency?: { __typename?: 'Currency', id?: string | null | undefined, symbol?: string | null | undefined, displayText?: string | null | undefined } | null | undefined } | null | undefined, matchScore?: { __typename?: 'MatchScore', score?: number | null | undefined, matchingDimensions?: Array<string | null | undefined> | null | undefined, unMatchedDimensions?: Array<string | null | undefined> | null | undefined, isError?: boolean | null | undefined, matchSkillsMetadata?: { __typename?: 'MatchSkillsMetaData', matchingSkillsCount: number, requestedSkillsCount: number } | null | undefined, matchResourcePoolsMetadata?: { __typename?: 'MatchResourcePoolsMetaData', matchingResourcePoolsCount: number, requestedResourcePoolsCount: number } | null | undefined, totalCost?: { __typename?: 'MatchScoreTotalCost', amount?: number | null | undefined, currency?: { __typename?: 'MatchScoreCurrency', uri?: string | null | undefined, symbol?: string | null | undefined } | null | undefined } | null | undefined, matchTagsMetadata?: { __typename?: 'MatchTagsMetaData', matchingTagsCount: number, requestedTagsCount: number } | null | undefined } | null | undefined, roleSchedules?: Array<{ __typename?: 'UserProjectRoleSchedule', effectiveDate?: any | null | undefined, projectRoles: Array<{ __typename?: 'UserProjectRole', isPrimary: boolean, projectRole: { __typename?: 'ProjectRole', uri?: string | null | undefined, name?: string | null | undefined } } | null | undefined> } | null | undefined> | null | undefined, resourceAvailabilitySummarySeries?: Array<{ __typename?: 'AvailabilityPeriod', dateRange: { __typename?: 'DateRange', startDate: any, endDate: any }, scheduledDuration: { __typename?: 'Duration', hours: number, minutes: number, seconds: number }, timeOffDuration: { __typename?: 'Duration', hours: number, minutes: number, seconds: number }, holidayDuration: { __typename?: 'Duration', hours: number, minutes: number, seconds: number }, overAllocatedDuration: { __typename?: 'Duration', hours: number, minutes: number, seconds: number }, allocatedDuration: { __typename?: 'Duration', hours: number, minutes: number, seconds: number } } | null | undefined> | null | undefined, holidays?: Array<{ __typename?: 'Holiday', date: any, uri: string, name: string, duration?: { __typename?: 'Duration', hours: number, minutes: number, seconds: number } | null | undefined, effectiveDuration: { __typename?: 'Duration', hours: number, minutes: number, seconds: number } } | null | undefined> | null | undefined, timeoffs?: Array<{ __typename?: 'Timeoff', hours?: number | null | undefined, days?: number | null | undefined, dateRange: { __typename?: 'DateRange', startDate: any, endDate: any }, timeOffType?: { __typename?: 'TimeOffType', displayText: string } | null | undefined, entries?: Array<{ __typename?: 'TimeOffEntryByDay', date: any, hours: number, days?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, supervisorAssignment?: { __typename?: 'SupervisorAssignment', effectiveDate?: any | null | undefined, supervisor?: { __typename?: 'Supervisor', uri?: string | null | undefined, displayText?: string | null | undefined } | null | undefined } | null | undefined, currentDepartment?: { __typename?: 'Groups', id?: string | null | undefined, displayText?: string | null | undefined, ancestors?: Array<{ __typename?: 'Groups', displayText?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, allResourcePools?: Array<{ __typename?: 'ResourcePool', id: string, slug: string, displayText: string }> | null | undefined, currentEmployeeType?: { __typename?: 'Groups', id?: string | null | undefined, displayText?: string | null | undefined, ancestors?: Array<{ __typename?: 'Groups', displayText?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, currentCostCenter?: { __typename?: 'Groups', id?: string | null | undefined, displayText?: string | null | undefined, ancestors?: Array<{ __typename?: 'Groups', displayText?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, currentServiceCenter?: { __typename?: 'Groups', id?: string | null | undefined, displayText?: string | null | undefined, ancestors?: Array<{ __typename?: 'Groups', displayText?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, currentDivision?: { __typename?: 'Groups', id?: string | null | undefined, displayText?: string | null | undefined, ancestors?: Array<{ __typename?: 'Groups', displayText?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, currentLocation?: { __typename?: 'Groups', id?: string | null | undefined, displayText?: string | null | undefined, ancestors?: Array<{ __typename?: 'Groups', displayText?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, tags?: Array<{ __typename?: 'TagAssignment', tag: { __typename?: 'Tag', id: string, name: string }, value?: { __typename?: 'TagValue', id: string, value: string } | null | undefined } | null | undefined> | null | undefined, customFieldValues?: Array<{ __typename?: 'CustomFieldValue', text?: string | null | undefined, date?: any | null | undefined, dropDownOptionUri?: string | null | undefined, number?: number | null | undefined, customField?: { __typename?: 'CustomFieldDefinitionReference', id?: string | null | undefined, uri?: string | null | undefined, displayText?: string | null | undefined, groupUri?: string | null | undefined } | null | undefined, customFieldType?: { __typename?: 'CustomFieldType', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined, customFieldDefinition?: { __typename?: 'CustomFieldDefinition', id?: string | null | undefined, uri?: string | null | undefined, displayText?: string | null | undefined, isEnabled?: boolean | null | undefined, isRequired?: boolean | null | undefined, isVisible?: boolean | null | undefined, type?: { __typename?: 'CustomFieldType', displayText?: string | null | undefined, uri?: string | null | undefined } | null | undefined, textConfiguration?: { __typename?: 'CustomFieldTextConfiguration', defaultTextValue?: string | null | undefined, maximumLength?: number | null | undefined } | null | undefined, dateConfiguration?: { __typename?: 'CustomFieldDateConfiguration', maximumDate?: any | null | undefined, minimumDate?: any | null | undefined, defaults?: { __typename?: 'CustomFieldDateDefaultsConfiguration', useTodayAsDefault?: boolean | null | undefined, value?: any | null | undefined } | null | undefined } | null | undefined, numericConfiguration?: { __typename?: 'CustomFieldNumericConfiguration', decimalPlaces?: number | null | undefined, defaultNumericValue?: number | null | undefined, maximumNumericValue?: number | null | undefined, minimumNumericValue?: number | null | undefined } | null | undefined, defaultDropDownValue?: { __typename?: 'CustomFieldDropdownOption', id?: string | null | undefined, displayText?: string | null | undefined, isDefaultValue?: boolean | null | undefined, isEnabled?: boolean | null | undefined, uri?: string | null | undefined } | null | undefined, dropDownOptions?: Array<{ __typename?: 'CustomFieldDropdownOption', id?: string | null | undefined, displayText?: string | null | undefined, isDefaultValue?: boolean | null | undefined, isEnabled?: boolean | null | undefined, uri?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type Eager_GetResourceUsersPaginatedQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  pagesize?: Maybe<Scalars['Int']>;
  filter?: Maybe<GetResourceUsersFilter>;
  resourceRequestId?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<ResourceUserSort> | ResourceUserSort>;
  isAvailabilityEnabled: Scalars['Boolean'];
  dateRange: DateRangeInput;
  startDate: Scalars['Date'];
  periodResolution: PeriodResolutionOption;
  scoreComputeType?: Maybe<ScoreComputeType>;
  tagIds?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  customFieldUris?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  includeCurrentDepartment: Scalars['Boolean'];
  includeResourcePools: Scalars['Boolean'];
  includeCurrentEmployeeType: Scalars['Boolean'];
  includeCurrentCostCenter: Scalars['Boolean'];
  includeCurrentServiceCenter: Scalars['Boolean'];
  includeCurrentDivision: Scalars['Boolean'];
  includeCurrentLocation: Scalars['Boolean'];
  includeSupervisorAssignment: Scalars['Boolean'];
  includeEmployeeId: Scalars['Boolean'];
  includeTags: Scalars['Boolean'];
  includeCustomFields: Scalars['Boolean'];
  skipMerge?: Maybe<Scalars['Boolean']>;
  includeRoleScheduleAsOfDate: Scalars['Boolean'];
  asOfDate?: Maybe<Scalars['Date2']>;
}>;


export type Eager_GetResourceUsersPaginatedQuery = { __typename?: 'Query', resourceUsers2?: Array<{ __typename?: 'ResourceUser', id: string, uri: string, slug: string, displayText: string, startDate?: any | null | undefined, endDate?: any | null | undefined, employeeId?: string | null | undefined, availabilityPercentage?: number | null | undefined, primaryRoleCostRate?: { __typename?: 'Money', amount?: number | null | undefined, currency?: { __typename?: 'Currency', id?: string | null | undefined, symbol?: string | null | undefined, displayText?: string | null | undefined } | null | undefined } | null | undefined, costRateAsOf?: { __typename?: 'Money', amount?: number | null | undefined, currency?: { __typename?: 'Currency', id?: string | null | undefined, symbol?: string | null | undefined, displayText?: string | null | undefined } | null | undefined } | null | undefined, matchScore?: { __typename?: 'MatchScore', score?: number | null | undefined, matchingDimensions?: Array<string | null | undefined> | null | undefined, unMatchedDimensions?: Array<string | null | undefined> | null | undefined, isError?: boolean | null | undefined, matchSkillsMetadata?: { __typename?: 'MatchSkillsMetaData', matchingSkillsCount: number, requestedSkillsCount: number } | null | undefined, matchResourcePoolsMetadata?: { __typename?: 'MatchResourcePoolsMetaData', matchingResourcePoolsCount: number, requestedResourcePoolsCount: number } | null | undefined, totalCost?: { __typename?: 'MatchScoreTotalCost', amount?: number | null | undefined, currency?: { __typename?: 'MatchScoreCurrency', uri?: string | null | undefined, symbol?: string | null | undefined } | null | undefined } | null | undefined, matchTagsMetadata?: { __typename?: 'MatchTagsMetaData', matchingTagsCount: number, requestedTagsCount: number } | null | undefined } | null | undefined, roleSchedules?: Array<{ __typename?: 'UserProjectRoleSchedule', effectiveDate?: any | null | undefined, projectRoles: Array<{ __typename?: 'UserProjectRole', isPrimary: boolean, projectRole: { __typename?: 'ProjectRole', uri?: string | null | undefined, name?: string | null | undefined } } | null | undefined> } | null | undefined> | null | undefined, roleSchedulesAsOfDate?: { __typename?: 'RoleScheduleAsOfDateResponse', effectiveRoleSchedule?: { __typename?: 'UserProjectRoleSchedule', effectiveDate?: any | null | undefined, projectRoles: Array<{ __typename?: 'UserProjectRole', isPrimary: boolean, projectRole: { __typename?: 'ProjectRole', uri?: string | null | undefined, name?: string | null | undefined } } | null | undefined> } | null | undefined } | null | undefined, resourceAvailabilitySummarySeries?: Array<{ __typename?: 'AvailabilityPeriod', dateRange: { __typename?: 'DateRange', startDate: any, endDate: any }, scheduledDuration: { __typename?: 'Duration', hours: number, minutes: number, seconds: number }, timeOffDuration: { __typename?: 'Duration', hours: number, minutes: number, seconds: number }, holidayDuration: { __typename?: 'Duration', hours: number, minutes: number, seconds: number }, overAllocatedDuration: { __typename?: 'Duration', hours: number, minutes: number, seconds: number }, allocatedDuration: { __typename?: 'Duration', hours: number, minutes: number, seconds: number } } | null | undefined> | null | undefined, holidays?: Array<{ __typename?: 'Holiday', date: any, uri: string, name: string, duration?: { __typename?: 'Duration', hours: number, minutes: number, seconds: number } | null | undefined, effectiveDuration: { __typename?: 'Duration', hours: number, minutes: number, seconds: number } } | null | undefined> | null | undefined, timeoffs?: Array<{ __typename?: 'Timeoff', hours?: number | null | undefined, days?: number | null | undefined, dateRange: { __typename?: 'DateRange', startDate: any, endDate: any }, timeOffType?: { __typename?: 'TimeOffType', displayText: string } | null | undefined, entries?: Array<{ __typename?: 'TimeOffEntryByDay', date: any, hours: number, days?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, supervisorAssignment?: { __typename?: 'SupervisorAssignment', effectiveDate?: any | null | undefined, supervisor?: { __typename?: 'Supervisor', uri?: string | null | undefined, displayText?: string | null | undefined } | null | undefined } | null | undefined, currentDepartment?: { __typename?: 'Groups', id?: string | null | undefined, displayText?: string | null | undefined, ancestors?: Array<{ __typename?: 'Groups', displayText?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, allResourcePools?: Array<{ __typename?: 'ResourcePool', id: string, slug: string, displayText: string }> | null | undefined, currentEmployeeType?: { __typename?: 'Groups', id?: string | null | undefined, displayText?: string | null | undefined, ancestors?: Array<{ __typename?: 'Groups', displayText?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, currentCostCenter?: { __typename?: 'Groups', id?: string | null | undefined, displayText?: string | null | undefined, ancestors?: Array<{ __typename?: 'Groups', displayText?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, currentServiceCenter?: { __typename?: 'Groups', id?: string | null | undefined, displayText?: string | null | undefined, ancestors?: Array<{ __typename?: 'Groups', displayText?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, currentDivision?: { __typename?: 'Groups', id?: string | null | undefined, displayText?: string | null | undefined, ancestors?: Array<{ __typename?: 'Groups', displayText?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, currentLocation?: { __typename?: 'Groups', id?: string | null | undefined, displayText?: string | null | undefined, ancestors?: Array<{ __typename?: 'Groups', displayText?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, tags?: Array<{ __typename?: 'TagAssignment', tag: { __typename?: 'Tag', id: string, name: string }, value?: { __typename?: 'TagValue', id: string, value: string } | null | undefined } | null | undefined> | null | undefined, customFieldValues?: Array<{ __typename?: 'CustomFieldValue', text?: string | null | undefined, date?: any | null | undefined, dropDownOptionUri?: string | null | undefined, number?: number | null | undefined, customField?: { __typename?: 'CustomFieldDefinitionReference', id?: string | null | undefined, uri?: string | null | undefined, displayText?: string | null | undefined, groupUri?: string | null | undefined } | null | undefined, customFieldType?: { __typename?: 'CustomFieldType', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined, customFieldDefinition?: { __typename?: 'CustomFieldDefinition', id?: string | null | undefined, uri?: string | null | undefined, displayText?: string | null | undefined, isEnabled?: boolean | null | undefined, isRequired?: boolean | null | undefined, isVisible?: boolean | null | undefined, type?: { __typename?: 'CustomFieldType', displayText?: string | null | undefined, uri?: string | null | undefined } | null | undefined, textConfiguration?: { __typename?: 'CustomFieldTextConfiguration', defaultTextValue?: string | null | undefined, maximumLength?: number | null | undefined } | null | undefined, dateConfiguration?: { __typename?: 'CustomFieldDateConfiguration', maximumDate?: any | null | undefined, minimumDate?: any | null | undefined, defaults?: { __typename?: 'CustomFieldDateDefaultsConfiguration', useTodayAsDefault?: boolean | null | undefined, value?: any | null | undefined } | null | undefined } | null | undefined, numericConfiguration?: { __typename?: 'CustomFieldNumericConfiguration', decimalPlaces?: number | null | undefined, defaultNumericValue?: number | null | undefined, maximumNumericValue?: number | null | undefined, minimumNumericValue?: number | null | undefined } | null | undefined, defaultDropDownValue?: { __typename?: 'CustomFieldDropdownOption', id?: string | null | undefined, displayText?: string | null | undefined, isDefaultValue?: boolean | null | undefined, isEnabled?: boolean | null | undefined, uri?: string | null | undefined } | null | undefined, dropDownOptions?: Array<{ __typename?: 'CustomFieldDropdownOption', id?: string | null | undefined, displayText?: string | null | undefined, isDefaultValue?: boolean | null | undefined, isEnabled?: boolean | null | undefined, uri?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type CurrentResourceCostRateQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  pagesize?: Maybe<Scalars['Int']>;
  filter?: Maybe<GetResourceUsersFilter>;
  targetCurrencyId?: Maybe<Scalars['String']>;
}>;


export type CurrentResourceCostRateQuery = { __typename?: 'Query', resourceUsers2?: Array<{ __typename?: 'ResourceUser', id: string, currentCostRateInTargetCurrency?: { __typename?: 'Money', amount?: number | null | undefined, currency?: { __typename?: 'Currency', symbol?: string | null | undefined, uri?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type CurrentRoleCostRateQueryVariables = Exact<{
  roleId: Scalars['String'];
  targetCurrencyId?: Maybe<Scalars['String']>;
}>;


export type CurrentRoleCostRateQuery = { __typename?: 'Query', role?: { __typename?: 'Role', id: string, currentRate?: { __typename?: 'Money', amount?: number | null | undefined, currency?: { __typename?: 'Currency', id?: string | null | undefined, symbol?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type TaskDetailsDataFragment = { __typename?: 'Task', id: string, uri?: string | null | undefined, slug?: string | null | undefined, displayText?: string | null | undefined, name?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined, initialEstimatedHours?: number | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, totalWorkToDate?: number | null | undefined, progressStatus?: TaskProgressStatus | null | undefined, fullPath?: Array<{ __typename?: 'TaskReference', id: string, uri?: string | null | undefined, slug?: string | null | undefined, displayText?: string | null | undefined } | null | undefined> | null | undefined, projectReference?: { __typename?: 'ProjectReference', id: string, displayText?: string | null | undefined } | null | undefined };

export type TaskEntryDetailsDataFragment = { __typename?: 'TaskEntry', id: string, hoursWorked?: number | null | undefined, hoursRemaining?: number | null | undefined, comment?: string | null | undefined, quality?: string | null | undefined, flagged?: boolean | null | undefined, estimatedCompletionDate?: any | null | undefined, entryDate?: any | null | undefined, approvalStatus_timestamp?: string | null | undefined, status?: string | null | undefined, totalWorkToDate?: number | null | undefined, revisionGroupUri?: string | null | undefined, estimatedDataAsOfTimestamp?: any | null | undefined, submittedTimestamp?: any | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined, override?: { __typename?: 'TaskEntryOverride', id: string, userUri?: string | null | undefined, hoursRemaining?: number | null | undefined, estimatedCompletionDate?: any | null | undefined, quality?: string | null | undefined, flagged?: boolean | null | undefined, comment?: string | null | undefined, status?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, displayText?: string | null | undefined, loginName?: string | null | undefined } | null | undefined } | null | undefined };

export type TaskEntryOverrideDataFragment = { __typename?: 'TaskEntryOverride', id: string, userUri?: string | null | undefined, hoursRemaining?: number | null | undefined, estimatedCompletionDate?: any | null | undefined, quality?: string | null | undefined, flagged?: boolean | null | undefined, comment?: string | null | undefined, status?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, displayText?: string | null | undefined, loginName?: string | null | undefined } | null | undefined };

export type Eager_GetMyInProgressTasksQueryVariables = Exact<{
  effectiveTimestamp: Scalars['Date2'];
  effectiveDateTime: Scalars['DateTime'];
}>;


export type Eager_GetMyInProgressTasksQuery = { __typename?: 'Query', me?: { __typename?: 'Me', id: string, inProgressTasks?: Array<{ __typename?: 'Task', isClosed?: boolean | null | undefined, id: string, uri?: string | null | undefined, slug?: string | null | undefined, displayText?: string | null | undefined, name?: string | null | undefined, code?: string | null | undefined, description?: string | null | undefined, initialEstimatedHours?: number | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, totalWorkToDate?: number | null | undefined, progressStatus?: TaskProgressStatus | null | undefined, taskEntries?: Array<{ __typename?: 'TaskEntry', rowNumber?: number | null | undefined, id: string, hoursWorked?: number | null | undefined, hoursRemaining?: number | null | undefined, comment?: string | null | undefined, quality?: string | null | undefined, flagged?: boolean | null | undefined, estimatedCompletionDate?: any | null | undefined, entryDate?: any | null | undefined, approvalStatus_timestamp?: string | null | undefined, status?: string | null | undefined, totalWorkToDate?: number | null | undefined, revisionGroupUri?: string | null | undefined, estimatedDataAsOfTimestamp?: any | null | undefined, submittedTimestamp?: any | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined, override?: { __typename?: 'TaskEntryOverride', id: string, userUri?: string | null | undefined, hoursRemaining?: number | null | undefined, estimatedCompletionDate?: any | null | undefined, quality?: string | null | undefined, flagged?: boolean | null | undefined, comment?: string | null | undefined, status?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, displayText?: string | null | undefined, loginName?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, currentUserTaskEstimates?: { __typename?: 'UserTaskEstimates', id: string, estimatedHours?: number | null | undefined, estimatedCompletionDate?: any | null | undefined, initialEstimate?: number | null | undefined } | null | undefined, fullPath?: Array<{ __typename?: 'TaskReference', id: string, uri?: string | null | undefined, slug?: string | null | undefined, displayText?: string | null | undefined } | null | undefined> | null | undefined, projectReference?: { __typename?: 'ProjectReference', id: string, displayText?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type SetTaskProgressStatusMutationVariables = Exact<{
  id: Scalars['String'];
  status: TaskProgressStatus;
  effectiveTimestamp: Scalars['Date'];
  effectiveTimestamp2: Scalars['Date2'];
  effectiveDateTimestamp: Scalars['DateTime'];
}>;


export type SetTaskProgressStatusMutation = { __typename?: 'Mutation', setTaskProgressStatus: { __typename?: 'SetTaskProgressStatusResult', task: { __typename?: 'Task', id: string, progressStatus?: TaskProgressStatus | null | undefined, totalWorkToDate?: number | null | undefined, taskEntries?: Array<{ __typename?: 'TaskEntry', id: string, hoursWorked?: number | null | undefined, hoursRemaining?: number | null | undefined, comment?: string | null | undefined, quality?: string | null | undefined, flagged?: boolean | null | undefined, estimatedCompletionDate?: any | null | undefined, entryDate?: any | null | undefined, approvalStatus_timestamp?: string | null | undefined, status?: string | null | undefined, totalWorkToDate?: number | null | undefined, revisionGroupUri?: string | null | undefined, estimatedDataAsOfTimestamp?: any | null | undefined, submittedTimestamp?: any | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, displayText?: string | null | undefined } | null | undefined, override?: { __typename?: 'TaskEntryOverride', id: string, userUri?: string | null | undefined, hoursRemaining?: number | null | undefined, estimatedCompletionDate?: any | null | undefined, quality?: string | null | undefined, flagged?: boolean | null | undefined, comment?: string | null | undefined, status?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, displayText?: string | null | undefined, loginName?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined } } };

export const ClientRatesFragmentDoc = gql`
    fragment ClientRates on Client {
  projectRate: projectRate2 {
    id
    billingScheduleEntries {
      effectiveDate: effectiveDate2
      amount {
        currency {
          id
          symbol
          displayText: symbol
        }
        amount
      }
    }
  }
  roleRates: roleRates2 {
    id
    roleReference {
      id
      displayText
    }
    billingScheduleEntries {
      effectiveDate: effectiveDate2
      amount {
        currency {
          id
          symbol
          displayText: symbol
        }
        amount
      }
    }
  }
  userRates: userRates2 {
    id
    userReference {
      id
      displayText
    }
    billingScheduleEntries {
      effectiveDate: effectiveDate2
      amount {
        currency {
          id
          symbol
          displayText: symbol
        }
        amount
      }
    }
  }
}
    `;
export const CustomFieldDefinitionFragmentDoc = gql`
    fragment CustomFieldDefinition on CustomFieldDefinition {
  id
  uri
  displayText
  isEnabled
  isRequired
  isVisible
  type {
    displayText
    uri
  }
  textConfiguration {
    defaultTextValue
    maximumLength
  }
  dateConfiguration {
    defaults {
      useTodayAsDefault
      value
    }
    maximumDate
    minimumDate
  }
  numericConfiguration {
    decimalPlaces
    defaultNumericValue
    maximumNumericValue
    minimumNumericValue
  }
  defaultDropDownValue {
    id
    displayText
    isDefaultValue
    isEnabled
    uri
  }
  dropDownOptions {
    id
    displayText
    isDefaultValue
    isEnabled
    uri
  }
}
    `;
export const CustomFieldValueFragmentDoc = gql`
    fragment CustomFieldValue on CustomFieldValue {
  customField {
    id
    uri
    displayText
    groupUri
  }
  customFieldType {
    id
    displayText
  }
  customFieldDefinition {
    ...CustomFieldDefinition
  }
  text
  date
  dropDownOptionUri
  number
}
    ${CustomFieldDefinitionFragmentDoc}`;
export const ClientFragmentDoc = gql`
    fragment Client on Client {
  id
  name
  slug
  code
  isActive
  comment
  defaultInvoicePaymentTerm
  invoiceCurrency {
    id
    symbol
  }
  taxProfile {
    id
    displayText
  }
  invoiceTemplate {
    id
    displayText
  }
  clientManager {
    id
    displayText
  }
  contactName
  contactInfo {
    address
    city
    country {
      id
      displayText
    }
    email
    faxNumber
    phoneNumber
    stateProvince
    website
    zipPostalCode
  }
  billingContactInfo {
    address
    city
    country {
      id
      displayText
    }
    email
    faxNumber
    phoneNumber
    stateProvince
    website
    zipPostalCode
  }
  clientRepresentatives {
    id
    displayText
  }
  comanagers {
    id
    displayText
  }
  customFieldValues {
    ...CustomFieldValue
  }
  projectsStatusCountSummary {
    initiate
    planning
    execution
    closed
    total
  }
  billingSettings {
    billLineItemsBy
    description
    internalNotes
    showComments
    billFrequency
    billFrequencyAbsoluteDate
    consolidateBillsBy
  }
}
    ${CustomFieldValueFragmentDoc}`;
export const ProgramStatusFragmentDoc = gql`
    fragment ProgramStatus on Program {
  isActive
}
    `;
export const ResourceRoleScheduleFragmentDoc = gql`
    fragment ResourceRoleSchedule on ResourceDetails {
  id
  roleScheduleDetails {
    effectiveDate
    projectRoles {
      isPrimary
      projectRole {
        uri
        name
      }
    }
  }
}
    `;
export const RequestAttributeWeightsFragmentDoc = gql`
    fragment RequestAttributeWeights on RequestAttributeWeights {
  location
  division
  serviceCenter
  costCenter
  department
  employeeType
  role
  skills
  tags
  requestedCostRate
  resourcePools
  preferredResources
}
    `;
export const SpecificResourceRequestFragmentDoc = gql`
    fragment SpecificResourceRequest on ResourceRequest {
  id
  projectUri
  role {
    id
    displayText
    currentRate {
      amount
      currency {
        id
        displayText
      }
    }
  }
  resourcePools {
    id
    displayText
  }
  location {
    id
    displayText
  }
  division {
    id
    displayText
  }
  serviceCenter {
    id
    displayText
  }
  costCenter {
    id
    displayText
  }
  employeeType {
    id
    displayText
  }
  department {
    id
    displayText
  }
  quantity
  comment
  scheduleRules {
    dateRange {
      startDate
      endDate
    }
    do
  }
  startDate
  endDate
  load
  isAdjustedLoading
  roleRate
  requestStatus
  currencyUri
  totalHours
  currency {
    id
    displayText
  }
  skills {
    id
    displayText
    category {
      id
      displayText
    }
    skillLevel {
      id
      rating
    }
  }
  tags {
    id
    tag {
      id
      name
      values {
        value
        id
      }
    }
    value {
      id
      value
    }
  }
  requestAttributeWeights {
    ...RequestAttributeWeights
  }
  exchangeRateValues {
    projectBudgetCurrency {
      currencyId
      rate
    }
    baseCurrency {
      currencyId
      rate
    }
  }
  preferredResources {
    id
    displayText
  }
  sourceMetadata {
    sourcedFromAI
    hiringStatus
  }
}
    ${RequestAttributeWeightsFragmentDoc}`;
export const TaskDetailsDataFragmentDoc = gql`
    fragment TaskDetailsData on Task {
  id
  uri
  slug
  displayText
  name
  code
  description
  initialEstimatedHours
  totalWorkToDate: totalWorkToDate2(effectiveTimestamp: $effectiveDateTime)
  startDate
  endDate
  progressStatus: progressStatus2(effectiveTimestamp: $effectiveTimestamp)
  fullPath {
    id
    uri
    slug
    displayText
  }
  projectReference {
    id
    displayText
  }
}
    `;
export const TaskEntryOverrideDataFragmentDoc = gql`
    fragment TaskEntryOverrideData on TaskEntryOverride {
  id
  userUri
  hoursRemaining
  estimatedCompletionDate
  quality
  flagged
  comment
  status
  user {
    id
    displayText
    loginName
  }
}
    `;
export const TaskEntryDetailsDataFragmentDoc = gql`
    fragment TaskEntryDetailsData on TaskEntry {
  id
  hoursWorked
  hoursRemaining
  comment
  quality
  flagged
  estimatedCompletionDate
  entryDate
  submittedTimestamp: submittedTimestamp2
  approvalStatus_timestamp
  status
  totalWorkToDate
  user {
    id
    displayText
  }
  override {
    ...TaskEntryOverrideData
  }
  revisionGroupUri
  estimatedDataAsOfTimestamp
}
    ${TaskEntryOverrideDataFragmentDoc}`;
export const ClientDocument = gql`
    query client($slug: String!) {
  client(slug: $slug) {
    id
    displayText
    slug
    defaultInvoicePaymentTerm
    clientManager {
      id
    }
    comanagers {
      id
    }
    invoiceCurrency {
      id
      displayText
      symbol
    }
    invoiceTemplate {
      id
      displayText
    }
  }
}
    `;

/**
 * __useClientQuery__
 *
 * To run a query within a React component, call `useClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useClientQuery(baseOptions: Apollo.QueryHookOptions<ClientQuery, ClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientQuery, ClientQueryVariables>(ClientDocument, options);
      }
export function useClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientQuery, ClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientQuery, ClientQueryVariables>(ClientDocument, options);
        }
export type ClientQueryHookResult = ReturnType<typeof useClientQuery>;
export type ClientLazyQueryHookResult = ReturnType<typeof useClientLazyQuery>;
export type ClientQueryResult = Apollo.QueryResult<ClientQuery, ClientQueryVariables>;
export const GetClientRatesDocument = gql`
    query GetClientRates($uri: String!, $roleRatePage: Int, $roleRatePageSize: Int, $resourceRatePage: Int, $resourceRatePageSize: Int) {
  client(uri: $uri) {
    id
    projectRate: projectRate2 {
      id
      billingScheduleEntries {
        effectiveDate: effectiveDate2
        amount {
          currency {
            id
            symbol
            displayText: symbol
          }
          amount
        }
      }
    }
    roleRates: roleRates2(page: $roleRatePage, pageSize: $roleRatePageSize) {
      id
      roleReference {
        id
        displayText
      }
      billingScheduleEntries {
        effectiveDate: effectiveDate2
        amount {
          currency {
            id
            symbol
            displayText: symbol
          }
          amount
        }
      }
    }
    roleRatesCount: roleRatesCount2
    userRatesCount: userRatesCount2
    userRates: userRates2(page: $resourceRatePage, pageSize: $resourceRatePageSize) {
      id
      userReference {
        id
        displayText
      }
      billingScheduleEntries {
        effectiveDate: effectiveDate2
        amount {
          currency {
            id
            symbol
            displayText: symbol
          }
          amount
        }
      }
    }
  }
}
    `;

/**
 * __useGetClientRatesQuery__
 *
 * To run a query within a React component, call `useGetClientRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientRatesQuery({
 *   variables: {
 *      uri: // value for 'uri'
 *      roleRatePage: // value for 'roleRatePage'
 *      roleRatePageSize: // value for 'roleRatePageSize'
 *      resourceRatePage: // value for 'resourceRatePage'
 *      resourceRatePageSize: // value for 'resourceRatePageSize'
 *   },
 * });
 */
export function useGetClientRatesQuery(baseOptions: Apollo.QueryHookOptions<GetClientRatesQuery, GetClientRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientRatesQuery, GetClientRatesQueryVariables>(GetClientRatesDocument, options);
      }
export function useGetClientRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientRatesQuery, GetClientRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientRatesQuery, GetClientRatesQueryVariables>(GetClientRatesDocument, options);
        }
export type GetClientRatesQueryHookResult = ReturnType<typeof useGetClientRatesQuery>;
export type GetClientRatesLazyQueryHookResult = ReturnType<typeof useGetClientRatesLazyQuery>;
export type GetClientRatesQueryResult = Apollo.QueryResult<GetClientRatesQuery, GetClientRatesQueryVariables>;
export const PutClientRatesDocument = gql`
    mutation putClientRates($clientId: String!, $rates: [ProjectRateInput2!]) {
  putClientRates: putClientRates3(clientId: $clientId, rates: $rates) {
    client {
      id
      ...ClientRates
    }
  }
}
    ${ClientRatesFragmentDoc}`;
export type PutClientRatesMutationFn = Apollo.MutationFunction<PutClientRatesMutation, PutClientRatesMutationVariables>;

/**
 * __usePutClientRatesMutation__
 *
 * To run a mutation, you first call `usePutClientRatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePutClientRatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [putClientRatesMutation, { data, loading, error }] = usePutClientRatesMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      rates: // value for 'rates'
 *   },
 * });
 */
export function usePutClientRatesMutation(baseOptions?: Apollo.MutationHookOptions<PutClientRatesMutation, PutClientRatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PutClientRatesMutation, PutClientRatesMutationVariables>(PutClientRatesDocument, options);
      }
export type PutClientRatesMutationHookResult = ReturnType<typeof usePutClientRatesMutation>;
export type PutClientRatesMutationResult = Apollo.MutationResult<PutClientRatesMutation>;
export type PutClientRatesMutationOptions = Apollo.BaseMutationOptions<PutClientRatesMutation, PutClientRatesMutationVariables>;
export const ClientBySlugDocument = gql`
    query clientBySlug($slug: String!) {
  client(slug: $slug) {
    ...Client
    permittedActionUris
  }
}
    ${ClientFragmentDoc}`;

/**
 * __useClientBySlugQuery__
 *
 * To run a query within a React component, call `useClientBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useClientBySlugQuery(baseOptions: Apollo.QueryHookOptions<ClientBySlugQuery, ClientBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientBySlugQuery, ClientBySlugQueryVariables>(ClientBySlugDocument, options);
      }
export function useClientBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientBySlugQuery, ClientBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientBySlugQuery, ClientBySlugQueryVariables>(ClientBySlugDocument, options);
        }
export type ClientBySlugQueryHookResult = ReturnType<typeof useClientBySlugQuery>;
export type ClientBySlugLazyQueryHookResult = ReturnType<typeof useClientBySlugLazyQuery>;
export type ClientBySlugQueryResult = Apollo.QueryResult<ClientBySlugQuery, ClientBySlugQueryVariables>;
export const ActiveRolesDocument = gql`
    query activeRoles($page: Int, $pageSize: Int, $searchTerm: String, $targetCurrencyId: String, $isCurrentRateEnabled: Boolean!, $includeSkills: Boolean!, $includeBillingScheduleEntries: Boolean = false) {
  activeRoles(page: $page, pageSize: $pageSize, searchTerm: $searchTerm) {
    id
    displayText
    currentRate(targetCurrencyId: $targetCurrencyId) @include(if: $isCurrentRateEnabled) {
      amount
      currency {
        id
        displayText
      }
    }
    skills @include(if: $includeSkills) {
      id
      displayText
      category {
        id
        displayText
      }
      skillLevel {
        id
        rating
      }
    }
    billingScheduleEntries @include(if: $includeBillingScheduleEntries) {
      effectiveDate
      amount {
        currency {
          id
          displayText
        }
        amount
      }
    }
  }
}
    `;

/**
 * __useActiveRolesQuery__
 *
 * To run a query within a React component, call `useActiveRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveRolesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      searchTerm: // value for 'searchTerm'
 *      targetCurrencyId: // value for 'targetCurrencyId'
 *      isCurrentRateEnabled: // value for 'isCurrentRateEnabled'
 *      includeSkills: // value for 'includeSkills'
 *      includeBillingScheduleEntries: // value for 'includeBillingScheduleEntries'
 *   },
 * });
 */
export function useActiveRolesQuery(baseOptions: Apollo.QueryHookOptions<ActiveRolesQuery, ActiveRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveRolesQuery, ActiveRolesQueryVariables>(ActiveRolesDocument, options);
      }
export function useActiveRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveRolesQuery, ActiveRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveRolesQuery, ActiveRolesQueryVariables>(ActiveRolesDocument, options);
        }
export type ActiveRolesQueryHookResult = ReturnType<typeof useActiveRolesQuery>;
export type ActiveRolesLazyQueryHookResult = ReturnType<typeof useActiveRolesLazyQuery>;
export type ActiveRolesQueryResult = Apollo.QueryResult<ActiveRolesQuery, ActiveRolesQueryVariables>;
export const GetDailyAllocationHoursSummaryForDateRangeDocument = gql`
    query getDailyAllocationHoursSummaryForDateRange($input: DailyMyAllocationHoursSummaryForDateRangeInput!) {
  me {
    id
    dailyAllocationHoursSummaryForDateRange(input: $input) {
      hasMoreAllocations
      projects {
        project {
          displayText
          name
          slug
        }
        days {
          date
          allocatedHours
          actualHours
        }
        tasks {
          task {
            id
            uri
            displayText
            name
          }
          fullPath {
            displayText
            name
          }
          days {
            date
            allocatedHours
            actualHours
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetDailyAllocationHoursSummaryForDateRangeQuery__
 *
 * To run a query within a React component, call `useGetDailyAllocationHoursSummaryForDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyAllocationHoursSummaryForDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyAllocationHoursSummaryForDateRangeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDailyAllocationHoursSummaryForDateRangeQuery(baseOptions: Apollo.QueryHookOptions<GetDailyAllocationHoursSummaryForDateRangeQuery, GetDailyAllocationHoursSummaryForDateRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyAllocationHoursSummaryForDateRangeQuery, GetDailyAllocationHoursSummaryForDateRangeQueryVariables>(GetDailyAllocationHoursSummaryForDateRangeDocument, options);
      }
export function useGetDailyAllocationHoursSummaryForDateRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyAllocationHoursSummaryForDateRangeQuery, GetDailyAllocationHoursSummaryForDateRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyAllocationHoursSummaryForDateRangeQuery, GetDailyAllocationHoursSummaryForDateRangeQueryVariables>(GetDailyAllocationHoursSummaryForDateRangeDocument, options);
        }
export type GetDailyAllocationHoursSummaryForDateRangeQueryHookResult = ReturnType<typeof useGetDailyAllocationHoursSummaryForDateRangeQuery>;
export type GetDailyAllocationHoursSummaryForDateRangeLazyQueryHookResult = ReturnType<typeof useGetDailyAllocationHoursSummaryForDateRangeLazyQuery>;
export type GetDailyAllocationHoursSummaryForDateRangeQueryResult = Apollo.QueryResult<GetDailyAllocationHoursSummaryForDateRangeQuery, GetDailyAllocationHoursSummaryForDateRangeQueryVariables>;
export const GetKeyValueSettingsDocument = gql`
    query GetKeyValueSettings($key: String!) {
  keyValueSettings(key: $key)
}
    `;

/**
 * __useGetKeyValueSettingsQuery__
 *
 * To run a query within a React component, call `useGetKeyValueSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKeyValueSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKeyValueSettingsQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetKeyValueSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetKeyValueSettingsQuery, GetKeyValueSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKeyValueSettingsQuery, GetKeyValueSettingsQueryVariables>(GetKeyValueSettingsDocument, options);
      }
export function useGetKeyValueSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKeyValueSettingsQuery, GetKeyValueSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKeyValueSettingsQuery, GetKeyValueSettingsQueryVariables>(GetKeyValueSettingsDocument, options);
        }
export type GetKeyValueSettingsQueryHookResult = ReturnType<typeof useGetKeyValueSettingsQuery>;
export type GetKeyValueSettingsLazyQueryHookResult = ReturnType<typeof useGetKeyValueSettingsLazyQuery>;
export type GetKeyValueSettingsQueryResult = Apollo.QueryResult<GetKeyValueSettingsQuery, GetKeyValueSettingsQueryVariables>;
export const GetUserBeatAppDownloadUrlDocument = gql`
    query getUserBeatAppDownloadUrl($os: OSType!) {
  getUserBeatAppDownloadUrl(os: $os) {
    url
  }
}
    `;

/**
 * __useGetUserBeatAppDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetUserBeatAppDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserBeatAppDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserBeatAppDownloadUrlQuery({
 *   variables: {
 *      os: // value for 'os'
 *   },
 * });
 */
export function useGetUserBeatAppDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetUserBeatAppDownloadUrlQuery, GetUserBeatAppDownloadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserBeatAppDownloadUrlQuery, GetUserBeatAppDownloadUrlQueryVariables>(GetUserBeatAppDownloadUrlDocument, options);
      }
export function useGetUserBeatAppDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserBeatAppDownloadUrlQuery, GetUserBeatAppDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserBeatAppDownloadUrlQuery, GetUserBeatAppDownloadUrlQueryVariables>(GetUserBeatAppDownloadUrlDocument, options);
        }
export type GetUserBeatAppDownloadUrlQueryHookResult = ReturnType<typeof useGetUserBeatAppDownloadUrlQuery>;
export type GetUserBeatAppDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetUserBeatAppDownloadUrlLazyQuery>;
export type GetUserBeatAppDownloadUrlQueryResult = Apollo.QueryResult<GetUserBeatAppDownloadUrlQuery, GetUserBeatAppDownloadUrlQueryVariables>;
export const GetMeDocument = gql`
    query getMe {
  me {
    id
    displayText
    loginName
    firstName
    lastName
    slug
    uri
    servicesUrl
    locale {
      dateTimeSettings {
        shortDateFormat {
          dotNetPattern
        }
        shortTimeFormat {
          dotNetPattern
        }
      }
      numberSettings {
        number {
          decimalDigits
          decimalSeparator
          dotNetNegativePattern
          dotNetPositivePattern
          groupSeparator
          groupSizes
          negativeSign
          positiveSign
        }
        currency {
          decimalDigits
          decimalSeparator
          dotNetNegativePattern
          dotNetPositivePattern
          groupSeparator
          groupSizes
          negativeSign
          positiveSign
        }
      }
      language {
        cultureCode
        displayText
        uri
        languageCode
      }
      timeZone {
        displayText
        ianaName
        offsetDisplayText
        uri
      }
      customTerms {
        originalTerm
        customTerm
      }
    }
    billingProcessType
    defaultRequestAttributeWeights {
      ...RequestAttributeWeights
    }
    featureFlags {
      isPsaEarnedRevenueEnabled: featureFlagBool(
        flagKey: "psa-prp-earned-revenue"
        defaultValue: false
      )
      isPsaPrpAccessibilityIssuesEnabled: featureFlagBool(
        flagKey: "psa-prp-accessibility-issues"
        defaultValue: false
      )
      isPsaPrpAccessabilityEnhancements2025Enabled: featureFlagBool(
        flagKey: "psa-prp-accessability-enhancements-2025"
        defaultValue: false
      )
      isPsaPrp2023q3BugFixesEnabled: featureFlagBool(
        flagKey: "psa-prp-2023q3-bug-fixes"
        defaultValue: false
      )
      isPsaPrpInvoiceBillingRateEnabled: featureFlagBool(
        flagKey: "psa-prp-invoice-billing-rate"
        defaultValue: false
      )
      isPsaPrpEmbedSchedulesInPolarisEnabled: featureFlagBool(
        flagKey: "psa-prp-embed-schedules-in-polaris"
        defaultValue: false
      )
      isPsaPrpPreventZeroAmountEnabled: featureFlagBool(
        flagKey: "psa-prp-prevent-zero-amount-line-items"
        defaultValue: false
      )
      isPsaPrpAddContactDetailsToTheProjectEnabled: featureFlagBool(
        flagKey: "psa-prp-add-contact-details-to-the-project"
        defaultValue: false
      )
      isPsaPrpBillUiEnhancementsEnabled: featureFlagBool(
        flagKey: "psa-prp-bill-ui-enhancements"
        defaultValue: false
      )
      isPsaPrpManualTaskStatusEnabled: featureFlagBool(
        flagKey: "psa-prp-manual-task-status"
        defaultValue: false
      )
      isPSATaskEstimateRollUpMobileViewEnabled: featureFlagBool(
        flagKey: "psa-task-estimate-rollup-mobile-view"
        defaultValue: false
      )
      isWBSEnabled: featureFlagBool(
        flagKey: "core-wbs-timesheet-search"
        defaultValue: false
      )
      isPSAQuickAllocationDemandEnabled: featureFlagBool(
        flagKey: "psa-rmp-quick-allocation-demand"
        defaultValue: false
      )
      isPsaProjectRiskEnabled: featureFlagBool(
        flagKey: "psa-project-risk-recommendation-system-ui"
        defaultValue: false
      )
      isPsaFPOvertimeBillingEnabled: featureFlagBool(
        flagKey: "psa-fp-overtime-billing"
        defaultValue: false
      )
      isPsaRescheduleProjectHintEnabled: featureFlagBool(
        flagKey: "psa-reschedule-project-hint"
        defaultValue: false
      )
      isPsaPrpTaskBeatUpdates2Enabled: featureFlagBool(
        flagKey: "psa-prp-task-beat-updates-2"
        defaultValue: false
      )
      PSAPRPTaskEstimateCalculation: featureFlagString(
        flagKey: "psa-prp-task-estimate-calculation"
        defaultValue: "Off"
      )
      isPsaPrpWcagFixesQ4Enabled: featureFlagBool(
        flagKey: "psa-prp-wcag-fixes-q4"
        defaultValue: false
      )
      isPsaFpAdvancedRateCardEnabled: featureFlagBool(
        flagKey: "psa-fp-advanced-rate-card"
        defaultValue: false
      )
      isPsaPrpProjectStatusChangeNotificationEnabled: featureFlagBool(
        flagKey: "psa-prp-project-status-change-notification"
        defaultValue: false
      )
      isPsaPrpVendorUiEnabled: featureFlagBool(
        flagKey: "psa-prp-vendor-ui"
        defaultValue: false
      )
      isPsaPrpRiskScoreEnabled: featureFlagBool(
        flagKey: "psa-prp-risk-score"
        defaultValue: false
      )
      isPsaRmpTaskAllocation1Enabled: featureFlagBool(
        flagKey: "psa-rmp-TaskAllocation1"
        defaultValue: false
      )
      isRmpTaskAllocationPhase2Enabled: featureFlagBool(
        flagKey: "psa-rmp-TaskAllocation2"
        defaultValue: false
      )
      isRmpTaskAllocationEnhancement1: featureFlagBool(
        flagKey: "psa-rmp-taskAllocation-Enhancement1"
        defaultValue: false
      )
      isRmp2025Q4Enhancements: featureFlagBool(
        flagKey: "psa-rmp-2025q4-enhancements"
        defaultValue: false
      )
      isRmp2026Q1PerfFixesEnabled: featureFlagBool(
        flagKey: "psa-rmp-reschedule-project-perf"
        defaultValue: false
      )
      isRmp2026Q1Enhancements: featureFlagBool(
        flagKey: "psa-rmp-2026q1-enhancements"
        defaultValue: false
      )
      repliconAssistant: featureFlagString(
        flagKey: "psa-replicon-assistant"
        defaultValue: "off"
      )
      projectRiskSummary: featureFlagString(
        flagKey: "psa-ti-project-risk-summary"
        defaultValue: "off"
      )
      isPsaPrpRenameProjectStatus2Enabled: featureFlagBool(
        flagKey: "psa-prp-rename-project-status-2"
        defaultValue: false
      )
      isPsaPswatBillingDraftSubStatusEnabled: featureFlagBool(
        flagKey: "psa-pswat-billing-draft-sub-status"
      )
      isPsaPraaResourceMatchingEnabled: featureFlagBool(
        flagKey: "psa-praa-resource-matching"
        defaultValue: false
      )
      isPsaPrpAddProjectColumnOnAvailableToBillEnabled: featureFlagBool(
        flagKey: "psa-prp-add-project-column-on-available-to-bill"
        defaultValue: false
      )
      isPsaDtmRequisitionEnabled: featureFlagBool(
        flagKey: "psa-rmp-dtm-requsitions"
        defaultValue: false
      )
      isPsaPrpMoveTimeEnabled: featureFlagBool(
        flagKey: "psa-prp-move-time"
        defaultValue: false
      )
      isPsaPrpExpenseAmountChangeInLoopFixEnabled: featureFlagBool(
        flagKey: "psa-prp-expense-amount-change-in-loop-fix"
        defaultValue: false
      )
      isPsaPraaUserProfileNudgesEnabled: featureFlagBool(
        flagKey: "psa-praa-user-profile-nudges"
        defaultValue: false
      )
      isPsaPrpRoleFilterOnTasksEnabled: featureFlagBool(
        flagKey: "psa-prp-role-filter-on-tasks"
        defaultValue: false
      )
      isPsaPrpExpenseCardPerformanceFixEnabled: featureFlagBool(
        flagKey: "psa-prp-expense-card-performance-fix"
        defaultValue: false
      )
      isPsaPrpCustomLineItemParityFlagEnabled: featureFlagBool(
        flagKey: "psa-prp-custom-line-item-parity-gen3"
        defaultValue: false
      )
      isPsaPrpMassEditBackgroundJobEnabled: featureFlagBool(
        flagKey: "psa-prp-mass-edit-background-job"
      )
      isPsaPrpGainsightEnabled: featureFlagBool(
        flagKey: "psa-prp-gainsight"
        defaultValue: false
      )
      isPsaRmp2025Q3WcagEnabled: featureFlagBool(
        flagKey: "psa-rmp-2025q3-wcag"
        defaultValue: false
      )
      isPsaRmp2025Q4WcagEnabled: featureFlagBool(
        flagKey: "psa-rmp-2025q4-wcag"
        defaultValue: false
      )
      isDecoupleCostDataPermissionEnabled: featureFlagBool(
        flagKey: "psa-prp-decouple-cost-data-permission"
        defaultValue: false
      )
      isPsaRmpSkillAnalyticsEnabled: featureFlagBool(
        flagKey: "psa-rmp-skill-analytics"
        defaultValue: false
      )
      isPsaPrpUnisysResourceManagementHiddenEnabled: featureFlagBool(
        flagKey: "psa-prp-unisys-resource-management-hidden"
        defaultValue: false
      )
      isPsaRmpDesktopAppLinkRemovalEnabled: featureFlagBool(
        flagKey: "psa-rmp-desktopapp-linkremoval"
        defaultValue: false
      )
      isPsaRmpSetResourceAllocationEnabled: featureFlagBool(
        flagKey: "psa-rmp-set-reoccurent-allocation"
        defaultValue: false
      )
    }
    isExpenseProductEnabled
    legacyDepartmentDisabled
    legacyEmployeeTypeDisabled
    helpUrl
    groupSettings {
      location {
        isEnabled
        pluralName
        singularName
      }
      department {
        isEnabled
        pluralName
        singularName
      }
      division {
        isEnabled
        pluralName
        singularName
      }
      employeeType {
        isEnabled
        pluralName
        singularName
      }
      costCenter {
        isEnabled
        pluralName
        singularName
      }
      serviceCenter {
        isEnabled
        pluralName
        singularName
      }
    }
    permissions {
      permissionActionUri
      dataAccessLevelUris
    }
    userAccessRoles
    sessionTimeoutDuration {
      days
      hours
      minutes
      seconds
      milliseconds
    }
    companyKey
    tenantSlug
    logoutHref
    uiRootPath
    baseCurrency {
      id
      uri
      name
      symbol
      displayText
    }
    workWeekStartDay {
      displayText
      uri
    }
    emailAddress
    cpoUrl
    zeroTimeUrl
    gainsightTagKey
    projectNameAndCodeUniqueness
    clientNameAndCodeUniqueness
    substituteUserMetadata {
      actionHref
      actionText
      bannerText
      userName
    }
    serverNodeEnv
    swimlane
    substituteUsers {
      id
      uri
      displayText
    }
    tenantType
    hasEditTargetBillableHours: hasTenantPermission(
      permissionUri: "urn:replicon:user-productivity-target-action:edit-target-billable-hours"
    )
    hasViewClientBillingData: hasTenantPermission(
      permissionUri: "urn:replicon:client-action:view-billing-data"
    )
    hasEditProjectBillingContracts: hasTenantPermission(
      permissionUri: "urn:replicon:project-action:edit-billing-contracts"
    )
    hasViewProjectBillingRates: hasTenantPermission(
      permissionUri: "urn:replicon:project-action:view-billing-rates"
    )
    hasViewProjectBillingOptions: hasTenantPermission(
      permissionUri: "urn:replicon:project-action:view-billing-options"
    )
    hasViewProjectCostType: hasTenantPermission(
      permissionUri: "urn:replicon:project-action:view-cost-type"
    )
    hasViewTaxProfile: hasTenantPermission(
      permissionUri: "urn:replicon:tax-profile-action:view-tax-profile"
    )
    hasClientManagerRole: hasTenantRole(
      roleUri: "urn:replicon:user-access-role:client-manager"
    )
    hasClientRepresentativeRole: hasTenantRole(
      roleUri: "urn:replicon:user-access-role:client-representative"
    )
    resourceCostMode
    resourcePlanningLimitInYears
    isRolledUpTaskEstimateCalculationMethodEnabled
    currentTimeInUserTimeZone
    projectRequestScoreScaleDetails {
      value {
        scale
        label
      }
      risk {
        scale
        label
      }
      investment {
        scale
        label
      }
    }
    isTimePunchAllowedFromAnyPunchSource
    isLogToSentryEnabled
    isFipsEnabled
    isGainsightDisabled
  }
}
    ${RequestAttributeWeightsFragmentDoc}`;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const GetProgramBySlugDocument = gql`
    query getProgramBySlug($programSlug: String!) {
  program(programSlug: $programSlug) {
    id
    uri
    slug
    name
    programManagerReference {
      id
      uri
      displayText
    }
    displayText
    budget {
      capital {
        amount
        currency {
          id
          displayText
          symbol
        }
      }
      operational {
        amount
        currency {
          id
          displayText
          symbol
        }
      }
      total {
        amount
        currency {
          id
          displayText
          symbol
        }
      }
    }
    startDate
    endDate
    projectsStatusCountSummary {
      initiate
      planning
      execution
      closed
      total
    }
    permittedActionUris
    ...ProgramStatus
  }
}
    ${ProgramStatusFragmentDoc}`;

/**
 * __useGetProgramBySlugQuery__
 *
 * To run a query within a React component, call `useGetProgramBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramBySlugQuery({
 *   variables: {
 *      programSlug: // value for 'programSlug'
 *   },
 * });
 */
export function useGetProgramBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetProgramBySlugQuery, GetProgramBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgramBySlugQuery, GetProgramBySlugQueryVariables>(GetProgramBySlugDocument, options);
      }
export function useGetProgramBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgramBySlugQuery, GetProgramBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgramBySlugQuery, GetProgramBySlugQueryVariables>(GetProgramBySlugDocument, options);
        }
export type GetProgramBySlugQueryHookResult = ReturnType<typeof useGetProgramBySlugQuery>;
export type GetProgramBySlugLazyQueryHookResult = ReturnType<typeof useGetProgramBySlugLazyQuery>;
export type GetProgramBySlugQueryResult = Apollo.QueryResult<GetProgramBySlugQuery, GetProgramBySlugQueryVariables>;
export const CreateProjectBillingContractScriptRecalculationBatchDocument = gql`
    mutation createProjectBillingContractScriptRecalculationBatch($projectBillingContractScriptUris: [String!]!) {
  createProjectBillingContractScriptRecalculationBatch(
    projectBillingContractScriptUris: $projectBillingContractScriptUris
  ) {
    batchUri
  }
}
    `;
export type CreateProjectBillingContractScriptRecalculationBatchMutationFn = Apollo.MutationFunction<CreateProjectBillingContractScriptRecalculationBatchMutation, CreateProjectBillingContractScriptRecalculationBatchMutationVariables>;

/**
 * __useCreateProjectBillingContractScriptRecalculationBatchMutation__
 *
 * To run a mutation, you first call `useCreateProjectBillingContractScriptRecalculationBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectBillingContractScriptRecalculationBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectBillingContractScriptRecalculationBatchMutation, { data, loading, error }] = useCreateProjectBillingContractScriptRecalculationBatchMutation({
 *   variables: {
 *      projectBillingContractScriptUris: // value for 'projectBillingContractScriptUris'
 *   },
 * });
 */
export function useCreateProjectBillingContractScriptRecalculationBatchMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectBillingContractScriptRecalculationBatchMutation, CreateProjectBillingContractScriptRecalculationBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectBillingContractScriptRecalculationBatchMutation, CreateProjectBillingContractScriptRecalculationBatchMutationVariables>(CreateProjectBillingContractScriptRecalculationBatchDocument, options);
      }
export type CreateProjectBillingContractScriptRecalculationBatchMutationHookResult = ReturnType<typeof useCreateProjectBillingContractScriptRecalculationBatchMutation>;
export type CreateProjectBillingContractScriptRecalculationBatchMutationResult = Apollo.MutationResult<CreateProjectBillingContractScriptRecalculationBatchMutation>;
export type CreateProjectBillingContractScriptRecalculationBatchMutationOptions = Apollo.BaseMutationOptions<CreateProjectBillingContractScriptRecalculationBatchMutation, CreateProjectBillingContractScriptRecalculationBatchMutationVariables>;
export const GetMyDefaultRequestAttributeWeightsDocument = gql`
    query GetMyDefaultRequestAttributeWeights {
  me {
    id
    defaultRequestAttributeWeights {
      ...RequestAttributeWeights
    }
  }
}
    ${RequestAttributeWeightsFragmentDoc}`;

/**
 * __useGetMyDefaultRequestAttributeWeightsQuery__
 *
 * To run a query within a React component, call `useGetMyDefaultRequestAttributeWeightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDefaultRequestAttributeWeightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDefaultRequestAttributeWeightsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyDefaultRequestAttributeWeightsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyDefaultRequestAttributeWeightsQuery, GetMyDefaultRequestAttributeWeightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyDefaultRequestAttributeWeightsQuery, GetMyDefaultRequestAttributeWeightsQueryVariables>(GetMyDefaultRequestAttributeWeightsDocument, options);
      }
export function useGetMyDefaultRequestAttributeWeightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyDefaultRequestAttributeWeightsQuery, GetMyDefaultRequestAttributeWeightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyDefaultRequestAttributeWeightsQuery, GetMyDefaultRequestAttributeWeightsQueryVariables>(GetMyDefaultRequestAttributeWeightsDocument, options);
        }
export type GetMyDefaultRequestAttributeWeightsQueryHookResult = ReturnType<typeof useGetMyDefaultRequestAttributeWeightsQuery>;
export type GetMyDefaultRequestAttributeWeightsLazyQueryHookResult = ReturnType<typeof useGetMyDefaultRequestAttributeWeightsLazyQuery>;
export type GetMyDefaultRequestAttributeWeightsQueryResult = Apollo.QueryResult<GetMyDefaultRequestAttributeWeightsQuery, GetMyDefaultRequestAttributeWeightsQueryVariables>;
export const SetMyDefaultRequestAttributeWeightsDocument = gql`
    mutation SetMyDefaultRequestAttributeWeights($input: RequestAttributeWeightsInput!) {
  setMyDefaultRequestAttributeWeights2(input: $input) {
    me {
      id
      defaultRequestAttributeWeights {
        ...RequestAttributeWeights
      }
    }
  }
}
    ${RequestAttributeWeightsFragmentDoc}`;
export type SetMyDefaultRequestAttributeWeightsMutationFn = Apollo.MutationFunction<SetMyDefaultRequestAttributeWeightsMutation, SetMyDefaultRequestAttributeWeightsMutationVariables>;

/**
 * __useSetMyDefaultRequestAttributeWeightsMutation__
 *
 * To run a mutation, you first call `useSetMyDefaultRequestAttributeWeightsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyDefaultRequestAttributeWeightsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyDefaultRequestAttributeWeightsMutation, { data, loading, error }] = useSetMyDefaultRequestAttributeWeightsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetMyDefaultRequestAttributeWeightsMutation(baseOptions?: Apollo.MutationHookOptions<SetMyDefaultRequestAttributeWeightsMutation, SetMyDefaultRequestAttributeWeightsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMyDefaultRequestAttributeWeightsMutation, SetMyDefaultRequestAttributeWeightsMutationVariables>(SetMyDefaultRequestAttributeWeightsDocument, options);
      }
export type SetMyDefaultRequestAttributeWeightsMutationHookResult = ReturnType<typeof useSetMyDefaultRequestAttributeWeightsMutation>;
export type SetMyDefaultRequestAttributeWeightsMutationResult = Apollo.MutationResult<SetMyDefaultRequestAttributeWeightsMutation>;
export type SetMyDefaultRequestAttributeWeightsMutationOptions = Apollo.BaseMutationOptions<SetMyDefaultRequestAttributeWeightsMutation, SetMyDefaultRequestAttributeWeightsMutationVariables>;
export const Eager_GetPageOfResourceUserMatchesForResourceRequestDocument = gql`
    query Eager_GetPageOfResourceUserMatchesForResourceRequest($page: Int!, $pagesize: Int!, $resourceRequestId: String!, $source: ResourceUserMatchSource!, $additionalColumns: ResourceUserColumns, $filter: ResourceUserMatchesFilter, $isAvailabilityEnabled: Boolean!, $dateRange: DateRangeInput!, $startDate: Date!, $periodResolution: PeriodResolutionOption!, $includeCurrentDepartment: Boolean!, $includeResourcePools: Boolean!, $includeCurrentEmployeeType: Boolean!, $includeCurrentCostCenter: Boolean!, $includeCurrentServiceCenter: Boolean!, $includeCurrentDivision: Boolean!, $includeCurrentLocation: Boolean!, $includeSupervisorAssignment: Boolean!, $includeEmployeeId: Boolean!, $includeTags: Boolean!, $includeCustomFields: Boolean!, $sort: [ResourceUserSort!]) {
  getPageOfResourceUserMatchesForResourceRequest(
    page: $page
    pagesize: $pagesize
    resourceRequestId: $resourceRequestId
    source: $source
    sort: $sort
    additionalColumns: $additionalColumns
    filter: $filter
  ) {
    id
    uri
    slug
    displayText
    startDate
    endDate
    employeeId @include(if: $includeEmployeeId)
    primaryRoleCostRate(date: $startDate) {
      amount
      currency {
        id
        symbol
        displayText
      }
    }
    costRateAsOf(date: $startDate) {
      amount
      currency {
        id
        symbol
        displayText
      }
    }
    availabilityPercentage @include(if: $isAvailabilityEnabled)
    matchScore {
      score
      matchingDimensions
      unMatchedDimensions
      matchSkillsMetadata {
        matchingSkillsCount
        requestedSkillsCount
      }
      matchResourcePoolsMetadata {
        matchingResourcePoolsCount
        requestedResourcePoolsCount
      }
      totalCost {
        amount
        currency {
          uri
          symbol
        }
      }
      matchTagsMetadata {
        matchingTagsCount
        requestedTagsCount
      }
      isError
    }
    roleSchedules {
      effectiveDate
      projectRoles {
        isPrimary
        projectRole {
          uri
          name
        }
      }
    }
    resourceAvailabilitySummarySeries(
      dateRange: $dateRange
      periodResolution: $periodResolution
    ) {
      dateRange {
        startDate: startDate2
        endDate: endDate2
      }
      scheduledDuration {
        hours
        minutes
        seconds
      }
      timeOffDuration {
        hours
        minutes
        seconds
      }
      holidayDuration {
        hours
        minutes
        seconds
      }
      overAllocatedDuration {
        hours
        minutes
        seconds
      }
      allocatedDuration {
        hours
        minutes
        seconds
      }
    }
    holidays(dateRange: $dateRange) @include(if: $isAvailabilityEnabled) {
      date
      uri
      name
      duration {
        hours
        minutes
        seconds
      }
      effectiveDuration {
        hours
        minutes
        seconds
      }
    }
    timeoffs(dateRange: $dateRange) @include(if: $isAvailabilityEnabled) {
      dateRange {
        startDate
        endDate
      }
      timeOffType {
        displayText
      }
      hours
      days
      entries {
        date
        hours
        days
      }
    }
    supervisorAssignment @include(if: $includeSupervisorAssignment) {
      supervisor {
        uri
        displayText
      }
      effectiveDate
    }
    currentDepartment @include(if: $includeCurrentDepartment) {
      id
      displayText
      ancestors {
        displayText
      }
    }
    allResourcePools @include(if: $includeResourcePools) {
      id
      slug
      displayText
    }
    currentEmployeeType @include(if: $includeCurrentEmployeeType) {
      id
      displayText
      ancestors {
        displayText
      }
    }
    currentCostCenter @include(if: $includeCurrentCostCenter) {
      id
      displayText
      ancestors {
        displayText
      }
    }
    currentServiceCenter @include(if: $includeCurrentServiceCenter) {
      id
      displayText
      ancestors {
        displayText
      }
    }
    currentDivision @include(if: $includeCurrentDivision) {
      id
      displayText
      ancestors {
        displayText
      }
    }
    currentLocation @include(if: $includeCurrentLocation) {
      id
      displayText
      ancestors {
        displayText
      }
    }
    tags @include(if: $includeTags) {
      tag {
        id
        name
      }
      value {
        id
        value
      }
    }
    customFieldValues @include(if: $includeCustomFields) {
      ...CustomFieldValue
    }
  }
}
    ${CustomFieldValueFragmentDoc}`;

/**
 * __useEager_GetPageOfResourceUserMatchesForResourceRequestQuery__
 *
 * To run a query within a React component, call `useEager_GetPageOfResourceUserMatchesForResourceRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useEager_GetPageOfResourceUserMatchesForResourceRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEager_GetPageOfResourceUserMatchesForResourceRequestQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pagesize: // value for 'pagesize'
 *      resourceRequestId: // value for 'resourceRequestId'
 *      source: // value for 'source'
 *      additionalColumns: // value for 'additionalColumns'
 *      filter: // value for 'filter'
 *      isAvailabilityEnabled: // value for 'isAvailabilityEnabled'
 *      dateRange: // value for 'dateRange'
 *      startDate: // value for 'startDate'
 *      periodResolution: // value for 'periodResolution'
 *      includeCurrentDepartment: // value for 'includeCurrentDepartment'
 *      includeResourcePools: // value for 'includeResourcePools'
 *      includeCurrentEmployeeType: // value for 'includeCurrentEmployeeType'
 *      includeCurrentCostCenter: // value for 'includeCurrentCostCenter'
 *      includeCurrentServiceCenter: // value for 'includeCurrentServiceCenter'
 *      includeCurrentDivision: // value for 'includeCurrentDivision'
 *      includeCurrentLocation: // value for 'includeCurrentLocation'
 *      includeSupervisorAssignment: // value for 'includeSupervisorAssignment'
 *      includeEmployeeId: // value for 'includeEmployeeId'
 *      includeTags: // value for 'includeTags'
 *      includeCustomFields: // value for 'includeCustomFields'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useEager_GetPageOfResourceUserMatchesForResourceRequestQuery(baseOptions: Apollo.QueryHookOptions<Eager_GetPageOfResourceUserMatchesForResourceRequestQuery, Eager_GetPageOfResourceUserMatchesForResourceRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Eager_GetPageOfResourceUserMatchesForResourceRequestQuery, Eager_GetPageOfResourceUserMatchesForResourceRequestQueryVariables>(Eager_GetPageOfResourceUserMatchesForResourceRequestDocument, options);
      }
export function useEager_GetPageOfResourceUserMatchesForResourceRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Eager_GetPageOfResourceUserMatchesForResourceRequestQuery, Eager_GetPageOfResourceUserMatchesForResourceRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Eager_GetPageOfResourceUserMatchesForResourceRequestQuery, Eager_GetPageOfResourceUserMatchesForResourceRequestQueryVariables>(Eager_GetPageOfResourceUserMatchesForResourceRequestDocument, options);
        }
export type Eager_GetPageOfResourceUserMatchesForResourceRequestQueryHookResult = ReturnType<typeof useEager_GetPageOfResourceUserMatchesForResourceRequestQuery>;
export type Eager_GetPageOfResourceUserMatchesForResourceRequestLazyQueryHookResult = ReturnType<typeof useEager_GetPageOfResourceUserMatchesForResourceRequestLazyQuery>;
export type Eager_GetPageOfResourceUserMatchesForResourceRequestQueryResult = Apollo.QueryResult<Eager_GetPageOfResourceUserMatchesForResourceRequestQuery, Eager_GetPageOfResourceUserMatchesForResourceRequestQueryVariables>;
export const Eager_GetResourceUsersPaginatedDocument = gql`
    query Eager_GetResourceUsersPaginated($page: Int, $pagesize: Int, $filter: GetResourceUsersFilter, $resourceRequestId: String, $sort: [ResourceUserSort!], $isAvailabilityEnabled: Boolean!, $dateRange: DateRangeInput!, $startDate: Date!, $periodResolution: PeriodResolutionOption!, $scoreComputeType: ScoreComputeType, $tagIds: [String!], $customFieldUris: [String!], $includeCurrentDepartment: Boolean!, $includeResourcePools: Boolean!, $includeCurrentEmployeeType: Boolean!, $includeCurrentCostCenter: Boolean!, $includeCurrentServiceCenter: Boolean!, $includeCurrentDivision: Boolean!, $includeCurrentLocation: Boolean!, $includeSupervisorAssignment: Boolean!, $includeEmployeeId: Boolean!, $includeTags: Boolean!, $includeCustomFields: Boolean!, $skipMerge: Boolean, $includeRoleScheduleAsOfDate: Boolean!, $asOfDate: Date2) {
  resourceUsers2(
    page: $page
    pagesize: $pagesize
    filter: $filter
    resourceRequestId: $resourceRequestId
    sort: $sort
    dateRange: $dateRange
    periodResolution: $periodResolution
    scoreComputeType: $scoreComputeType
    tagIds: $tagIds
    customFieldUris: $customFieldUris
    skipMerge: $skipMerge
  ) {
    id
    uri
    slug
    displayText
    startDate
    endDate
    employeeId @include(if: $includeEmployeeId)
    primaryRoleCostRate(date: $startDate) {
      amount
      currency {
        id
        symbol
        displayText
      }
    }
    costRateAsOf(date: $startDate) {
      amount
      currency {
        id
        symbol
        displayText
      }
    }
    availabilityPercentage @include(if: $isAvailabilityEnabled)
    matchScore {
      score
      matchingDimensions
      unMatchedDimensions
      matchSkillsMetadata {
        matchingSkillsCount
        requestedSkillsCount
      }
      matchResourcePoolsMetadata {
        matchingResourcePoolsCount
        requestedResourcePoolsCount
      }
      totalCost {
        amount
        currency {
          uri
          symbol
        }
      }
      matchTagsMetadata {
        matchingTagsCount
        requestedTagsCount
      }
      isError
    }
    roleSchedules {
      effectiveDate
      projectRoles {
        isPrimary
        projectRole {
          uri
          name
        }
      }
    }
    roleSchedulesAsOfDate(asOfDate: $asOfDate) @include(if: $includeRoleScheduleAsOfDate) {
      effectiveRoleSchedule {
        effectiveDate
        projectRoles {
          projectRole {
            uri
            name
          }
          isPrimary
        }
      }
    }
    resourceAvailabilitySummarySeries(
      dateRange: $dateRange
      periodResolution: $periodResolution
    ) {
      dateRange {
        startDate: startDate2
        endDate: endDate2
      }
      scheduledDuration {
        hours
        minutes
        seconds
      }
      timeOffDuration {
        hours
        minutes
        seconds
      }
      holidayDuration {
        hours
        minutes
        seconds
      }
      overAllocatedDuration {
        hours
        minutes
        seconds
      }
      allocatedDuration {
        hours
        minutes
        seconds
      }
    }
    holidays(dateRange: $dateRange) @include(if: $isAvailabilityEnabled) {
      date
      uri
      name
      duration {
        hours
        minutes
        seconds
      }
      effectiveDuration {
        hours
        minutes
        seconds
      }
    }
    timeoffs(dateRange: $dateRange) @include(if: $isAvailabilityEnabled) {
      dateRange {
        startDate
        endDate
      }
      timeOffType {
        displayText
      }
      hours
      days
      entries {
        date
        hours
        days
      }
    }
    supervisorAssignment @include(if: $includeSupervisorAssignment) {
      supervisor {
        uri
        displayText
      }
      effectiveDate
    }
    currentDepartment @include(if: $includeCurrentDepartment) {
      id
      displayText
      ancestors {
        displayText
      }
    }
    allResourcePools @include(if: $includeResourcePools) {
      id
      slug
      displayText
    }
    currentEmployeeType @include(if: $includeCurrentEmployeeType) {
      id
      displayText
      ancestors {
        displayText
      }
    }
    currentCostCenter @include(if: $includeCurrentCostCenter) {
      id
      displayText
      ancestors {
        displayText
      }
    }
    currentServiceCenter @include(if: $includeCurrentServiceCenter) {
      id
      displayText
      ancestors {
        displayText
      }
    }
    currentDivision @include(if: $includeCurrentDivision) {
      id
      displayText
      ancestors {
        displayText
      }
    }
    currentLocation @include(if: $includeCurrentLocation) {
      id
      displayText
      ancestors {
        displayText
      }
    }
    tags @include(if: $includeTags) {
      tag {
        id
        name
      }
      value {
        id
        value
      }
    }
    customFieldValues @include(if: $includeCustomFields) {
      ...CustomFieldValue
    }
  }
}
    ${CustomFieldValueFragmentDoc}`;

/**
 * __useEager_GetResourceUsersPaginatedQuery__
 *
 * To run a query within a React component, call `useEager_GetResourceUsersPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useEager_GetResourceUsersPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEager_GetResourceUsersPaginatedQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pagesize: // value for 'pagesize'
 *      filter: // value for 'filter'
 *      resourceRequestId: // value for 'resourceRequestId'
 *      sort: // value for 'sort'
 *      isAvailabilityEnabled: // value for 'isAvailabilityEnabled'
 *      dateRange: // value for 'dateRange'
 *      startDate: // value for 'startDate'
 *      periodResolution: // value for 'periodResolution'
 *      scoreComputeType: // value for 'scoreComputeType'
 *      tagIds: // value for 'tagIds'
 *      customFieldUris: // value for 'customFieldUris'
 *      includeCurrentDepartment: // value for 'includeCurrentDepartment'
 *      includeResourcePools: // value for 'includeResourcePools'
 *      includeCurrentEmployeeType: // value for 'includeCurrentEmployeeType'
 *      includeCurrentCostCenter: // value for 'includeCurrentCostCenter'
 *      includeCurrentServiceCenter: // value for 'includeCurrentServiceCenter'
 *      includeCurrentDivision: // value for 'includeCurrentDivision'
 *      includeCurrentLocation: // value for 'includeCurrentLocation'
 *      includeSupervisorAssignment: // value for 'includeSupervisorAssignment'
 *      includeEmployeeId: // value for 'includeEmployeeId'
 *      includeTags: // value for 'includeTags'
 *      includeCustomFields: // value for 'includeCustomFields'
 *      skipMerge: // value for 'skipMerge'
 *      includeRoleScheduleAsOfDate: // value for 'includeRoleScheduleAsOfDate'
 *      asOfDate: // value for 'asOfDate'
 *   },
 * });
 */
export function useEager_GetResourceUsersPaginatedQuery(baseOptions: Apollo.QueryHookOptions<Eager_GetResourceUsersPaginatedQuery, Eager_GetResourceUsersPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Eager_GetResourceUsersPaginatedQuery, Eager_GetResourceUsersPaginatedQueryVariables>(Eager_GetResourceUsersPaginatedDocument, options);
      }
export function useEager_GetResourceUsersPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Eager_GetResourceUsersPaginatedQuery, Eager_GetResourceUsersPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Eager_GetResourceUsersPaginatedQuery, Eager_GetResourceUsersPaginatedQueryVariables>(Eager_GetResourceUsersPaginatedDocument, options);
        }
export type Eager_GetResourceUsersPaginatedQueryHookResult = ReturnType<typeof useEager_GetResourceUsersPaginatedQuery>;
export type Eager_GetResourceUsersPaginatedLazyQueryHookResult = ReturnType<typeof useEager_GetResourceUsersPaginatedLazyQuery>;
export type Eager_GetResourceUsersPaginatedQueryResult = Apollo.QueryResult<Eager_GetResourceUsersPaginatedQuery, Eager_GetResourceUsersPaginatedQueryVariables>;
export const CurrentResourceCostRateDocument = gql`
    query currentResourceCostRate($page: Int, $pagesize: Int, $filter: GetResourceUsersFilter, $targetCurrencyId: String) {
  resourceUsers2(page: $page, pagesize: $pagesize, filter: $filter) {
    id
    currentCostRateInTargetCurrency(targetCurrencyId: $targetCurrencyId) {
      amount
      currency {
        symbol
        uri
      }
    }
  }
}
    `;

/**
 * __useCurrentResourceCostRateQuery__
 *
 * To run a query within a React component, call `useCurrentResourceCostRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentResourceCostRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentResourceCostRateQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pagesize: // value for 'pagesize'
 *      filter: // value for 'filter'
 *      targetCurrencyId: // value for 'targetCurrencyId'
 *   },
 * });
 */
export function useCurrentResourceCostRateQuery(baseOptions?: Apollo.QueryHookOptions<CurrentResourceCostRateQuery, CurrentResourceCostRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentResourceCostRateQuery, CurrentResourceCostRateQueryVariables>(CurrentResourceCostRateDocument, options);
      }
export function useCurrentResourceCostRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentResourceCostRateQuery, CurrentResourceCostRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentResourceCostRateQuery, CurrentResourceCostRateQueryVariables>(CurrentResourceCostRateDocument, options);
        }
export type CurrentResourceCostRateQueryHookResult = ReturnType<typeof useCurrentResourceCostRateQuery>;
export type CurrentResourceCostRateLazyQueryHookResult = ReturnType<typeof useCurrentResourceCostRateLazyQuery>;
export type CurrentResourceCostRateQueryResult = Apollo.QueryResult<CurrentResourceCostRateQuery, CurrentResourceCostRateQueryVariables>;
export const CurrentRoleCostRateDocument = gql`
    query currentRoleCostRate($roleId: String!, $targetCurrencyId: String) {
  role(id: $roleId) {
    id
    currentRate(targetCurrencyId: $targetCurrencyId) {
      amount
      currency {
        id
        symbol
      }
    }
  }
}
    `;

/**
 * __useCurrentRoleCostRateQuery__
 *
 * To run a query within a React component, call `useCurrentRoleCostRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentRoleCostRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentRoleCostRateQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      targetCurrencyId: // value for 'targetCurrencyId'
 *   },
 * });
 */
export function useCurrentRoleCostRateQuery(baseOptions: Apollo.QueryHookOptions<CurrentRoleCostRateQuery, CurrentRoleCostRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentRoleCostRateQuery, CurrentRoleCostRateQueryVariables>(CurrentRoleCostRateDocument, options);
      }
export function useCurrentRoleCostRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentRoleCostRateQuery, CurrentRoleCostRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentRoleCostRateQuery, CurrentRoleCostRateQueryVariables>(CurrentRoleCostRateDocument, options);
        }
export type CurrentRoleCostRateQueryHookResult = ReturnType<typeof useCurrentRoleCostRateQuery>;
export type CurrentRoleCostRateLazyQueryHookResult = ReturnType<typeof useCurrentRoleCostRateLazyQuery>;
export type CurrentRoleCostRateQueryResult = Apollo.QueryResult<CurrentRoleCostRateQuery, CurrentRoleCostRateQueryVariables>;
export const Eager_GetMyInProgressTasksDocument = gql`
    query Eager_GetMyInProgressTasks($effectiveTimestamp: Date2!, $effectiveDateTime: DateTime!) {
  me {
    id
    inProgressTasks: inProgressTasks2(
      onlyOpenTasks: true
      effectiveTimestamp: $effectiveDateTime
    ) {
      ...TaskDetailsData
      isClosed
      taskEntries: taskEntries2(effectiveTimestamp: $effectiveDateTime) {
        ...TaskEntryDetailsData
        rowNumber
      }
      currentUserTaskEstimates {
        id
        estimatedHours
        estimatedCompletionDate
        initialEstimate
      }
    }
  }
}
    ${TaskDetailsDataFragmentDoc}
${TaskEntryDetailsDataFragmentDoc}`;

/**
 * __useEager_GetMyInProgressTasksQuery__
 *
 * To run a query within a React component, call `useEager_GetMyInProgressTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useEager_GetMyInProgressTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEager_GetMyInProgressTasksQuery({
 *   variables: {
 *      effectiveTimestamp: // value for 'effectiveTimestamp'
 *      effectiveDateTime: // value for 'effectiveDateTime'
 *   },
 * });
 */
export function useEager_GetMyInProgressTasksQuery(baseOptions: Apollo.QueryHookOptions<Eager_GetMyInProgressTasksQuery, Eager_GetMyInProgressTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Eager_GetMyInProgressTasksQuery, Eager_GetMyInProgressTasksQueryVariables>(Eager_GetMyInProgressTasksDocument, options);
      }
export function useEager_GetMyInProgressTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Eager_GetMyInProgressTasksQuery, Eager_GetMyInProgressTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Eager_GetMyInProgressTasksQuery, Eager_GetMyInProgressTasksQueryVariables>(Eager_GetMyInProgressTasksDocument, options);
        }
export type Eager_GetMyInProgressTasksQueryHookResult = ReturnType<typeof useEager_GetMyInProgressTasksQuery>;
export type Eager_GetMyInProgressTasksLazyQueryHookResult = ReturnType<typeof useEager_GetMyInProgressTasksLazyQuery>;
export type Eager_GetMyInProgressTasksQueryResult = Apollo.QueryResult<Eager_GetMyInProgressTasksQuery, Eager_GetMyInProgressTasksQueryVariables>;
export const SetTaskProgressStatusDocument = gql`
    mutation SetTaskProgressStatus($id: String!, $status: TaskProgressStatus!, $effectiveTimestamp: Date!, $effectiveTimestamp2: Date2!, $effectiveDateTimestamp: DateTime!) {
  setTaskProgressStatus: setTaskProgressStatus2(
    input: {taskId: $id, status: $status, effectiveTimestamp: $effectiveTimestamp}
  ) {
    task {
      id
      progressStatus: progressStatus2(effectiveTimestamp: $effectiveTimestamp2)
      totalWorkToDate: totalWorkToDate2(effectiveTimestamp: $effectiveDateTimestamp)
      taskEntries: taskEntries2(effectiveTimestamp: $effectiveDateTimestamp) {
        ...TaskEntryDetailsData
      }
    }
  }
}
    ${TaskEntryDetailsDataFragmentDoc}`;
export type SetTaskProgressStatusMutationFn = Apollo.MutationFunction<SetTaskProgressStatusMutation, SetTaskProgressStatusMutationVariables>;

/**
 * __useSetTaskProgressStatusMutation__
 *
 * To run a mutation, you first call `useSetTaskProgressStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTaskProgressStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTaskProgressStatusMutation, { data, loading, error }] = useSetTaskProgressStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      effectiveTimestamp: // value for 'effectiveTimestamp'
 *      effectiveTimestamp2: // value for 'effectiveTimestamp2'
 *      effectiveDateTimestamp: // value for 'effectiveDateTimestamp'
 *   },
 * });
 */
export function useSetTaskProgressStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetTaskProgressStatusMutation, SetTaskProgressStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTaskProgressStatusMutation, SetTaskProgressStatusMutationVariables>(SetTaskProgressStatusDocument, options);
      }
export type SetTaskProgressStatusMutationHookResult = ReturnType<typeof useSetTaskProgressStatusMutation>;
export type SetTaskProgressStatusMutationResult = Apollo.MutationResult<SetTaskProgressStatusMutation>;
export type SetTaskProgressStatusMutationOptions = Apollo.BaseMutationOptions<SetTaskProgressStatusMutation, SetTaskProgressStatusMutationVariables>;